// @ts-nocheck
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date */
  Date: Date;
  JSON: any;
  join__FieldSet: any;
  link__Import: any;
};

export type AccessControlItem = AccessControlItemDateTime | AccessControlItemLeaderboard | AccessControlItemNft;

export type AccessControlItemDateTime = {
  __typename?: 'AccessControlItemDateTime';
  /** (Optional) closing time, ISO 8601 format */
  closeAtISO?: Maybe<Scalars['String']>;
  /** Opening time, ISO 8601 format */
  openAtISO: Scalars['String'];
};

export type AccessControlItemLeaderboard = {
  __typename?: 'AccessControlItemLeaderboard';
  /** Project ID of the world that the user must be have a leaderboard entry for */
  projectId: Scalars['ID'];
};

export type AccessControlItemNft = {
  __typename?: 'AccessControlItemNFT';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

/** Reason why access was granted or denied */
export enum AccessControlReason {
  /** Error: user does not have required NFT */
  NftNotOwned = 'NFT_NOT_OWNED',
  /** Error: user is not authenticated */
  NotAuthenticated = 'NOT_AUTHENTICATED',
  /** Error: user does not have any leaderbord entry for the specified project */
  NoLeaderboardEntry = 'NO_LEADERBOARD_ENTRY',
  /** Error: user is trying to access the world before it is open */
  TooEarly = 'TOO_EARLY',
  /** Error: user is trying to access the world after it has closed */
  TooLate = 'TOO_LATE',
  /** Error: unknown */
  Unknown = 'UNKNOWN'
}

export type ActiveSuspensionList = {
  __typename?: 'ActiveSuspensionList';
  cursor: Scalars['String'];
  next: Scalars['Boolean'];
  suspensionList: Array<Suspension>;
  totalCount: Scalars['Float'];
};

export type ActivitiesFilter = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  fromDate?: InputMaybe<Scalars['Date']>;
  toDate?: InputMaybe<Scalars['Date']>;
  unread?: InputMaybe<Scalars['Boolean']>;
};

export type ActivitiesPageInfo = {
  __typename?: 'ActivitiesPageInfo';
  cursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
};

export type ActivitiesResponse = {
  __typename?: 'ActivitiesResponse';
  items: Array<Activity>;
  pageInfo: ActivitiesPageInfo;
};

export type Activity = {
  __typename?: 'Activity';
  amount: Scalars['Int'];
  content?: Maybe<ContentUnion>;
  contentId: Scalars['ID'];
  contentType: Scalars['String'];
  /** the creation time in UTC */
  createdAt: Scalars['Date'];
  groupId: Scalars['String'];
  receiverId: Scalars['ID'];
  sender: User;
  senderId: Scalars['ID'];
  sourceId: Scalars['String'];
  type: Scalars['String'];
};

export type ActivityGroupFilter = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  groupId: Scalars['String'];
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  correlationId?: Maybe<Scalars['String']>;
  data: ActivityLogItem;
  key: Scalars['String'];
  timestamp: Scalars['Date'];
  userId: Scalars['Int'];
};

/** Available logs for activity logger */
export type ActivityLogItem = SoftCurrencyTransactionLog;

/** Log types for activity logger */
export enum ActivityLogType {
  SoftCurrencyTransaction = 'SOFT_CURRENCY_TRANSACTION'
}

export type AddActivityInput = {
  activityType: Scalars['String'];
  contentId: Scalars['ID'];
  contentType: Scalars['String'];
  receiverIds: Array<Scalars['ID']>;
  senderId: Scalars['ID'];
};

export type AddGamificationRewardsDto = {
  rewards?: InputMaybe<Array<GamificationReward>>;
  userId: Scalars['ID'];
};

export type Appearance = {
  __typename?: 'Appearance';
  achievementIconKey: Scalars['String'];
  achievementIconUrl: Scalars['String'];
  appearanceQuality: Scalars['String'];
  canEquip: Scalars['Boolean'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  externalAssetType?: Maybe<Scalars['String']>;
  externalDescription?: Maybe<Scalars['String']>;
  externalDetailThumbnail?: Maybe<Scalars['String']>;
  externalFemaleId?: Maybe<Scalars['String']>;
  externalMaleId?: Maybe<Scalars['String']>;
  externalThumbnail?: Maybe<Scalars['String']>;
  externalTitle?: Maybe<Scalars['String']>;
  glbGZKey: Scalars['String'];
  glbGZUrl: Scalars['String'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  isPromotional: Scalars['Boolean'];
  isVariation: Scalars['Boolean'];
  name: Scalars['String'];
  parentAppearanceId?: Maybe<Scalars['Int']>;
  quality: AppearanceQuality;
  source: AppearanceSource;
  sourceDescription: Scalars['String'];
  thumbnailKey: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  type: AppearanceType;
  variations?: Maybe<Array<Appearance>>;
};

export type AppearanceConnection = {
  __typename?: 'AppearanceConnection';
  edges: Array<AppearanceEdge>;
  items: Array<Appearance>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type AppearanceEdge = {
  __typename?: 'AppearanceEdge';
  cursor: Scalars['String'];
  node: Appearance;
};

/** quality for appearances */
export enum AppearanceQuality {
  Artifact = 'ARTIFACT',
  Bronze = 'BRONZE',
  Common = 'COMMON',
  Epic = 'EPIC',
  Gold = 'GOLD',
  Legendary = 'LEGENDARY',
  Rare = 'RARE',
  Silver = 'SILVER',
  Uncommon = 'UNCOMMON'
}

export type AppearanceSource = {
  __typename?: 'AppearanceSource';
  appearanceId: Scalars['ID'];
  badge?: Maybe<Badge>;
  defaultSourceDescription?: Maybe<Scalars['String']>;
};

/** types of appearances */
export enum AppearanceType {
  Skin = 'SKIN'
}

export type AssetLockForUserInput = {
  hiberId: Scalars['ID'];
  id: Scalars['ID'];
  provider: AvatarProvider;
  stripeInput?: InputMaybe<StripeInput>;
};

export type AssetResponse = {
  __typename?: 'AssetResponse';
  message: Scalars['String'];
  status: Scalars['ID'];
  type: Scalars['String'];
};

export enum AssetType {
  Prefix = 'Prefix',
  Suffix = 'Suffix'
}

export type AssetUnlockAndEquipInput = {
  femaleAsset: AssetUnlockInput;
  hiberId: Scalars['ID'];
  maleAsset: AssetUnlockInput;
};

export type AssetUnlockForUsersInput = {
  assets: Array<AssetUnlockInput>;
  hiberIds: Array<Scalars['String']>;
};

export type AssetUnlockInput = {
  id: Scalars['ID'];
  provider: AvatarProvider;
  stripeInput?: InputMaybe<StripeInput>;
};

/** Auth response for JWTs */
export type AuthResponse = {
  __typename?: 'AuthResponse';
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  user: User;
};

export type Avatar = {
  __typename?: 'Avatar';
  claimableRpmAchievement: Array<UnlockableRpmAchievements>;
  glbUrl: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  provider: AvatarProvider;
  rpmAvatarId?: Maybe<Scalars['String']>;
  rpmGlbUrl?: Maybe<Scalars['String']>;
  rpmHasLinkedAccount?: Maybe<Scalars['Boolean']>;
  rpmJsonData?: Maybe<RpmJsonData>;
  rpmUserId?: Maybe<Scalars['String']>;
  thumbnail: Scalars['String'];
  unlockedAssets?: Maybe<Array<UnlockedAsset>>;
};

export enum AvatarProvider {
  Hiber = 'Hiber',
  ReadyPlayerMe = 'ReadyPlayerMe'
}

export type Badge = {
  __typename?: 'Badge';
  active?: Maybe<Scalars['Boolean']>;
  activeAt?: Maybe<Scalars['Date']>;
  criteriaData?: Maybe<Array<CriteriaData>>;
  criterias: Array<Criteria>;
  description: Scalars['String'];
  difficulty?: Maybe<BadgeDifficulty>;
  displayName: Scalars['String'];
  groupId: Scalars['Int'];
  groupTotal?: Maybe<Scalars['Float']>;
  hiddenIfLocked: Scalars['Boolean'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  level: Scalars['Int'];
  locked_icon: Scalars['String'];
  name: Scalars['String'];
  nextBadge?: Maybe<Badge>;
  rarity: AppearanceQuality;
  rewards: Array<Reward>;
  type?: Maybe<Persistence>;
};


export type BadgeCriteriaDataArgs = {
  userId?: InputMaybe<Scalars['Int']>;
};

/** difficulty of badges */
export enum BadgeDifficulty {
  Easy = 'EASY',
  Hard = 'HARD'
}

export type Banner = {
  __typename?: 'Banner';
  background?: Maybe<CmsImage>;
  backgroundVideo?: Maybe<CmsVideo>;
  buttonLabel: Scalars['String'];
  header: Scalars['String'];
  id: Scalars['ID'];
  layout?: Maybe<BannerLayout>;
  projectIdOrButtonLink: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

/** Available feed card layouts on cms feeds */
export enum BannerLayout {
  Large = 'LARGE',
  Small = 'SMALL'
}

export type BlockUserDto = {
  userId: Scalars['ID'];
};

export type BlockedUser = {
  __typename?: 'BlockedUser';
  blockedAt: Scalars['Date'];
  blockedByMe: Scalars['Boolean'];
  id: Scalars['ID'];
  user1: User;
  user1Id: Scalars['ID'];
  user2: User;
  user2Id: Scalars['ID'];
};

export type BuildInfo = {
  __typename?: 'BuildInfo';
  latestCommit: Scalars['String'];
  revision: Scalars['String'];
  version: Scalars['String'];
};

export type CmsImage = {
  __typename?: 'CMSImage';
  url: Scalars['String'];
};

export type CmsVideo = {
  __typename?: 'CMSVideo';
  url: Scalars['String'];
};

export type CalculateProjectTagsDto = {
  metadata: MetadataDto;
  projectId: Scalars['ID'];
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignProjects?: Maybe<ProjectConnection>;
  description: Scalars['String'];
  filterTags: Array<Scalars['String']>;
  gameUrls: Array<Scalars['String']>;
  id: Scalars['Float'];
  imgAltText?: Maybe<Scalars['String']>;
  pageImage?: Maybe<Scalars['String']>;
  socialMediaImage?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url: Scalars['String'];
};


export type CampaignCampaignProjectsArgs = {
  input: SearchDto;
};

export type CanJoinRequest = {
  channel?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion?: InputMaybe<Scalars['Int']>;
  clientVersion?: InputMaybe<Scalars['String']>;
};

export type CanJoinRequestV2 = {
  channel?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion?: InputMaybe<Scalars['Int']>;
  clientVersion?: InputMaybe<Scalars['String']>;
};

export type Carousel = {
  __typename?: 'Carousel';
  id: Scalars['ID'];
  items: Array<Banner>;
};

export type Challenge = {
  __typename?: 'Challenge';
  badge: UserBadge;
  expires: Scalars['Date'];
  reward?: Maybe<Reward>;
  rewardType: Scalars['String'];
};

export type ChallengeBanner = {
  __typename?: 'ChallengeBanner';
  buttonLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  projectIdOrLink?: Maybe<Scalars['String']>;
  type: ChallengeBannerType;
};

/** Available challenge banner types on cms feeds */
export enum ChallengeBannerType {
  LatestHiberChallenge = 'LATEST_HIBER_CHALLENGE',
  OnboardingMission = 'ONBOARDING_MISSION'
}

export type Chat = {
  __typename?: 'Chat';
  category: Scalars['Float'];
  comments?: Maybe<CommentConnection>;
  commentsV2?: Maybe<CommentConnection>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasTag: Scalars['Boolean'];
  id: Scalars['ID'];
  isLiked?: Maybe<Scalars['Boolean']>;
  isReported?: Maybe<Scalars['Boolean']>;
  likes: Scalars['Float'];
  tags_v2: Array<Tag>;
  totalViews: Scalars['Float'];
  updatedAt: Scalars['Date'];
  views: Scalars['Float'];
};


export type ChatCommentsArgs = {
  payload: SearchDto;
};


export type ChatCommentsV2Args = {
  payload: SearchDto;
};


export type ChatHasTagArgs = {
  name: Scalars['String'];
  type?: InputMaybe<TagType>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  message: Scalars['String'];
  roomId: Scalars['String'];
  sender?: Maybe<User>;
  senderId: Scalars['ID'];
};

export type ChatMessageMetadata = {
  __typename?: 'ChatMessageMetadata';
  confidence?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  history: Array<ChatMessage>;
  humanReviewed: Scalars['Boolean'];
  id: Scalars['Int'];
  message: ChatMessage;
  moderatorVersion: Scalars['ID'];
  recommendation: Scalars['String'];
  recommendationDesc?: Maybe<Scalars['String']>;
  result: Scalars['String'];
  resultDesc?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<User>;
};

export type ChatMessageMetadataDto = {
  humanReviewed: Scalars['Boolean'];
  id: Scalars['ID'];
  result: Scalars['String'];
  resultDesc?: InputMaybe<Scalars['String']>;
};

export type CheckoutSessionResponse = {
  __typename?: 'CheckoutSessionResponse';
  clientSecret?: Maybe<Scalars['String']>;
  sessionId: Scalars['String'];
  sessionUrl?: Maybe<Scalars['String']>;
};

export type ClientInfo = {
  clientId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type Comment = {
  __typename?: 'Comment';
  author: User;
  category: Scalars['Float'];
  comments?: Maybe<CommentConnection>;
  commentsV2?: Maybe<CommentConnection>;
  contentId: Scalars['ID'];
  contentType: ContentType;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasTag: Scalars['Boolean'];
  id: Scalars['ID'];
  isLiked?: Maybe<Scalars['Boolean']>;
  isPinned?: Maybe<Scalars['Boolean']>;
  isReported?: Maybe<Scalars['Boolean']>;
  language: Scalars['String'];
  likes: Scalars['Float'];
  rawText: Scalars['String'];
  replies?: Maybe<CommentConnection>;
  shouldShow?: Maybe<Scalars['Boolean']>;
  sourceContent?: Maybe<ContentUnion>;
  tags_v2: Array<Tag>;
  text: Scalars['String'];
  totalViews: Scalars['Float'];
  updatedAt: Scalars['Date'];
  views: Scalars['Float'];
};


export type CommentCommentsArgs = {
  payload: SearchDto;
};


export type CommentCommentsV2Args = {
  payload: SearchDto;
};


export type CommentHasTagArgs = {
  name: Scalars['String'];
  type?: InputMaybe<TagType>;
};


export type CommentRepliesArgs = {
  payload: SearchDto;
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  edges: Array<Edge>;
  items: Array<Comment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type ContentIdentifier = {
  id: Scalars['ID'];
  type: ContentType;
};

export type ContentTagRelation = {
  __typename?: 'ContentTagRelation';
  contentId: Scalars['ID'];
  contentType: ContentType;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  tagId: Scalars['ID'];
};

/** Type of content */
export enum ContentType {
  Chat = 'Chat',
  Comment = 'Comment',
  Image = 'Image',
  Project = 'Project',
  User = 'User'
}

export type ContentUnion = Chat | Comment | Image | Project | User;

export type ContentfulFeaturedMaps = {
  __typename?: 'ContentfulFeaturedMaps';
  featuredParkours: Array<Project>;
  featuredPlaygrounds: Array<Project>;
  featuredProject?: Maybe<Project>;
  featuredProjectButtonText?: Maybe<Scalars['String']>;
  featuredProjectId?: Maybe<Scalars['String']>;
  featuredProjectImage?: Maybe<Scalars['String']>;
  featuredShooters: Array<Project>;
  parkourDescription?: Maybe<Scalars['String']>;
  parkourTitle?: Maybe<Scalars['String']>;
  playgroundDescription?: Maybe<Scalars['String']>;
  playgroundTitle?: Maybe<Scalars['String']>;
  shooterDescription?: Maybe<Scalars['String']>;
  shooterTitle?: Maybe<Scalars['String']>;
  welcomeDescription?: Maybe<Scalars['String']>;
  welcomeDescriptionButtonText?: Maybe<Scalars['String']>;
  welcomeTitle?: Maybe<Scalars['String']>;
};

export type ContentfulFrontPageContent = {
  __typename?: 'ContentfulFrontPageContent';
  article?: Maybe<ContentfulNewsArticle>;
  feeds?: Maybe<Array<ContentfulFrontPageFeed>>;
  hero?: Maybe<ContentfulFrontPageHero>;
};

export type ContentfulFrontPageFeed = {
  __typename?: 'ContentfulFrontPageFeed';
  buttonLink?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  includeSoMe: Scalars['Boolean'];
  meta?: Maybe<Array<Scalars['String']>>;
  onlyFollowing?: Maybe<Scalars['Boolean']>;
  onlyForEmployees?: Maybe<Scalars['Boolean']>;
  orderIndex: Scalars['Float'];
  quantity?: Maybe<Scalars['Float']>;
  showForLoggedIn: Scalars['Boolean'];
  showForLoggedOut: Scalars['Boolean'];
  sortBy?: Maybe<SortBy>;
  specificProjectIds?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type ContentfulFrontPageHero = {
  __typename?: 'ContentfulFrontPageHero';
  buttonLabel: Scalars['String'];
  header: Scalars['String'];
  heroBackground: ContentfulImage;
  preHeader?: Maybe<Scalars['String']>;
  projectIdOrButtonLink: Scalars['String'];
  showForLoggedIn: Scalars['Boolean'];
  showForLoggedOut: Scalars['Boolean'];
  subHeader?: Maybe<Scalars['String']>;
};

export type ContentfulImage = {
  __typename?: 'ContentfulImage';
  url: Scalars['String'];
};

export type ContentfulNewsArticle = {
  __typename?: 'ContentfulNewsArticle';
  article: Scalars['String'];
  ctaButtonLink?: Maybe<Scalars['String']>;
  ctaButtonText?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  iosCtaButtonLink?: Maybe<Scalars['String']>;
  modalButtonText?: Maybe<Scalars['String']>;
  modalText?: Maybe<Scalars['String']>;
  modalTitle?: Maybe<Scalars['String']>;
  openModal?: Maybe<Scalars['Boolean']>;
  showForLoggedIn?: Maybe<Scalars['Boolean']>;
  showForLoggedOut?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['Date']>;
  thumbnail?: Maybe<ContentfulImage>;
  title: Scalars['String'];
};

export type ContentfulYoutubeLinks = {
  __typename?: 'ContentfulYoutubeLinks';
  daoLandingPage?: Maybe<Scalars['String']>;
  daoLandingPageDescription?: Maybe<Scalars['String']>;
  daoLandingPageTitle?: Maybe<Scalars['String']>;
};

export type CreateAppearanceDto = {
  displayName: Scalars['String'];
  isPromotional?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  quality: AppearanceQuality;
  sourceDescription: Scalars['String'];
};

export type CreateAppleUserDto = {
  appleAuthCode: Scalars['String'];
  birthdate?: InputMaybe<Scalars['Date']>;
  username: Scalars['String'];
};

export type CreateBadgeDto = {
  active?: InputMaybe<Scalars['Boolean']>;
  activeAt?: InputMaybe<Scalars['Date']>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  groupId: Scalars['Float'];
  hiddenIfLocked?: Scalars['Boolean'];
  icon: Scalars['String'];
  level: Scalars['Float'];
  locked_icon: Scalars['String'];
  name: Scalars['String'];
  rarity: AppearanceQuality;
  type?: InputMaybe<Persistence>;
};

export type CreateChatMessageDto = {
  projectGameKit: GameKit;
  projectId: Scalars['ID'];
  roomId: Scalars['String'];
  text: Scalars['String'];
};

export type CreateChatMessageForUserDto = {
  projectGameKit: GameKit;
  projectId: Scalars['ID'];
  roomId: Scalars['String'];
  text: Scalars['String'];
  userId: Scalars['ID'];
};

export type CreateGoogleUserDto = {
  accessToken: Scalars['String'];
  birthdate?: InputMaybe<Scalars['Date']>;
  hasAcceptedTos?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};

export type CreateManyTagsForManyContentDto = {
  contents: Array<ContentIdentifier>;
  tags: Array<TagIdentifierInput>;
};

export type CreatePlatformerSessionSettingsDto = {
  gameMode: PlatformerGameMode;
  timeLimit?: InputMaybe<Scalars['Int']>;
  winCondition: PlatformerWinCondition;
  winConditionValue?: InputMaybe<Scalars['Int']>;
};

export type CreateProjectDto = {
  description?: InputMaybe<Scalars['String']>;
  difficulty?: InputMaybe<Difficulty>;
  doPublish?: InputMaybe<Scalars['Boolean']>;
  engineVersion?: InputMaybe<Scalars['Int']>;
  forkId?: InputMaybe<Scalars['Float']>;
  gameKit?: InputMaybe<GameKit>;
  inheritTitle?: InputMaybe<Scalars['Boolean']>;
  isSnapMode?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['Int']>;
};

export type CreateReportDto = {
  contentType: ContentType;
  id: Scalars['ID'];
  projectId?: InputMaybe<Scalars['ID']>;
  reason: ReportReason;
  reasonText?: InputMaybe<Scalars['String']>;
  reportedUser?: InputMaybe<Scalars['ID']>;
  rootContentId: Scalars['ID'];
};

export type CreateRewardDto = {
  badgeId: Scalars['Int'];
  subType: Scalars['Int'];
  type: RewardType;
  value: Scalars['Int'];
};

export type CreateScheduledProjectUpdateDto = {
  featured?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['ID'];
  reFeature?: InputMaybe<Scalars['Boolean']>;
  updateAt: Scalars['Date'];
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type CreateShooterSessionSettingsDto = {
  gameMode: ShooterGameMode;
  subWinCondition: SubShooterWinCondition;
  timeLimit?: InputMaybe<Scalars['Int']>;
  winCondition: ShooterWinCondition;
  winConditionValue?: InputMaybe<Scalars['Int']>;
};

export type CreateStashCheckoutLinkResponse = {
  __typename?: 'CreateStashCheckoutLinkResponse';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type CreateTagDto = {
  contentId: Scalars['ID'];
  contentType: ContentType;
  name: Scalars['String'];
  type: TagType;
};

export type CreateTagsDto = {
  contentId: Scalars['ID'];
  contentType: ContentType;
  tags: Array<TagIdentifierInput>;
};

export type CreateUserDto = {
  birthdate?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Platform>;
  rewardSoftCurrency?: InputMaybe<Scalars['Boolean']>;
  secret?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserType>;
  username: Scalars['String'];
};

export type CreateUserWithoutPasswordDto = {
  birthdate?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Platform>;
  secret?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type CreateZendeskTicketDto = {
  description: Scalars['String'];
  device: Device;
  email: Scalars['String'];
  name: Scalars['String'];
  os?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type Criteria = {
  __typename?: 'Criteria';
  badgeId: Scalars['Int'];
  id: Scalars['ID'];
  subType: Scalars['Int'];
  total: Scalars['Int'];
  type: CriteriaTypes;
};

export type CriteriaData = {
  __typename?: 'CriteriaData';
  badgeId: Scalars['Float'];
  currentValue?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type CustomData = {
  __typename?: 'CustomData';
  commentText: Scalars['String'];
  contentId?: Maybe<Scalars['ID']>;
  gameKit?: Maybe<GameKit>;
  projectTitle?: Maybe<Scalars['String']>;
};

export type DefaultAvatarInput = {
  gender?: InputMaybe<Gender>;
  provider: AvatarProvider;
};

export type DefaultPrice = {
  __typename?: 'DefaultPrice';
  currency: Scalars['String'];
  priceAmount: Scalars['Int'];
  priceId: Scalars['String'];
};

export type DeleteScheduledProjectUpdateKey = {
  projectId: Scalars['ID'];
  updateAt: Scalars['Date'];
};

export type DeleteTagFromContentDto = {
  contentId: Scalars['ID'];
  name: Scalars['String'];
  type: TagType;
};

/** types of devices */
export enum Device {
  AmazonDevice = 'AmazonDevice',
  AndroidPhone = 'AndroidPhone',
  AndroidTablet = 'AndroidTablet',
  ChromeBook = 'ChromeBook',
  Mac = 'Mac',
  Pc = 'PC',
  IPad = 'iPad',
  IPhone = 'iPhone'
}

export type Edge = {
  __typename?: 'Edge';
  cursor: Scalars['String'];
  node: Comment;
};

/** user email verified state */
export enum EmailVerification {
  Bypass = 'BYPASS',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type Emote = {
  __typename?: 'Emote';
  animationUrl: Scalars['String'];
  emoteId: Scalars['String'];
  id: Scalars['ID'];
  thumbnailUrl: Scalars['String'];
};

export type EmoteShopItem = ShopItem & {
  __typename?: 'EmoteShopItem';
  category: Scalars['String'];
  created: Scalars['Date'];
  currency: Scalars['String'];
  description: Scalars['String'];
  emoteId: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  id: Scalars['ID'];
  image: Scalars['String'];
  isNew: Scalars['Boolean'];
  name: Scalars['String'];
  owned: Scalars['Boolean'];
  price: Scalars['Float'];
  priceId: Scalars['String'];
  priceString: Scalars['String'];
  priceType: PriceType;
  rarity: Scalars['String'];
  type: ShopItemType;
  videoUrl: Scalars['String'];
};

export type EquipAssetInput = {
  id: Scalars['ID'];
  provider: AvatarProvider;
};

export type ExecuteScheduledProjectUpdateDto = {
  featured?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['ID'];
  reFeature?: InputMaybe<Scalars['Boolean']>;
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type FeatureCriteria = {
  __typename?: 'FeatureCriteria';
  minLevel?: Maybe<Scalars['Float']>;
  minRole?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<TagIdentifierType>>;
};

export type FeatureCriteriaInputDto = {
  minLevel?: InputMaybe<Scalars['Float']>;
  minRole?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Array<TagIdentifierInput>>;
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['String']>;
  criteria?: Maybe<FeatureCriteria>;
  description?: Maybe<Scalars['String']>;
  disabledAt?: Maybe<Scalars['Date']>;
  enabledAt: Scalars['Date'];
  isConfig?: Maybe<Scalars['Boolean']>;
  isEnabled: Scalars['Boolean'];
  isEnabledForUser: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  values?: Maybe<Array<FeatureToggle>>;
};

export type FeatureToggleInputDto = {
  criteria?: InputMaybe<FeatureCriteriaInputDto>;
  disabledAt?: InputMaybe<Scalars['Date']>;
  enabledAt: Scalars['Date'];
  name: Scalars['String'];
  values?: InputMaybe<Array<FeatureToggleInputDto>>;
};

export type FeaturedFriend = {
  __typename?: 'FeaturedFriend';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  owner: User;
  ownerId: Scalars['ID'];
  target: User;
  targetId: Scalars['ID'];
};

export type FeaturedFriendConnection = {
  __typename?: 'FeaturedFriendConnection';
  edges: Array<FeaturedFriendEdge>;
  items: Array<FeaturedFriend>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type FeaturedFriendEdge = {
  __typename?: 'FeaturedFriendEdge';
  cursor: Scalars['String'];
  node: FeaturedFriend;
};

export type FeaturedProfile = {
  __typename?: 'FeaturedProfile';
  addedAt: Scalars['Date'];
  user: User;
  userId: Scalars['ID'];
};

/** Available feed card layouts on cms feeds */
export enum FeedCardLayout {
  Large = 'LARGE',
  Portrait = 'PORTRAIT',
  Small = 'SMALL'
}

/** Available filters on cms project feeds */
export enum FeedFilter {
  Following = 'FOLLOWING',
  Recommended = 'RECOMMENDED'
}

export type FetchLootDto = {
  includeSeen?: InputMaybe<Scalars['Boolean']>;
  setSeen?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<LootType>>;
};

export type FetchReportsDto = {
  contentType?: InputMaybe<ContentType>;
  filter?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortReportBy>;
  status?: InputMaybe<ReportStatus>;
};

export type FetchUsersMetaDataDto = {
  filterByRole?: InputMaybe<Scalars['Int']>;
  filterByUserName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
};

export type File = {
  __typename?: 'File';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  owner: User;
  updatedAt: Scalars['Date'];
};

export type FindActivityLogsInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  sortBy?: InputMaybe<FindActivityLogsSort>;
  startDate?: InputMaybe<Scalars['Date']>;
  type: ActivityLogType;
};

export enum FindActivityLogsSort {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type FinishRegistrationDto = {
  hasAcceptedTOS: Scalars['Boolean'];
  newsletterSignup?: InputMaybe<Scalars['Boolean']>;
  rewardSoftCurrency?: InputMaybe<Scalars['Boolean']>;
  username: Scalars['String'];
};

export type ForgotPasswordDto = {
  captcha: Scalars['String'];
  email: Scalars['String'];
};

export type GqlModerateResponse = {
  __typename?: 'GQLModerateResponse';
  /** @deprecated not used anymore */
  confidence?: Maybe<Scalars['Float']>;
  moderatorVersion: Scalars['String'];
  recommendation: Scalars['String'];
  /** @deprecated not used anymore */
  recommendationDesc?: Maybe<Scalars['String']>;
  result: Scalars['String'];
  /** @deprecated not used anymore */
  resultDesc?: Maybe<Scalars['String']>;
};

export type GameAsset = {
  __typename?: 'GameAsset';
  id: Scalars['ID'];
  unlockedAt: Scalars['Date'];
};

export type GameAssetShopItem = ShopItem & {
  __typename?: 'GameAssetShopItem';
  category: Scalars['String'];
  created: Scalars['Date'];
  currency: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  gameAssetId: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  isNew: Scalars['Boolean'];
  name: Scalars['String'];
  owned: Scalars['Boolean'];
  price: Scalars['Float'];
  priceId: Scalars['String'];
  priceString: Scalars['String'];
  priceType: PriceType;
  rarity: Scalars['String'];
  type: ShopItemType;
};

/** GameKit for projects */
export enum GameKit {
  Platformer = 'PLATFORMER',
  Playground = 'PLAYGROUND',
  Shooter = 'SHOOTER'
}

export type GamificationLoginResponse = {
  __typename?: 'GamificationLoginResponse';
  productUserId: Scalars['String'];
  token: Scalars['String'];
};

export type GamificationReward = {
  currency: GamificationRewardCurrency;
  value: Scalars['Int'];
};

/** Types of rewards from the gamification service */
export enum GamificationRewardCurrency {
  Appearance = 'Appearance',
  Xp = 'XP'
}

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  NotSpecified = 'NotSpecified'
}

export type GlobalLeaderboard = {
  __typename?: 'GlobalLeaderboard';
  entries: Array<LeaderboardEntry>;
  hasNextPage: Scalars['Boolean'];
};

/** Gwen event types triggered from a client (app) */
export enum GwenClientEventType {
  AppLogin = 'APP_LOGIN'
}

export type Hero = {
  __typename?: 'Hero';
  background?: Maybe<CmsImage>;
  buttonLabel: Scalars['String'];
  header: Scalars['String'];
  id: Scalars['ID'];
  preHeader?: Maybe<Scalars['String']>;
  projectIdOrButtonLink: Scalars['String'];
  subHeader?: Maybe<Scalars['String']>;
};

export type HiberChallenge = {
  __typename?: 'HiberChallenge';
  buttonText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredGameId?: Maybe<Scalars['String']>;
  platform?: Maybe<PlatformType>;
  tag: Scalars['String'];
  thumbnail: HiberChallengeThumbnail;
  thumbnailSmall?: Maybe<HiberChallengeThumbnail>;
  title: Scalars['String'];
};

export type HiberChallengeThumbnail = {
  __typename?: 'HiberChallengeThumbnail';
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type Homeworld = {
  __typename?: 'Homeworld';
  active: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  project: Project;
  updatedAt: Scalars['Date'];
};

export type Image = {
  __typename?: 'Image';
  category: Scalars['Float'];
  comments?: Maybe<CommentConnection>;
  commentsV2?: Maybe<CommentConnection>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  file: File;
  hasTag: Scalars['Boolean'];
  height: Scalars['Float'];
  id: Scalars['ID'];
  isLiked?: Maybe<Scalars['Boolean']>;
  isReported?: Maybe<Scalars['Boolean']>;
  likes: Scalars['Float'];
  tags: Array<Scalars['String']>;
  tags_v2: Array<Tag>;
  totalViews: Scalars['Float'];
  updatedAt: Scalars['Date'];
  url: Scalars['String'];
  views: Scalars['Float'];
  width: Scalars['Float'];
};


export type ImageCommentsArgs = {
  payload: SearchDto;
};


export type ImageCommentsV2Args = {
  payload: SearchDto;
};


export type ImageHasTagArgs = {
  name: Scalars['String'];
  type?: InputMaybe<TagType>;
};

export type Inventory = {
  __typename?: 'Inventory';
  emotes: Array<Emote>;
  gameAssets: Array<GameAsset>;
  id: Scalars['ID'];
  rpmAssets: Array<RpmAsset>;
  titles?: Maybe<Array<TitleAsset>>;
};

export type JoinResponse = {
  __typename?: 'JoinResponse';
  id: Scalars['String'];
  levelMeta: ResponseLevelV2;
  project: Project;
  serverUdpAddress: Scalars['String'];
  serverWebRtcPort?: Maybe<Scalars['Int']>;
  serverWebsocketAddress: Scalars['String'];
  settings: Array<Scalars['String']>;
  type: SessionType;
  userData: ResponseUserV2;
};

export enum JoinStatus {
  Joinable = 'JOINABLE',
  MismatchedChannel = 'MISMATCHED_CHANNEL',
  MismatchedClientNetworkProtocolVersion = 'MISMATCHED_CLIENT_NETWORK_PROTOCOL_VERSION',
  MismatchedClientVersion = 'MISMATCHED_CLIENT_VERSION',
  SessionFull = 'SESSION_FULL',
  SessionNotFound = 'SESSION_NOT_FOUND',
  UnknownError = 'UNKNOWN_ERROR'
}

export type LeaderBoardEntries = {
  __typename?: 'LeaderBoardEntries';
  entries: Array<LeaderboardEntry>;
  hasNextPage: Scalars['Boolean'];
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  entries?: Maybe<LeaderBoardEntries>;
  id: Scalars['ID'];
  me?: Maybe<LeaderboardEntry>;
  project?: Maybe<Project>;
};


export type LeaderboardEntriesArgs = {
  filter: LeaderboardEntriesDto;
};


export type LeaderboardMeArgs = {
  filter?: InputMaybe<LeaderboardEntriesDto>;
};

export type LeaderboardEntriesDto = {
  cycle?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<LeaderboardGroup>;
  platform?: InputMaybe<LeaderboardPlatform>;
  skip?: InputMaybe<Scalars['Int']>;
  timespan?: InputMaybe<LeaderboardPeriod>;
};

export type LeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  attempts: Scalars['Float'];
  beaten: Scalars['Float'];
  createdAt: Scalars['Date'];
  deletedAt: Scalars['Date'];
  rank: Scalars['Float'];
  score: Scalars['Float'];
  updatedAt: Scalars['Date'];
  user: User;
};

export type LeaderboardEntryV2 = {
  __typename?: 'LeaderboardEntryV2';
  id: Scalars['Int'];
  rank: Scalars['Int'];
  score: Scalars['Float'];
  user: User;
};

/** Leaderboard group */
export enum LeaderboardGroup {
  Friends = 'FRIENDS',
  Global = 'GLOBAL'
}

export type LeaderboardMyEntry = {
  __typename?: 'LeaderboardMyEntry';
  rank: Scalars['Int'];
  score: Scalars['Float'];
};

/** Leaderboard platform */
export enum LeaderboardPeriod {
  All = 'ALL',
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Leaderboard platform */
export enum LeaderboardPlatform {
  All = 'ALL',
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export enum LeaderboardScoreKind {
  Sum = 'SUM',
  Top = 'TOP'
}

export enum LeaderboardSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type LeaderboardV2Input = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  kind?: LeaderboardScoreKind;
  order?: LeaderboardSortOrder;
  platform?: LeaderboardPlatform;
  projectId: Scalars['ID'];
  type?: Scalars['String'];
};

export type LeaderboardV2Output = {
  __typename?: 'LeaderboardV2Output';
  leaderboard: Array<LeaderboardEntryV2>;
  myResult?: Maybe<LeaderboardMyEntry>;
  pageInfo: PageInfoV2;
  type: Scalars['String'];
};

export type LinkTo = {
  __typename?: 'LinkTo';
  as: Scalars['String'];
  href: Scalars['String'];
};

export type LiveEvent = {
  __typename?: 'LiveEvent';
  id: Scalars['ID'];
  label: Scalars['String'];
  worldId: Scalars['String'];
};

export type Loadout = {
  __typename?: 'Loadout';
  avatarName: Scalars['String'];
  avatarProvider: AvatarProvider;
  avatarRpmUrl: Scalars['String'];
  emotes: Array<Scalars['String']>;
  id: Scalars['ID'];
};

export type LogActivityItem = {
  activity: PaymentActivity;
  checkoutSessionId?: InputMaybe<Scalars['String']>;
  hiberId: Scalars['String'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
};

export type LoginInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type Loot = {
  __typename?: 'Loot';
  content: LootContent;
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  refId: Scalars['Int'];
  seen: Scalars['Boolean'];
  type: LootType;
};

export type LootContent = {
  __typename?: 'LootContent';
  description?: Maybe<Scalars['String']>;
  persistence?: Maybe<Persistence>;
  rarity?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  values?: Maybe<Array<LootValues>>;
};

/** LootType */
export enum LootType {
  Appearance = 'APPEARANCE',
  Level = 'LEVEL',
  Resource = 'RESOURCE',
  Stat = 'STAT'
}

export type LootValues = {
  __typename?: 'LootValues';
  imageUrl?: Maybe<Scalars['String']>;
  subType?: Maybe<Scalars['Float']>;
  type?: Maybe<RewardType>;
  value?: Maybe<Scalars['Int']>;
};

export type MatchmakeRequest = {
  avoidSessionId?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion?: InputMaybe<Scalars['Int']>;
  clientVersion?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  type: SessionType;
};

export type MatchmakeResponse = {
  __typename?: 'MatchmakeResponse';
  id: Scalars['String'];
  sessionUrl?: Maybe<Scalars['String']>;
};

export type MetadataDto = {
  attributes: Array<Scalars['String']>;
};

export enum ModerateContentType {
  Comment = 'Comment',
  DirectMessage = 'DirectMessage',
  GameChatMessage = 'GameChatMessage',
  ProjectDescription = 'ProjectDescription',
  ProjectTags = 'ProjectTags',
  ProjectTitle = 'ProjectTitle',
  UserDescription = 'UserDescription',
  Username = 'Username'
}

export type ModerateRequest = {
  content: Scalars['String'];
  contentType: ModerateContentType;
  contextId: Scalars['String'];
};

export type ModerateUserDto = {
  email: Scalars['String'];
  id: Scalars['Float'];
  password: Scalars['String'];
};

export type MultiplayerSession = {
  __typename?: 'MultiplayerSession';
  canJoin: Scalars['Boolean'];
  clientVersion: Scalars['String'];
  closedAt: Scalars['String'];
  createdAt: Scalars['String'];
  currentProject?: Maybe<Project>;
  host: Scalars['String'];
  id: Scalars['ID'];
  joinableUsers?: Maybe<Array<User>>;
  maxPlayerCount: Scalars['Float'];
  newlyCreated?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<User>;
  ownerClientId: Scalars['Float'];
  playerCount: Scalars['Float'];
  players?: Maybe<Array<User>>;
  protocolVersion: Scalars['String'];
  publicity: Publicity;
  sessionId: Scalars['String'];
  sessionMode: MultiplayerSessionMode;
  sessionStatus: MultiplayerSessionStatus;
  sessionType: MultiplayerSessionType;
  sessionUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<MultiplayerSessionSettings>;
  updatedAt: Scalars['String'];
};

export type MultiplayerSessionConnection = {
  __typename?: 'MultiplayerSessionConnection';
  edges: Array<MultiplayerSessionEdge>;
  items: Array<MultiplayerSession>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type MultiplayerSessionCreateDto = {
  clients?: InputMaybe<Array<ClientInfo>>;
  joinablePlayerIds?: InputMaybe<Array<Scalars['ID']>>;
  maxPlayerCount: Scalars['Float'];
  ownerClientId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
  publicity: Publicity;
  sessionMode?: InputMaybe<MultiplayerSessionMode>;
  sessionStatus?: InputMaybe<MultiplayerSessionStatus>;
  sessionType?: InputMaybe<MultiplayerSessionType>;
};

export type MultiplayerSessionEdge = {
  __typename?: 'MultiplayerSessionEdge';
  cursor: Scalars['String'];
  node: MultiplayerSession;
};

/** MultiplayerSessionMode */
export enum MultiplayerSessionMode {
  Creative = 'CREATIVE',
  GhostMode = 'GHOST_MODE',
  Play = 'PLAY',
  SpectateMode = 'SPECTATE_MODE'
}

/** settings for multiplayer settings */
export type MultiplayerSessionSettings = PlatformerSessionSettings | ShooterSessionSettings;

/** MultiplayerSessionStatus */
export enum MultiplayerSessionStatus {
  Closed = 'CLOSED',
  Initializing = 'INITIALIZING',
  Offline = 'OFFLINE',
  Open = 'OPEN'
}

/** MultiplayerSessionType */
export enum MultiplayerSessionType {
  DedicatedServer = 'DEDICATED_SERVER',
  P2P = 'P2P'
}

export type MultiplayerSessionUpdateDto = {
  clients?: InputMaybe<Array<ClientInfo>>;
  maxPlayerCount?: InputMaybe<Scalars['Float']>;
  ownerClientId?: InputMaybe<Scalars['ID']>;
  playerCount?: InputMaybe<Scalars['Float']>;
  projectId?: InputMaybe<Scalars['ID']>;
  sessionId: Scalars['ID'];
  sessionMode?: InputMaybe<MultiplayerSessionMode>;
  sessionStatus?: InputMaybe<MultiplayerSessionStatus>;
  sessionType?: InputMaybe<MultiplayerSessionType>;
  settingsId?: InputMaybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptDeviceNotifications: Scalars['Boolean'];
  acceptFriendRequest: UserFriend;
  activateSecret?: Maybe<Scalars['String']>;
  addActivity: SqsCreateResponse;
  addCommentSampleToUtopia: Scalars['Boolean'];
  addFeaturedProfile?: Maybe<FeaturedProfile>;
  addGamificationRewards: Scalars['Boolean'];
  assignSecret?: Maybe<Scalars['String']>;
  awardAppearance: Scalars['Boolean'];
  awardAppearancesForUsers: Scalars['Boolean'];
  blockUser?: Maybe<BlockedUser>;
  calculateProjectTags?: Maybe<Array<Tag>>;
  cancelFriendRequest: User;
  claimHibuxReward: Scalars['Boolean'];
  clearAllWarningsForUser?: Maybe<Scalars['Boolean']>;
  closeSession: Scalars['Boolean'];
  createAppearance: Appearance;
  createBadge: Badge;
  createCheckoutSession?: Maybe<CheckoutSessionResponse>;
  createDefaultAvatar?: Maybe<Avatar>;
  createDeveloperToken: Scalars['String'];
  createFeatureToggle?: Maybe<FeatureToggle>;
  createHomeworld?: Maybe<Homeworld>;
  createMessage?: Maybe<GqlModerateResponse>;
  createMessageForUser?: Maybe<GqlModerateResponse>;
  createNonRegisteredUser: AuthResponse;
  createPlatformerSessionSettings: PlatformerSessionSettings;
  createProject?: Maybe<Project>;
  createProjectReward?: Maybe<ProjectReward>;
  /** Only for new engine. Creates project and a public session for that project. */
  createProjectWithCreativeSession: MultiplayerSession;
  /** Only for new engine. Creates public session for a project. */
  createPublicCreativeSessionForProject: MultiplayerSession;
  createReward?: Maybe<Reward>;
  createScheduledProjectUpdate: ScheduledProjectUpdate;
  createSession?: Maybe<MultiplayerSession>;
  createShooterSessionSettings: ShooterSessionSettings;
  createStashCheckoutLink: CreateStashCheckoutLinkResponse;
  createUser: AuthResponse;
  createUserWithApple: AuthResponse;
  createUserWithGoogle: AuthResponse;
  createUserWithPhoneNumber: AuthResponse;
  createZendeskTicket: Scalars['Boolean'];
  declineFriendRequest: User;
  deleteAccount?: Maybe<Scalars['Boolean']>;
  deleteAccountRequest?: Maybe<Scalars['Boolean']>;
  deleteActivity: Scalars['String'];
  deleteAllRefreshTokens: Scalars['Float'];
  deleteAppearance: Scalars['Boolean'];
  deleteComment: Comment;
  deleteFeatureToggle?: Maybe<Scalars['Boolean']>;
  deleteFeaturedFriend: Scalars['Boolean'];
  deleteLeaderboardEntry: Scalars['Boolean'];
  deleteProject?: Maybe<Project>;
  deleteProjectReward?: Maybe<Scalars['Boolean']>;
  deleteScheduledProjectUpdate: Scalars['Boolean'];
  deleteUserAccount: Scalars['Boolean'];
  editComment: Comment;
  equipAppearance?: Maybe<Appearance>;
  equipAsset?: Maybe<AssetResponse>;
  equipClassicAvatar?: Maybe<Avatar>;
  equipProduct: Loadout;
  equipRpmAvatar?: Maybe<Avatar>;
  executeScheduledProjectsUpdates: Scalars['Boolean'];
  featureFriend: FeaturedFriend;
  finishRegistration?: Maybe<User>;
  follow?: Maybe<User>;
  forkFromFile: Project;
  /** [WALLET] Get nonce for Sign In With Ethereum (SIWE) message */
  generateNonce: Scalars['String'];
  generateSkyboxFromPrompt?: Maybe<Scalars['Boolean']>;
  generateSkyboxUrl: Skybox;
  generateUploadPictureURL: Scalars['String'];
  getDeleteAccountToken?: Maybe<Scalars['String']>;
  linkRpmAccount?: Maybe<Avatar>;
  /** [WALLET] Link Ethereum wallet to authenticated user using Sign In With Ethereum (SIWE) protocol. */
  linkWallet: Scalars['Boolean'];
  lockAssetForUser?: Maybe<AssetResponse>;
  logActivity?: Maybe<PaymentItemResponse>;
  loginOrCreateRegistrationTokenWithPhoneNumber: PhoneNumberAuthResponse;
  loginToGamificationService: GamificationLoginResponse;
  loginUser?: Maybe<AuthResponse>;
  logoutAllDevices: Scalars['Float'];
  logoutUser: Scalars['Boolean'];
  markActivitiesAsRead: Scalars['Boolean'];
  mintToken: Token;
  moderateContent?: Maybe<Scalars['Boolean']>;
  moderateDirectMessage: GqlModerateResponse;
  moderateUserAccount: User;
  muteChat?: Maybe<MutedChat>;
  newRpmUserByUserId: NewRpmUserByUserIdResponse;
  pinComment?: Maybe<Comment>;
  playerJoined: Scalars['Boolean'];
  playerLeft: Scalars['Boolean'];
  postComment?: Maybe<Comment>;
  previewAsset?: Maybe<AssetResponse>;
  publishProject?: Maybe<Project>;
  purchaseProductWithSoftCurrency?: Maybe<ShopItem>;
  /** Returns new access token if refresh token still valid */
  refreshAccessToken: Scalars['String'];
  refreshSecret?: Maybe<Scalars['String']>;
  removeActiveSessionsFromMatchmake?: Maybe<Scalars['Boolean']>;
  removeDescription?: Maybe<User>;
  removeDeviceNotifications: Scalars['Boolean'];
  removeFeaturedProfile?: Maybe<Scalars['Boolean']>;
  removeFriend: User;
  removeProfileBackground: User;
  removeProfilePicture?: Maybe<Scalars['Boolean']>;
  removeSocialMediaType?: Maybe<SocialMedia>;
  removeTagFromContent: Scalars['Boolean'];
  removeThumbnail: Scalars['Boolean'];
  reportContent?: Maybe<ContentUnion>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  resetPasswordBySecretRequest?: Maybe<Scalars['String']>;
  resetPasswordRequest?: Maybe<Scalars['Boolean']>;
  rotateChallenges: Array<Challenge>;
  sendFriendRequest: User;
  sendGamificationEvent: Scalars['Boolean'];
  sendSmsAuthCode: SmsResponse;
  serverError: Scalars['Boolean'];
  serverReady: Scalars['Boolean'];
  setDisableComments: Project;
  setEmotes: Loadout;
  setFriendRequestsSeen: Scalars['Boolean'];
  setProjectAuthor: Project;
  setPublishStatus?: Maybe<Project>;
  setSeenBadges: Scalars['Boolean'];
  setSeenSuspension?: Maybe<Suspension>;
  setUserLevel: SetUserLevelResult;
  setUserRole: Scalars['Boolean'];
  signInWithApple?: Maybe<AuthResponse>;
  /** [WALLET] Sign up or sign in with Ethereum wallet using Sign In With Ethereum (SIWE) protocol. */
  signInWithEthereum: AuthResponse;
  signInWithGoogle?: Maybe<AuthResponse>;
  signInWithGoogleCode?: Maybe<AuthResponse>;
  status: UpdatedTimeSpentDto;
  suspendUser: Suspension;
  tagContent: Scalars['Boolean'];
  tagContentMany: Scalars['Boolean'];
  tagManyContentMany: Array<Array<ContentTagRelation>>;
  tagSelf: Scalars['Boolean'];
  toggleLike?: Maybe<ContentUnion>;
  unblockUser?: Maybe<Scalars['Boolean']>;
  unequipAppearance?: Maybe<Scalars['Boolean']>;
  unfollow?: Maybe<User>;
  unlockAndEquipAssetToUser: UnlockAndEquipAssetToUserResponse;
  unlockAssetsForUsers?: Maybe<Array<AssetResponse>>;
  unlockBadgeForUser?: Maybe<Badge>;
  unlockRpmAssetAchievement?: Maybe<Avatar>;
  unmuteChat?: Maybe<Scalars['Boolean']>;
  updateAchievementPublicity: PrivacySettings;
  updateAppearance: Appearance;
  updateBirthdate?: Maybe<User>;
  updateChatMessageMetadata: ChatMessageMetadata;
  updateContentfulCache?: Maybe<Scalars['Boolean']>;
  updateDescription?: Maybe<User>;
  updateDirectMessagingPublicity: PrivacySettings;
  updateFavoriteGamesPublicity: PrivacySettings;
  updateFeatureToggle?: Maybe<FeatureToggle>;
  updateFeedback: Scalars['Boolean'];
  updateFriendsPublicity: PrivacySettings;
  updateLootSeenStatus: Scalars['Boolean'];
  updateNotificationVisitedStatus: Array<Notification>;
  updateOnlyFriendsInMultiplayer: PrivacySettings;
  /** Only for new engine. Updates amount of players in a room. */
  updatePlayerCountForSession: MultiplayerSession;
  updateProfileBackground: Scalars['String'];
  updateProject?: Maybe<Project>;
  updateProjectReward?: Maybe<ProjectReward>;
  updateReportStatus?: Maybe<ReportEntry>;
  updateResource: UpdateResourceResult;
  updateSession?: Maybe<MultiplayerSession>;
  updateSocialMedia?: Maybe<SocialMedia>;
  updateUserEmail?: Maybe<User>;
  updateUserPassword?: Maybe<Scalars['Boolean']>;
  updateUserTitle?: Maybe<User>;
  updateUsername?: Maybe<User>;
  verifyEmail: Scalars['Boolean'];
  wipeLeaderboardForProject: Scalars['Boolean'];
};


export type MutationAcceptDeviceNotificationsArgs = {
  deviceToken: Scalars['String'];
  firebaseToken: Scalars['String'];
};


export type MutationAcceptFriendRequestArgs = {
  targetId: Scalars['Float'];
};


export type MutationActivateSecretArgs = {
  password: Scalars['String'];
};


export type MutationAddActivityArgs = {
  data: AddActivityInput;
};


export type MutationAddCommentSampleToUtopiaArgs = {
  commentId: Scalars['ID'];
};


export type MutationAddFeaturedProfileArgs = {
  username: Scalars['String'];
};


export type MutationAddGamificationRewardsArgs = {
  payload: AddGamificationRewardsDto;
};


export type MutationAwardAppearanceArgs = {
  avatarId: Scalars['Float'];
  username: Scalars['String'];
};


export type MutationAwardAppearancesForUsersArgs = {
  avatarIds: Array<Scalars['Float']>;
  usernames: Array<Scalars['String']>;
};


export type MutationBlockUserArgs = {
  payload: BlockUserDto;
};


export type MutationCalculateProjectTagsArgs = {
  payload: CalculateProjectTagsDto;
};


export type MutationCancelFriendRequestArgs = {
  targetId: Scalars['Float'];
};


export type MutationClearAllWarningsForUserArgs = {
  userId: Scalars['ID'];
};


export type MutationCloseSessionArgs = {
  sessionId: Scalars['String'];
};


export type MutationCreateAppearanceArgs = {
  input: CreateAppearanceDto;
};


export type MutationCreateBadgeArgs = {
  input: CreateBadgeDto;
};


export type MutationCreateCheckoutSessionArgs = {
  embed?: InputMaybe<Scalars['Boolean']>;
  priceId: Scalars['String'];
};


export type MutationCreateDefaultAvatarArgs = {
  input: DefaultAvatarInput;
};


export type MutationCreateFeatureToggleArgs = {
  input: FeatureToggleInputDto;
};


export type MutationCreateHomeworldArgs = {
  projectId: Scalars['ID'];
};


export type MutationCreateMessageArgs = {
  payload: CreateChatMessageDto;
};


export type MutationCreateMessageForUserArgs = {
  payload: CreateChatMessageForUserDto;
};


export type MutationCreateNonRegisteredUserArgs = {
  birthdate?: InputMaybe<Scalars['Date']>;
};


export type MutationCreatePlatformerSessionSettingsArgs = {
  payload: CreatePlatformerSessionSettingsDto;
  sessionId: Scalars['ID'];
};


export type MutationCreateProjectArgs = {
  payload: CreateProjectDto;
};


export type MutationCreateProjectRewardArgs = {
  projectReward: ProjectRewardInputDto;
};


export type MutationCreateProjectWithCreativeSessionArgs = {
  channel?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion?: InputMaybe<Scalars['String']>;
  clientVersion?: InputMaybe<Scalars['String']>;
  forkId?: InputMaybe<Scalars['Float']>;
};


export type MutationCreatePublicCreativeSessionForProjectArgs = {
  channel?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion: Scalars['String'];
  clientVersion: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationCreateRewardArgs = {
  input: CreateRewardDto;
};


export type MutationCreateScheduledProjectUpdateArgs = {
  payload: CreateScheduledProjectUpdateDto;
};


export type MutationCreateSessionArgs = {
  payload: MultiplayerSessionCreateDto;
};


export type MutationCreateShooterSessionSettingsArgs = {
  payload: CreateShooterSessionSettingsDto;
  sessionId: Scalars['ID'];
};


export type MutationCreateStashCheckoutLinkArgs = {
  productId: Scalars['String'];
};


export type MutationCreateUserArgs = {
  payload: CreateUserDto;
};


export type MutationCreateUserWithAppleArgs = {
  payload: CreateAppleUserDto;
};


export type MutationCreateUserWithGoogleArgs = {
  payload: CreateGoogleUserDto;
};


export type MutationCreateUserWithPhoneNumberArgs = {
  input: CreateUserWithoutPasswordDto;
  registrationToken: Scalars['String'];
};


export type MutationCreateZendeskTicketArgs = {
  payload: CreateZendeskTicketDto;
};


export type MutationDeclineFriendRequestArgs = {
  targetId: Scalars['Float'];
};


export type MutationDeleteAccountArgs = {
  token: Scalars['String'];
};


export type MutationDeleteActivityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAppearanceArgs = {
  appearanceId: Scalars['Float'];
};


export type MutationDeleteCommentArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteFeatureToggleArgs = {
  name: Scalars['String'];
};


export type MutationDeleteFeaturedFriendArgs = {
  targetId: Scalars['Float'];
};


export type MutationDeleteLeaderboardEntryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProjectRewardArgs = {
  projectId: Scalars['ID'];
  rewardType: ProjectRewardType;
};


export type MutationDeleteScheduledProjectUpdateArgs = {
  key: DeleteScheduledProjectUpdateKey;
};


export type MutationDeleteUserAccountArgs = {
  id: Scalars['Float'];
};


export type MutationEditCommentArgs = {
  payload: UpdateCommentDto;
};


export type MutationEquipAppearanceArgs = {
  appearanceId: Scalars['ID'];
};


export type MutationEquipAssetArgs = {
  input: EquipAssetInput;
};


export type MutationEquipClassicAvatarArgs = {
  name: Scalars['String'];
};


export type MutationEquipProductArgs = {
  id: Scalars['ID'];
};


export type MutationEquipRpmAvatarArgs = {
  avatarId: Scalars['String'];
};


export type MutationExecuteScheduledProjectsUpdatesArgs = {
  scheduledUpdates: Array<ExecuteScheduledProjectUpdateDto>;
};


export type MutationFeatureFriendArgs = {
  targetId: Scalars['Float'];
};


export type MutationFinishRegistrationArgs = {
  input: FinishRegistrationDto;
};


export type MutationFollowArgs = {
  targetId: Scalars['Float'];
};


export type MutationForkFromFileArgs = {
  fileId: Scalars['String'];
};


export type MutationGenerateSkyboxFromPromptArgs = {
  prompt: Scalars['String'];
  sessionId: Scalars['ID'];
};


export type MutationGenerateSkyboxUrlArgs = {
  prompt: Scalars['String'];
};


export type MutationGenerateUploadPictureUrlArgs = {
  format: Scalars['String'];
};


export type MutationLinkRpmAccountArgs = {
  accountUserId: Scalars['String'];
};


export type MutationLinkWalletArgs = {
  message: Scalars['String'];
  signature: Scalars['String'];
  walletType: Scalars['String'];
};


export type MutationLockAssetForUserArgs = {
  input: AssetLockForUserInput;
};


export type MutationLogActivityArgs = {
  payload: LogActivityItem;
};


export type MutationLoginOrCreateRegistrationTokenWithPhoneNumberArgs = {
  code: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationLoginUserArgs = {
  login: LoginInput;
};


export type MutationLogoutAllDevicesArgs = {
  userId: Scalars['String'];
};


export type MutationLogoutUserArgs = {
  refreshToken: Scalars['String'];
};


export type MutationMintTokenArgs = {
  address: Scalars['String'];
  claimId: Scalars['ID'];
};


export type MutationModerateContentArgs = {
  payload: ModerateRequest;
};


export type MutationModerateDirectMessageArgs = {
  chatId: Scalars['String'];
  message: Scalars['String'];
};


export type MutationModerateUserAccountArgs = {
  payload: ModerateUserDto;
};


export type MutationMuteChatArgs = {
  payload: MutedChatDto;
};


export type MutationNewRpmUserByUserIdArgs = {
  userId: Scalars['ID'];
};


export type MutationPinCommentArgs = {
  commentId: Scalars['Float'];
  contentId: Scalars['Float'];
};


export type MutationPlayerJoinedArgs = {
  request: PlayerActivityRequest;
};


export type MutationPlayerLeftArgs = {
  request: PlayerActivityRequest;
};


export type MutationPostCommentArgs = {
  payload: PostCommentDto;
};


export type MutationPreviewAssetArgs = {
  input: PreviewAssetInput;
};


export type MutationPublishProjectArgs = {
  payload: PublishProjectDto;
};


export type MutationPurchaseProductWithSoftCurrencyArgs = {
  productId: Scalars['String'];
};


export type MutationRefreshAccessTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRefreshSecretArgs = {
  password: Scalars['String'];
};


export type MutationRemoveActiveSessionsFromMatchmakeArgs = {
  projectId: Scalars['ID'];
};


export type MutationRemoveDescriptionArgs = {
  id: Scalars['Float'];
};


export type MutationRemoveDeviceNotificationsArgs = {
  deviceToken: Scalars['String'];
};


export type MutationRemoveFeaturedProfileArgs = {
  id: Scalars['Float'];
};


export type MutationRemoveFriendArgs = {
  targetId: Scalars['Float'];
};


export type MutationRemoveProfileBackgroundArgs = {
  userId: Scalars['Float'];
};


export type MutationRemoveProfilePictureArgs = {
  id: Scalars['Float'];
};


export type MutationRemoveSocialMediaTypeArgs = {
  id: Scalars['Float'];
  type: SocialMediaType;
};


export type MutationRemoveTagFromContentArgs = {
  payload: DeleteTagFromContentDto;
};


export type MutationRemoveThumbnailArgs = {
  id: Scalars['ID'];
};


export type MutationReportContentArgs = {
  payload: CreateReportDto;
};


export type MutationResetPasswordArgs = {
  payload: ResetPasswordDto;
};


export type MutationResetPasswordBySecretRequestArgs = {
  payload: UserSecretDto;
};


export type MutationResetPasswordRequestArgs = {
  payload: ForgotPasswordDto;
};


export type MutationRotateChallengesArgs = {
  persistence: Persistence;
};


export type MutationSendFriendRequestArgs = {
  targetId: Scalars['Float'];
};


export type MutationSendGamificationEventArgs = {
  payload: SendGamificationClientEventDto;
};


export type MutationSendSmsAuthCodeArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationServerErrorArgs = {
  sessionError: Scalars['String'];
  sessionId: Scalars['String'];
};


export type MutationServerReadyArgs = {
  sessionId: Scalars['String'];
};


export type MutationSetDisableCommentsArgs = {
  disableComments: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationSetEmotesArgs = {
  emotes: Array<Scalars['String']>;
};


export type MutationSetProjectAuthorArgs = {
  newOwnerId: Scalars['Float'];
  projectId: Scalars['ID'];
};


export type MutationSetPublishStatusArgs = {
  id: Scalars['ID'];
  isPublished: Scalars['Boolean'];
};


export type MutationSetSeenBadgesArgs = {
  badgeIds: Array<Scalars['ID']>;
};


export type MutationSetSeenSuspensionArgs = {
  id: Scalars['ID'];
};


export type MutationSetUserLevelArgs = {
  level: Scalars['Float'];
  userId: Scalars['ID'];
};


export type MutationSetUserRoleArgs = {
  role: Scalars['Int'];
  userId: Scalars['ID'];
};


export type MutationSignInWithAppleArgs = {
  appleAuthCode: Scalars['String'];
};


export type MutationSignInWithEthereumArgs = {
  message: Scalars['String'];
  signature: Scalars['String'];
  walletType: Scalars['String'];
};


export type MutationSignInWithGoogleArgs = {
  accessToken: Scalars['String'];
};


export type MutationSignInWithGoogleCodeArgs = {
  code: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
};


export type MutationStatusArgs = {
  body: RecordTimeSpentDto;
};


export type MutationSuspendUserArgs = {
  payload: SuspendUserDto;
};


export type MutationTagContentArgs = {
  payload: CreateTagDto;
};


export type MutationTagContentManyArgs = {
  payload: CreateTagsDto;
};


export type MutationTagManyContentManyArgs = {
  payload: CreateManyTagsForManyContentDto;
};


export type MutationTagSelfArgs = {
  payload: TagIdentifierInput;
};


export type MutationToggleLikeArgs = {
  id: Scalars['ID'];
  type: ContentType;
};


export type MutationUnblockUserArgs = {
  payload: BlockUserDto;
};


export type MutationUnequipAppearanceArgs = {
  type: Scalars['Float'];
};


export type MutationUnfollowArgs = {
  targetId: Scalars['Float'];
};


export type MutationUnlockAndEquipAssetToUserArgs = {
  input: AssetUnlockAndEquipInput;
};


export type MutationUnlockAssetsForUsersArgs = {
  input: AssetUnlockForUsersInput;
};


export type MutationUnlockBadgeForUserArgs = {
  badge: Scalars['String'];
  username: Scalars['String'];
};


export type MutationUnlockRpmAssetAchievementArgs = {
  id: Scalars['ID'];
};


export type MutationUnmuteChatArgs = {
  payload: MutedChatDto;
};


export type MutationUpdateAchievementPublicityArgs = {
  payload: UpdateAchievementPublicityDto;
};


export type MutationUpdateAppearanceArgs = {
  input: UpdateAppearanceDto;
};


export type MutationUpdateBirthdateArgs = {
  birthdate?: InputMaybe<Scalars['Date']>;
};


export type MutationUpdateChatMessageMetadataArgs = {
  payload: ChatMessageMetadataDto;
};


export type MutationUpdateDescriptionArgs = {
  description: Scalars['String'];
};


export type MutationUpdateDirectMessagingPublicityArgs = {
  payload: UpdatePublicityDto;
};


export type MutationUpdateFavoriteGamesPublicityArgs = {
  payload: UpdatePublicityDto;
};


export type MutationUpdateFeatureToggleArgs = {
  input: FeatureToggleInputDto;
};


export type MutationUpdateFeedbackArgs = {
  correlation_id: Scalars['String'];
  rating: Scalars['Int'];
};


export type MutationUpdateFriendsPublicityArgs = {
  payload: UpdatePublicityDto;
};


export type MutationUpdateLootSeenStatusArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  seen: Scalars['Boolean'];
};


export type MutationUpdateNotificationVisitedStatusArgs = {
  payload: UpdateVisitiedDto;
};


export type MutationUpdateOnlyFriendsInMultiplayerArgs = {
  onlyFriendsInMultiplayer: Scalars['Boolean'];
};


export type MutationUpdatePlayerCountForSessionArgs = {
  playerCount: Scalars['Float'];
  sessionId: Scalars['ID'];
};


export type MutationUpdateProfileBackgroundArgs = {
  format: Scalars['String'];
};


export type MutationUpdateProjectArgs = {
  payload: UpdateProjectDto;
};


export type MutationUpdateProjectRewardArgs = {
  projectReward: ProjectRewardInputDto;
};


export type MutationUpdateReportStatusArgs = {
  payload: UpdateReportDto;
};


export type MutationUpdateResourceArgs = {
  input: UpdateResourceDto;
};


export type MutationUpdateSessionArgs = {
  payload: MultiplayerSessionUpdateDto;
};


export type MutationUpdateSocialMediaArgs = {
  input: UpdateSocialMediaDto;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateUserPasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdateUserTitleArgs = {
  title: Scalars['String'];
};


export type MutationUpdateUsernameArgs = {
  input: UpdateUsernameInput;
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String'];
};


export type MutationWipeLeaderboardForProjectArgs = {
  projectId: Scalars['ID'];
};

export type MutedChat = {
  __typename?: 'MutedChat';
  chatId: Scalars['ID'];
  id: Scalars['ID'];
  mutedAt: Scalars['Date'];
  user: User;
  userId: Scalars['ID'];
};

export type MutedChatDto = {
  chatId: Scalars['ID'];
};

export type NewRpmUserByUserIdResponse = {
  __typename?: 'NewRpmUserByUserIdResponse';
  success: Scalars['Boolean'];
};

export type NewsArticle = {
  __typename?: 'NewsArticle';
  article: Scalars['String'];
  ctaButtonLink?: Maybe<Scalars['String']>;
  ctaButtonText?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  iosCtaButtonLink?: Maybe<Scalars['String']>;
  modalButtonText?: Maybe<Scalars['String']>;
  modalText?: Maybe<Scalars['String']>;
  modalTitle?: Maybe<Scalars['String']>;
  openModal?: Maybe<Scalars['Boolean']>;
  showForLoggedIn?: Maybe<Scalars['Boolean']>;
  showForLoggedOut?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['Date']>;
  thumbnail?: Maybe<ContentfulImage>;
  title: Scalars['String'];
};

export type NewsFeed = {
  __typename?: 'NewsFeed';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  receiver: User;
  receiverId: Scalars['Int'];
  sender: User;
  senderId: Scalars['Int'];
  sourceContentType?: Maybe<ContentType>;
  sourceId: Scalars['ID'];
  type: NotificationsTypes;
  visited?: Maybe<Scalars['Boolean']>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type NotificationContent = {
  __typename?: 'NotificationContent';
  customData?: Maybe<CustomData>;
  image?: Maybe<Image>;
  linkTo: LinkTo;
  title?: Maybe<Scalars['String']>;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  content: NotificationContent;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  lastUsers: Array<User>;
  message?: Maybe<Scalars['String']>;
  read: Scalars['Boolean'];
  sourceContent?: Maybe<ContentUnion>;
  sourceContentType?: Maybe<Scalars['Int']>;
  sourceId: Scalars['ID'];
  total: Scalars['Float'];
  type: Scalars['Int'];
  visited?: Maybe<Scalars['Boolean']>;
};

export type Page = {
  __typename?: 'Page';
  id: Scalars['ID'];
  modules: Array<PageModule>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor: Scalars['String'];
};

export type PageInfoV2 = {
  __typename?: 'PageInfoV2';
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor: Scalars['String'];
};

/** Available modules for a module page */
export type PageModule = Banner | Carousel | ChallengeBanner | Hero | NewsFeed | ProjectFeedRegular | ProjectFeedSpecific | Section | SessionFeed | UserFeedOnlineFriends | UserFeedRegular;

export enum PaymentActivity {
  FailCancelPaymentIntent = 'FailCancelPaymentIntent',
  FailCapturePaymentIntent = 'FailCapturePaymentIntent',
  FailChargeCaptured = 'FailChargeCaptured',
  FailCompleteCheckoutSession = 'FailCompleteCheckoutSession',
  FailCreateCheckoutSession = 'FailCreateCheckoutSession',
  FailCreateCustomer = 'FailCreateCustomer',
  FailCreatePaymentIntent = 'FailCreatePaymentIntent',
  FailFreeAssetUnlock = 'FailFreeAssetUnlock',
  FailHandlePaymentIntent = 'FailHandlePaymentIntent',
  FailRpmLock = 'FailRpmLock',
  FailRpmLockAlreadyLocked = 'FailRpmLockAlreadyLocked',
  FailRpmUnlock = 'FailRpmUnlock',
  FailRpmUnlockAlreadyUnlocked = 'FailRpmUnlockAlreadyUnlocked',
  FailUpdatePaymentIntent = 'FailUpdatePaymentIntent',
  SuccessCancelPaymentIntent = 'SuccessCancelPaymentIntent',
  SuccessCapturePaymentIntent = 'SuccessCapturePaymentIntent',
  SuccessChargeCaptured = 'SuccessChargeCaptured',
  SuccessCompleteCheckoutSession = 'SuccessCompleteCheckoutSession',
  SuccessCreateCheckoutSession = 'SuccessCreateCheckoutSession',
  SuccessCreateCustomer = 'SuccessCreateCustomer',
  SuccessCreatePaymentIntent = 'SuccessCreatePaymentIntent',
  SuccessFreeAssetUnlock = 'SuccessFreeAssetUnlock',
  SuccessHandlePaymentIntent = 'SuccessHandlePaymentIntent',
  SuccessRpmLock = 'SuccessRpmLock',
  SuccessRpmUnlock = 'SuccessRpmUnlock',
  SuccessStashCheckoutCompleted = 'SuccessStashCheckoutCompleted',
  SuccessStashCheckoutCreated = 'SuccessStashCheckoutCreated',
  SuccessStashPaymentCompleted = 'SuccessStashPaymentCompleted',
  SuccessUpdatePaymentIntent = 'SuccessUpdatePaymentIntent'
}

export type PaymentItemResponse = {
  __typename?: 'PaymentItemResponse';
  activity: Scalars['String'];
  hiberId: Scalars['ID'];
  paymentIntentId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  timestamp: Scalars['String'];
};

export enum PaymentProvider {
  Stripe = 'Stripe'
}

/** data persistence types */
export enum Persistence {
  Account = 'ACCOUNT',
  Daily = 'DAILY'
}

/** Object representing login or sign up with phone response */
export type PhoneNumberAuthResponse = {
  __typename?: 'PhoneNumberAuthResponse';
  authResponse?: Maybe<AuthResponse>;
  registrationToken?: Maybe<Scalars['String']>;
};

/** Platform */
export enum Platform {
  App = 'APP',
  Web = 'WEB'
}

export enum PlatformType {
  All = 'ALL',
  App = 'APP',
  Web = 'WEB'
}

/** different game modes */
export enum PlatformerGameMode {
  Speedrun = 'SPEEDRUN'
}

export type PlatformerSessionSettings = {
  __typename?: 'PlatformerSessionSettings';
  gameMode: Scalars['String'];
  id: Scalars['ID'];
  sessionId: Scalars['ID'];
  timeLimit?: Maybe<Scalars['Int']>;
  winCondition: Scalars['String'];
  winConditionValue?: Maybe<Scalars['Int']>;
};

/** types of Win condition */
export enum PlatformerWinCondition {
  BestTime = 'BEST_TIME'
}

export type PlayerActivityRequest = {
  sessionId: Scalars['String'];
  sessionUser: SessionUser;
};

export type PostCommentDto = {
  contentId: Scalars['ID'];
  contentType: ContentType;
  text: Scalars['String'];
};

export type PreviewAssetInput = {
  assetId: Scalars['String'];
  avatarId: Scalars['String'];
};

export enum PriceType {
  Money = 'Money',
  SoftCurrency = 'SoftCurrency'
}

export type PrivacySettings = {
  __typename?: 'PrivacySettings';
  achievementPublicity: Scalars['Float'];
  directMessagingPublicity?: Maybe<Scalars['Float']>;
  favoriteGamesArePublic?: Maybe<Scalars['Float']>;
  friendsArePublic?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  onlyFriendsInMultiplayer: Scalars['Boolean'];
  user: User;
  userId: Scalars['Int'];
};

export type Project = {
  __typename?: 'Project';
  /**
   * User must satisify at least one of the conditions listed in the ACL.
   * If the list is empty, the world is unrestricted.
   */
  accessControlList: Array<AccessControlItem>;
  activeFriends: Array<User>;
  activePlayers: Array<User>;
  author: User;
  badges: Array<Badge>;
  canEdit: Scalars['Boolean'];
  categories: Array<Scalars['String']>;
  category: Scalars['Float'];
  comments?: Maybe<CommentConnection>;
  commentsV2?: Maybe<CommentConnection>;
  completionRate: Scalars['Float'];
  createdAt: Scalars['String'];
  dataUrl: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  difficulty: Scalars['Float'];
  disableComments: Scalars['Boolean'];
  engineVersion: Scalars['Float'];
  featured: Scalars['Boolean'];
  forkId?: Maybe<Scalars['ID']>;
  gameKit: GameKit;
  hasNotified: Scalars['Boolean'];
  hasTag: Scalars['Boolean'];
  history: Array<File>;
  id: Scalars['ID'];
  iframeUrl?: Maybe<Scalars['String']>;
  isEmpty: Scalars['Boolean'];
  isHomeworld: Scalars['Boolean'];
  isLiked?: Maybe<Scalars['Boolean']>;
  isOwner: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isReported?: Maybe<Scalars['Boolean']>;
  /**
   * Shorthand to check if ACL is populated, i.e. if the world is restricted.
   * Requested by the game team
   */
  isRestricted: Scalars['Boolean'];
  leaderboard?: Maybe<Leaderboard>;
  likes: Scalars['Float'];
  locked: Scalars['Boolean'];
  moduleCount: Scalars['Float'];
  numberOfActivePlayersV2: Scalars['Int'];
  playUrl?: Maybe<Scalars['String']>;
  projectType: ProjectType;
  publishedAt?: Maybe<Scalars['Date']>;
  reFeaturedAt?: Maybe<Scalars['Date']>;
  rePublishedAt?: Maybe<Scalars['Date']>;
  tags?: Maybe<Array<Scalars['String']>>;
  tags_v2: Array<Tag>;
  thumbnail?: Maybe<Thumbnail>;
  thumbnails: Array<Thumbnail>;
  timespent: Scalars['Float'];
  timespentBuilding: Scalars['Float'];
  title: Scalars['String'];
  totalViews: Scalars['Float'];
  updatedAt: Scalars['Date'];
  viewUrl?: Maybe<Scalars['String']>;
  views: Scalars['Float'];
  visibility: Scalars['Float'];
  youtubeId?: Maybe<Scalars['String']>;
};


export type ProjectActiveFriendsArgs = {
  limit?: Scalars['Int'];
};


export type ProjectActivePlayersArgs = {
  limit?: Scalars['Int'];
};


export type ProjectCommentsArgs = {
  payload: SearchDto;
};


export type ProjectCommentsV2Args = {
  payload: SearchDto;
};


export type ProjectDataUrlArgs = {
  public?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectHasTagArgs = {
  name: Scalars['String'];
  type?: InputMaybe<TagType>;
};

/** Resonse to query `requestAccessToProject` */
export type ProjectAccessResponse = {
  __typename?: 'ProjectAccessResponse';
  /** Access granted? */
  granted: Scalars['Boolean'];
  /** Reason why access was granted or denied */
  reason?: Maybe<AccessControlReason>;
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  edges: Array<ProjectEdge>;
  items: Array<Project>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  cursor: Scalars['String'];
  node: Project;
};

export type ProjectFeedPage = {
  __typename?: 'ProjectFeedPage';
  background?: Maybe<CmsImage>;
  description?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<FeedFilter>>;
  forkIds?: Maybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  metaTags?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  sortBy: Array<SortBy>;
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type ProjectFeedRegular = {
  __typename?: 'ProjectFeedRegular';
  directPlayOnClick: Scalars['Boolean'];
  filters?: Maybe<Array<FeedFilter>>;
  forkIds?: Maybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  layout: FeedCardLayout;
  metaTags?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<ProjectFeedPage>;
  quantity: Scalars['Float'];
  showAuthor?: Maybe<Scalars['Boolean']>;
  sortBy: SortBy;
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type ProjectFeedSpecific = {
  __typename?: 'ProjectFeedSpecific';
  directPlayOnClick: Scalars['Boolean'];
  id: Scalars['ID'];
  layout: FeedCardLayout;
  page?: Maybe<ProjectFeedPage>;
  projectIds: Array<Scalars['String']>;
  showAuthor?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type ProjectReward = {
  __typename?: 'ProjectReward';
  project: Project;
  projectId: Scalars['ID'];
  rewardType: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type ProjectRewardInputDto = {
  projectId: Scalars['ID'];
  rewardType: ProjectRewardType;
  values: Array<Scalars['String']>;
};

/** types of project rewards */
export enum ProjectRewardType {
  Appearance = 'APPEARANCE',
  Badge = 'BADGE',
  Resource = 'RESOURCE',
  Stat = 'STAT'
}

export type ProjectSearchDto = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['String']>;
  filterFavorites?: InputMaybe<Scalars['Boolean']>;
  filterFollowing?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Float']>;
  forkIds?: InputMaybe<Array<Scalars['ID']>>;
  gameKits?: InputMaybe<Array<GameKit>>;
  includeContentIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Float']>;
  maxEngineVersion?: Scalars['Int'];
  meta?: InputMaybe<Array<Scalars['String']>>;
  minEngineVersion?: Scalars['Int'];
  projectGameKit?: InputMaybe<GameKit>;
  projectType?: InputMaybe<ProjectType>;
  requireRelevancy?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<SortBy>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ProjectTemplate = {
  __typename?: 'ProjectTemplate';
  category?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isNew: Scalars['Boolean'];
  project?: Maybe<Project>;
  projectId: Scalars['Float'];
};

/** ProjectType for games */
export enum ProjectType {
  FreeMode = 'FREE_MODE',
  GridMode = 'GRID_MODE',
  OldStudio = 'OLD_STUDIO'
}

export type PublishProjectDto = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  difficulty?: InputMaybe<Scalars['Int']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  tags: Array<Scalars['String']>;
  thumbnailId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  visibility: Scalars['Int'];
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  activeSuspensionList?: Maybe<ActiveSuspensionList>;
  activities: ActivitiesResponse;
  activitiesByGroup: ActivitiesResponse;
  activityLogs: Array<ActivityLog>;
  allAppearances?: Maybe<Array<Appearance>>;
  allWarningsForUser?: Maybe<Array<Suspension>>;
  appearance?: Maybe<Appearance>;
  appearances: AppearanceConnection;
  avatar?: Maybe<Avatar>;
  badge?: Maybe<Badge>;
  badges?: Maybe<Array<Badge>>;
  buildInfo: BuildInfo;
  campaign?: Maybe<Campaign>;
  checkDeleteAccountToken?: Maybe<Scalars['Boolean']>;
  checkIsStashCheckoutCompleted?: Maybe<Scalars['Boolean']>;
  checkResetPasswordToken?: Maybe<Scalars['Boolean']>;
  checkVerifyEmailToken?: Maybe<Scalars['Boolean']>;
  checkoutSessionStatus?: Maybe<StripeCheckoutSessionStatus>;
  contentfulYoutubeLinks?: Maybe<ContentfulYoutubeLinks>;
  criteriasForBadgeGroupId: Array<Criteria>;
  dailyChallenges?: Maybe<Array<Challenge>>;
  /** Placeholder */
  doNothing?: Maybe<Scalars['Boolean']>;
  executeSnippet: SnippetExecutionResponse;
  featuredFriends: FeaturedFriendConnection;
  featuredMaps?: Maybe<ContentfulFeaturedMaps>;
  featuredProfiles?: Maybe<Array<FeaturedProfile>>;
  featuredProjects: Array<Project>;
  fetchHiberChallenges: Array<HiberChallenge>;
  fetchUsersMetaData: Array<User>;
  findAllFeatureToggles?: Maybe<Array<FeatureToggle>>;
  findAllFeaturedProfiles?: Maybe<Array<FeaturedProfile>>;
  findAllProjectRewards?: Maybe<Array<ProjectReward>>;
  findFeatureToggle?: Maybe<FeatureToggle>;
  findProjectRewards?: Maybe<Array<ProjectReward>>;
  findUsernameUpdatedAt: UsernameUpdatedAt;
  friendRequestAmount?: Maybe<Scalars['Int']>;
  frontPageContent: ContentfulFrontPageContent;
  gameTemplates: Array<Project>;
  getOpenSessions: Array<MultiplayerSession>;
  /** Only for new engine. Creates or retrieves an existing public session for a project. */
  getOrCreatePublicSessionForProject: MultiplayerSession;
  /**
   * Only for new engine. Creates or retrieves an existing public session for a project.
   * @deprecated Not a good name, will mutate if no session is found, will be removed after 2022-11-02
   */
  getPublicSessionForProject: MultiplayerSession;
  getScheduledProjectUpdates: Array<ScheduledProjectUpdate>;
  getSession?: Maybe<MultiplayerSession>;
  getSessionV3: Session;
  getSessionsByGameKit: MultiplayerSessionConnection;
  getSessionsByProjectId: MultiplayerSessionConnection;
  getUsersInSessionsV2: Array<User>;
  globalLeaderboard?: Maybe<GlobalLeaderboard>;
  googleUser?: Maybe<User>;
  hasSecret?: Maybe<Scalars['Boolean']>;
  hasUnlockedAssets: Array<Scalars['Boolean']>;
  health?: Maybe<Scalars['String']>;
  isFeatureEnabled?: Maybe<Scalars['Boolean']>;
  isUsernameAvailable: Scalars['Boolean'];
  join: JoinResponse;
  latestHiberChallenge?: Maybe<HiberChallenge>;
  latestNews?: Maybe<NewsArticle>;
  latestNewsArticle?: Maybe<ContentfulNewsArticle>;
  leaderboard?: Maybe<Leaderboard>;
  leaderboardByProjectId?: Maybe<Leaderboard>;
  leaderboardV2: LeaderboardV2Output;
  listMintedTokens: Array<Token>;
  listTokenClaims: Array<TokenClaim>;
  loadout: Loadout;
  loot?: Maybe<Array<Loot>>;
  matchMake: MatchmakeResponse;
  me?: Maybe<User>;
  me_v2: User;
  messageToBeReviewed?: Maybe<ChatMessageMetadata>;
  messagesToBeReviewed: Array<ChatMessageMetadata>;
  mostPopularProjectsV2: Array<Project>;
  mutedChatsList?: Maybe<Array<MutedChat>>;
  news?: Maybe<Array<NewsArticle>>;
  notificationsAmount: Scalars['Float'];
  onlineFriends: Array<UserFriend>;
  page?: Maybe<Page>;
  paymentDetails?: Maybe<StripePaymentDetails>;
  priceById?: Maybe<StripePrice>;
  productById?: Maybe<ShopItem>;
  project?: Maybe<Project>;
  projectFeedPage?: Maybe<ProjectFeedPage>;
  projectTemplates: Array<ProjectTemplate>;
  projects?: Maybe<ProjectConnection>;
  projectsByIds?: Maybe<Array<Project>>;
  providerSessionToken?: Maybe<Scalars['String']>;
  querySnippetModel: QuerySnippetModelResponse;
  queryWorldModel: QueryWorldModelResponse;
  randomSession?: Maybe<MultiplayerSession>;
  randomizedUsernames?: Maybe<Array<Scalars['String']>>;
  recommendations: RecommendationResult;
  replies?: Maybe<CommentConnection>;
  repliesV2?: Maybe<CommentConnection>;
  reports: Array<ReportEntry>;
  reportsForContent: Array<ReportEntry>;
  /** Request access to project using JWT for authentication */
  requestAccessToProject: ProjectAccessResponse;
  search: SearchResult;
  shopProducts: Array<ShopItem>;
  socialFeed?: Maybe<ProjectConnection>;
  stripeCustomerIdByHiberId?: Maybe<Scalars['String']>;
  suspensionsByUserId?: Maybe<Array<Suspension>>;
  tags: TagConnection;
  totalPlayersInActiveProjectsV2: Scalars['Int'];
  tutorialSections: Array<TutorialSection>;
  unlockableRpmAchievements: Array<UnlockableRpmAchievements>;
  unreadActitivies: ActivitiesResponse;
  unreadActitiviesAmount: Scalars['Int'];
  unseenAchievementLoot: Array<Loot>;
  user?: Maybe<User>;
  userByEmail?: Maybe<User>;
  userByUsername?: Maybe<User>;
  userByUsernames?: Maybe<Array<User>>;
  userHasBoughtProduct?: Maybe<StripeUserHasBoughtProductResponse>;
  users?: Maybe<UserConnection>;
  usersByIds: Array<User>;
  validateExternalIdsForUnlocking: Array<Scalars['String']>;
  warnings?: Maybe<Array<WarningsList>>;
};


export type QueryActiveSuspensionListArgs = {
  payload: SearchDto;
};


export type QueryActivitiesArgs = {
  payload: ActivitiesFilter;
};


export type QueryActivitiesByGroupArgs = {
  filter: ActivityGroupFilter;
};


export type QueryActivityLogsArgs = {
  input: FindActivityLogsInput;
  username: Scalars['String'];
};


export type QueryAllAppearancesArgs = {
  filter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AppearanceType>;
};


export type QueryAllWarningsForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryAppearanceArgs = {
  name: Scalars['String'];
};


export type QueryAppearancesArgs = {
  input: SearchDto;
  type: AppearanceType;
};


export type QueryAvatarArgs = {
  userId: Scalars['ID'];
};


export type QueryBadgeArgs = {
  badgeId: Scalars['Float'];
};


export type QueryCampaignArgs = {
  name: Scalars['String'];
};


export type QueryCheckDeleteAccountTokenArgs = {
  token: Scalars['String'];
};


export type QueryCheckIsStashCheckoutCompletedArgs = {
  checkoutId: Scalars['String'];
};


export type QueryCheckResetPasswordTokenArgs = {
  token: Scalars['String'];
};


export type QueryCheckVerifyEmailTokenArgs = {
  token: Scalars['String'];
};


export type QueryCheckoutSessionStatusArgs = {
  sessionId: Scalars['String'];
};


export type QueryCriteriasForBadgeGroupIdArgs = {
  groupId: Scalars['Float'];
};


export type QueryExecuteSnippetArgs = {
  correlation_id: Scalars['String'];
  seed?: InputMaybe<Scalars['Int']>;
  snippet: Scalars['String'];
};


export type QueryFeaturedFriendsArgs = {
  payload: SearchDto;
  userId: Scalars['Float'];
};


export type QueryFetchHiberChallengesArgs = {
  first?: InputMaybe<Scalars['Float']>;
  platform: PlatformType;
  skip?: InputMaybe<Scalars['Float']>;
};


export type QueryFetchUsersMetaDataArgs = {
  payload: FetchUsersMetaDataDto;
};


export type QueryFindFeatureToggleArgs = {
  name: Scalars['String'];
};


export type QueryFindProjectRewardsArgs = {
  projectId: Scalars['String'];
};


export type QueryFindUsernameUpdatedAtArgs = {
  username: Scalars['String'];
};


export type QueryGetOrCreatePublicSessionForProjectArgs = {
  channel?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion: Scalars['String'];
  clientVersion: Scalars['String'];
  id: Scalars['ID'];
};


export type QueryGetPublicSessionForProjectArgs = {
  channel?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion: Scalars['String'];
  clientVersion: Scalars['String'];
  id: Scalars['ID'];
};


export type QueryGetSessionArgs = {
  sessionId: Scalars['ID'];
};


export type QueryGetSessionsByGameKitArgs = {
  gameKit: GameKit;
  payload: SearchDto;
};


export type QueryGetSessionsByProjectIdArgs = {
  payload: SearchDto;
  projectId: Scalars['ID'];
};


export type QueryGetUsersInSessionsV2Args = {
  userIds: Array<Scalars['String']>;
};


export type QueryGoogleUserArgs = {
  code: Scalars['String'];
};


export type QueryHasUnlockedAssetsArgs = {
  assetIds: Array<Scalars['String']>;
  userId: Scalars['String'];
};


export type QueryIsFeatureEnabledArgs = {
  name: Scalars['String'];
};


export type QueryIsUsernameAvailableArgs = {
  username: Scalars['String'];
};


export type QueryJoinArgs = {
  request?: InputMaybe<CanJoinRequestV2>;
  sessionId: Scalars['String'];
  waitForSessionReady?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLatestHiberChallengeArgs = {
  platform: PlatformType;
};


export type QueryLatestNewsArgs = {
  previewUserType?: InputMaybe<UserType>;
};


export type QueryLeaderboardArgs = {
  id: Scalars['ID'];
};


export type QueryLeaderboardByProjectIdArgs = {
  projectId: Scalars['ID'];
};


export type QueryLeaderboardV2Args = {
  input: LeaderboardV2Input;
};


export type QueryLoadoutArgs = {
  userId: Scalars['ID'];
};


export type QueryLootArgs = {
  payload?: InputMaybe<FetchLootDto>;
};


export type QueryMatchMakeArgs = {
  request: MatchmakeRequest;
};


export type QueryMessageToBeReviewedArgs = {
  id: Scalars['Float'];
};


export type QueryMessagesToBeReviewedArgs = {
  humanReviewed: Scalars['Boolean'];
};


export type QueryMostPopularProjectsV2Args = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  limit?: Scalars['Int'];
};


export type QueryPageArgs = {
  platform: Platform;
  previewUserType?: InputMaybe<UserType>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentDetailsArgs = {
  paymentIntentId: Scalars['String'];
};


export type QueryPriceByIdArgs = {
  priceId: Scalars['String'];
};


export type QueryProductByIdArgs = {
  productId: Scalars['String'];
};


export type QueryProjectArgs = {
  id: Scalars['ID'];
};


export type QueryProjectFeedPageArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};


export type QueryProjectTemplatesArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProjectsArgs = {
  payload?: InputMaybe<ProjectSearchDto>;
};


export type QueryProjectsByIdsArgs = {
  projectIds: Array<Scalars['ID']>;
};


export type QueryProviderSessionTokenArgs = {
  provider: AvatarProvider;
};


export type QueryQuerySnippetModelArgs = {
  correlation_id?: InputMaybe<Scalars['String']>;
  place_prefab?: InputMaybe<Scalars['Boolean']>;
  prefabId?: InputMaybe<Scalars['String']>;
  prev_output?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
  seed?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryWorldModelArgs = {
  correlation_id: Scalars['String'];
  prev_output?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
  seed?: InputMaybe<Scalars['Int']>;
  strategy?: InputMaybe<Scalars['String']>;
};


export type QueryRandomSessionArgs = {
  payload: RandomMultiplayerSessionDto;
};


export type QueryRandomizedUsernamesArgs = {
  amount: Scalars['Int'];
};


export type QueryRecommendationsArgs = {
  payload: RecommendationsPayload;
};


export type QueryRepliesArgs = {
  commentId: Scalars['ID'];
  payload: SearchDto;
};


export type QueryRepliesV2Args = {
  commentId: Scalars['ID'];
  payload: SearchDto;
};


export type QueryReportsArgs = {
  payload: FetchReportsDto;
};


export type QueryReportsForContentArgs = {
  id: Scalars['ID'];
};


export type QueryRequestAccessToProjectArgs = {
  projectId: Scalars['ID'];
};


export type QuerySearchArgs = {
  searchTerm: Scalars['String'];
  searchType: Scalars['String'];
  sortBy?: InputMaybe<SortBy>;
};


export type QuerySocialFeedArgs = {
  includeOwnGames?: InputMaybe<Scalars['Boolean']>;
  payload?: InputMaybe<ProjectSearchDto>;
};


export type QueryStripeCustomerIdByHiberIdArgs = {
  hiberId: Scalars['String'];
};


export type QuerySuspensionsByUserIdArgs = {
  userId: Scalars['Float'];
};


export type QueryTagsArgs = {
  payload?: InputMaybe<SearchDto>;
  preferExactMatch?: InputMaybe<Scalars['Boolean']>;
  tagTypes?: InputMaybe<Array<TagType>>;
};


export type QueryTotalPlayersInActiveProjectsV2Args = {
  skipFirstGames?: Scalars['Int'];
};


export type QueryUnreadActitiviesArgs = {
  payload: ActivitiesFilter;
};


export type QueryUserArgs = {
  id: Scalars['Float'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String'];
};


export type QueryUserByUsernameArgs = {
  relations?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};


export type QueryUserByUsernamesArgs = {
  usernames: Scalars['String'];
};


export type QueryUserHasBoughtProductArgs = {
  productId: Scalars['String'];
};


export type QueryUsersArgs = {
  payload: UserSearchDto;
};


export type QueryUsersByIdsArgs = {
  ids: Array<Scalars['ID']>;
  includeBlocked?: InputMaybe<Scalars['Boolean']>;
};


export type QueryValidateExternalIdsForUnlockingArgs = {
  externalIds: Array<Scalars['String']>;
};

export type QuerySnippetModelResponse = {
  __typename?: 'QuerySnippetModelResponse';
  correlation_id: Scalars['String'];
  creator_ver: Scalars['String'];
  data: Array<Scalars['String']>;
  endpoint_ver: Scalars['String'];
  prev_output: Scalars['String'];
  seed: Scalars['Int'];
};

export type QueryWorldModelResponse = {
  __typename?: 'QueryWorldModelResponse';
  correlation_id: Scalars['String'];
  creator_ver: Scalars['String'];
  data: Array<Scalars['String']>;
  endpoint_ver: Scalars['String'];
  prev_output: Scalars['String'];
  reply?: Maybe<Scalars['String']>;
  seed: Scalars['Int'];
  strategy: Scalars['String'];
};

export type RandomMultiplayerSessionDto = {
  gameKit?: InputMaybe<GameKit>;
  onlyFeatured?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export enum RecommendationFilter {
  ExcludeFeatured = 'EXCLUDE_FEATURED',
  IncludeFeatured = 'INCLUDE_FEATURED'
}

export type RecommendationResult = {
  __typename?: 'RecommendationResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<Project>;
};

export enum RecommendationSort {
  Random = 'RANDOM',
  Score = 'SCORE'
}

export type RecommendationsPayload = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<RecommendationFilter>;
  projectId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  sort?: InputMaybe<RecommendationSort>;
};

export type RecordTimeSpentDto = {
  id: Scalars['ID'];
  isNewRound: Scalars['Boolean'];
  message: Scalars['String'];
  mode: TimeSpentType;
};

export type ReportEntry = {
  __typename?: 'ReportEntry';
  content?: Maybe<ContentUnion>;
  contentId: Scalars['ID'];
  contentType: ContentType;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  projectId?: Maybe<Scalars['ID']>;
  reason: ReportReason;
  reasonText: Scalars['String'];
  resolved: Scalars['Boolean'];
  status: ReportStatus;
  /** this property is mapped a value when fetching @reports query in gql */
  totalReports?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

/** Reason of report */
export enum ReportReason {
  Abusive = 'Abusive',
  Cheating = 'Cheating',
  Custom = 'Custom',
  Harmful = 'Harmful',
  OffensiveAccInfo = 'OffensiveAccInfo',
  Phishing = 'Phishing',
  Sexual = 'Sexual',
  Spam = 'Spam',
  Violence = 'Violence'
}

/** Status of report */
export enum ReportStatus {
  Resolved = 'RESOLVED',
  Unsolved = 'UNSOLVED'
}

export type ResetPasswordDto = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type Resource = {
  __typename?: 'Resource';
  id: Scalars['ID'];
  persistence: Scalars['Float'];
  type: Resourcetype;
  updatedAt: Scalars['Date'];
  user: User;
  userId: Scalars['Int'];
  value: Scalars['Int'];
};

export type ResponseLevelV2 = {
  __typename?: 'ResponseLevelV2';
  canEdit: Scalars['Boolean'];
  hasThumbnail: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  levelId: Scalars['String'];
  levelUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ResponseMetadata = {
  __typename?: 'ResponseMetadata';
  RequestId: Scalars['String'];
};

export type ResponseUserV2 = {
  __typename?: 'ResponseUserV2';
  avatarId?: Maybe<Scalars['String']>;
  isRegistered: Scalars['Boolean'];
  username: Scalars['String'];
};

export type Reward = {
  __typename?: 'Reward';
  badge: Badge;
  badgeId: Scalars['Int'];
  id: Scalars['ID'];
  rewardItemName?: Maybe<Scalars['String']>;
  subType: Scalars['Int'];
  type: Scalars['Int'];
  value: Scalars['Int'];
};

export type RewardConnection = {
  __typename?: 'RewardConnection';
  newLevels?: Maybe<Scalars['Float']>;
  rewards: Array<Reward>;
  totalXp?: Maybe<Scalars['Float']>;
};

/** types of rewards */
export enum RewardType {
  Appearance = 'APPEARANCE',
  Resource = 'RESOURCE',
  Stat = 'STAT'
}

export type RpmAsset = {
  __typename?: 'RpmAsset';
  id: Scalars['ID'];
  unlockedAt: Scalars['Date'];
};

export type RpmJsonData = {
  __typename?: 'RpmJsonData';
  bodyType: Scalars['String'];
  createdAt: Scalars['Date'];
  outfitGender: Scalars['String'];
  outfitVersion: Scalars['Int'];
  skinTone: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type RpmShopItem = ShopItem & {
  __typename?: 'RpmShopItem';
  brandLogoUrl?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  created: Scalars['Date'];
  currency: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  id: Scalars['ID'];
  image: Scalars['String'];
  isNew: Scalars['Boolean'];
  name: Scalars['String'];
  owned: Scalars['Boolean'];
  price: Scalars['Float'];
  priceId: Scalars['String'];
  priceString: Scalars['String'];
  priceType: PriceType;
  rarity: Scalars['String'];
  type: ShopItemType;
};

export type ScheduledProjectUpdate = {
  __typename?: 'ScheduledProjectUpdate';
  featured?: Maybe<Scalars['Boolean']>;
  project?: Maybe<Project>;
  projectId: Scalars['ID'];
  reFeature?: Maybe<Scalars['Boolean']>;
  updateAt: Scalars['Date'];
  youtubeId?: Maybe<Scalars['String']>;
};

export type SearchDto = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['String']>;
  filterFavorites?: InputMaybe<Scalars['Boolean']>;
  filterFollowing?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Float']>;
  gameKits?: InputMaybe<Array<GameKit>>;
  includeContentIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Float']>;
  maxEngineVersion?: Scalars['Int'];
  meta?: InputMaybe<Array<Scalars['String']>>;
  minEngineVersion?: Scalars['Int'];
  projectGameKit?: InputMaybe<GameKit>;
  projectType?: InputMaybe<ProjectType>;
  requireRelevancy?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<SortBy>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  explorableTags?: Maybe<Array<SearchTags>>;
  noResultFoundSuggestions?: Maybe<Array<Scalars['String']>>;
  searchedTerm: Scalars['String'];
  sections: Array<SearchResultSection>;
  totalHits: Scalars['Int'];
};

export type SearchResultProjectFeedSection = {
  __typename?: 'SearchResultProjectFeedSection';
  feed: Array<Project>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  viewMoreUrl?: Maybe<Scalars['String']>;
};

export type SearchResultSection = SearchResultProjectFeedSection | SearchResultUserSection;

export type SearchResultUserSection = {
  __typename?: 'SearchResultUserSection';
  totalHits: Scalars['Int'];
  users: Array<User>;
};

export type SearchTags = {
  __typename?: 'SearchTags';
  count: Scalars['Int'];
  tag: Scalars['String'];
};

export type Section = {
  __typename?: 'Section';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type SendGamificationClientEventDto = {
  event: Scalars['String'];
  eventType: GwenClientEventType;
};

export type Session = {
  __typename?: 'Session';
  canJoin: JoinStatus;
  id: Scalars['ID'];
  players: Array<SessionUserType>;
  project: Project;
  sessionUrl?: Maybe<Scalars['String']>;
  type: SessionType;
};


export type SessionCanJoinArgs = {
  request: CanJoinRequest;
};

export type SessionFeed = {
  __typename?: 'SessionFeed';
  id: Scalars['ID'];
  liveEvents: Array<LiveEvent>;
  quantity: Scalars['Float'];
  title: Scalars['String'];
};

export enum SessionType {
  Creative = 'CREATIVE',
  Play = 'PLAY'
}

export type SessionUser = {
  sessionUserId: Scalars['String'];
  sessionUsername: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type SessionUserType = {
  __typename?: 'SessionUserType';
  sessionUserId: Scalars['ID'];
  sessionUsername: Scalars['String'];
  user?: Maybe<User>;
};

export type SetUserLevelError = {
  __typename?: 'SetUserLevelError';
  message?: Maybe<Scalars['String']>;
};

export type SetUserLevelResult = Badge | SetUserLevelError;

/** different game modes */
export enum ShooterGameMode {
  FreeForAll = 'FREE_FOR_ALL'
}

export type ShooterSessionSettings = {
  __typename?: 'ShooterSessionSettings';
  gameMode: Scalars['String'];
  id: Scalars['ID'];
  sessionId: Scalars['ID'];
  subWinCondition: SubShooterWinCondition;
  timeLimit?: Maybe<Scalars['Int']>;
  winCondition: Scalars['String'];
  winConditionValue?: Maybe<Scalars['Int']>;
};

/** types of Win condition */
export enum ShooterWinCondition {
  Kills = 'KILLS'
}

export type ShopItem = {
  category: Scalars['String'];
  created: Scalars['Date'];
  currency: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  id: Scalars['ID'];
  image: Scalars['String'];
  isNew: Scalars['Boolean'];
  name: Scalars['String'];
  owned: Scalars['Boolean'];
  price: Scalars['Float'];
  priceId: Scalars['String'];
  priceString: Scalars['String'];
  priceType: PriceType;
  rarity: Scalars['String'];
  type: ShopItemType;
};

export enum ShopItemType {
  Emote = 'Emote',
  GameAsset = 'GameAsset',
  RpmAsset = 'RpmAsset'
}

export type Skybox = {
  __typename?: 'Skybox';
  cubenegx: Scalars['String'];
  cubenegy: Scalars['String'];
  cubenegz: Scalars['String'];
  cubeposx: Scalars['String'];
  cubeposy: Scalars['String'];
  cubeposz: Scalars['String'];
  thumbnail: Scalars['String'];
};

export type SmsResponse = {
  __typename?: 'SmsResponse';
  status: Scalars['Boolean'];
};

export type SnippetExecutionResponse = {
  __typename?: 'SnippetExecutionResponse';
  commands?: Maybe<Array<Maybe<Scalars['String']>>>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SocialMedia = {
  __typename?: 'SocialMedia';
  id: Scalars['ID'];
  instagram?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  user: User;
  userId: Scalars['Int'];
  youtube?: Maybe<Scalars['String']>;
};

/** types of SocialMedia */
export enum SocialMediaType {
  Instagram = 'INSTAGRAM',
  Tiktok = 'TIKTOK',
  Twitch = 'TWITCH',
  Twitter = 'TWITTER',
  Youtube = 'YOUTUBE'
}

export type SoftCurrencyTransactionLog = {
  __typename?: 'SoftCurrencyTransactionLog';
  amount: Scalars['Int'];
  reason: Scalars['String'];
};

/** Sort order */
export enum SortBy {
  Alphabetic = 'ALPHABETIC',
  Featured = 'FEATURED',
  LastEdited = 'LAST_EDITED',
  Likes = 'LIKES',
  New = 'NEW',
  Oldest = 'OLDEST',
  Popular = 'POPULAR',
  Random = 'RANDOM',
  Relevance = 'RELEVANCE',
  Timespent = 'TIMESPENT',
  TotalContent = 'TOTAL_CONTENT',
  TotalViews = 'TOTAL_VIEWS',
  Views = 'VIEWS'
}

/** sort reports */
export enum SortReportBy {
  LastReported = 'LAST_REPORTED',
  LiableAZ = 'LIABLE_A_Z',
  MostReports = 'MOST_REPORTS'
}

export type SqsCreateResponse = {
  __typename?: 'SqsCreateResponse';
  MD5OfMessageBody: Scalars['String'];
  MessageId: Scalars['String'];
  ResponseMetadata: ResponseMetadata;
};

export type Stat = {
  __typename?: 'Stat';
  id: Scalars['ID'];
  persistence: Scalars['Float'];
  type: Stattype;
  updatedAt: Scalars['Date'];
  user: User;
  userId: Scalars['Int'];
  value: Scalars['Int'];
};

export type Stripe = {
  __typename?: 'Stripe';
  activity: Scalars['String'];
  hiberId: Scalars['ID'];
  stripeCustomerId: Scalars['String'];
  timestamp: Scalars['String'];
};

export type StripeCheckoutSessionStatus = {
  __typename?: 'StripeCheckoutSessionStatus';
  isCompleted: Scalars['Boolean'];
  paymentIntentId?: Maybe<Scalars['String']>;
};

export type StripeFeeDetails = {
  __typename?: 'StripeFeeDetails';
  amount: Scalars['Int'];
  application?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type StripeInput = {
  paymentIntentId: Scalars['String'];
  stripeCustomerId: Scalars['String'];
};

export type StripeMetadata = {
  __typename?: 'StripeMetadata';
  key: Scalars['String'];
  value: Scalars['JSON'];
};

export type StripePaymentDetails = {
  __typename?: 'StripePaymentDetails';
  chargeId: Scalars['String'];
  currency: Scalars['String'];
  orderDate: Scalars['Int'];
  paymentMethodType: Scalars['String'];
  receiptNumber?: Maybe<Scalars['String']>;
  subtotal: Scalars['Int'];
  taxAmount: Scalars['Int'];
  total: Scalars['Int'];
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  clientSecret: Scalars['String'];
  id: Scalars['String'];
};

export type StripePrice = {
  __typename?: 'StripePrice';
  active?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  livemode?: Maybe<Scalars['Boolean']>;
  nickname?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
  unitAmountDecimal?: Maybe<Scalars['String']>;
};

export type StripeUserHasBoughtProductResponse = {
  __typename?: 'StripeUserHasBoughtProductResponse';
  hasBoughtProduct: Scalars['Boolean'];
};

/** sub win conditions */
export enum SubShooterWinCondition {
  FirstTo = 'FIRST_TO',
  Timed = 'TIMED'
}

export type SuspendUserDto = {
  customMessage?: InputMaybe<Scalars['String']>;
  endedAt: Scalars['Date'];
  reason: Scalars['Int'];
  username: Scalars['String'];
};

export type Suspension = {
  __typename?: 'Suspension';
  createdAt: Scalars['Date'];
  customMessage?: Maybe<Scalars['String']>;
  endedAt: Scalars['Date'];
  id: Scalars['ID'];
  reason: ReportReason;
  seen: Scalars['Int'];
  type: SuspensionType;
  user: User;
  userId: Scalars['Int'];
};

/** type of suspension */
export enum SuspensionType {
  Suspended = 'SUSPENDED',
  Warning = 'WARNING'
}

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID'];
  name: Scalars['String'];
  projects: Array<Project>;
  totalContent: Scalars['Float'];
  type: TagType;
};


export type TagProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  maxEngineVersion?: InputMaybe<Scalars['Int']>;
  minEngineVersion?: InputMaybe<Scalars['Int']>;
};


export type TagTotalContentArgs = {
  contentTypes?: InputMaybe<Array<ContentType>>;
  maxEngineVersion?: InputMaybe<Scalars['Int']>;
  minEngineVersion?: InputMaybe<Scalars['Int']>;
};

export type TagConnection = {
  __typename?: 'TagConnection';
  edges: Array<TagEdge>;
  items: Array<Tag>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type TagEdge = {
  __typename?: 'TagEdge';
  cursor: Scalars['String'];
  node: Tag;
};

export type TagIdentifierInput = {
  name: Scalars['String'];
  type: TagType;
};

export type TagIdentifierType = {
  __typename?: 'TagIdentifierType';
  name: Scalars['String'];
  type: TagType;
};

/** different type of tag */
export enum TagType {
  Meta = 'Meta',
  Private = 'Private',
  Public = 'Public'
}

export type Thumbnail = {
  __typename?: 'Thumbnail';
  category: Scalars['Float'];
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  large: Image;
  likes: Scalars['Float'];
  medium: Image;
  owner: User;
  small: Image;
  totalViews: Scalars['Float'];
  updatedAt: Scalars['Date'];
  views: Scalars['Float'];
};

/** Time spent type */
export enum TimeSpentType {
  Building = 'Building',
  Playing = 'Playing'
}

export type TitleAsset = {
  __typename?: 'TitleAsset';
  assetType: AssetType;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type Token = {
  __typename?: 'Token';
  chainId: Scalars['Int'];
  contractAddress: Scalars['String'];
  metadata?: Maybe<Scalars['String']>;
  tokenId: Scalars['String'];
  type: TokenType;
};

export type TokenClaim = {
  __typename?: 'TokenClaim';
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['String']>;
  status: TokenClaimStatus;
  type: TokenType;
};

export enum TokenClaimStatus {
  Minted = 'MINTED',
  Unclaimed = 'UNCLAIMED'
}

export enum TokenType {
  Nft = 'NFT',
  Soulbound = 'SOULBOUND'
}

export type TutorialSection = {
  __typename?: 'TutorialSection';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
  tutorialVideos: Array<TutorialVideo>;
};

export type TutorialVideo = {
  __typename?: 'TutorialVideo';
  name: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  videoLink: Scalars['String'];
};

export type UnlockAndEquipAssetToUserResponse = {
  __typename?: 'UnlockAndEquipAssetToUserResponse';
  equipResult: AssetResponse;
  unlockedAssetResponse: Array<AssetResponse>;
};

export type UnlockableRpmAchievements = {
  __typename?: 'UnlockableRpmAchievements';
  description: Scalars['String'];
  femaleId: Scalars['ID'];
  id: Scalars['ID'];
  levelRequired: Scalars['Int'];
  maleId: Scalars['ID'];
  rarity: Scalars['String'];
  thumbnail: Scalars['String'];
  thumbnailDetailed: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type UnlockedAppearance = {
  __typename?: 'UnlockedAppearance';
  appearance: Appearance;
  appearanceId: Scalars['Int'];
  equipped: Scalars['Boolean'];
  id: Scalars['Int'];
  unlockedAt: Scalars['Date'];
  user: User;
  userId: Scalars['Int'];
};

export type UnlockedAsset = {
  __typename?: 'UnlockedAsset';
  id: Scalars['ID'];
  provider: AvatarProvider;
  unlockedAt: Scalars['Date'];
};

export type UnlockedBadge = {
  __typename?: 'UnlockedBadge';
  badge: Badge;
  badgeId: Scalars['Int'];
  careerTimeSinceLastLevel?: Maybe<Scalars['Int']>;
  careerTimeWhenUnlocked?: Maybe<Scalars['Int']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  seen?: Maybe<Scalars['Boolean']>;
  user: User;
  userId: Scalars['Int'];
};

export type UnlockedBadgeConnection = {
  __typename?: 'UnlockedBadgeConnection';
  edges: Array<UnlockedBadgeEdge>;
  items: Array<UnlockedBadge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type UnlockedBadgeEdge = {
  __typename?: 'UnlockedBadgeEdge';
  cursor: Scalars['String'];
  node: UnlockedBadge;
};

export type UpdateAchievementPublicityDto = {
  publicity: Scalars['Int'];
};

export type UpdateAppearanceDto = {
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  isPromotional?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<AppearanceQuality>;
  sourceDescription?: InputMaybe<Scalars['String']>;
};

export type UpdateCommentDto = {
  commentId: Scalars['ID'];
  text: Scalars['String'];
};

export type UpdateEmailInput = {
  email: Scalars['String'];
  verifyAge?: InputMaybe<Scalars['Boolean']>;
};

export type UpdatePasswordInput = {
  currentPassword?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type UpdateProjectDto = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  difficulty?: InputMaybe<Scalars['Int']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locked?: InputMaybe<Scalars['Boolean']>;
  metaTags?: InputMaybe<Array<Scalars['String']>>;
  reFeature?: InputMaybe<Scalars['Boolean']>;
  tags: Array<Scalars['String']>;
  thumbnailId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  visibility: Scalars['Int'];
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type UpdatePublicityDto = {
  publicity: Scalars['Int'];
};

export type UpdateReportDto = {
  id: Scalars['ID'];
  status: ReportStatus;
};

export type UpdateResourceDto = {
  correlationId?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  type: Resourcetype;
  userId: Scalars['Float'];
  value: Scalars['Float'];
};

export type UpdateResourceResult = {
  __typename?: 'UpdateResourceResult';
  reason?: Maybe<Scalars['String']>;
  resource?: Maybe<Resource>;
  success: Scalars['Boolean'];
};

export type UpdateSocialMediaDto = {
  instagram?: InputMaybe<Scalars['String']>;
  tiktok?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
};

export type UpdateUsernameInput = {
  oldUsername: Scalars['String'];
  username: Scalars['String'];
};

export type UpdateVisitiedDto = {
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  sourceId?: InputMaybe<Scalars['ID']>;
  status: Scalars['Boolean'];
  type?: InputMaybe<Scalars['Int']>;
};

export type UpdatedTimeSpentDto = {
  __typename?: 'UpdatedTimeSpentDTO';
  content: Project;
  xp: Scalars['Float'];
};

export type User = {
  __typename?: 'User';
  activeSession?: Maybe<Session>;
  allUnlockedIds: Array<Scalars['String']>;
  amountOfFeaturedFriends?: Maybe<Scalars['Int']>;
  appleId?: Maybe<Scalars['ID']>;
  avatar?: Maybe<UnlockedAppearance>;
  avatarV2?: Maybe<Avatar>;
  badges?: Maybe<Array<UserBadge>>;
  birthdate?: Maybe<Scalars['Date']>;
  blockedUsers?: Maybe<Array<BlockedUser>>;
  comments?: Maybe<CommentConnection>;
  commentsV2?: Maybe<CommentConnection>;
  constants?: Maybe<UserConstants>;
  createdAt: Scalars['Date'];
  currentXp?: Maybe<Scalars['Float']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailVerification?: Maybe<EmailVerification>;
  /** @deprecated Removed */
  facebookId: Scalars['String'];
  featuredFriends?: Maybe<FeaturedFriendConnection>;
  gender: Scalars['Int'];
  getCommonFriends: Array<UserFriend>;
  getFollowers?: Maybe<UserFollowConnection>;
  getFollowing?: Maybe<UserFollowConnection>;
  getFriendInvites: Array<User>;
  getFriendInvitesSent: Array<User>;
  getFriends?: Maybe<UserFriendConnection>;
  getOnlineFriends: Array<UserFriend>;
  getOrCreatePrivacySettings?: Maybe<PrivacySettings>;
  googleId?: Maybe<Scalars['ID']>;
  hasAcceptedTos?: Maybe<Scalars['Boolean']>;
  hasDefaultProfileImage: Scalars['Boolean'];
  hasFinishedRegistration?: Maybe<Scalars['Boolean']>;
  hasTag: Scalars['Boolean'];
  hasUnlockedAssets: Array<Scalars['Boolean']>;
  hasUnlockedBadges?: Maybe<Scalars['Boolean']>;
  haveIBlocked: Scalars['Boolean'];
  haveIFeaturedFriend: Scalars['Boolean'];
  haveIReceivedFriendRequest?: Maybe<Scalars['Boolean']>;
  haveIReported: Scalars['Boolean'];
  haveISentFriendRequest?: Maybe<Scalars['Boolean']>;
  homeworld?: Maybe<Homeworld>;
  id: Scalars['ID'];
  inventory?: Maybe<Inventory>;
  isBetatester: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isEmployee: Scalars['Boolean'];
  isFeatureEnabled?: Maybe<Scalars['Boolean']>;
  isFollowing: Scalars['Boolean'];
  isFriends?: Maybe<Scalars['Boolean']>;
  isLiked?: Maybe<Scalars['Boolean']>;
  isRegistered: Scalars['Boolean'];
  isReported?: Maybe<Scalars['Boolean']>;
  /** Returns true if a user is currently suspended */
  isSuspended: Scalars['Boolean'];
  isValidAge?: Maybe<Scalars['Boolean']>;
  isVerified: Scalars['Boolean'];
  level?: Maybe<Scalars['Float']>;
  loadout: Loadout;
  multiplayerSession?: Maybe<MultiplayerSession>;
  newRewards?: Maybe<RewardConnection>;
  newsletterSignup?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<NotificationConnection>;
  notificationsAmount: Scalars['Float'];
  pictureUrl: Scalars['String'];
  privacySettings?: Maybe<PrivacySettings>;
  profileBackgroundUrl: Scalars['String'];
  profileImage?: Maybe<Image>;
  projects: ProjectConnection;
  role?: Maybe<Scalars['Int']>;
  session?: Maybe<UserSession>;
  socialMedia?: Maybe<SocialMedia>;
  softCurrency?: Maybe<Scalars['Float']>;
  stat?: Maybe<Stat>;
  /** Returns active suspension of user or null. If only interested in presense of suspension, see "User.isSuspended" */
  suspension?: Maybe<Suspension>;
  suspensions: Array<Suspension>;
  tags_v2: Array<Tag>;
  timeSpentPlayingShooter?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  tosAcceptedDate?: Maybe<Scalars['Date']>;
  totalFollowers: Scalars['Float'];
  totalFollowing: Scalars['Float'];
  totalFriends: Scalars['Float'];
  totalProjectViews: Scalars['Float'];
  totalPublishedGames?: Maybe<Scalars['Float']>;
  uniqueGamesCompleted?: Maybe<Scalars['Float']>;
  unlockedBadges?: Maybe<UnlockedBadgeConnection>;
  updatedAt: Scalars['Date'];
  username: Scalars['String'];
  /** [WALLET] Ethereum accounts linked to user */
  wallets?: Maybe<Array<Maybe<Wallet>>>;
  /** Returns active warning of user or null. */
  warning?: Maybe<Suspension>;
  xp?: Maybe<Scalars['Float']>;
  xpToNextLevel?: Maybe<Scalars['Float']>;
};


export type UserCommentsArgs = {
  payload: SearchDto;
};


export type UserCommentsV2Args = {
  payload: SearchDto;
};


export type UserFeaturedFriendsArgs = {
  payload: SearchDto;
};


export type UserGetCommonFriendsArgs = {
  username: Scalars['String'];
};


export type UserGetFollowersArgs = {
  payload: SearchDto;
};


export type UserGetFollowingArgs = {
  payload: SearchDto;
};


export type UserGetFriendsArgs = {
  payload: SearchDto;
};


export type UserHasTagArgs = {
  name: Scalars['String'];
  type?: InputMaybe<TagType>;
};


export type UserHasUnlockedAssetsArgs = {
  assetIds: Array<Scalars['String']>;
};


export type UserIsFeatureEnabledArgs = {
  name: Scalars['String'];
};


export type UserMultiplayerSessionArgs = {
  maxEngineVersion?: InputMaybe<Scalars['Float']>;
  minEngineVersion?: InputMaybe<Scalars['Float']>;
};


export type UserNotificationsArgs = {
  payload?: InputMaybe<SearchDto>;
};


export type UserProjectsArgs = {
  excludePublished?: InputMaybe<Scalars['Boolean']>;
  includeUnpublished?: InputMaybe<Scalars['Boolean']>;
  payload?: InputMaybe<SearchDto>;
};


export type UserStatArgs = {
  type: Stattype;
};


export type UserUnlockedBadgesArgs = {
  input: SearchDto;
};

export type UserBadge = {
  __typename?: 'UserBadge';
  badge: Badge;
  createdAt?: Maybe<Scalars['Date']>;
  seen: Scalars['Boolean'];
  unlocked?: Maybe<Scalars['Boolean']>;
  user: User;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  items: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type UserConstants = {
  __typename?: 'UserConstants';
  maxFeaturedFriends?: Maybe<Scalars['Int']>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String'];
  node: User;
};

/** Available CTA on cms user feeds card */
export enum UserFeedCta {
  Follow = 'FOLLOW'
}

export type UserFeedOnlineFriends = {
  __typename?: 'UserFeedOnlineFriends';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type UserFeedRegular = {
  __typename?: 'UserFeedRegular';
  cta?: Maybe<UserFeedCta>;
  id: Scalars['ID'];
  layout: FeedCardLayout;
  metaTags?: Maybe<Array<Scalars['String']>>;
  quantity: Scalars['Float'];
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type UserFollow = {
  __typename?: 'UserFollow';
  followedSince: Scalars['Date'];
  user: User;
};

export type UserFollowConnection = {
  __typename?: 'UserFollowConnection';
  edges: Array<UserFollowEdge>;
  items: Array<UserFollow>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type UserFollowEdge = {
  __typename?: 'UserFollowEdge';
  cursor: Scalars['String'];
  node: UserFollow;
};

export type UserFriend = {
  __typename?: 'UserFriend';
  friendSince: Scalars['Date'];
  user: User;
};

export type UserFriendConnection = {
  __typename?: 'UserFriendConnection';
  edges: Array<UserFriendEdge>;
  items: Array<UserFriend>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
};

export type UserFriendEdge = {
  __typename?: 'UserFriendEdge';
  cursor: Scalars['String'];
  node: UserFriend;
};

export type UserIdsOfUsersOwningAssetsResponse = {
  __typename?: 'UserIdsOfUsersOwningAssetsResponse';
  numberOfUsers: Scalars['Int'];
  userIds?: Maybe<Array<Scalars['ID']>>;
};

/** user roles */
export enum UserRole {
  Admin = 'ADMIN',
  Moderator = 'MODERATOR',
  SystemOwner = 'SYSTEM_OWNER',
  User = 'USER'
}

export type UserSearchDto = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['String']>;
  filterFavorites?: InputMaybe<Scalars['Boolean']>;
  filterFollowing?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Float']>;
  gameKits?: InputMaybe<Array<GameKit>>;
  includeContentIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Float']>;
  maxEngineVersion?: Scalars['Int'];
  meta?: InputMaybe<Array<Scalars['String']>>;
  minEngineVersion?: Scalars['Int'];
  projectGameKit?: InputMaybe<GameKit>;
  projectType?: InputMaybe<ProjectType>;
  requireRelevancy?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserRole>;
  sortBy?: InputMaybe<SortBy>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type UserSecretDto = {
  secret: Scalars['String'];
  usernameOrEmail: Scalars['String'];
};

export type UserSession = {
  __typename?: 'UserSession';
  actionStatus: UserSessionActionStatus;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  lastSeen: Scalars['Date'];
  sessionLength: Scalars['Float'];
  sessionStatus: UserSessionStatus;
  updatedAt: Scalars['Date'];
  user: User;
};

/** UserSessionActionStatus */
export enum UserSessionActionStatus {
  Idle = 'IDLE',
  InCreativeMode = 'IN_CREATIVE_MODE',
  Playing = 'PLAYING',
  PlayingMultiplayer = 'PLAYING_MULTIPLAYER'
}

/** UserSessionStatus */
export enum UserSessionStatus {
  Invisible = 'INVISIBLE',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

/** Type of user */
export enum UserType {
  ExternalDeveloper = 'EXTERNAL_DEVELOPER',
  Guest = 'GUEST',
  Nonregistered = 'NONREGISTERED',
  Registered = 'REGISTERED'
}

export type UsernameUpdatedAt = {
  __typename?: 'UsernameUpdatedAt';
  isAllowChange: Scalars['Boolean'];
  message: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  userId: Scalars['Float'];
  username: Scalars['String'];
};

export type Wallet = {
  __typename?: 'Wallet';
  address: Scalars['String'];
  type: Scalars['String'];
};

export type WarningsList = {
  __typename?: 'WarningsList';
  customMessage: Scalars['String'];
  endingAt: Scalars['Date'];
  id: Scalars['ID'];
  total: Scalars['Int'];
  user: User;
};

/** types of criterias */
export enum CriteriaTypes {
  Resource = 'Resource',
  Stat = 'Stat'
}

/** difficulty for games */
export enum Difficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Insane = 'INSANE',
  Normal = 'NORMAL',
  Unplayable = 'UNPLAYABLE'
}

export enum Join__Graph {
  Activities = 'ACTIVITIES',
  Auth = 'AUTH',
  Avatar = 'AVATAR',
  GameSessionV2 = 'GAME_SESSION_V2',
  Inventory = 'INVENTORY',
  Leaderboard = 'LEADERBOARD',
  Loadout = 'LOADOUT',
  Moderation = 'MODERATION',
  Monolith = 'MONOLITH',
  Payment = 'PAYMENT',
  ProjectAccessControl = 'PROJECT_ACCESS_CONTROL',
  Recommendation = 'RECOMMENDATION',
  Skybox = 'SKYBOX',
  SnippetRunner = 'SNIPPET_RUNNER',
  Token = 'TOKEN',
  Wallet = 'WALLET'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

/** types of notifications */
export enum NotificationsTypes {
  Announcement = 'ANNOUNCEMENT',
  Comment = 'COMMENT',
  FeaturedContent = 'FEATURED_CONTENT',
  Followed = 'FOLLOWED',
  FriendRequest = 'FRIEND_REQUEST',
  FriendRequestAccepted = 'FRIEND_REQUEST_ACCEPTED',
  HighscoreBeaten = 'HIGHSCORE_BEATEN',
  KnockedOutTop_10 = 'KNOCKED_OUT_TOP_10',
  Liked = 'LIKED',
  Mentioned = 'MENTIONED',
  NewContent = 'NEW_CONTENT',
  ScoreBeaten = 'SCORE_BEATEN'
}

/** publicity codes */
export enum Publicity {
  FriendsOnly = 'FRIENDS_ONLY',
  Hidden = 'HIDDEN',
  Public = 'PUBLIC'
}

/** types_of_resources */
export enum Resourcetype {
  SoftCurrency = 'SOFT_CURRENCY'
}

/** types_of_stats */
export enum Stattype {
  ClaimedHibuxReward = 'CLAIMED_HIBUX_REWARD',
  ConsecutiveDaysPlayed = 'CONSECUTIVE_DAYS_PLAYED',
  GamesCreated = 'GAMES_CREATED',
  GamesPublished = 'GAMES_PUBLISHED',
  TimeSpentBuilding = 'TIME_SPENT_BUILDING',
  TimeSpentPlaying = 'TIME_SPENT_PLAYING',
  TimeSpentPlayingPlatformer = 'TIME_SPENT_PLAYING_PLATFORMER',
  TimeSpentPlayingShooter = 'TIME_SPENT_PLAYING_SHOOTER',
  TotalCommentsOnUniqueProjects = 'TOTAL_COMMENTS_ON_UNIQUE_PROJECTS',
  TotalFeaturedGamesCompleted = 'TOTAL_FEATURED_GAMES_COMPLETED',
  TotalFlyingGamesPlayed = 'TOTAL_FLYING_GAMES_PLAYED',
  TotalFollowers = 'TOTAL_FOLLOWERS',
  TotalFollowing = 'TOTAL_FOLLOWING',
  TotalFriends = 'TOTAL_FRIENDS',
  TotalGamesBeatenFriendsIn = 'TOTAL_GAMES_BEATEN_FRIENDS_IN',
  TotalLikes = 'TOTAL_LIKES',
  TotalLikesGiven = 'TOTAL_LIKES_GIVEN',
  TotalOwnRecordsBeaten = 'TOTAL_OWN_RECORDS_BEATEN',
  TotalVehicleGamesPlayed = 'TOTAL_VEHICLE_GAMES_PLAYED',
  UniqueGamesCompleted = 'UNIQUE_GAMES_COMPLETED',
  UniqueGamesPlayed = 'UNIQUE_GAMES_PLAYED',
  UniquePlays = 'UNIQUE_PLAYS',
  Xp = 'XP'
}

export type AuthorFragmentFragment = { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null };

export type CurrentUserFragment = { __typename?: 'User', id: string, role?: number | null, email?: string | null, username: string, title?: string | null, pictureUrl: string, profileBackgroundUrl: string, description?: string | null, hasFinishedRegistration?: boolean | null, hasAcceptedTos?: boolean | null, isValidAge?: boolean | null, isVerified: boolean, isEmployee: boolean, isRegistered: boolean, birthdate?: Date | null, notificationsAmount: number, xp?: number | null, currentXp?: number | null, xpToNextLevel?: number | null, timeSpentPlayingShooter?: number | null, totalPublishedGames?: number | null, uniqueGamesCompleted?: number | null, level?: number | null, googleId?: string | null, hasDefaultProfileImage: boolean, softCurrency?: number | null, amountOfFeaturedFriends?: number | null, isSuspended: boolean, constants?: { __typename?: 'UserConstants', maxFeaturedFriends?: number | null } | null, session?: { __typename?: 'UserSession', id: string } | null, suspension?: { __typename: 'Suspension', id: string, seen: number, endedAt: Date, reason: ReportReason, customMessage?: string | null, type: SuspensionType } | null, warning?: { __typename: 'Suspension', id: string, seen: number, endedAt: Date, reason: ReportReason, customMessage?: string | null, type: SuspensionType } | null, socialMedia?: { __typename: 'SocialMedia', id: string, youtube?: string | null, twitter?: string | null, twitch?: string | null, instagram?: string | null, tiktok?: string | null } | null, getOrCreatePrivacySettings?: { __typename?: 'PrivacySettings', userId: number, directMessagingPublicity?: number | null, id: string, friendsArePublic?: number | null, onlyFriendsInMultiplayer: boolean, achievementPublicity: number } | null };

export type ProjectFragmentFragment = { __typename?: 'Project', id: string, title: string, description: string, totalViews: number, completionRate: number, publishedAt?: Date | null, rePublishedAt?: Date | null, createdAt: string, updatedAt: Date, canEdit: boolean, isPublished: boolean, isLiked?: boolean | null, likes: number, isReported?: boolean | null, featured: boolean, forkId?: string | null, locked: boolean, projectType: ProjectType, disableComments: boolean, isHomeworld: boolean, youtubeId?: string | null, gameKit: GameKit, engineVersion: number, categories: Array<string>, tags?: Array<string> | null, visibility: number, playUrl?: string | null, isRestricted: boolean, madeWithHDK: boolean, carSoccer: boolean, carSumo: boolean, tanks: boolean, copsAndRobbers: boolean, match: boolean, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string, type: TagType }>, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null, thumbnails: Array<{ __typename?: 'Thumbnail', medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } }>, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, socialMedia?: { __typename?: 'SocialMedia', id: string, twitter?: string | null, twitch?: string | null, youtube?: string | null, instagram?: string | null, tiktok?: string | null } | null, suspension?: { __typename?: 'Suspension', id: string } | null }, badges: Array<{ __typename?: 'Badge', id: string, icon: string, displayName: string, description: string, rewards: Array<{ __typename?: 'Reward', id: string, value: number, type: number, subType: number }> }> };

export type ProjectInfoFragment = { __typename?: 'Project', id: string, title: string, gameKit: GameKit, likes: number, description: string, createdAt: string, updatedAt: Date, publishedAt?: Date | null, views: number, totalViews: number, youtubeId?: string | null, playUrl?: string | null, isLiked?: boolean | null, isPublished: boolean, projectType: ProjectType, dataUrl: string, viewUrl?: string | null, engineVersion: number, categories: Array<string>, visibility: number, disableComments: boolean, isOwner: boolean, isHomeworld: boolean, featured: boolean, reFeaturedAt?: Date | null, locked: boolean, tags?: Array<string> | null, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string }>, totalCountComments?: { __typename?: 'CommentConnection', totalCount: number } | null, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null, thumbnails: Array<{ __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } }>, author: { __typename?: 'User', isFollowing: boolean, id: string, username: string, pictureUrl: string, level?: number | null, isVerified: boolean, isEmployee: boolean } };

type ShopItem_EmoteShopItem_Fragment = { __typename?: 'EmoteShopItem', emoteId: string, videoUrl: string, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null };

type ShopItem_GameAssetShopItem_Fragment = { __typename?: 'GameAssetShopItem', gameAssetId: string, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null };

type ShopItem_RpmShopItem_Fragment = { __typename?: 'RpmShopItem', brandLogoUrl?: string | null, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null };

export type ShopItemFragment = ShopItem_EmoteShopItem_Fragment | ShopItem_GameAssetShopItem_Fragment | ShopItem_RpmShopItem_Fragment;

export type TagFragmentFragment = { __typename?: 'Tag', id: string, name: string, type: TagType };

export type AcceptFriendRequestMutationVariables = Exact<{
  targetId: Scalars['Float'];
}>;


export type AcceptFriendRequestMutation = { __typename?: 'Mutation', acceptFriendRequest: { __typename: 'UserFriend', friendSince: Date, user: { __typename: 'User', username: string, id: string, pictureUrl: string, level?: number | null, isFriends?: boolean | null, haveISentFriendRequest?: boolean | null, haveIReceivedFriendRequest?: boolean | null, isVerified: boolean, isEmployee: boolean } } };

export type AddFeatureFriendMutationVariables = Exact<{
  targetId: Scalars['Float'];
}>;


export type AddFeatureFriendMutation = { __typename?: 'Mutation', featureFriend: { __typename?: 'FeaturedFriend', id: string, createdAt: Date, target: { __typename?: 'User', id: string, haveIFeaturedFriend: boolean, username: string, pictureUrl: string, isVerified: boolean, homeworld?: { __typename?: 'Homeworld', id: string, project: { __typename?: 'Project', id: string, thumbnail?: { __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', id: string, url: string } } | null } } | null } } };

export type AddFeaturedProfileMutationVariables = Exact<{
  username: Scalars['String'];
}>;


export type AddFeaturedProfileMutation = { __typename?: 'Mutation', addFeaturedProfile?: { __typename?: 'FeaturedProfile', userId: string, addedAt: Date } | null };

export type AwardAppearancesForUsersMutationVariables = Exact<{
  usernames: Array<Scalars['String']> | Scalars['String'];
  avatarIds: Array<Scalars['Float']> | Scalars['Float'];
}>;


export type AwardAppearancesForUsersMutation = { __typename?: 'Mutation', awardAppearancesForUsers: boolean };

export type BlockUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type BlockUserMutation = { __typename?: 'Mutation', blockUser?: { __typename: 'BlockedUser', id: string, user1Id: string, user2Id: string, blockedAt: Date } | null };

export type CancelFriendRequestMutationVariables = Exact<{
  targetId: Scalars['Float'];
}>;


export type CancelFriendRequestMutation = { __typename?: 'Mutation', cancelFriendRequest: { __typename?: 'User', id: string, username: string, pictureUrl: string, haveISentFriendRequest?: boolean | null, haveIReceivedFriendRequest?: boolean | null, level?: number | null } };

export type ClaimHibuxRewardMutationVariables = Exact<{ [key: string]: never; }>;


export type ClaimHibuxRewardMutation = { __typename?: 'Mutation', claimHibuxReward: boolean };

export type ClearAllWarningsForUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ClearAllWarningsForUserMutation = { __typename?: 'Mutation', clearAllWarningsForUser?: boolean | null };

export type CreateAppearanceMutationVariables = Exact<{
  input: CreateAppearanceDto;
}>;


export type CreateAppearanceMutation = { __typename?: 'Mutation', createAppearance: { __typename?: 'Appearance', id: number, displayName: string, name: string, quality: AppearanceQuality, isPromotional: boolean, sourceDescription: string } };

export type CreateCheckoutSessionMutationVariables = Exact<{
  priceId: Scalars['String'];
  embed?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'CheckoutSessionResponse', sessionId: string, sessionUrl?: string | null, clientSecret?: string | null } | null };

export type CreateDefaultAvatarMutationVariables = Exact<{
  input: DefaultAvatarInput;
}>;


export type CreateDefaultAvatarMutation = { __typename?: 'Mutation', createDefaultAvatar?: { __typename?: 'Avatar', id: string, glbUrl: string, rpmUserId?: string | null, rpmAvatarId?: string | null, rpmGlbUrl?: string | null, rpmHasLinkedAccount?: boolean | null, thumbnail: string, name: string, provider: AvatarProvider, rpmJsonData?: { __typename?: 'RpmJsonData', outfitGender: string } | null } | null };

export type CreateDeveloperTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateDeveloperTokenMutation = { __typename?: 'Mutation', createDeveloperToken: string };

export type CreateNonRegisteredUserMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateNonRegisteredUserMutation = { __typename?: 'Mutation', createNonRegisteredUser: { __typename?: 'AuthResponse', accessToken?: string | null, refreshToken?: string | null, user: { __typename?: 'User', id: string, role?: number | null, email?: string | null, username: string, title?: string | null, pictureUrl: string, profileBackgroundUrl: string, description?: string | null, hasFinishedRegistration?: boolean | null, hasAcceptedTos?: boolean | null, isValidAge?: boolean | null, isVerified: boolean, isEmployee: boolean, isRegistered: boolean, birthdate?: Date | null, notificationsAmount: number, xp?: number | null, currentXp?: number | null, xpToNextLevel?: number | null, timeSpentPlayingShooter?: number | null, totalPublishedGames?: number | null, uniqueGamesCompleted?: number | null, level?: number | null, googleId?: string | null, hasDefaultProfileImage: boolean, softCurrency?: number | null, amountOfFeaturedFriends?: number | null, isSuspended: boolean, constants?: { __typename?: 'UserConstants', maxFeaturedFriends?: number | null } | null, session?: { __typename?: 'UserSession', id: string } | null, suspension?: { __typename: 'Suspension', id: string, seen: number, endedAt: Date, reason: ReportReason, customMessage?: string | null, type: SuspensionType } | null, warning?: { __typename: 'Suspension', id: string, seen: number, endedAt: Date, reason: ReportReason, customMessage?: string | null, type: SuspensionType } | null, socialMedia?: { __typename: 'SocialMedia', id: string, youtube?: string | null, twitter?: string | null, twitch?: string | null, instagram?: string | null, tiktok?: string | null } | null, getOrCreatePrivacySettings?: { __typename?: 'PrivacySettings', userId: number, directMessagingPublicity?: number | null, id: string, friendsArePublic?: number | null, onlyFriendsInMultiplayer: boolean, achievementPublicity: number } | null } } };

export type CreateProjectMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  gameKit?: InputMaybe<GameKit>;
  engineVersion?: InputMaybe<Scalars['Int']>;
  isSnapMode?: InputMaybe<Scalars['Boolean']>;
  forkId?: InputMaybe<Scalars['Float']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'Project', id: string, title: string, projectType: ProjectType, gameKit: GameKit, playUrl?: string | null, viewUrl?: string | null, author: { __typename?: 'User', id: string, username: string } } | null };

export type CreatePublicCreativeSessionForProjectMutationVariables = Exact<{
  channel?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion: Scalars['String'];
  clientVersion: Scalars['String'];
  id: Scalars['ID'];
}>;


export type CreatePublicCreativeSessionForProjectMutation = { __typename?: 'Mutation', createPublicCreativeSessionForProject: { __typename?: 'MultiplayerSession', id: string, sessionUrl?: string | null, sessionId: string, newlyCreated?: boolean | null, sessionStatus: MultiplayerSessionStatus, playerCount: number, maxPlayerCount: number, publicity: Publicity } };

export type CreateScheduledProjectUpdateMutationVariables = Exact<{
  projectId: Scalars['ID'];
  updateAt: Scalars['Date'];
  featured?: InputMaybe<Scalars['Boolean']>;
  reFeature?: InputMaybe<Scalars['Boolean']>;
  youtubeId?: InputMaybe<Scalars['String']>;
}>;


export type CreateScheduledProjectUpdateMutation = { __typename?: 'Mutation', createScheduledProjectUpdate: { __typename?: 'ScheduledProjectUpdate', projectId: string, updateAt: Date, featured?: boolean | null, reFeature?: boolean | null, youtubeId?: string | null, project?: { __typename?: 'Project', id: string, title: string, description: string, totalViews: number, publishedAt?: Date | null, canEdit: boolean, isPublished: boolean, isLiked?: boolean | null, likes: number, isReported?: boolean | null, projectType: ProjectType, disableComments: boolean, youtubeId?: string | null, gameKit: GameKit, engineVersion: number, tags?: Array<string> | null, visibility: number, playUrl?: string | null, leaderboard?: { __typename?: 'Leaderboard', id: string } | null, thumbnail?: { __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', id: string, url: string } } | null, thumbnails: Array<{ __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', id: string, url: string } }>, author: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null, socialMedia?: { __typename?: 'SocialMedia', id: string, twitter?: string | null, twitch?: string | null, youtube?: string | null, instagram?: string | null, tiktok?: string | null } | null } } | null } };

export type CreateSessionMutationVariables = Exact<{
  projectId: Scalars['ID'];
  publicity: Publicity;
  maxPlayerCount: Scalars['Float'];
  sessionMode?: InputMaybe<MultiplayerSessionMode>;
  sessionStatus?: InputMaybe<MultiplayerSessionStatus>;
  sessionType?: InputMaybe<MultiplayerSessionType>;
  joinablePlayerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession?: { __typename?: 'MultiplayerSession', id: string, sessionId: string, sessionUrl?: string | null, sessionStatus: MultiplayerSessionStatus, playerCount: number, maxPlayerCount: number, publicity: Publicity, currentProject?: { __typename?: 'Project', id: string, title: string, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string } } | null } | null } | null };

export type CreateShooterSessionSettingsMutationVariables = Exact<{
  payload: CreateShooterSessionSettingsDto;
  sessionId: Scalars['ID'];
}>;


export type CreateShooterSessionSettingsMutation = { __typename?: 'Mutation', createShooterSessionSettings: { __typename?: 'ShooterSessionSettings', id: string, sessionId: string } };

export type CreateZendeskTicketMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  subject: Scalars['String'];
  device: Device;
  os?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
}>;


export type CreateZendeskTicketMutation = { __typename?: 'Mutation', createZendeskTicket: boolean };

export type DeleteAccountRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountRequestMutation = { __typename?: 'Mutation', deleteAccountRequest?: boolean | null };

export type DeleteAccountMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: boolean | null };

export type DeleteAllRefreshTokensMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllRefreshTokensMutation = { __typename?: 'Mutation', deleteAllRefreshTokens: number };

export type DeleteApperanceMutationVariables = Exact<{
  appearanceId: Scalars['Float'];
}>;


export type DeleteApperanceMutation = { __typename?: 'Mutation', deleteAppearance: boolean };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename: 'Comment', id: string, text: string, deletedAt?: Date | null } };

export type DeleteFeaturedFriendMutationVariables = Exact<{
  targetId: Scalars['Float'];
}>;


export type DeleteFeaturedFriendMutation = { __typename?: 'Mutation', deleteFeaturedFriend: boolean };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject?: { __typename?: 'Project', id: string, deletedAt?: Date | null } | null };

export type DeleteScheduledProjectUpdateMutationVariables = Exact<{
  projectId: Scalars['ID'];
  updateAt: Scalars['Date'];
}>;


export type DeleteScheduledProjectUpdateMutation = { __typename?: 'Mutation', deleteScheduledProjectUpdate: boolean };

export type DeleteUserAccountMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type DeleteUserAccountMutation = { __typename?: 'Mutation', deleteUserAccount: boolean };

export type EquipAppearanceMutationVariables = Exact<{
  appearanceId: Scalars['ID'];
}>;


export type EquipAppearanceMutation = { __typename?: 'Mutation', equipAppearance?: { __typename?: 'Appearance', id: number, name: string } | null };

export type EquipAssetMutationVariables = Exact<{
  input: EquipAssetInput;
}>;


export type EquipAssetMutation = { __typename?: 'Mutation', equipAsset?: { __typename?: 'AssetResponse', status: string, message: string, type: string } | null };

export type EquipClassicAvatarMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type EquipClassicAvatarMutation = { __typename?: 'Mutation', equipClassicAvatar?: { __typename?: 'Avatar', id: string, glbUrl: string, name: string, provider: AvatarProvider } | null };

export type EquipRpmAvatarMutationVariables = Exact<{
  avatarId: Scalars['String'];
}>;


export type EquipRpmAvatarMutation = { __typename?: 'Mutation', equipRpmAvatar?: { __typename?: 'Avatar', id: string, provider: AvatarProvider, glbUrl: string, name: string, rpmAvatarId?: string | null, rpmGlbUrl?: string | null, thumbnail: string, rpmJsonData?: { __typename?: 'RpmJsonData', outfitGender: string } | null } | null };

export type UpdateFeatureToggleMutationVariables = Exact<{
  input: FeatureToggleInputDto;
}>;


export type UpdateFeatureToggleMutation = { __typename?: 'Mutation', updateFeatureToggle?: { __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null, criteria?: { __typename?: 'FeatureCriteria', tags?: Array<{ __typename?: 'TagIdentifierType', type: TagType, name: string }> | null } | null, values?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null, criteria?: { __typename?: 'FeatureCriteria', tags?: Array<{ __typename?: 'TagIdentifierType', type: TagType, name: string }> | null } | null, values?: Array<{ __typename?: 'FeatureToggle', name: string, enabledAt: Date, values?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null }> | null }> | null }> | null } | null };

export type CreateFeatureToggleMutationVariables = Exact<{
  input: FeatureToggleInputDto;
}>;


export type CreateFeatureToggleMutation = { __typename?: 'Mutation', updateFeatureToggle?: { __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null, criteria?: { __typename?: 'FeatureCriteria', tags?: Array<{ __typename?: 'TagIdentifierType', type: TagType, name: string }> | null } | null, values?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null, values?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, values?: Array<{ __typename?: 'FeatureToggle', name: string, enabledAt: Date, disabledAt?: Date | null }> | null }> | null }> | null } | null };

export type DeleteFeatureToggleMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type DeleteFeatureToggleMutation = { __typename?: 'Mutation', deleteFeatureToggle?: boolean | null };

export type FinishRegistrationMutationVariables = Exact<{
  payload: FinishRegistrationDto;
}>;


export type FinishRegistrationMutation = { __typename?: 'Mutation', finishRegistration?: { __typename?: 'User', id: string, username: string, googleId?: string | null, hasFinishedRegistration?: boolean | null, isRegistered: boolean, wallets?: Array<{ __typename?: 'Wallet', address: string, type: string } | null> | null } | null };

export type FollowUserMutationVariables = Exact<{
  targetId: Scalars['Float'];
}>;


export type FollowUserMutation = { __typename?: 'Mutation', follow?: { __typename?: 'User', id: string, isFollowing: boolean } | null };

export type ForkFromFileMutationVariables = Exact<{
  fileId: Scalars['String'];
}>;


export type ForkFromFileMutation = { __typename?: 'Mutation', forkFromFile: { __typename?: 'Project', id: string } };

export type GenerateNonceMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateNonceMutation = { __typename?: 'Mutation', generateNonce: string };

export type GenerateSkyboxFromPromptMutationVariables = Exact<{
  prompt: Scalars['String'];
  sessionId: Scalars['ID'];
}>;


export type GenerateSkyboxFromPromptMutation = { __typename?: 'Mutation', generateSkyboxFromPrompt?: boolean | null };

export type GenerateSkyboxUrlMutationVariables = Exact<{
  prompt: Scalars['String'];
}>;


export type GenerateSkyboxUrlMutation = { __typename?: 'Mutation', generateSkyboxUrl: { __typename?: 'Skybox', thumbnail: string, cubenegx: string, cubenegy: string, cubenegz: string, cubeposx: string, cubeposy: string, cubeposz: string } };

export type GenerateUploadPictureUrlMutationVariables = Exact<{
  format: Scalars['String'];
}>;


export type GenerateUploadPictureUrlMutation = { __typename?: 'Mutation', generateUploadPictureURL: string };

export type GetDeleteAccountTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetDeleteAccountTokenMutation = { __typename?: 'Mutation', getDeleteAccountToken?: string | null };

export type LinkRpmAccountMutationVariables = Exact<{
  accountUserId: Scalars['String'];
}>;


export type LinkRpmAccountMutation = { __typename?: 'Mutation', linkRpmAccount?: { __typename?: 'Avatar', id: string, glbUrl: string, rpmUserId?: string | null, rpmAvatarId?: string | null, rpmGlbUrl?: string | null, rpmHasLinkedAccount?: boolean | null, thumbnail: string, name: string, provider: AvatarProvider, rpmJsonData?: { __typename?: 'RpmJsonData', outfitGender: string } | null } | null };

export type LinkWalletMutationVariables = Exact<{
  message: Scalars['String'];
  signature: Scalars['String'];
  walletType: Scalars['String'];
}>;


export type LinkWalletMutation = { __typename?: 'Mutation', linkWallet: boolean };

export type LogoutUserMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type LogoutUserMutation = { __typename?: 'Mutation', logoutUser: boolean };

export type LogoutAllDevicesMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type LogoutAllDevicesMutation = { __typename?: 'Mutation', logoutAllDevices: number };

export type MarkSuspensionAsResolvedMutationVariables = Exact<{
  payload: SuspendUserDto;
}>;


export type MarkSuspensionAsResolvedMutation = { __typename?: 'Mutation', suspendUser: { __typename?: 'Suspension', id: string, endedAt: Date } };

export type ModerateUserAccountMutationVariables = Exact<{
  payload: ModerateUserDto;
}>;


export type ModerateUserAccountMutation = { __typename?: 'Mutation', moderateUserAccount: { __typename?: 'User', id: string, email?: string | null } };

export type MuteChatMutationVariables = Exact<{
  payload: MutedChatDto;
}>;


export type MuteChatMutation = { __typename?: 'Mutation', muteChat?: { __typename?: 'MutedChat', id: string, chatId: string } | null };

export type NewRpmUserByUserIdMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type NewRpmUserByUserIdMutation = { __typename?: 'Mutation', newRpmUserByUserId: { __typename?: 'NewRpmUserByUserIdResponse', success: boolean } };

export type PinCommentMutationVariables = Exact<{
  commentId: Scalars['Float'];
  contentId: Scalars['Float'];
}>;


export type PinCommentMutation = { __typename?: 'Mutation', pinComment?: { __typename?: 'Comment', id: string, isPinned?: boolean | null } | null };

export type PostCommentMutationVariables = Exact<{
  contentId: Scalars['ID'];
  text: Scalars['String'];
  contentType: ContentType;
}>;


export type PostCommentMutation = { __typename?: 'Mutation', postComment?: { __typename?: 'Comment', contentId: string, contentType: ContentType, text: string, id: string, likes: number, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, isReported?: boolean | null, isLiked?: boolean | null, author: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, level?: number | null, isEmployee: boolean, isVerified: boolean, suspension?: { __typename?: 'Suspension', id: string } | null }, comments?: { __typename?: 'CommentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor: string, endCursor: string }, edges: Array<{ __typename?: 'Edge', node: { __typename?: 'Comment', contentId: string, contentType: ContentType, likes: number, isLiked?: boolean | null, isReported?: boolean | null, text: string, id: string, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null } } }> } | null } | null };

export type PreviewAssetMutationVariables = Exact<{
  input: PreviewAssetInput;
}>;


export type PreviewAssetMutation = { __typename?: 'Mutation', previewAsset?: { __typename?: 'AssetResponse', status: string, message: string, type: string } | null };

export type CreateProjectRewardItemMutationMutationVariables = Exact<{
  projectId: Scalars['ID'];
  values: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateProjectRewardItemMutationMutation = { __typename?: 'Mutation', createProjectReward?: { __typename?: 'ProjectReward', projectId: string, values: Array<string>, project: { __typename?: 'Project', id: string, title: string, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null } } | null };

export type DeleteProjectRewardMutationVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type DeleteProjectRewardMutation = { __typename?: 'Mutation', deleteProjectReward?: boolean | null };

export type UpdateProjectRewardMutationVariables = Exact<{
  projectId: Scalars['ID'];
  values: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateProjectRewardMutation = { __typename?: 'Mutation', updateProjectReward?: { __typename?: 'ProjectReward', projectId: string, values: Array<string>, project: { __typename?: 'Project', id: string, title: string, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null } } | null };

export type PublishProjectMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tags: Array<Scalars['String']> | Scalars['String'];
  visibility: Scalars['Int'];
  disableComments?: InputMaybe<Scalars['Boolean']>;
}>;


export type PublishProjectMutation = { __typename?: 'Mutation', publishProject?: { __typename?: 'Project', id: string, title: string, gameKit: GameKit, likes: number, description: string, createdAt: string, updatedAt: Date, publishedAt?: Date | null, views: number, totalViews: number, youtubeId?: string | null, playUrl?: string | null, isLiked?: boolean | null, isPublished: boolean, projectType: ProjectType, dataUrl: string, viewUrl?: string | null, engineVersion: number, categories: Array<string>, visibility: number, disableComments: boolean, isOwner: boolean, isHomeworld: boolean, featured: boolean, reFeaturedAt?: Date | null, locked: boolean, tags?: Array<string> | null, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string }>, totalCountComments?: { __typename?: 'CommentConnection', totalCount: number } | null, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null, thumbnails: Array<{ __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } }>, author: { __typename?: 'User', isFollowing: boolean, id: string, username: string, pictureUrl: string, level?: number | null, isVerified: boolean, isEmployee: boolean } } | null };

export type RefreshAccessTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', refreshAccessToken: string };

export type RemoveActiveSessionsFromMatchmakeMutationVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type RemoveActiveSessionsFromMatchmakeMutation = { __typename?: 'Mutation', removeActiveSessionsFromMatchmake?: boolean | null };

export type RemoveDescriptionMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type RemoveDescriptionMutation = { __typename?: 'Mutation', removeDescription?: { __typename?: 'User', id: string, username: string, description?: string | null } | null };

export type RemoveFeaturedProfileMutationMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type RemoveFeaturedProfileMutationMutation = { __typename?: 'Mutation', removeFeaturedProfile?: boolean | null };

export type RemoveFriendMutationVariables = Exact<{
  targetId: Scalars['Float'];
}>;


export type RemoveFriendMutation = { __typename?: 'Mutation', removeFriend: { __typename?: 'User', id: string, isFriends?: boolean | null, haveIFeaturedFriend: boolean } };

export type RemoveProfileBackgroundMutationVariables = Exact<{
  userId: Scalars['Float'];
}>;


export type RemoveProfileBackgroundMutation = { __typename?: 'Mutation', removeProfileBackground: { __typename?: 'User', id: string, profileBackgroundUrl: string } };

export type RemoveProfilePictureMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type RemoveProfilePictureMutation = { __typename?: 'Mutation', removeProfilePicture?: boolean | null };

export type RemoveSocialMediaTypeMutationVariables = Exact<{
  id: Scalars['Float'];
  type: SocialMediaType;
}>;


export type RemoveSocialMediaTypeMutation = { __typename?: 'Mutation', removeSocialMediaType?: { __typename: 'SocialMedia', id: string, twitch?: string | null, youtube?: string | null, twitter?: string | null, instagram?: string | null, tiktok?: string | null } | null };

export type RemoveTagFromContentMutationVariables = Exact<{
  contentId: Scalars['ID'];
  name: Scalars['String'];
  type: TagType;
}>;


export type RemoveTagFromContentMutation = { __typename?: 'Mutation', removeTagFromContent: boolean };

export type ReplyToCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
  text: Scalars['String'];
  contentType: ContentType;
}>;


export type ReplyToCommentMutation = { __typename?: 'Mutation', postComment?: { __typename: 'Comment', id: string, text: string, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, isLiked?: boolean | null, likes: number, isReported?: boolean | null, contentId: string, contentType: ContentType, author: { __typename?: 'User', level?: number | null, id: string, role?: number | null, username: string, pictureUrl: string, isVerified: boolean, isEmployee: boolean, suspension?: { __typename?: 'Suspension', id: string } | null } } | null };

export type ReportContentMutationVariables = Exact<{
  id: Scalars['ID'];
  type: ContentType;
  reason: ReportReason;
  reasonText?: InputMaybe<Scalars['String']>;
  rootContentId: Scalars['ID'];
  reportedUser?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
}>;


export type ReportContentMutation = { __typename?: 'Mutation', reportContent?: { __typename?: 'Chat', id: string, isReported?: boolean | null } | { __typename?: 'Comment', id: string, isReported?: boolean | null } | { __typename?: 'Image', id: string, isReported?: boolean | null } | { __typename?: 'Project', id: string, isReported?: boolean | null } | { __typename?: 'User', id: string, isReported?: boolean | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type ResetPasswordRequestMutationVariables = Exact<{
  email: Scalars['String'];
  captcha: Scalars['String'];
}>;


export type ResetPasswordRequestMutation = { __typename?: 'Mutation', resetPasswordRequest?: boolean | null };

export type RotateChallengesMutationVariables = Exact<{
  persistence: Persistence;
}>;


export type RotateChallengesMutation = { __typename?: 'Mutation', rotateChallenges: Array<{ __typename?: 'Challenge', badge: { __typename?: 'UserBadge', badge: { __typename?: 'Badge', id: string } } }> };

export type SetFriendRequestsSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type SetFriendRequestsSeenMutation = { __typename?: 'Mutation', setFriendRequestsSeen: boolean };

export type SetHomeworldMutationVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type SetHomeworldMutation = { __typename?: 'Mutation', createHomeworld?: { __typename: 'Homeworld', id: string, active: boolean, project: { __typename: 'Project', id: string, title: string, isHomeworld: boolean, isPublished: boolean, engineVersion: number, thumbnail?: { __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', id: string, url: string } } | null } } | null };

export type SetProjectAuthorMutationVariables = Exact<{
  newOwnerId: Scalars['Float'];
  projectId: Scalars['ID'];
}>;


export type SetProjectAuthorMutation = { __typename?: 'Mutation', setProjectAuthor: { __typename?: 'Project', id: string, author: { __typename?: 'User', id: string } } };

export type SetProjectPublishStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  isPublished: Scalars['Boolean'];
}>;


export type SetProjectPublishStatusMutation = { __typename?: 'Mutation', setPublishStatus?: { __typename?: 'Project', id: string, isPublished: boolean } | null };

export type SetSeenBadgesMutationVariables = Exact<{
  badgeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetSeenBadgesMutation = { __typename?: 'Mutation', setSeenBadges: boolean };

export type SetSeenSuspensionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetSeenSuspensionMutation = { __typename?: 'Mutation', setSeenSuspension?: { __typename: 'Suspension', id: string, seen: number } | null };

export type SetUserLevelMutationVariables = Exact<{
  userId: Scalars['ID'];
  level: Scalars['Float'];
}>;


export type SetUserLevelMutation = { __typename?: 'Mutation', setUserLevel: { __typename: 'Badge', id: string } | { __typename: 'SetUserLevelError', message?: string | null } };

export type SetUserRoleMutationVariables = Exact<{
  role: Scalars['Int'];
  userId: Scalars['ID'];
}>;


export type SetUserRoleMutation = { __typename?: 'Mutation', setUserRole: boolean };

export type SignInWithEthereumMutationVariables = Exact<{
  message: Scalars['String'];
  signature: Scalars['String'];
  walletType: Scalars['String'];
}>;


export type SignInWithEthereumMutation = { __typename?: 'Mutation', signInWithEthereum: { __typename?: 'AuthResponse', accessToken?: string | null, refreshToken?: string | null, user: { __typename?: 'User', id: string, username: string, totalPublishedGames?: number | null, isRegistered: boolean, hasAcceptedTos?: boolean | null, avatarV2?: { __typename?: 'Avatar', id: string, glbUrl: string } | null } } };

export type SignInWithGoogleCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type SignInWithGoogleCodeMutation = { __typename?: 'Mutation', signInWithGoogleCode?: { __typename?: 'AuthResponse', accessToken?: string | null, refreshToken?: string | null, user: { __typename?: 'User', hasAcceptedTos?: boolean | null, totalPublishedGames?: number | null, id: string, role?: number | null, email?: string | null, username: string, title?: string | null, pictureUrl: string, profileBackgroundUrl: string, description?: string | null, hasFinishedRegistration?: boolean | null, isValidAge?: boolean | null, isVerified: boolean, isEmployee: boolean, isRegistered: boolean, birthdate?: Date | null, notificationsAmount: number, xp?: number | null, currentXp?: number | null, xpToNextLevel?: number | null, timeSpentPlayingShooter?: number | null, uniqueGamesCompleted?: number | null, level?: number | null, googleId?: string | null, hasDefaultProfileImage: boolean, softCurrency?: number | null, amountOfFeaturedFriends?: number | null, isSuspended: boolean, avatarV2?: { __typename?: 'Avatar', id: string, glbUrl: string } | null, constants?: { __typename?: 'UserConstants', maxFeaturedFriends?: number | null } | null, session?: { __typename?: 'UserSession', id: string } | null, suspension?: { __typename: 'Suspension', id: string, seen: number, endedAt: Date, reason: ReportReason, customMessage?: string | null, type: SuspensionType } | null, warning?: { __typename: 'Suspension', id: string, seen: number, endedAt: Date, reason: ReportReason, customMessage?: string | null, type: SuspensionType } | null, socialMedia?: { __typename: 'SocialMedia', id: string, youtube?: string | null, twitter?: string | null, twitch?: string | null, instagram?: string | null, tiktok?: string | null } | null, getOrCreatePrivacySettings?: { __typename?: 'PrivacySettings', userId: number, directMessagingPublicity?: number | null, id: string, friendsArePublic?: number | null, onlyFriendsInMultiplayer: boolean, achievementPublicity: number } | null } } | null };

export type SignUpWithEmailMutationVariables = Exact<{
  payload: CreateUserDto;
}>;


export type SignUpWithEmailMutation = { __typename?: 'Mutation', createUser: { __typename?: 'AuthResponse', accessToken?: string | null, refreshToken?: string | null, user: { __typename?: 'User', id: string, pictureUrl: string, role?: number | null, username: string, level?: number | null, xp?: number | null } } };

export type SigninMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type SigninMutation = { __typename?: 'Mutation', loginUser?: { __typename?: 'AuthResponse', accessToken?: string | null, refreshToken?: string | null, user: { __typename?: 'User', id: string, birthdate?: Date | null, username: string, totalPublishedGames?: number | null, xp?: number | null, isRegistered: boolean, level?: number | null, session?: { __typename?: 'UserSession', id: string } | null } } | null };

export type SuspendUserMutationVariables = Exact<{
  username: Scalars['String'];
  customMessage?: InputMaybe<Scalars['String']>;
  reason: Scalars['Int'];
  endedAt: Scalars['Date'];
}>;


export type SuspendUserMutation = { __typename?: 'Mutation', suspendUser: { __typename?: 'Suspension', id: string } };

export type TagContentMutationVariables = Exact<{
  contentId: Scalars['ID'];
  contentType: ContentType;
  name: Scalars['String'];
  type: TagType;
}>;


export type TagContentMutation = { __typename?: 'Mutation', tagContent: boolean };

export type TagManyContentManyMutationVariables = Exact<{
  payload: CreateManyTagsForManyContentDto;
}>;


export type TagManyContentManyMutation = { __typename?: 'Mutation', tagManyContentMany: Array<Array<{ __typename?: 'ContentTagRelation', contentId: string, tagId: string }>> };

export type TagSelfMutationVariables = Exact<{
  name: Scalars['String'];
  type: TagType;
}>;


export type TagSelfMutation = { __typename?: 'Mutation', tagSelf: boolean };

export type ToggleLikeMutationVariables = Exact<{
  contentId: Scalars['ID'];
  type: ContentType;
}>;


export type ToggleLikeMutation = { __typename?: 'Mutation', toggleLike?: { __typename?: 'Chat' } | { __typename?: 'Comment', id: string, isLiked?: boolean | null, likes: number } | { __typename?: 'Image' } | { __typename?: 'Project', id: string, isLiked?: boolean | null, likes: number } | { __typename?: 'User' } | null };

export type UnblockUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UnblockUserMutation = { __typename?: 'Mutation', unblockUser?: boolean | null };

export type UnfollowUserMutationVariables = Exact<{
  targetId: Scalars['Float'];
}>;


export type UnfollowUserMutation = { __typename?: 'Mutation', unfollow?: { __typename?: 'User', id: string, isFollowing: boolean } | null };

export type UnlockAndEquipAssetToUserMutationVariables = Exact<{
  input: AssetUnlockAndEquipInput;
}>;


export type UnlockAndEquipAssetToUserMutation = { __typename?: 'Mutation', unlockAndEquipAssetToUser: { __typename?: 'UnlockAndEquipAssetToUserResponse', equipResult: { __typename?: 'AssetResponse', message: string, status: string, type: string }, unlockedAssetResponse: Array<{ __typename?: 'AssetResponse', message: string, status: string, type: string }> } };

export type UnlockAssetsForUsersMutationVariables = Exact<{
  input: AssetUnlockForUsersInput;
}>;


export type UnlockAssetsForUsersMutation = { __typename?: 'Mutation', unlockAssetsForUsers?: Array<{ __typename?: 'AssetResponse', message: string, status: string, type: string }> | null };

export type UnlockBadgeForUserMutationVariables = Exact<{
  username: Scalars['String'];
  badge: Scalars['String'];
}>;


export type UnlockBadgeForUserMutation = { __typename?: 'Mutation', unlockBadgeForUser?: { __typename?: 'Badge', id: string } | null };

export type UnlockRpmAssetAchievementMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnlockRpmAssetAchievementMutation = { __typename?: 'Mutation', unlockRpmAssetAchievement?: { __typename?: 'Avatar', id: string, unlockedAssets?: Array<{ __typename?: 'UnlockedAsset', id: string, provider: AvatarProvider, unlockedAt: Date }> | null, claimableRpmAchievement: Array<{ __typename?: 'UnlockableRpmAchievements', id: string }> } | null };

export type UnmuteChatMutationVariables = Exact<{
  payload: MutedChatDto;
}>;


export type UnmuteChatMutation = { __typename?: 'Mutation', unmuteChat?: boolean | null };

export type UpdateAppearanceMutationVariables = Exact<{
  input: UpdateAppearanceDto;
}>;


export type UpdateAppearanceMutation = { __typename?: 'Mutation', updateAppearance: { __typename?: 'Appearance', id: number, displayName: string, name: string, quality: AppearanceQuality, isPromotional: boolean, sourceDescription: string } };

export type UpdateCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
  text: Scalars['String'];
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', editComment: { __typename?: 'Comment', id: string, text: string } };

export type UpdateContentfulCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateContentfulCacheMutation = { __typename?: 'Mutation', updateContentfulCache?: boolean | null };

export type UpdateFeedbackMutationVariables = Exact<{
  correlation_id: Scalars['String'];
  rating: Scalars['Int'];
}>;


export type UpdateFeedbackMutation = { __typename?: 'Mutation', updateFeedback: boolean };

export type UpdateLootSeenStatusMutationVariables = Exact<{
  seen: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateLootSeenStatusMutation = { __typename?: 'Mutation', updateLootSeenStatus: boolean };

export type UpdateMessageMetadataMutationVariables = Exact<{
  result: Scalars['String'];
  id: Scalars['ID'];
}>;


export type UpdateMessageMetadataMutation = { __typename?: 'Mutation', updateChatMessageMetadata: { __typename?: 'ChatMessageMetadata', id: number } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tags: Array<Scalars['String']> | Scalars['String'];
  metaTags: Array<Scalars['String']> | Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
  visibility: Scalars['Int'];
  featured?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  reFeature?: InputMaybe<Scalars['Boolean']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  youtubeId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename: 'Project', id: string, title: string, description: string, isPublished: boolean, categories: Array<string>, tags?: Array<string> | null, visibility: number, featured: boolean, disableComments: boolean, youtubeId?: string | null, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string }>, author: { __typename?: 'User', id: string, pictureUrl: string, username: string, role?: number | null }, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null } | null };

export type UpdateReportMutationVariables = Exact<{
  id: Scalars['ID'];
  status: ReportStatus;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReportStatus?: { __typename?: 'ReportEntry', id: string, status: ReportStatus, resolved: boolean } | null };

export type UpdateEmailMutationVariables = Exact<{
  email: Scalars['String'];
  verifyAge?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateUserEmail?: { __typename?: 'User', id: string, email?: string | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  oldPassword?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updateUserPassword?: boolean | null };

export type UpdateFriendsPublicityMutationVariables = Exact<{
  friendsArePublic: Scalars['Int'];
}>;


export type UpdateFriendsPublicityMutation = { __typename?: 'Mutation', updateFriendsPublicity: { __typename?: 'PrivacySettings', id: string, friendsArePublic?: number | null } };

export type UpdateOnlyFriendsInMultiplayerMutationVariables = Exact<{
  onlyFriendsInMultiplayer: Scalars['Boolean'];
}>;


export type UpdateOnlyFriendsInMultiplayerMutation = { __typename?: 'Mutation', updateOnlyFriendsInMultiplayer: { __typename?: 'PrivacySettings', id: string, onlyFriendsInMultiplayer: boolean } };

export type UpdateBirthdateMutationVariables = Exact<{
  birthdate: Scalars['Date'];
}>;


export type UpdateBirthdateMutation = { __typename?: 'Mutation', updateBirthdate?: { __typename: 'User', id: string, birthdate?: Date | null } | null };

export type UpdateDescriptionMutationVariables = Exact<{
  description: Scalars['String'];
}>;


export type UpdateDescriptionMutation = { __typename?: 'Mutation', updateDescription?: { __typename?: 'User', id: string, description?: string | null } | null };

export type UpdateSocialMediaMutationVariables = Exact<{
  twitch?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  tiktok?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSocialMediaMutation = { __typename?: 'Mutation', updateSocialMedia?: { __typename?: 'SocialMedia', twitter?: string | null, instagram?: string | null, youtube?: string | null, twitch?: string | null, tiktok?: string | null } | null };

export type UpdateAchievementPublicityMutationVariables = Exact<{
  publicity: Scalars['Int'];
}>;


export type UpdateAchievementPublicityMutation = { __typename?: 'Mutation', updateAchievementPublicity: { __typename?: 'PrivacySettings', id: string, achievementPublicity: number } };

export type UpdateFavoriteGamesPublicityMutationVariables = Exact<{
  publicity: Scalars['Int'];
}>;


export type UpdateFavoriteGamesPublicityMutation = { __typename?: 'Mutation', updateFavoriteGamesPublicity: { __typename?: 'PrivacySettings', id: string, favoriteGamesArePublic?: number | null } };

export type UpdateDirectMessagingPublicityMutationVariables = Exact<{
  publicity: Scalars['Int'];
}>;


export type UpdateDirectMessagingPublicityMutation = { __typename?: 'Mutation', updateDirectMessagingPublicity: { __typename?: 'PrivacySettings', id: string, directMessagingPublicity?: number | null } };

export type UpdateProfileBackgroundMutationVariables = Exact<{
  format: Scalars['String'];
}>;


export type UpdateProfileBackgroundMutation = { __typename?: 'Mutation', updateProfileBackground: string };

export type UpdateUserTitleMutationVariables = Exact<{
  userTitle: Scalars['String'];
}>;


export type UpdateUserTitleMutation = { __typename?: 'Mutation', updateUserTitle?: { __typename?: 'User', id: string, title?: string | null } | null };

export type UpdateUsernameMutationVariables = Exact<{
  input: UpdateUsernameInput;
}>;


export type UpdateUsernameMutation = { __typename?: 'Mutation', updateUsername?: { __typename?: 'User', username: string } | null };

export type UpdateVisitedStatusMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  sourceId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['Int']>;
  status: Scalars['Boolean'];
  date?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateVisitedStatusMutation = { __typename?: 'Mutation', updateNotificationVisitedStatus: Array<{ __typename: 'Notification', id: string }> };

export type ValidateDeleteAccountTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidateDeleteAccountTokenQuery = { __typename?: 'Query', checkDeleteAccountToken?: boolean | null };

export type ValidateDirectMessageMutationVariables = Exact<{
  message: Scalars['String'];
  chatId: Scalars['String'];
}>;


export type ValidateDirectMessageMutation = { __typename?: 'Mutation', moderateDirectMessage: { __typename?: 'GQLModerateResponse', result: string } };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: boolean };

export type CreateProjectWithCreativeSessionMutationVariables = Exact<{
  channel: Scalars['String'];
  clientVersion?: InputMaybe<Scalars['String']>;
  clientNetworkProtocolVersion?: InputMaybe<Scalars['String']>;
  forkId?: InputMaybe<Scalars['Float']>;
}>;


export type CreateProjectWithCreativeSessionMutation = { __typename?: 'Mutation', createProjectWithCreativeSession: { __typename?: 'MultiplayerSession', id: string, sessionUrl?: string | null, sessionId: string, newlyCreated?: boolean | null, sessionStatus: MultiplayerSessionStatus, playerCount: number, maxPlayerCount: number, publicity: Publicity, currentProject?: { __typename?: 'Project', id: string } | null } };

export type SendFriendRequestMutationVariables = Exact<{
  userId: Scalars['Float'];
}>;


export type SendFriendRequestMutation = { __typename?: 'Mutation', sendFriendRequest: { __typename?: 'User', id: string, haveISentFriendRequest?: boolean | null, haveIReceivedFriendRequest?: boolean | null } };

export type AllAppearancesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAppearancesQuery = { __typename?: 'Query', allAppearances?: Array<{ __typename?: 'Appearance', id: number, name: string, displayName: string, thumbnailUrl: string, sourceDescription: string, quality: AppearanceQuality, isPromotional: boolean }> | null };

export type AllWarningsForUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type AllWarningsForUserQuery = { __typename?: 'Query', allWarningsForUser?: Array<{ __typename?: 'Suspension', id: string, customMessage?: string | null }> | null };

export type AuthUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, role?: number | null, hasFinishedRegistration?: boolean | null, isEmployee: boolean, username: string } | null };

export type BadgesQueryVariables = Exact<{ [key: string]: never; }>;


export type BadgesQuery = { __typename?: 'Query', badges?: Array<{ __typename?: 'Badge', id: string, name: string, displayName: string, level: number, icon: string, type?: Persistence | null, groupId: number }> | null };

export type BadgesByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type BadgesByUsernameQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, role?: number | null, username: string, badges?: Array<{ __typename?: 'UserBadge', createdAt?: Date | null, unlocked?: boolean | null, seen: boolean, user: { __typename?: 'User', id: string, username: string, isFriends?: boolean | null }, badge: { __typename?: 'Badge', displayName: string, id: string, level: number, groupId: number, icon: string, groupTotal?: number | null, description: string, locked_icon: string, criteriaData?: Array<{ __typename?: 'CriteriaData', total?: number | null, currentValue?: number | null, name?: string | null, badgeId: number }> | null, nextBadge?: { __typename?: 'Badge', description: string, criteriaData?: Array<{ __typename?: 'CriteriaData', total?: number | null, currentValue?: number | null, name?: string | null, badgeId: number }> | null } | null } }> | null } | null };

export type BlockedUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type BlockedUsersQuery = { __typename?: 'Query', me?: { __typename: 'User', id: string, blockedUsers?: Array<{ __typename?: 'BlockedUser', user2: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, level?: number | null, haveIBlocked: boolean } }> | null } | null };

export type BuildInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type BuildInfoQuery = { __typename?: 'Query', buildInfo: { __typename?: 'BuildInfo', latestCommit: string, revision: string, version: string } };

export type CheckVerifyEmailTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CheckVerifyEmailTokenQuery = { __typename?: 'Query', checkVerifyEmailToken?: boolean | null };

export type CheckoutSessionStatusQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type CheckoutSessionStatusQuery = { __typename?: 'Query', checkoutSessionStatus?: { __typename?: 'StripeCheckoutSessionStatus', isCompleted: boolean, paymentIntentId?: string | null } | null };

export type CommentsQueryVariables = Exact<{
  contentId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Float']>;
}>;


export type CommentsQuery = { __typename?: 'Query', repliesV2?: { __typename?: 'CommentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'Edge', node: { __typename?: 'Comment', contentId: string, contentType: ContentType, text: string, id: string, likes: number, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, isReported?: boolean | null, isLiked?: boolean | null, author: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, level?: number | null, isEmployee: boolean, isVerified: boolean, suspension?: { __typename?: 'Suspension', id: string } | null } } }> } | null };

export type CommentsWithRepliesQueryVariables = Exact<{
  contentId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['ID']>;
  includeContentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  first?: InputMaybe<Scalars['Float']>;
}>;


export type CommentsWithRepliesQuery = { __typename?: 'Query', repliesV2?: { __typename?: 'CommentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'Edge', node: { __typename?: 'Comment', contentId: string, contentType: ContentType, text: string, id: string, likes: number, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, isReported?: boolean | null, isLiked?: boolean | null, author: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, level?: number | null, isEmployee: boolean, isVerified: boolean, suspension?: { __typename?: 'Suspension', id: string } | null }, comments?: { __typename?: 'CommentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor: string, endCursor: string }, edges: Array<{ __typename?: 'Edge', node: { __typename?: 'Comment', contentId: string, contentType: ContentType, likes: number, isLiked?: boolean | null, isReported?: boolean | null, text: string, id: string, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null } } }> } | null } }> } | null };

export type CommonFriendsQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type CommonFriendsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, getCommonFriends: Array<{ __typename?: 'UserFriend', friendSince: Date, user: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, level?: number | null, isFriends?: boolean | null, isVerified: boolean, isEmployee: boolean } }> } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, role?: number | null, email?: string | null, username: string, title?: string | null, pictureUrl: string, profileBackgroundUrl: string, description?: string | null, hasFinishedRegistration?: boolean | null, hasAcceptedTos?: boolean | null, isValidAge?: boolean | null, isVerified: boolean, isEmployee: boolean, isRegistered: boolean, birthdate?: Date | null, notificationsAmount: number, xp?: number | null, currentXp?: number | null, xpToNextLevel?: number | null, timeSpentPlayingShooter?: number | null, totalPublishedGames?: number | null, uniqueGamesCompleted?: number | null, level?: number | null, googleId?: string | null, hasDefaultProfileImage: boolean, softCurrency?: number | null, amountOfFeaturedFriends?: number | null, isSuspended: boolean, constants?: { __typename?: 'UserConstants', maxFeaturedFriends?: number | null } | null, session?: { __typename?: 'UserSession', id: string } | null, suspension?: { __typename: 'Suspension', id: string, seen: number, endedAt: Date, reason: ReportReason, customMessage?: string | null, type: SuspensionType } | null, warning?: { __typename: 'Suspension', id: string, seen: number, endedAt: Date, reason: ReportReason, customMessage?: string | null, type: SuspensionType } | null, socialMedia?: { __typename: 'SocialMedia', id: string, youtube?: string | null, twitter?: string | null, twitch?: string | null, instagram?: string | null, tiktok?: string | null } | null, getOrCreatePrivacySettings?: { __typename?: 'PrivacySettings', userId: number, directMessagingPublicity?: number | null, id: string, friendsArePublic?: number | null, onlyFriendsInMultiplayer: boolean, achievementPublicity: number } | null } | null };

export type CurrentUserAvatarQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAvatarQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, avatarV2?: { __typename?: 'Avatar', id: string, glbUrl: string, rpmUserId?: string | null, rpmAvatarId?: string | null, rpmGlbUrl?: string | null, rpmHasLinkedAccount?: boolean | null, thumbnail: string, name: string, provider: AvatarProvider, rpmJsonData?: { __typename?: 'RpmJsonData', outfitGender: string } | null } | null } | null };

export type DailyChallengesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
}>;


export type DailyChallengesQuery = { __typename?: 'Query', dailyChallenges?: Array<{ __typename?: 'Challenge', expires: Date, badge: { __typename?: 'UserBadge', createdAt?: Date | null, unlocked?: boolean | null, badge: { __typename?: 'Badge', displayName: string, description: string, name: string, icon: string, locked_icon: string, id: string, difficulty?: BadgeDifficulty | null, criteriaData?: Array<{ __typename?: 'CriteriaData', total?: number | null, currentValue?: number | null }> | null } }, reward?: { __typename?: 'Reward', id: string, value: number } | null }> | null };

export type DaoLandingQueryVariables = Exact<{ [key: string]: never; }>;


export type DaoLandingQuery = { __typename?: 'Query', contentfulYoutubeLinks?: { __typename?: 'ContentfulYoutubeLinks', daoLandingPage?: string | null, daoLandingPageTitle?: string | null, daoLandingPageDescription?: string | null } | null };

export type FindFeatureToggleQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type FindFeatureToggleQuery = { __typename?: 'Query', findFeatureToggle?: { __typename?: 'FeatureToggle', name: string, isEnabled: boolean, isEnabledForUser: boolean, enabledAt: Date, disabledAt?: Date | null, description?: string | null, createdBy?: string | null, isConfig?: boolean | null, criteria?: { __typename?: 'FeatureCriteria', minLevel?: number | null, minRole?: number | null, tags?: Array<{ __typename?: 'TagIdentifierType', name: string, type: TagType }> | null } | null, values?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null, values?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null }> | null }> | null } | null };

export type FeaturedFriendsQueryVariables = Exact<{
  userId: Scalars['Float'];
  first: Scalars['Float'];
  cursor?: InputMaybe<Scalars['ID']>;
}>;


export type FeaturedFriendsQuery = { __typename?: 'Query', featuredFriends: { __typename?: 'FeaturedFriendConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, items: Array<{ __typename?: 'FeaturedFriend', id: string, createdAt: Date, targetId: string, target: { __typename?: 'User', id: string, pictureUrl: string, username: string, profileBackgroundUrl: string, isVerified: boolean, isEmployee: boolean, totalFollowers: number, isFollowing: boolean } }> } };

export type FeaturedProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturedProfilesQuery = { __typename?: 'Query', findAllFeaturedProfiles?: Array<{ __typename?: 'FeaturedProfile', userId: string, addedAt: Date, user: { __typename?: 'User', id: string, username: string, pictureUrl: string } }> | null };

export type FetchUsersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  role?: InputMaybe<UserRole>;
  first?: InputMaybe<Scalars['Float']>;
}>;


export type FetchUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UserConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, role?: number | null, level?: number | null, username: string, email?: string | null, pictureUrl: string, isVerified: boolean, isDeveloper: boolean, isBetatester: boolean, isEmployee: boolean, haveISentFriendRequest?: boolean | null, haveIReceivedFriendRequest?: boolean | null, isFriends?: boolean | null, createdAt: Date } }> } | null };

export type FindAllProjectRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllProjectRewardsQuery = { __typename?: 'Query', findAllProjectRewards?: Array<{ __typename?: 'ProjectReward', projectId: string, values: Array<string>, project: { __typename?: 'Project', id: string, title: string, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null } }> | null };

export type FindUsernameUpdatedAtQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type FindUsernameUpdatedAtQuery = { __typename?: 'Query', findUsernameUpdatedAt: { __typename?: 'UsernameUpdatedAt', isAllowChange: boolean, message: string, username: string, updatedAt?: string | null, userId: number } };

export type FollowingGamesQueryVariables = Exact<{
  first: Scalars['Float'];
  cursor?: InputMaybe<Scalars['ID']>;
  maxEngineVersion?: InputMaybe<Scalars['Int']>;
}>;


export type FollowingGamesQuery = { __typename?: 'Query', me?: { __typename: 'User', id: string, role?: number | null, projects: { __typename: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProjectEdge', node: { __typename: 'Project', id: string, title: string, likes: number, totalViews: number, tags?: Array<string> | null, gameKit: GameKit, engineVersion: number, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string, type: TagType }>, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null } } }> } } | null };

export type FriendRequestAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type FriendRequestAmountQuery = { __typename?: 'Query', friendRequestAmount?: number | null };

export type FriendRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type FriendRequestsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, getFriendInvites: Array<{ __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, haveIReceivedFriendRequest?: boolean | null, level?: number | null, isEmployee: boolean, isVerified: boolean }> } | null };

export type FrontPageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type FrontPageContentQuery = { __typename?: 'Query', frontPageContent: { __typename?: 'ContentfulFrontPageContent', hero?: { __typename?: 'ContentfulFrontPageHero', buttonLabel: string, header: string, projectIdOrButtonLink: string, showForLoggedIn: boolean, showForLoggedOut: boolean, subHeader?: string | null, preHeader?: string | null, heroBackground: { __typename?: 'ContentfulImage', url: string } } | null, feeds?: Array<{ __typename?: 'ContentfulFrontPageFeed', title: string, buttonLink?: string | null, buttonText?: string | null, tags?: Array<string> | null, specificProjectIds?: Array<string> | null, description?: string | null, includeSoMe: boolean, meta?: Array<string> | null, orderIndex: number, quantity?: number | null, onlyFollowing?: boolean | null, showForLoggedIn: boolean, showForLoggedOut: boolean, sortBy?: SortBy | null }> | null, article?: { __typename?: 'ContentfulNewsArticle', title: string, article: string, modalText?: string | null, modalButtonText?: string | null, modalTitle?: string | null, openModal?: boolean | null, ctaButtonLink?: string | null, ctaButtonText?: string | null, startDate?: Date | null, endDate?: Date | null, iosCtaButtonLink?: string | null, showForLoggedIn?: boolean | null, showForLoggedOut?: boolean | null, thumbnail?: { __typename?: 'ContentfulImage', url: string } | null } | null } };

export type GameKitSessionsQueryVariables = Exact<{
  gameKit: GameKit;
  cursor?: InputMaybe<Scalars['ID']>;
}>;


export type GameKitSessionsQuery = { __typename?: 'Query', getSessionsByGameKit: { __typename?: 'MultiplayerSessionConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'MultiplayerSessionEdge', node: { __typename?: 'MultiplayerSession', id: string, playerCount: number, maxPlayerCount: number, createdAt: string, sessionUrl?: string | null, publicity: Publicity, currentProject?: { __typename?: 'Project', title: string, id: string, gameKit: GameKit, likes: number, totalViews: number, disableComments: boolean, projectType: ProjectType, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, role?: number | null, username: string } } | null, settings?: { __typename?: 'PlatformerSessionSettings', id: string } | { __typename?: 'ShooterSessionSettings', id: string, subWinCondition: SubShooterWinCondition, winCondition: string, winConditionValue?: number | null, gameMode: string, timeLimit?: number | null } | null } }> } };

export type GameTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GameTemplatesQuery = { __typename?: 'Query', gameTemplates: Array<{ __typename?: 'Project', id: string, title: string, author: { __typename?: 'User', id: string, username: string }, thumbnail?: { __typename?: 'Thumbnail', small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null }> };

export type GetAppearancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppearancesQuery = { __typename?: 'Query', appearances: { __typename?: 'AppearanceConnection', items: Array<{ __typename?: 'Appearance', id: number, name: string, displayName: string, sourceDescription: string, type: AppearanceType, quality: AppearanceQuality, canEquip: boolean, description: string, appearanceQuality: string, thumbnailUrl: string, glbGZUrl: string, achievementIconUrl: string, isVariation: boolean, parentAppearanceId?: number | null, variations?: Array<{ __typename?: 'Appearance', id: number, name: string, displayName: string, description: string, sourceDescription: string, canEquip: boolean, quality: AppearanceQuality, thumbnailUrl: string, glbGZUrl: string, achievementIconUrl: string, appearanceQuality: string, isVariation: boolean, parentAppearanceId?: number | null, source: { __typename?: 'AppearanceSource', defaultSourceDescription?: string | null, badge?: { __typename?: 'Badge', displayName: string, level: number, description: string, groupTotal?: number | null, groupId: number } | null } }> | null, source: { __typename?: 'AppearanceSource', defaultSourceDescription?: string | null, badge?: { __typename?: 'Badge', displayName: string, level: number, description: string, groupTotal?: number | null, groupId: number } | null } }> } };

export type GetOrCreatePublicSessionForProjectQueryVariables = Exact<{
  channel: Scalars['String'];
  clientVersion: Scalars['String'];
  clientNetworkProtocolVersion: Scalars['String'];
  projectId: Scalars['ID'];
}>;


export type GetOrCreatePublicSessionForProjectQuery = { __typename?: 'Query', getOrCreatePublicSessionForProject: { __typename?: 'MultiplayerSession', id: string, sessionUrl?: string | null, sessionId: string, newlyCreated?: boolean | null, sessionStatus: MultiplayerSessionStatus, playerCount: number, maxPlayerCount: number, publicity: Publicity } };

export type GetScheduledProjectUpdatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScheduledProjectUpdatesQuery = { __typename?: 'Query', getScheduledProjectUpdates: Array<{ __typename?: 'ScheduledProjectUpdate', projectId: string, updateAt: Date, featured?: boolean | null, reFeature?: boolean | null, youtubeId?: string | null, project?: { __typename?: 'Project', id: string, title: string, description: string, engineVersion: number, totalViews: number, publishedAt?: Date | null, canEdit: boolean, isPublished: boolean, isLiked?: boolean | null, likes: number, isReported?: boolean | null, projectType: ProjectType, disableComments: boolean, youtubeId?: string | null, gameKit: GameKit, tags?: Array<string> | null, visibility: number, leaderboard?: { __typename?: 'Leaderboard', id: string } | null, thumbnail?: { __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', id: string, url: string } } | null, thumbnails: Array<{ __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', id: string, url: string } }>, author: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null, socialMedia?: { __typename?: 'SocialMedia', id: string, twitter?: string | null, twitch?: string | null, youtube?: string | null, instagram?: string | null, tiktok?: string | null } | null } } | null }> };

export type GoogleUserQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GoogleUserQuery = { __typename?: 'Query', googleUser?: { __typename?: 'User', id: string, googleId?: string | null } | null };

export type IsProfileImageReportedQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type IsProfileImageReportedQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, username: string, profileImage?: { __typename?: 'Image', id: string, isReported?: boolean | null } | null } | null };

export type IsSuspendedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsSuspendedQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, isSuspended: boolean } | null };

export type LatestHiberChallengeQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestHiberChallengeQuery = { __typename?: 'Query', latestHiberChallenge?: { __typename?: 'HiberChallenge', title: string, tag: string, description?: string | null, buttonText?: string | null, featuredGameId?: string | null, thumbnail: { __typename?: 'HiberChallengeThumbnail', url: string }, thumbnailSmall?: { __typename?: 'HiberChallengeThumbnail', url: string } | null } | null };

export type LatestNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestNewsQuery = { __typename?: 'Query', latestNewsArticle?: { __typename?: 'ContentfulNewsArticle', title: string, ctaButtonText?: string | null, ctaButtonLink?: string | null, iosCtaButtonLink?: string | null, showForLoggedIn?: boolean | null, showForLoggedOut?: boolean | null, startDate?: Date | null, endDate?: Date | null, modalTitle?: string | null, modalButtonText?: string | null, modalText?: string | null, openModal?: boolean | null, article: string, thumbnail?: { __typename?: 'ContentfulImage', url: string } | null } | null };

export type LeaderboardQueryVariables = Exact<{
  projectId: Scalars['ID'];
  platform: LeaderboardPlatform;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  timespan?: InputMaybe<LeaderboardPeriod>;
  group?: InputMaybe<LeaderboardGroup>;
  cycle?: InputMaybe<Scalars['Int']>;
}>;


export type LeaderboardQuery = { __typename?: 'Query', leaderboard?: { __typename?: 'Leaderboard', id: string, project?: { __typename?: 'Project', author: { __typename?: 'User', id: string, username: string } } | null, me?: { __typename?: 'LeaderboardEntry', rank: number, score: number, attempts: number, user: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string } } | null, entries?: { __typename?: 'LeaderBoardEntries', hasNextPage: boolean, entries: Array<{ __typename?: 'LeaderboardEntry', rank: number, score: number, attempts: number, user: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string } }> } | null } | null };

export type LeaderboardV2QueryVariables = Exact<{
  projectId: Scalars['ID'];
  platform: LeaderboardPlatform;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<LeaderboardScoreKind>;
  order?: InputMaybe<LeaderboardSortOrder>;
  type: Scalars['String'];
}>;


export type LeaderboardV2Query = { __typename?: 'Query', leaderboardV2: { __typename?: 'LeaderboardV2Output', type: string, leaderboard: Array<{ __typename?: 'LeaderboardEntryV2', score: number, rank: number, id: number, user: { __typename?: 'User', id: string, username: string, pictureUrl: string, isEmployee: boolean, isVerified: boolean } }>, myResult?: { __typename?: 'LeaderboardMyEntry', score: number, rank: number } | null, pageInfo: { __typename?: 'PageInfoV2', startCursor: string, endCursor: string, hasNextPage: boolean } } };

export type LootQueryVariables = Exact<{
  payload?: InputMaybe<FetchLootDto>;
}>;


export type LootQuery = { __typename?: 'Query', loot?: Array<{ __typename?: 'Loot', id: number, type: LootType, createdAt: Date, seen: boolean, refId: number, content: { __typename?: 'LootContent', title?: string | null, src?: string | null, rarity?: string | null, description?: string | null, persistence?: Persistence | null, values?: Array<{ __typename?: 'LootValues', type?: RewardType | null, subType?: number | null, value?: number | null, imageUrl?: string | null }> | null } }> | null };

export type MatchmakeQueryVariables = Exact<{
  request: MatchmakeRequest;
}>;


export type MatchmakeQuery = { __typename?: 'Query', matchMake: { __typename?: 'MatchmakeResponse', id: string, sessionUrl?: string | null } };

export type MessageToBeReviewedQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type MessageToBeReviewedQuery = { __typename?: 'Query', messageToBeReviewed?: { __typename?: 'ChatMessageMetadata', confidence?: number | null, result: string, id: number, history: Array<{ __typename?: 'ChatMessage', message: string, id: number, sender?: { __typename?: 'User', id: string, role?: number | null, username: string } | null }> } | null };

export type MessagesToBeReviewedQueryVariables = Exact<{
  humanReviewed: Scalars['Boolean'];
}>;


export type MessagesToBeReviewedQuery = { __typename?: 'Query', messagesToBeReviewed: Array<{ __typename?: 'ChatMessageMetadata', confidence?: number | null, result: string, id: number, humanReviewed: boolean, message: { __typename?: 'ChatMessage', message: string, id: number, createdAt: Date, sender?: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string } | null } }> };

export type MyProjectsQueryVariables = Exact<{
  first: Scalars['Float'];
  cursor?: InputMaybe<Scalars['ID']>;
  sortBy: SortBy;
  maxEngineVersion?: InputMaybe<Scalars['Int']>;
}>;


export type MyProjectsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, role?: number | null, username: string, projects: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, title: string, description: string, isPublished: boolean, visibility: number, totalViews: number, likes: number, tags?: Array<string> | null, gameKit: GameKit, createdAt: string, publishedAt?: Date | null, deletedAt?: Date | null, featured: boolean, projectType: ProjectType, engineVersion: number, isHomeworld: boolean, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string, type: TagType }>, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null, thumbnails: Array<{ __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } }>, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, suspension?: { __typename?: 'Suspension', id: string } | null } } }> } } | null };

export type MyTotalFriendsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTotalFriendsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, totalFriends: number } | null };

export type NextBadgeQueryVariables = Exact<{
  badgeId: Scalars['Float'];
  userId: Scalars['Int'];
  skip: Scalars['Boolean'];
}>;


export type NextBadgeQuery = { __typename?: 'Query', badge?: { __typename?: 'Badge', id: string, criteriaData?: Array<{ __typename?: 'CriteriaData', currentValue?: number | null, total?: number | null, name?: string | null, badgeId: number }> | null, nextBadge?: { __typename?: 'Badge', displayName: string, level: number, id: string, description: string, criteriaData?: Array<{ __typename?: 'CriteriaData', currentValue?: number | null, total?: number | null, name?: string | null, badgeId: number }> | null, rewards: Array<{ __typename?: 'Reward', id: string, value: number, rewardItemName?: string | null, subType: number, type: number }> } | null, rewards: Array<{ __typename?: 'Reward', id: string, value: number, subType: number, type: number, rewardItemName?: string | null }> } | null };

export type NotificationsAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsAmountQuery = { __typename?: 'Query', notificationsAmount: number };

export type NotificationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', me?: { __typename: 'User', id: string, notifications?: { __typename?: 'NotificationConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'NotificationEdge', id: string, sourceId: string, type: number, read: boolean, total: number, createdAt: Date, sourceContentType?: number | null, visited?: boolean | null, message?: string | null, content: { __typename?: 'NotificationContent', title?: string | null, image?: { __typename?: 'Image', url: string } | null, linkTo: { __typename?: 'LinkTo', as: string, href: string }, customData?: { __typename?: 'CustomData', commentText: string, gameKit?: GameKit | null, projectTitle?: string | null } | null }, lastUsers: Array<{ __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string }> }> } | null } | null };

export type NumberOfActivePlayersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NumberOfActivePlayersQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, numberOfActivePlayersV2: number } | null };

export type OnlineFriendsQueryVariables = Exact<{ [key: string]: never; }>;


export type OnlineFriendsQuery = { __typename?: 'Query', onlineFriends: Array<{ __typename?: 'UserFriend', friendSince: Date, user: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, level?: number | null, pictureUrl: string, isValidAge?: boolean | null, privacySettings?: { __typename?: 'PrivacySettings', directMessagingPublicity?: number | null } | null, session?: { __typename?: 'UserSession', id: string, sessionStatus: UserSessionStatus, actionStatus: UserSessionActionStatus, sessionLength: number } | null, activeSession?: { __typename?: 'Session', id: string, type: SessionType, sessionUrl?: string | null, players: Array<{ __typename?: 'SessionUserType', sessionUserId: string, sessionUsername: string }>, project: { __typename?: 'Project', id: string, title: string, numberOfActivePlayersV2: number, engineVersion: number, visibility: number, gameKit: GameKit, completionRate: number, totalViews: number, thumbnail?: { __typename?: 'Thumbnail', medium: { __typename?: 'Image', url: string }, small: { __typename?: 'Image', url: string } } | null } } | null } }> };

export type PageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  previewUserType?: InputMaybe<UserType>;
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', title: string, slug: string, modules: Array<{ __typename: 'Banner', id: string, header: string, text?: string | null, buttonLabel: string, projectIdOrButtonLink: string, bannerLayout?: BannerLayout | null, background?: { __typename?: 'CMSImage', url: string } | null } | { __typename: 'Carousel', id: string, items: Array<{ __typename?: 'Banner', id: string, header: string, text?: string | null, layout?: BannerLayout | null, buttonLabel: string, projectIdOrButtonLink: string, background?: { __typename?: 'CMSImage', url: string } | null, backgroundVideo?: { __typename?: 'CMSVideo', url: string } | null }> } | { __typename: 'ChallengeBanner', id: string, projectIdOrLink?: string | null, buttonText?: string | null } | { __typename: 'Hero', id: string, header: string, preHeader?: string | null, subHeader?: string | null, buttonLabel: string, projectIdOrButtonLink: string, background?: { __typename?: 'CMSImage', url: string } | null } | { __typename: 'NewsFeed', id: string } | { __typename: 'ProjectFeedRegular', id: string, title: string, layout: FeedCardLayout, showAuthor?: boolean | null, quantity: number, sortBy: SortBy, tags?: Array<string> | null, metaTags?: Array<string> | null, forkIds?: Array<string> | null, directPlayOnClick: boolean, filters?: Array<FeedFilter> | null, page?: { __typename?: 'ProjectFeedPage', title: string, slug: string, filters?: Array<FeedFilter> | null, metaTags?: Array<string> | null, tags?: Array<string> | null, sortBy: Array<SortBy> } | null } | { __typename: 'ProjectFeedSpecific', id: string, title: string, layout: FeedCardLayout, showAuthor?: boolean | null, projectIds: Array<string>, directPlayOnClick: boolean, page?: { __typename?: 'ProjectFeedPage', slug: string } | null } | { __typename: 'Section', id: string, title: string } | { __typename: 'SessionFeed', id: string, title: string, quantity: number, liveEvents: Array<{ __typename?: 'LiveEvent', id: string, worldId: string, label: string }> } | { __typename: 'UserFeedOnlineFriends', id: string, title: string } | { __typename: 'UserFeedRegular', title: string, quantity: number, metaTags?: Array<string> | null, tags?: Array<string> | null, layout: FeedCardLayout, cta?: UserFeedCta | null }> } | null };

export type PaymentDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PaymentDetailsQuery = { __typename?: 'Query', paymentDetails?: { __typename?: 'StripePaymentDetails', chargeId: string, orderDate: number, paymentMethodType: string, subtotal: number, total: number, currency: string, taxAmount: number, receiptNumber?: string | null } | null };

export type PrivacySettingsQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type PrivacySettingsQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, getOrCreatePrivacySettings?: { __typename?: 'PrivacySettings', id: string, userId: number, friendsArePublic?: number | null, onlyFriendsInMultiplayer: boolean, achievementPublicity: number, favoriteGamesArePublic?: number | null, directMessagingPublicity?: number | null } | null } | null };

export type ProductByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProductByIdQuery = { __typename?: 'Query', productById?: { __typename?: 'EmoteShopItem', emoteId: string, videoUrl: string, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null } | { __typename?: 'GameAssetShopItem', gameAssetId: string, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null } | { __typename?: 'RpmShopItem', brandLogoUrl?: string | null, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null } | null };

export type ProfilePageUserQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type ProfilePageUserQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, level?: number | null, role?: number | null, username: string, title?: string | null, description?: string | null, pictureUrl: string, birthdate?: Date | null, profileBackgroundUrl: string, isFollowing: boolean, isFriends?: boolean | null, deletedAt?: Date | null, isValidAge?: boolean | null, hasDefaultProfileImage: boolean, isVerified: boolean, isDeveloper: boolean, isBetatester: boolean, isEmployee: boolean, totalFollowers: number, totalProjectViews: number, haveIReceivedFriendRequest?: boolean | null, haveISentFriendRequest?: boolean | null, haveIFeaturedFriend: boolean, haveIBlocked: boolean, haveIReported: boolean, socialMedia?: { __typename?: 'SocialMedia', id: string, twitter?: string | null, twitch?: string | null, instagram?: string | null, youtube?: string | null, tiktok?: string | null } | null, activeSession?: { __typename?: 'Session', id: string, type: SessionType, sessionUrl?: string | null, project: { __typename?: 'Project', id: string, title: string, numberOfActivePlayersV2: number, engineVersion: number, visibility: number, thumbnail?: { __typename?: 'Thumbnail', medium: { __typename?: 'Image', url: string } } | null } } | null, getOrCreatePrivacySettings?: { __typename?: 'PrivacySettings', id: string, userId: number, friendsArePublic?: number | null, onlyFriendsInMultiplayer: boolean, achievementPublicity: number, favoriteGamesArePublic?: number | null, directMessagingPublicity?: number | null } | null } | null };

export type ProjectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', categories: Array<string>, iframeUrl?: string | null, id: string, title: string, description: string, totalViews: number, completionRate: number, publishedAt?: Date | null, rePublishedAt?: Date | null, createdAt: string, updatedAt: Date, canEdit: boolean, isPublished: boolean, isLiked?: boolean | null, likes: number, isReported?: boolean | null, featured: boolean, forkId?: string | null, locked: boolean, projectType: ProjectType, disableComments: boolean, isHomeworld: boolean, youtubeId?: string | null, gameKit: GameKit, engineVersion: number, tags?: Array<string> | null, visibility: number, playUrl?: string | null, isRestricted: boolean, madeWithHDK: boolean, carSoccer: boolean, carSumo: boolean, tanks: boolean, copsAndRobbers: boolean, match: boolean, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string, type: TagType }>, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null, thumbnails: Array<{ __typename?: 'Thumbnail', medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } }>, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, socialMedia?: { __typename?: 'SocialMedia', id: string, twitter?: string | null, twitch?: string | null, youtube?: string | null, instagram?: string | null, tiktok?: string | null } | null, suspension?: { __typename?: 'Suspension', id: string } | null }, badges: Array<{ __typename?: 'Badge', id: string, icon: string, displayName: string, description: string, rewards: Array<{ __typename?: 'Reward', id: string, value: number, type: number, subType: number }> }> } | null };

export type ProjectActiveFriendsQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ProjectActiveFriendsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, activeFriends: Array<{ __typename?: 'User', id: string, username: string, pictureUrl: string }> } | null };

export type ProjectCommentsQueryVariables = Exact<{
  projectId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['ID']>;
}>;


export type ProjectCommentsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, comments?: { __typename?: 'CommentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'Edge', node: { __typename?: 'Comment', text: string, id: string, likes: number, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, isReported?: boolean | null, isLiked?: boolean | null, author: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, level?: number | null, suspension?: { __typename?: 'Suspension', id: string } | null }, comments?: { __typename?: 'CommentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor: string, endCursor: string }, edges: Array<{ __typename?: 'Edge', node: { __typename?: 'Comment', likes: number, isLiked?: boolean | null, isReported?: boolean | null, text: string, id: string, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null } } }> } | null } }> } | null } | null };

export type ProjectEmbedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectEmbedQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, playUrl?: string | null, title: string, description: string, thumbnail?: { __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', id: string, url: string } } | null } | null };

export type ProjectFeedPageQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProjectFeedPageQuery = { __typename?: 'Query', projectFeedPage?: { __typename?: 'ProjectFeedPage', title: string, slug: string, filters?: Array<FeedFilter> | null, metaTags?: Array<string> | null, tags?: Array<string> | null, forkIds?: Array<string> | null, sortBy: Array<SortBy>, description?: string | null, background?: { __typename?: 'CMSImage', url: string } | null } | null };

export type ProjectTemplatesQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProjectTemplatesQuery = { __typename?: 'Query', projectTemplates: Array<{ __typename?: 'ProjectTemplate', id: string, isNew: boolean, category?: string | null, project?: { __typename?: 'Project', id: string, title: string, author: { __typename?: 'User', id: string, username: string }, thumbnail?: { __typename?: 'Thumbnail', small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null } | null }> };

export type ProjectsQueryVariables = Exact<{
  first: Scalars['Float'];
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortBy>;
  gamekit?: InputMaybe<GameKit>;
  requireRelevancy?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  meta?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  forkIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  maxEngineVersion?: InputMaybe<Scalars['Int']>;
  minEngineVersion?: InputMaybe<Scalars['Int']>;
  filterFollowing?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProjectsQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, title: string, completionRate: number, engineVersion: number, gameKit: GameKit, featured: boolean, totalViews: number, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, username: string, pictureUrl: string, isEmployee: boolean, isVerified: boolean } } }> } | null };

export type ProjectsByIdsQueryVariables = Exact<{
  projectIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ProjectsByIdsQuery = { __typename?: 'Query', projectsByIds?: Array<{ __typename?: 'Project', id: string, title: string, engineVersion: number, gameKit: GameKit, completionRate: number, featured: boolean, totalViews: number, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, username: string, pictureUrl: string, isEmployee: boolean, isVerified: boolean } }> | null };

export type ProjectsByUserQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Float']>;
  username: Scalars['String'];
  cursor?: InputMaybe<Scalars['ID']>;
  filterFavorites?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<SortBy>;
  maxEngineVersion?: InputMaybe<Scalars['Int']>;
}>;


export type ProjectsByUserQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, role?: number | null, username: string, projects: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, title: string, description: string, isPublished: boolean, visibility: number, featured: boolean, totalViews: number, engineVersion: number, completionRate: number, likes: number, tags?: Array<string> | null, projectType: ProjectType, createdAt: string, deletedAt?: Date | null, publishedAt?: Date | null, gameKit: GameKit, isHomeworld: boolean, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string, type: TagType }>, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string }, large: { __typename?: 'Image', id: string, url: string } } | null, thumbnails: Array<{ __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } }>, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null } } }> } } | null };

export type ProviderSessionTokenQueryVariables = Exact<{
  provider: AvatarProvider;
}>;


export type ProviderSessionTokenQuery = { __typename?: 'Query', providerSessionToken?: string | null };

export type QuerySnippetModelQueryVariables = Exact<{
  question: Scalars['String'];
  prev_output?: InputMaybe<Scalars['String']>;
  prefabId?: InputMaybe<Scalars['String']>;
  correlation_id?: InputMaybe<Scalars['String']>;
  place_prefab?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuerySnippetModelQuery = { __typename?: 'Query', querySnippetModel: { __typename?: 'QuerySnippetModelResponse', correlation_id: string, creator_ver: string, data: Array<string>, endpoint_ver: string, prev_output: string, seed: number } };

export type QueryWorldModelQueryVariables = Exact<{
  correlation_id: Scalars['String'];
  prev_output?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
  seed?: InputMaybe<Scalars['Int']>;
  strategy?: InputMaybe<Scalars['String']>;
}>;


export type QueryWorldModelQuery = { __typename?: 'Query', queryWorldModel: { __typename?: 'QueryWorldModelResponse', prev_output: string, data: Array<string>, reply?: string | null, endpoint_ver: string, creator_ver: string, correlation_id: string, seed: number, strategy: string } };

export type RandomSessionQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']>;
  gameKit?: InputMaybe<GameKit>;
}>;


export type RandomSessionQuery = { __typename?: 'Query', randomSession?: { __typename?: 'MultiplayerSession', id: string, sessionUrl?: string | null, sessionId: string, newlyCreated?: boolean | null, sessionStatus: MultiplayerSessionStatus, playerCount: number, maxPlayerCount: number, publicity: Publicity, currentProject?: { __typename?: 'Project', id: string, title: string, projectType: ProjectType, totalViews: number, disableComments: boolean, likes: number, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, role?: number | null, username: string } } | null } | null };

export type RandomizedUsernamesQueryVariables = Exact<{
  amount: Scalars['Int'];
}>;


export type RandomizedUsernamesQuery = { __typename?: 'Query', randomizedUsernames?: Array<string> | null };

export type RecommendationsQueryVariables = Exact<{
  quantity: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<RecommendationSort>;
  projectId?: InputMaybe<Scalars['String']>;
}>;


export type RecommendationsQuery = { __typename?: 'Query', recommendations: { __typename?: 'RecommendationResult', cursor?: string | null, items: Array<{ __typename?: 'Project', id: string, title: string, engineVersion: number, featured: boolean, totalViews: number, gameKit: GameKit, completionRate: number, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, username: string, pictureUrl: string, isEmployee: boolean, isVerified: boolean } }> } };

export type RepliesQueryVariables = Exact<{
  commentId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['ID']>;
  first: Scalars['Float'];
}>;


export type RepliesQuery = { __typename?: 'Query', replies?: { __typename?: 'CommentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'Edge', node: { __typename?: 'Comment', contentId: string, contentType: ContentType, likes: number, isLiked?: boolean | null, text: string, id: string, createdAt: string, updatedAt: Date, deletedAt?: Date | null, isPinned?: boolean | null, isReported?: boolean | null, author: { __typename?: 'User', isVerified: boolean, isEmployee: boolean, id: string, level?: number | null, role?: number | null, username: string, pictureUrl: string, suspension?: { __typename?: 'Suspension', id: string } | null } } }> } | null };

export type ReportsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<ContentType>;
  status?: InputMaybe<ReportStatus>;
  sortBy?: InputMaybe<SortReportBy>;
}>;


export type ReportsQuery = { __typename?: 'Query', reports: Array<{ __typename?: 'ReportEntry', id: string, contentId: string, reason: ReportReason, contentType: ContentType, status: ReportStatus, totalReports?: number | null, projectId?: string | null, createdAt: Date, resolved: boolean, content?: { __typename: 'Chat' } | { __typename: 'Comment', id: string, contentId: string, contentType: ContentType, rawText: string, author: { __typename?: 'User', id: string, role?: number | null, username: string, suspension?: { __typename?: 'Suspension', id: string } | null, suspensions: Array<{ __typename?: 'Suspension', id: string, createdAt: Date, endedAt: Date, reason: ReportReason, customMessage?: string | null }> } } | { __typename: 'Image', id: string, file: { __typename?: 'File', id: string, owner: { __typename?: 'User', id: string, role?: number | null, username: string, pictureUrl: string, suspension?: { __typename?: 'Suspension', id: string } | null, suspensions: Array<{ __typename?: 'Suspension', id: string, createdAt: Date, endedAt: Date, reason: ReportReason, customMessage?: string | null }> } } } | { __typename: 'Project', title: string, id: string, description: string, viewUrl?: string | null, author: { __typename?: 'User', id: string, role?: number | null, username: string, suspension?: { __typename?: 'Suspension', id: string } | null, suspensions: Array<{ __typename?: 'Suspension', id: string, createdAt: Date, endedAt: Date, reason: ReportReason, customMessage?: string | null }> }, thumbnail?: { __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', url: string, id: string } } | null } | { __typename: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, suspension?: { __typename?: 'Suspension', id: string } | null, suspensions: Array<{ __typename?: 'Suspension', id: string, createdAt: Date, endedAt: Date, reason: ReportReason, customMessage?: string | null }> } | null }> };

export type ReportsForContentQueryVariables = Exact<{
  contentId: Scalars['ID'];
}>;


export type ReportsForContentQuery = { __typename?: 'Query', reportsForContent: Array<{ __typename?: 'ReportEntry', id: string, contentType: ContentType, contentId: string, reason: ReportReason, reasonText: string, createdAt: Date, status: ReportStatus, resolved: boolean, user?: { __typename?: 'User', id: string, role?: number | null, username: string } | null }> };

export type RequestAccessToProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type RequestAccessToProjectQuery = { __typename?: 'Query', requestAccessToProject: { __typename?: 'ProjectAccessResponse', granted: boolean, reason?: AccessControlReason | null } };

export type RewardLadderQueryVariables = Exact<{ [key: string]: never; }>;


export type RewardLadderQuery = { __typename?: 'Query', criteriasForBadgeGroupId: Array<{ __typename?: 'Criteria', id: string, total: number, badgeId: number }>, me?: { __typename?: 'User', id: string, isRegistered: boolean, level?: number | null, avatarV2?: { __typename?: 'Avatar', id: string, provider: AvatarProvider, unlockedAssets?: Array<{ __typename?: 'UnlockedAsset', id: string }> | null } | null } | null, unlockableRpmAchievements: Array<{ __typename?: 'UnlockableRpmAchievements', id: string, title: string, description: string, maleId: string, femaleId: string, thumbnail: string, thumbnailDetailed: string, type: string, rarity: string, levelRequired: number }> };

export type SearchFriendsQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type SearchFriendsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, getFriends?: { __typename?: 'UserFriendConnection', edges: Array<{ __typename?: 'UserFriendEdge', node: { __typename?: 'UserFriend', user: { __typename?: 'User', id: string, username: string, pictureUrl: string, isValidAge?: boolean | null, privacySettings?: { __typename?: 'PrivacySettings', userId: number, id: string, directMessagingPublicity?: number | null } | null, activeSession?: { __typename?: 'Session', id: string, project: { __typename?: 'Project', id: string, title: string, thumbnail?: { __typename?: 'Thumbnail', large: { __typename?: 'Image', url: string } } | null } } | null, session?: { __typename?: 'UserSession', id: string, sessionStatus: UserSessionStatus, lastSeen: Date, actionStatus: UserSessionActionStatus } | null } } }> } | null } | null };

export type SessionsByProjectsQueryVariables = Exact<{
  limit: Scalars['Int'];
  projectIds: Array<Scalars['ID']> | Scalars['ID'];
  showPinnedWorlds: Scalars['Boolean'];
}>;


export type SessionsByProjectsQuery = { __typename?: 'Query', mostPopularProjectsV2: Array<{ __typename?: 'Project', numberOfActivePlayersV2: number, id: string, title: string, isRestricted: boolean, visibility: number, iframeUrl?: string | null, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null }>, projectsByIds?: Array<{ __typename?: 'Project', id: string, title: string, iframeUrl?: string | null, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null }> | null };

export type SocialFeedQueryVariables = Exact<{
  payload?: InputMaybe<ProjectSearchDto>;
  includeOwnGames?: InputMaybe<Scalars['Boolean']>;
}>;


export type SocialFeedQuery = { __typename?: 'Query', socialFeed?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Project', id: string, title: string, completionRate: number, gameKit: GameKit, engineVersion: number, featured: boolean, totalViews: number, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, username: string, pictureUrl: string, isEmployee: boolean, isVerified: boolean } }> } | null };

export type SuspensionsByUserIdQueryVariables = Exact<{
  userId: Scalars['Float'];
}>;


export type SuspensionsByUserIdQuery = { __typename?: 'Query', suspensionsByUserId?: Array<{ __typename?: 'Suspension', id: string, customMessage?: string | null, reason: ReportReason, endedAt: Date, createdAt: Date }> | null };

export type TagsQueryVariables = Exact<{
  first: Scalars['Float'];
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortBy>;
  minEngineVersion?: InputMaybe<Scalars['Int']>;
  maxEngineVersion?: InputMaybe<Scalars['Int']>;
  tagTypes?: InputMaybe<Array<TagType> | TagType>;
  preferExactMatch?: InputMaybe<Scalars['Boolean']>;
  contentTypes?: InputMaybe<Array<ContentType> | ContentType>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'TagEdge', node: { __typename?: 'Tag', id: string, name: string, type: TagType, totalContent: number, projects: Array<{ __typename?: 'Project', id: string, title: string, likes: number, totalViews: number, tags?: Array<string> | null, completionRate: number, engineVersion: number, gameKit: GameKit, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string, type: TagType }>, thumbnail?: { __typename?: 'Thumbnail', id: string, small: { __typename?: 'Image', id: string, url: string }, medium: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, pictureUrl: string, level?: number | null, isFollowing: boolean, suspension?: { __typename?: 'Suspension', id: string } | null } }> } }> } };

export type TutorialSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type TutorialSectionQuery = { __typename?: 'Query', tutorialSections: Array<{ __typename?: 'TutorialSection', id: string, title: string, description?: string | null, tutorialVideos: Array<{ __typename?: 'TutorialVideo', title?: string | null, name: string, videoLink: string, thumbnailUrl: string }> }> };

export type UnlockedAchiementsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Float']>;
  username: Scalars['String'];
  after?: InputMaybe<Scalars['ID']>;
}>;


export type UnlockedAchiementsQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, unlockedBadges?: { __typename?: 'UnlockedBadgeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, items: Array<{ __typename?: 'UnlockedBadge', id: string, createdAt: string, badge: { __typename?: 'Badge', displayName: string, id: string, level: number, groupId: number, icon: string, groupTotal?: number | null, locked_icon: string, description: string } }> } | null } | null };

export type UnlockedAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnlockedAssetsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, softCurrency?: number | null, avatarV2?: { __typename?: 'Avatar', id: string, unlockedAssets?: Array<{ __typename?: 'UnlockedAsset', id: string, provider: AvatarProvider }> | null } | null } | null };

export type UnseenAchievementsLootQueryVariables = Exact<{ [key: string]: never; }>;


export type UnseenAchievementsLootQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, avatarV2?: { __typename?: 'Avatar', id: string, claimableRpmAchievement: Array<{ __typename?: 'UnlockableRpmAchievements', id: string }> } | null } | null };

export type UserByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserByUsernameQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, role?: number | null, username: string, title?: string | null, pictureUrl: string, profileBackgroundUrl: string, description?: string | null, isValidAge?: boolean | null, haveISentFriendRequest?: boolean | null, haveIReceivedFriendRequest?: boolean | null, haveIBlocked: boolean, haveIReported: boolean, isFriends?: boolean | null, totalFriends: number, totalFollowers: number, level?: number | null, xp?: number | null, createdAt: Date, totalFollowing: number, hasDefaultProfileImage: boolean, haveIFeaturedFriend: boolean, isFollowing: boolean, isVerified: boolean, isDeveloper: boolean, isBetatester: boolean, isEmployee: boolean, deletedAt?: Date | null, email?: string | null, birthdate?: Date | null, homeworld?: { __typename: 'Homeworld', id: string, project: { __typename: 'Project', id: string, isPublished: boolean, title: string, engineVersion: number, thumbnail?: { __typename?: 'Thumbnail', id: string, large: { __typename?: 'Image', id: string, url: string } } | null } } | null, session?: { __typename?: 'UserSession', id: string, sessionStatus: UserSessionStatus } | null, getOrCreatePrivacySettings?: { __typename?: 'PrivacySettings', id: string, userId: number, friendsArePublic?: number | null, onlyFriendsInMultiplayer: boolean, achievementPublicity: number, favoriteGamesArePublic?: number | null, directMessagingPublicity?: number | null } | null, socialMedia?: { __typename?: 'SocialMedia', id: string, twitter?: string | null, twitch?: string | null, instagram?: string | null, youtube?: string | null, tiktok?: string | null } | null, unlockedBadges?: { __typename?: 'UnlockedBadgeConnection', items: Array<{ __typename?: 'UnlockedBadge', createdAt: string, badge: { __typename?: 'Badge', displayName: string, id: string, level: number, groupId: number, icon: string, groupTotal?: number | null, locked_icon: string, description: string } }> } | null } | null };

export type UserByUsernamesQueryVariables = Exact<{
  usernames: Scalars['String'];
}>;


export type UserByUsernamesQuery = { __typename?: 'Query', userByUsernames?: Array<{ __typename?: 'User', id: string, username: string }> | null };

export type UserFollowersQueryVariables = Exact<{
  username: Scalars['String'];
  cursor?: InputMaybe<Scalars['ID']>;
}>;


export type UserFollowersQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, role?: number | null, username: string, totalFollowers: number, getFollowers?: { __typename?: 'UserFollowConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'UserFollowEdge', node: { __typename?: 'UserFollow', followedSince: Date, user: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, level?: number | null, pictureUrl: string } } }> } | null } | null };

export type UserFollowingQueryVariables = Exact<{
  username: Scalars['String'];
  cursor?: InputMaybe<Scalars['ID']>;
}>;


export type UserFollowingQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, role?: number | null, username: string, totalFollowing: number, getFollowing?: { __typename?: 'UserFollowConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'UserFollowEdge', node: { __typename?: 'UserFollow', followedSince: Date, user: { __typename?: 'User', id: string, role?: number | null, isVerified: boolean, isEmployee: boolean, username: string, level?: number | null, pictureUrl: string } } }> } | null } | null };

export type UserFriendsQueryVariables = Exact<{
  username: Scalars['String'];
  cursor?: InputMaybe<Scalars['ID']>;
  first: Scalars['Float'];
}>;


export type UserFriendsQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, role?: number | null, username: string, isFriends?: boolean | null, totalFriends: number, getFriends?: { __typename?: 'UserFriendConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'UserFriendEdge', node: { __typename?: 'UserFriend', friendSince: Date, user: { __typename?: 'User', id: string, isVerified: boolean, isEmployee: boolean, isFriends?: boolean | null, username: string, level?: number | null, pictureUrl: string } } }> } | null } | null };

export type UserHasBoughtProductQueryVariables = Exact<{
  productId: Scalars['String'];
}>;


export type UserHasBoughtProductQuery = { __typename?: 'Query', userHasBoughtProduct?: { __typename?: 'StripeUserHasBoughtProductResponse', hasBoughtProduct: boolean } | null };

export type UserHomeworldQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserHomeworldQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, homeworld?: { __typename?: 'Homeworld', id: string, project: { __typename?: 'Project', id: string, isPublished: boolean, engineVersion: number, isRestricted: boolean } } | null } | null };

export type UserIdByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserIdByUsernameQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string } | null };

export type UserSuspensionsQueryVariables = Exact<{
  payload: SearchDto;
}>;


export type UserSuspensionsQuery = { __typename?: 'Query', activeSuspensionList?: { __typename?: 'ActiveSuspensionList', totalCount: number, suspensionList: Array<{ __typename?: 'Suspension', id: string, reason: ReportReason, createdAt: Date, customMessage?: string | null, user: { __typename?: 'User', id: string, username: string } }> } | null };

export type UserTagsQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserTagsQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, tags_v2: Array<{ __typename: 'Tag', name: string, type: TagType, id: string }> } | null };

export type ValidateResetPasswordTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidateResetPasswordTokenQuery = { __typename?: 'Query', checkResetPasswordToken?: boolean | null };

export type WalletQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, wallets?: Array<{ __typename?: 'Wallet', address: string, type: string } | null> | null } | null };

export type WarningsQueryVariables = Exact<{ [key: string]: never; }>;


export type WarningsQuery = { __typename?: 'Query', warnings?: Array<{ __typename?: 'WarningsList', total: number, endingAt: Date, customMessage: string, id: string, user: { __typename?: 'User', id: string, username: string } }> | null };

export type FindAllFeatureTogglesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllFeatureTogglesQuery = { __typename?: 'Query', findAllFeatureToggles?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null, description?: string | null, createdBy?: string | null, isConfig?: boolean | null, createdAt?: Date | null, updatedAt?: Date | null, criteria?: { __typename?: 'FeatureCriteria', minLevel?: number | null, minRole?: number | null, tags?: Array<{ __typename?: 'TagIdentifierType', name: string, type: TagType }> | null } | null, values?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null, createdAt?: Date | null, updatedAt?: Date | null, criteria?: { __typename?: 'FeatureCriteria', minLevel?: number | null, minRole?: number | null, tags?: Array<{ __typename?: 'TagIdentifierType', name: string, type: TagType }> | null } | null, values?: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, enabledAt: Date, disabledAt?: Date | null, createdAt?: Date | null, updatedAt?: Date | null }> | null }> | null }> | null };

export type IsUsernameAvailableQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type IsUsernameAvailableQuery = { __typename?: 'Query', isUsernameAvailable: boolean };

export type LeaderboardEmbedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LeaderboardEmbedQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, match: boolean, author: { __typename?: 'User', id: string }, tags_v2: Array<{ __typename?: 'Tag', id: string, name: string, type: TagType }> } | null };

export type ProductPathQueryVariables = Exact<{
  assetIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ProductPathQuery = { __typename?: 'Query', me?: { __typename: 'User', id: string, hasUnlockedAssets: Array<boolean> } | null };

export type PurchaseProductWithSoftCurrencyMutationVariables = Exact<{
  productId: Scalars['String'];
}>;


export type PurchaseProductWithSoftCurrencyMutation = { __typename?: 'Mutation', purchaseProductWithSoftCurrency?: { __typename?: 'EmoteShopItem', emoteId: string, videoUrl: string, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null } | { __typename?: 'GameAssetShopItem', gameAssetId: string, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null } | { __typename?: 'RpmShopItem', brandLogoUrl?: string | null, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null } | null };

export type MyLoadoutQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLoadoutQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, avatarV2?: { __typename?: 'Avatar', id: string, rpmHasLinkedAccount?: boolean | null, rpmJsonData?: { __typename?: 'RpmJsonData', outfitGender: string } | null } | null, loadout: { __typename?: 'Loadout', id: string, avatarName: string, avatarProvider: AvatarProvider, avatarRpmUrl: string, emotes: Array<string> }, inventory?: { __typename?: 'Inventory', titles?: Array<{ __typename?: 'TitleAsset', id: string, title: string, assetType: AssetType }> | null, emotes: Array<{ __typename?: 'Emote', emoteId: string, animationUrl: string, thumbnailUrl: string }> } | null } | null };

export type SetEmotesMutationVariables = Exact<{
  emotes: Array<Scalars['String']> | Scalars['String'];
}>;


export type SetEmotesMutation = { __typename?: 'Mutation', setEmotes: { __typename?: 'Loadout', id: string, avatarName: string, avatarProvider: AvatarProvider, avatarRpmUrl: string, emotes: Array<string> } };

export type GiveNewRpmIdUserByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GiveNewRpmIdUserByUsernameQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', id: string, avatarV2?: { __typename?: 'Avatar', id: string, rpmUserId?: string | null, unlockedAssets?: Array<{ __typename?: 'UnlockedAsset', id: string, provider: AvatarProvider, unlockedAt: Date }> | null } | null } | null };

export type ActivityLogQueryVariables = Exact<{
  username: Scalars['String'];
  input: FindActivityLogsInput;
}>;


export type ActivityLogQuery = { __typename?: 'Query', activityLogs: Array<{ __typename?: 'ActivityLog', timestamp: Date, correlationId?: string | null, data: { __typename: 'SoftCurrencyTransactionLog', amount: number, reason: string } }>, userByUsername?: { __typename?: 'User', id: string, softCurrency?: number | null } | null };

export type UpdateResourceMutationVariables = Exact<{
  input: UpdateResourceDto;
}>;


export type UpdateResourceMutation = { __typename?: 'Mutation', updateResource: { __typename?: 'UpdateResourceResult', success: boolean, reason?: string | null } };

export type CheckIsStashCheckoutCompletedQueryVariables = Exact<{
  checkoutId: Scalars['String'];
}>;


export type CheckIsStashCheckoutCompletedQuery = { __typename?: 'Query', checkIsStashCheckoutCompleted?: boolean | null };

export type CreateStashCheckoutLinkMutationVariables = Exact<{
  productId: Scalars['String'];
}>;


export type CreateStashCheckoutLinkMutation = { __typename?: 'Mutation', createStashCheckoutLink: { __typename?: 'CreateStashCheckoutLinkResponse', id: string, url: string } };

export type EquipProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EquipProductMutation = { __typename?: 'Mutation', equipProduct: { __typename?: 'Loadout', id: string, avatarRpmUrl: string, avatarName: string, avatarProvider: AvatarProvider, emotes: Array<string> } };

export type MyInventoryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyInventoryQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, allUnlockedIds: Array<string>, loadout: { __typename?: 'Loadout', emotes: Array<string> } } | null };

export type SearchPageQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  searchType: Scalars['String'];
}>;


export type SearchPageQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', totalHits: number, searchedTerm: string, noResultFoundSuggestions?: Array<string> | null, explorableTags?: Array<{ __typename?: 'SearchTags', tag: string, count: number }> | null, sections: Array<{ __typename: 'SearchResultProjectFeedSection', title?: string | null, subTitle?: string | null, viewMoreUrl?: string | null, feed: Array<{ __typename?: 'Project', id: string, title: string, totalViews: number, featured: boolean, completionRate: number, gameKit: GameKit, thumbnail?: { __typename?: 'Thumbnail', id: string, medium: { __typename?: 'Image', id: string, url: string } } | null, author: { __typename?: 'User', id: string, username: string, pictureUrl: string, isVerified: boolean, isEmployee: boolean } }> } | { __typename: 'SearchResultUserSection', totalHits: number, users: Array<{ __typename?: 'User', id: string, role?: number | null, level?: number | null, username: string, email?: string | null, pictureUrl: string, isVerified: boolean, isEmployee: boolean, haveISentFriendRequest?: boolean | null, haveIReceivedFriendRequest?: boolean | null, isFriends?: boolean | null, createdAt: Date }> }> } };

export type ShopProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopProductsQuery = { __typename?: 'Query', shopProducts: Array<{ __typename?: 'EmoteShopItem', emoteId: string, videoUrl: string, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null } | { __typename?: 'GameAssetShopItem', gameAssetId: string, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null } | { __typename?: 'RpmShopItem', brandLogoUrl?: string | null, id: string, category: string, rarity: string, type: ShopItemType, price: number, priceId: string, priceString: string, priceType: PriceType, description: string, image: string, name: string, owned: boolean, featured: boolean, isNew: boolean, currency: string, endTime?: string | null }> };

export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on User {
  id
  role
  email
  username
  title
  pictureUrl
  profileBackgroundUrl
  description
  hasFinishedRegistration
  hasAcceptedTos
  role
  isValidAge
  isVerified
  isEmployee
  isRegistered
  birthdate
  notificationsAmount
  xp
  currentXp
  xpToNextLevel
  timeSpentPlayingShooter
  totalPublishedGames
  uniqueGamesCompleted
  level
  googleId
  hasDefaultProfileImage
  googleId
  softCurrency
  constants {
    maxFeaturedFriends
  }
  amountOfFeaturedFriends
  session {
    id
  }
  suspension {
    id
    seen
    endedAt
    reason
    customMessage
    __typename
    type
  }
  warning {
    id
    seen
    endedAt
    reason
    customMessage
    __typename
    type
  }
  isSuspended
  socialMedia {
    id
    youtube
    twitter
    twitch
    instagram
    tiktok
    __typename
  }
  getOrCreatePrivacySettings {
    userId
    directMessagingPublicity
    id
    friendsArePublic
    onlyFriendsInMultiplayer
    achievementPublicity
  }
}
    `;
export const TagFragmentFragmentDoc = gql`
    fragment TagFragment on Tag {
  id
  name
  type
}
    `;
export const AuthorFragmentFragmentDoc = gql`
    fragment AuthorFragment on User {
  id
  role
  isVerified
  isEmployee
  username
  pictureUrl
  level
  isFollowing
  suspension {
    id
  }
}
    `;
export const ProjectFragmentFragmentDoc = gql`
    fragment ProjectFragment on Project {
  id
  title
  description
  totalViews
  completionRate
  publishedAt
  rePublishedAt
  createdAt
  updatedAt
  canEdit
  isPublished
  isLiked
  likes
  isReported
  featured
  forkId
  locked
  projectType
  disableComments
  isHomeworld
  youtubeId
  gameKit
  engineVersion
  categories
  tags
  tags_v2 {
    ...TagFragment
  }
  visibility
  playUrl
  madeWithHDK: hasTag(name: "hdk", type: Meta)
  carSoccer: hasTag(name: "car_soccer", type: Meta)
  carSumo: hasTag(name: "car_sumo", type: Meta)
  tanks: hasTag(name: "tanks", type: Meta)
  copsAndRobbers: hasTag(name: "cops_and_robbers", type: Meta)
  match: hasTag(name: "g_gameplay_match_settings", type: Meta)
  thumbnail {
    id
    small {
      id
      url
    }
    medium {
      id
      url
    }
    large {
      id
      url
    }
  }
  thumbnails {
    medium {
      id
      url
    }
    large {
      id
      url
    }
  }
  author {
    ...AuthorFragment
    socialMedia {
      id
      twitter
      twitch
      youtube
      instagram
      tiktok
    }
  }
  isRestricted
  badges {
    id
    icon
    displayName
    description
    rewards {
      id
      value
      type
      subType
    }
  }
}
    ${TagFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}`;
export const ProjectInfoFragmentDoc = gql`
    fragment ProjectInfo on Project {
  id
  title
  gameKit
  likes
  description
  createdAt
  updatedAt
  publishedAt
  views
  totalViews
  youtubeId
  playUrl
  isLiked
  isPublished
  projectType
  dataUrl
  viewUrl
  engineVersion
  categories
  tags_v2 {
    id
    name
  }
  visibility
  disableComments
  isOwner
  isHomeworld
  featured
  reFeaturedAt
  locked
  tags
  totalCountComments: commentsV2(payload: {first: 1}) {
    totalCount
  }
  thumbnail {
    id
    small {
      id
      url
    }
    medium {
      id
      url
    }
    large {
      id
      url
    }
  }
  thumbnails {
    id
    small {
      id
      url
    }
    large {
      id
      url
    }
  }
  author {
    isFollowing
    id
    username
    pictureUrl
    level
    isVerified
    isEmployee
  }
}
    `;
export const ShopItemFragmentDoc = gql`
    fragment ShopItem on ShopItem {
  id
  category
  rarity
  type
  price
  priceId
  priceString
  priceType
  description
  image
  name
  owned
  featured
  isNew
  currency
  endTime
  ... on RpmShopItem {
    brandLogoUrl
  }
  ... on EmoteShopItem {
    emoteId
    videoUrl
  }
  ... on GameAssetShopItem {
    gameAssetId
  }
}
    `;
export const AcceptFriendRequestDocument = gql`
    mutation acceptFriendRequest($targetId: Float!) {
  acceptFriendRequest(targetId: $targetId) {
    friendSince
    __typename
    user {
      __typename
      username
      id
      pictureUrl
      level
      isFriends
      haveISentFriendRequest
      haveIReceivedFriendRequest
      isVerified
      isEmployee
    }
  }
}
    `;
export type AcceptFriendRequestMutationFn = Apollo.MutationFunction<AcceptFriendRequestMutation, AcceptFriendRequestMutationVariables>;

/**
 * __useAcceptFriendRequestMutation__
 *
 * To run a mutation, you first call `useAcceptFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptFriendRequestMutation, { data, loading, error }] = useAcceptFriendRequestMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useAcceptFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptFriendRequestMutation, AcceptFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptFriendRequestMutation, AcceptFriendRequestMutationVariables>(AcceptFriendRequestDocument, options);
      }
export type AcceptFriendRequestMutationHookResult = ReturnType<typeof useAcceptFriendRequestMutation>;
export type AcceptFriendRequestMutationResult = Apollo.MutationResult<AcceptFriendRequestMutation>;
export type AcceptFriendRequestMutationOptions = Apollo.BaseMutationOptions<AcceptFriendRequestMutation, AcceptFriendRequestMutationVariables>;
export const AddFeatureFriendDocument = gql`
    mutation addFeatureFriend($targetId: Float!) {
  featureFriend(targetId: $targetId) {
    id
    createdAt
    target {
      id
      haveIFeaturedFriend
      username
      pictureUrl
      isVerified
      homeworld {
        id
        project {
          id
          thumbnail {
            id
            large {
              id
              url
            }
          }
        }
      }
    }
  }
}
    `;
export type AddFeatureFriendMutationFn = Apollo.MutationFunction<AddFeatureFriendMutation, AddFeatureFriendMutationVariables>;

/**
 * __useAddFeatureFriendMutation__
 *
 * To run a mutation, you first call `useAddFeatureFriendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeatureFriendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeatureFriendMutation, { data, loading, error }] = useAddFeatureFriendMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useAddFeatureFriendMutation(baseOptions?: Apollo.MutationHookOptions<AddFeatureFriendMutation, AddFeatureFriendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeatureFriendMutation, AddFeatureFriendMutationVariables>(AddFeatureFriendDocument, options);
      }
export type AddFeatureFriendMutationHookResult = ReturnType<typeof useAddFeatureFriendMutation>;
export type AddFeatureFriendMutationResult = Apollo.MutationResult<AddFeatureFriendMutation>;
export type AddFeatureFriendMutationOptions = Apollo.BaseMutationOptions<AddFeatureFriendMutation, AddFeatureFriendMutationVariables>;
export const AddFeaturedProfileDocument = gql`
    mutation AddFeaturedProfile($username: String!) {
  addFeaturedProfile(username: $username) {
    userId
    addedAt
  }
}
    `;
export type AddFeaturedProfileMutationFn = Apollo.MutationFunction<AddFeaturedProfileMutation, AddFeaturedProfileMutationVariables>;

/**
 * __useAddFeaturedProfileMutation__
 *
 * To run a mutation, you first call `useAddFeaturedProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeaturedProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeaturedProfileMutation, { data, loading, error }] = useAddFeaturedProfileMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useAddFeaturedProfileMutation(baseOptions?: Apollo.MutationHookOptions<AddFeaturedProfileMutation, AddFeaturedProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeaturedProfileMutation, AddFeaturedProfileMutationVariables>(AddFeaturedProfileDocument, options);
      }
export type AddFeaturedProfileMutationHookResult = ReturnType<typeof useAddFeaturedProfileMutation>;
export type AddFeaturedProfileMutationResult = Apollo.MutationResult<AddFeaturedProfileMutation>;
export type AddFeaturedProfileMutationOptions = Apollo.BaseMutationOptions<AddFeaturedProfileMutation, AddFeaturedProfileMutationVariables>;
export const AwardAppearancesForUsersDocument = gql`
    mutation awardAppearancesForUsers($usernames: [String!]!, $avatarIds: [Float!]!) {
  awardAppearancesForUsers(usernames: $usernames, avatarIds: $avatarIds)
}
    `;
export type AwardAppearancesForUsersMutationFn = Apollo.MutationFunction<AwardAppearancesForUsersMutation, AwardAppearancesForUsersMutationVariables>;

/**
 * __useAwardAppearancesForUsersMutation__
 *
 * To run a mutation, you first call `useAwardAppearancesForUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAwardAppearancesForUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [awardAppearancesForUsersMutation, { data, loading, error }] = useAwardAppearancesForUsersMutation({
 *   variables: {
 *      usernames: // value for 'usernames'
 *      avatarIds: // value for 'avatarIds'
 *   },
 * });
 */
export function useAwardAppearancesForUsersMutation(baseOptions?: Apollo.MutationHookOptions<AwardAppearancesForUsersMutation, AwardAppearancesForUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AwardAppearancesForUsersMutation, AwardAppearancesForUsersMutationVariables>(AwardAppearancesForUsersDocument, options);
      }
export type AwardAppearancesForUsersMutationHookResult = ReturnType<typeof useAwardAppearancesForUsersMutation>;
export type AwardAppearancesForUsersMutationResult = Apollo.MutationResult<AwardAppearancesForUsersMutation>;
export type AwardAppearancesForUsersMutationOptions = Apollo.BaseMutationOptions<AwardAppearancesForUsersMutation, AwardAppearancesForUsersMutationVariables>;
export const BlockUserDocument = gql`
    mutation blockUser($userId: ID!) {
  blockUser(payload: {userId: $userId}) {
    __typename
    id
    user1Id
    user2Id
    blockedAt
  }
}
    `;
export type BlockUserMutationFn = Apollo.MutationFunction<BlockUserMutation, BlockUserMutationVariables>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockUserMutation, BlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(BlockUserDocument, options);
      }
export type BlockUserMutationHookResult = ReturnType<typeof useBlockUserMutation>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<BlockUserMutation, BlockUserMutationVariables>;
export const CancelFriendRequestDocument = gql`
    mutation cancelFriendRequest($targetId: Float!) {
  cancelFriendRequest(targetId: $targetId) {
    id
    username
    pictureUrl
    haveISentFriendRequest
    haveIReceivedFriendRequest
    level
  }
}
    `;
export type CancelFriendRequestMutationFn = Apollo.MutationFunction<CancelFriendRequestMutation, CancelFriendRequestMutationVariables>;

/**
 * __useCancelFriendRequestMutation__
 *
 * To run a mutation, you first call `useCancelFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFriendRequestMutation, { data, loading, error }] = useCancelFriendRequestMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useCancelFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelFriendRequestMutation, CancelFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelFriendRequestMutation, CancelFriendRequestMutationVariables>(CancelFriendRequestDocument, options);
      }
export type CancelFriendRequestMutationHookResult = ReturnType<typeof useCancelFriendRequestMutation>;
export type CancelFriendRequestMutationResult = Apollo.MutationResult<CancelFriendRequestMutation>;
export type CancelFriendRequestMutationOptions = Apollo.BaseMutationOptions<CancelFriendRequestMutation, CancelFriendRequestMutationVariables>;
export const ClaimHibuxRewardDocument = gql`
    mutation ClaimHibuxReward {
  claimHibuxReward
}
    `;
export type ClaimHibuxRewardMutationFn = Apollo.MutationFunction<ClaimHibuxRewardMutation, ClaimHibuxRewardMutationVariables>;

/**
 * __useClaimHibuxRewardMutation__
 *
 * To run a mutation, you first call `useClaimHibuxRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimHibuxRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimHibuxRewardMutation, { data, loading, error }] = useClaimHibuxRewardMutation({
 *   variables: {
 *   },
 * });
 */
export function useClaimHibuxRewardMutation(baseOptions?: Apollo.MutationHookOptions<ClaimHibuxRewardMutation, ClaimHibuxRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimHibuxRewardMutation, ClaimHibuxRewardMutationVariables>(ClaimHibuxRewardDocument, options);
      }
export type ClaimHibuxRewardMutationHookResult = ReturnType<typeof useClaimHibuxRewardMutation>;
export type ClaimHibuxRewardMutationResult = Apollo.MutationResult<ClaimHibuxRewardMutation>;
export type ClaimHibuxRewardMutationOptions = Apollo.BaseMutationOptions<ClaimHibuxRewardMutation, ClaimHibuxRewardMutationVariables>;
export const ClearAllWarningsForUserDocument = gql`
    mutation clearAllWarningsForUser($userId: ID!) {
  clearAllWarningsForUser(userId: $userId)
}
    `;
export type ClearAllWarningsForUserMutationFn = Apollo.MutationFunction<ClearAllWarningsForUserMutation, ClearAllWarningsForUserMutationVariables>;

/**
 * __useClearAllWarningsForUserMutation__
 *
 * To run a mutation, you first call `useClearAllWarningsForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllWarningsForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllWarningsForUserMutation, { data, loading, error }] = useClearAllWarningsForUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useClearAllWarningsForUserMutation(baseOptions?: Apollo.MutationHookOptions<ClearAllWarningsForUserMutation, ClearAllWarningsForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAllWarningsForUserMutation, ClearAllWarningsForUserMutationVariables>(ClearAllWarningsForUserDocument, options);
      }
export type ClearAllWarningsForUserMutationHookResult = ReturnType<typeof useClearAllWarningsForUserMutation>;
export type ClearAllWarningsForUserMutationResult = Apollo.MutationResult<ClearAllWarningsForUserMutation>;
export type ClearAllWarningsForUserMutationOptions = Apollo.BaseMutationOptions<ClearAllWarningsForUserMutation, ClearAllWarningsForUserMutationVariables>;
export const CreateAppearanceDocument = gql`
    mutation CreateAppearance($input: CreateAppearanceDTO!) {
  createAppearance(input: $input) {
    id
    displayName
    name
    quality
    isPromotional
    sourceDescription
  }
}
    `;
export type CreateAppearanceMutationFn = Apollo.MutationFunction<CreateAppearanceMutation, CreateAppearanceMutationVariables>;

/**
 * __useCreateAppearanceMutation__
 *
 * To run a mutation, you first call `useCreateAppearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppearanceMutation, { data, loading, error }] = useCreateAppearanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppearanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppearanceMutation, CreateAppearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppearanceMutation, CreateAppearanceMutationVariables>(CreateAppearanceDocument, options);
      }
export type CreateAppearanceMutationHookResult = ReturnType<typeof useCreateAppearanceMutation>;
export type CreateAppearanceMutationResult = Apollo.MutationResult<CreateAppearanceMutation>;
export type CreateAppearanceMutationOptions = Apollo.BaseMutationOptions<CreateAppearanceMutation, CreateAppearanceMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation CreateCheckoutSession($priceId: String!, $embed: Boolean) {
  createCheckoutSession(priceId: $priceId, embed: $embed) {
    sessionId
    sessionUrl
    clientSecret
  }
}
    `;
export type CreateCheckoutSessionMutationFn = Apollo.MutationFunction<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionMutation, { data, loading, error }] = useCreateCheckoutSessionMutation({
 *   variables: {
 *      priceId: // value for 'priceId'
 *      embed: // value for 'embed'
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, options);
      }
export type CreateCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationResult = Apollo.MutationResult<CreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CreateDefaultAvatarDocument = gql`
    mutation CreateDefaultAvatar($input: DefaultAvatarInput!) {
  createDefaultAvatar(input: $input) {
    id
    glbUrl
    rpmUserId
    rpmAvatarId
    rpmGlbUrl
    rpmJsonData {
      outfitGender
    }
    rpmHasLinkedAccount
    thumbnail
    name
    provider
    thumbnail
  }
}
    `;
export type CreateDefaultAvatarMutationFn = Apollo.MutationFunction<CreateDefaultAvatarMutation, CreateDefaultAvatarMutationVariables>;

/**
 * __useCreateDefaultAvatarMutation__
 *
 * To run a mutation, you first call `useCreateDefaultAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefaultAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefaultAvatarMutation, { data, loading, error }] = useCreateDefaultAvatarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDefaultAvatarMutation(baseOptions?: Apollo.MutationHookOptions<CreateDefaultAvatarMutation, CreateDefaultAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDefaultAvatarMutation, CreateDefaultAvatarMutationVariables>(CreateDefaultAvatarDocument, options);
      }
export type CreateDefaultAvatarMutationHookResult = ReturnType<typeof useCreateDefaultAvatarMutation>;
export type CreateDefaultAvatarMutationResult = Apollo.MutationResult<CreateDefaultAvatarMutation>;
export type CreateDefaultAvatarMutationOptions = Apollo.BaseMutationOptions<CreateDefaultAvatarMutation, CreateDefaultAvatarMutationVariables>;
export const CreateDeveloperTokenDocument = gql`
    mutation CreateDeveloperToken {
  createDeveloperToken
}
    `;
export type CreateDeveloperTokenMutationFn = Apollo.MutationFunction<CreateDeveloperTokenMutation, CreateDeveloperTokenMutationVariables>;

/**
 * __useCreateDeveloperTokenMutation__
 *
 * To run a mutation, you first call `useCreateDeveloperTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeveloperTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeveloperTokenMutation, { data, loading, error }] = useCreateDeveloperTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDeveloperTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeveloperTokenMutation, CreateDeveloperTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeveloperTokenMutation, CreateDeveloperTokenMutationVariables>(CreateDeveloperTokenDocument, options);
      }
export type CreateDeveloperTokenMutationHookResult = ReturnType<typeof useCreateDeveloperTokenMutation>;
export type CreateDeveloperTokenMutationResult = Apollo.MutationResult<CreateDeveloperTokenMutation>;
export type CreateDeveloperTokenMutationOptions = Apollo.BaseMutationOptions<CreateDeveloperTokenMutation, CreateDeveloperTokenMutationVariables>;
export const CreateNonRegisteredUserDocument = gql`
    mutation CreateNonRegisteredUser {
  createNonRegisteredUser {
    accessToken
    refreshToken
    user {
      ...CurrentUser
    }
  }
}
    ${CurrentUserFragmentDoc}`;
export type CreateNonRegisteredUserMutationFn = Apollo.MutationFunction<CreateNonRegisteredUserMutation, CreateNonRegisteredUserMutationVariables>;

/**
 * __useCreateNonRegisteredUserMutation__
 *
 * To run a mutation, you first call `useCreateNonRegisteredUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNonRegisteredUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNonRegisteredUserMutation, { data, loading, error }] = useCreateNonRegisteredUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateNonRegisteredUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateNonRegisteredUserMutation, CreateNonRegisteredUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNonRegisteredUserMutation, CreateNonRegisteredUserMutationVariables>(CreateNonRegisteredUserDocument, options);
      }
export type CreateNonRegisteredUserMutationHookResult = ReturnType<typeof useCreateNonRegisteredUserMutation>;
export type CreateNonRegisteredUserMutationResult = Apollo.MutationResult<CreateNonRegisteredUserMutation>;
export type CreateNonRegisteredUserMutationOptions = Apollo.BaseMutationOptions<CreateNonRegisteredUserMutation, CreateNonRegisteredUserMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($name: String, $gameKit: GameKit, $engineVersion: Int, $isSnapMode: Boolean, $forkId: Float) {
  createProject(
    payload: {isSnapMode: $isSnapMode, engineVersion: $engineVersion, title: $name, gameKit: $gameKit, forkId: $forkId}
  ) {
    id
    title
    projectType
    gameKit
    playUrl
    viewUrl
    author {
      id
      username
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      gameKit: // value for 'gameKit'
 *      engineVersion: // value for 'engineVersion'
 *      isSnapMode: // value for 'isSnapMode'
 *      forkId: // value for 'forkId'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreatePublicCreativeSessionForProjectDocument = gql`
    mutation CreatePublicCreativeSessionForProject($channel: String, $clientNetworkProtocolVersion: String!, $clientVersion: String!, $id: ID!) {
  createPublicCreativeSessionForProject(
    channel: $channel
    clientNetworkProtocolVersion: $clientNetworkProtocolVersion
    clientVersion: $clientVersion
    id: $id
  ) {
    id
    sessionUrl
    sessionId
    newlyCreated
    sessionStatus
    playerCount
    maxPlayerCount
    publicity
  }
}
    `;
export type CreatePublicCreativeSessionForProjectMutationFn = Apollo.MutationFunction<CreatePublicCreativeSessionForProjectMutation, CreatePublicCreativeSessionForProjectMutationVariables>;

/**
 * __useCreatePublicCreativeSessionForProjectMutation__
 *
 * To run a mutation, you first call `useCreatePublicCreativeSessionForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicCreativeSessionForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicCreativeSessionForProjectMutation, { data, loading, error }] = useCreatePublicCreativeSessionForProjectMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      clientNetworkProtocolVersion: // value for 'clientNetworkProtocolVersion'
 *      clientVersion: // value for 'clientVersion'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreatePublicCreativeSessionForProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicCreativeSessionForProjectMutation, CreatePublicCreativeSessionForProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicCreativeSessionForProjectMutation, CreatePublicCreativeSessionForProjectMutationVariables>(CreatePublicCreativeSessionForProjectDocument, options);
      }
export type CreatePublicCreativeSessionForProjectMutationHookResult = ReturnType<typeof useCreatePublicCreativeSessionForProjectMutation>;
export type CreatePublicCreativeSessionForProjectMutationResult = Apollo.MutationResult<CreatePublicCreativeSessionForProjectMutation>;
export type CreatePublicCreativeSessionForProjectMutationOptions = Apollo.BaseMutationOptions<CreatePublicCreativeSessionForProjectMutation, CreatePublicCreativeSessionForProjectMutationVariables>;
export const CreateScheduledProjectUpdateDocument = gql`
    mutation CreateScheduledProjectUpdate($projectId: ID!, $updateAt: Date!, $featured: Boolean, $reFeature: Boolean, $youtubeId: String) {
  createScheduledProjectUpdate(
    payload: {projectId: $projectId, updateAt: $updateAt, featured: $featured, reFeature: $reFeature, youtubeId: $youtubeId}
  ) {
    projectId
    updateAt
    featured
    reFeature
    youtubeId
    project {
      id
      title
      description
      totalViews
      publishedAt
      canEdit
      isPublished
      isLiked
      likes
      isReported
      projectType
      disableComments
      youtubeId
      gameKit
      engineVersion
      tags
      visibility
      playUrl
      leaderboard {
        id
      }
      thumbnail {
        id
        large {
          id
          url
        }
      }
      thumbnails {
        id
        large {
          id
          url
        }
      }
      author {
        id
        role
        username
        pictureUrl
        level
        isFollowing
        suspension {
          id
        }
        socialMedia {
          id
          twitter
          twitch
          youtube
          instagram
          tiktok
        }
      }
    }
  }
}
    `;
export type CreateScheduledProjectUpdateMutationFn = Apollo.MutationFunction<CreateScheduledProjectUpdateMutation, CreateScheduledProjectUpdateMutationVariables>;

/**
 * __useCreateScheduledProjectUpdateMutation__
 *
 * To run a mutation, you first call `useCreateScheduledProjectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledProjectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledProjectUpdateMutation, { data, loading, error }] = useCreateScheduledProjectUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      updateAt: // value for 'updateAt'
 *      featured: // value for 'featured'
 *      reFeature: // value for 'reFeature'
 *      youtubeId: // value for 'youtubeId'
 *   },
 * });
 */
export function useCreateScheduledProjectUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledProjectUpdateMutation, CreateScheduledProjectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledProjectUpdateMutation, CreateScheduledProjectUpdateMutationVariables>(CreateScheduledProjectUpdateDocument, options);
      }
export type CreateScheduledProjectUpdateMutationHookResult = ReturnType<typeof useCreateScheduledProjectUpdateMutation>;
export type CreateScheduledProjectUpdateMutationResult = Apollo.MutationResult<CreateScheduledProjectUpdateMutation>;
export type CreateScheduledProjectUpdateMutationOptions = Apollo.BaseMutationOptions<CreateScheduledProjectUpdateMutation, CreateScheduledProjectUpdateMutationVariables>;
export const CreateSessionDocument = gql`
    mutation CreateSession($projectId: ID!, $publicity: publicity!, $maxPlayerCount: Float!, $sessionMode: MultiplayerSessionMode, $sessionStatus: MultiplayerSessionStatus, $sessionType: MultiplayerSessionType, $joinablePlayerIds: [ID!]) {
  createSession(
    payload: {projectId: $projectId, publicity: $publicity, maxPlayerCount: $maxPlayerCount, sessionMode: $sessionMode, sessionStatus: $sessionStatus, sessionType: $sessionType, joinablePlayerIds: $joinablePlayerIds}
  ) {
    id
    sessionId
    sessionUrl
    sessionStatus
    playerCount
    maxPlayerCount
    publicity
    currentProject {
      id
      title
      thumbnail {
        id
        small {
          id
          url
        }
      }
    }
  }
}
    `;
export type CreateSessionMutationFn = Apollo.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      publicity: // value for 'publicity'
 *      maxPlayerCount: // value for 'maxPlayerCount'
 *      sessionMode: // value for 'sessionMode'
 *      sessionStatus: // value for 'sessionStatus'
 *      sessionType: // value for 'sessionType'
 *      joinablePlayerIds: // value for 'joinablePlayerIds'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const CreateShooterSessionSettingsDocument = gql`
    mutation CreateShooterSessionSettings($payload: CreateShooterSessionSettingsDTO!, $sessionId: ID!) {
  createShooterSessionSettings(payload: $payload, sessionId: $sessionId) {
    id
    sessionId
  }
}
    `;
export type CreateShooterSessionSettingsMutationFn = Apollo.MutationFunction<CreateShooterSessionSettingsMutation, CreateShooterSessionSettingsMutationVariables>;

/**
 * __useCreateShooterSessionSettingsMutation__
 *
 * To run a mutation, you first call `useCreateShooterSessionSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShooterSessionSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShooterSessionSettingsMutation, { data, loading, error }] = useCreateShooterSessionSettingsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCreateShooterSessionSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateShooterSessionSettingsMutation, CreateShooterSessionSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShooterSessionSettingsMutation, CreateShooterSessionSettingsMutationVariables>(CreateShooterSessionSettingsDocument, options);
      }
export type CreateShooterSessionSettingsMutationHookResult = ReturnType<typeof useCreateShooterSessionSettingsMutation>;
export type CreateShooterSessionSettingsMutationResult = Apollo.MutationResult<CreateShooterSessionSettingsMutation>;
export type CreateShooterSessionSettingsMutationOptions = Apollo.BaseMutationOptions<CreateShooterSessionSettingsMutation, CreateShooterSessionSettingsMutationVariables>;
export const CreateZendeskTicketDocument = gql`
    mutation CreateZendeskTicket($name: String!, $email: String!, $subject: String!, $device: Device!, $os: String, $description: String!) {
  createZendeskTicket(
    payload: {name: $name, email: $email, device: $device, os: $os, description: $description, subject: $subject}
  )
}
    `;
export type CreateZendeskTicketMutationFn = Apollo.MutationFunction<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>;

/**
 * __useCreateZendeskTicketMutation__
 *
 * To run a mutation, you first call `useCreateZendeskTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZendeskTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZendeskTicketMutation, { data, loading, error }] = useCreateZendeskTicketMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      subject: // value for 'subject'
 *      device: // value for 'device'
 *      os: // value for 'os'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateZendeskTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>(CreateZendeskTicketDocument, options);
      }
export type CreateZendeskTicketMutationHookResult = ReturnType<typeof useCreateZendeskTicketMutation>;
export type CreateZendeskTicketMutationResult = Apollo.MutationResult<CreateZendeskTicketMutation>;
export type CreateZendeskTicketMutationOptions = Apollo.BaseMutationOptions<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>;
export const DeleteAccountRequestDocument = gql`
    mutation deleteAccountRequest {
  deleteAccountRequest
}
    `;
export type DeleteAccountRequestMutationFn = Apollo.MutationFunction<DeleteAccountRequestMutation, DeleteAccountRequestMutationVariables>;

/**
 * __useDeleteAccountRequestMutation__
 *
 * To run a mutation, you first call `useDeleteAccountRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountRequestMutation, { data, loading, error }] = useDeleteAccountRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountRequestMutation, DeleteAccountRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountRequestMutation, DeleteAccountRequestMutationVariables>(DeleteAccountRequestDocument, options);
      }
export type DeleteAccountRequestMutationHookResult = ReturnType<typeof useDeleteAccountRequestMutation>;
export type DeleteAccountRequestMutationResult = Apollo.MutationResult<DeleteAccountRequestMutation>;
export type DeleteAccountRequestMutationOptions = Apollo.BaseMutationOptions<DeleteAccountRequestMutation, DeleteAccountRequestMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($token: String!) {
  deleteAccount(token: $token)
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const DeleteAllRefreshTokensDocument = gql`
    mutation DeleteAllRefreshTokens {
  deleteAllRefreshTokens
}
    `;
export type DeleteAllRefreshTokensMutationFn = Apollo.MutationFunction<DeleteAllRefreshTokensMutation, DeleteAllRefreshTokensMutationVariables>;

/**
 * __useDeleteAllRefreshTokensMutation__
 *
 * To run a mutation, you first call `useDeleteAllRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllRefreshTokensMutation, { data, loading, error }] = useDeleteAllRefreshTokensMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAllRefreshTokensMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllRefreshTokensMutation, DeleteAllRefreshTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllRefreshTokensMutation, DeleteAllRefreshTokensMutationVariables>(DeleteAllRefreshTokensDocument, options);
      }
export type DeleteAllRefreshTokensMutationHookResult = ReturnType<typeof useDeleteAllRefreshTokensMutation>;
export type DeleteAllRefreshTokensMutationResult = Apollo.MutationResult<DeleteAllRefreshTokensMutation>;
export type DeleteAllRefreshTokensMutationOptions = Apollo.BaseMutationOptions<DeleteAllRefreshTokensMutation, DeleteAllRefreshTokensMutationVariables>;
export const DeleteApperanceDocument = gql`
    mutation DeleteApperance($appearanceId: Float!) {
  deleteAppearance(appearanceId: $appearanceId)
}
    `;
export type DeleteApperanceMutationFn = Apollo.MutationFunction<DeleteApperanceMutation, DeleteApperanceMutationVariables>;

/**
 * __useDeleteApperanceMutation__
 *
 * To run a mutation, you first call `useDeleteApperanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApperanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApperanceMutation, { data, loading, error }] = useDeleteApperanceMutation({
 *   variables: {
 *      appearanceId: // value for 'appearanceId'
 *   },
 * });
 */
export function useDeleteApperanceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApperanceMutation, DeleteApperanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApperanceMutation, DeleteApperanceMutationVariables>(DeleteApperanceDocument, options);
      }
export type DeleteApperanceMutationHookResult = ReturnType<typeof useDeleteApperanceMutation>;
export type DeleteApperanceMutationResult = Apollo.MutationResult<DeleteApperanceMutation>;
export type DeleteApperanceMutationOptions = Apollo.BaseMutationOptions<DeleteApperanceMutation, DeleteApperanceMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($id: Float!) {
  deleteComment(id: $id) {
    id
    __typename
    text
    deletedAt
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteFeaturedFriendDocument = gql`
    mutation deleteFeaturedFriend($targetId: Float!) {
  deleteFeaturedFriend(targetId: $targetId)
}
    `;
export type DeleteFeaturedFriendMutationFn = Apollo.MutationFunction<DeleteFeaturedFriendMutation, DeleteFeaturedFriendMutationVariables>;

/**
 * __useDeleteFeaturedFriendMutation__
 *
 * To run a mutation, you first call `useDeleteFeaturedFriendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeaturedFriendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeaturedFriendMutation, { data, loading, error }] = useDeleteFeaturedFriendMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useDeleteFeaturedFriendMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeaturedFriendMutation, DeleteFeaturedFriendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeaturedFriendMutation, DeleteFeaturedFriendMutationVariables>(DeleteFeaturedFriendDocument, options);
      }
export type DeleteFeaturedFriendMutationHookResult = ReturnType<typeof useDeleteFeaturedFriendMutation>;
export type DeleteFeaturedFriendMutationResult = Apollo.MutationResult<DeleteFeaturedFriendMutation>;
export type DeleteFeaturedFriendMutationOptions = Apollo.BaseMutationOptions<DeleteFeaturedFriendMutation, DeleteFeaturedFriendMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id) {
    id
    deletedAt
  }
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteScheduledProjectUpdateDocument = gql`
    mutation DeleteScheduledProjectUpdate($projectId: ID!, $updateAt: Date!) {
  deleteScheduledProjectUpdate(key: {projectId: $projectId, updateAt: $updateAt})
}
    `;
export type DeleteScheduledProjectUpdateMutationFn = Apollo.MutationFunction<DeleteScheduledProjectUpdateMutation, DeleteScheduledProjectUpdateMutationVariables>;

/**
 * __useDeleteScheduledProjectUpdateMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledProjectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledProjectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledProjectUpdateMutation, { data, loading, error }] = useDeleteScheduledProjectUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      updateAt: // value for 'updateAt'
 *   },
 * });
 */
export function useDeleteScheduledProjectUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledProjectUpdateMutation, DeleteScheduledProjectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledProjectUpdateMutation, DeleteScheduledProjectUpdateMutationVariables>(DeleteScheduledProjectUpdateDocument, options);
      }
export type DeleteScheduledProjectUpdateMutationHookResult = ReturnType<typeof useDeleteScheduledProjectUpdateMutation>;
export type DeleteScheduledProjectUpdateMutationResult = Apollo.MutationResult<DeleteScheduledProjectUpdateMutation>;
export type DeleteScheduledProjectUpdateMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledProjectUpdateMutation, DeleteScheduledProjectUpdateMutationVariables>;
export const DeleteUserAccountDocument = gql`
    mutation DeleteUserAccount($id: Float!) {
  deleteUserAccount(id: $id)
}
    `;
export type DeleteUserAccountMutationFn = Apollo.MutationFunction<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;

/**
 * __useDeleteUserAccountMutation__
 *
 * To run a mutation, you first call `useDeleteUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAccountMutation, { data, loading, error }] = useDeleteUserAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, options);
      }
export type DeleteUserAccountMutationHookResult = ReturnType<typeof useDeleteUserAccountMutation>;
export type DeleteUserAccountMutationResult = Apollo.MutationResult<DeleteUserAccountMutation>;
export type DeleteUserAccountMutationOptions = Apollo.BaseMutationOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;
export const EquipAppearanceDocument = gql`
    mutation EquipAppearance($appearanceId: ID!) {
  equipAppearance(appearanceId: $appearanceId) {
    id
    name
  }
}
    `;
export type EquipAppearanceMutationFn = Apollo.MutationFunction<EquipAppearanceMutation, EquipAppearanceMutationVariables>;

/**
 * __useEquipAppearanceMutation__
 *
 * To run a mutation, you first call `useEquipAppearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipAppearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipAppearanceMutation, { data, loading, error }] = useEquipAppearanceMutation({
 *   variables: {
 *      appearanceId: // value for 'appearanceId'
 *   },
 * });
 */
export function useEquipAppearanceMutation(baseOptions?: Apollo.MutationHookOptions<EquipAppearanceMutation, EquipAppearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipAppearanceMutation, EquipAppearanceMutationVariables>(EquipAppearanceDocument, options);
      }
export type EquipAppearanceMutationHookResult = ReturnType<typeof useEquipAppearanceMutation>;
export type EquipAppearanceMutationResult = Apollo.MutationResult<EquipAppearanceMutation>;
export type EquipAppearanceMutationOptions = Apollo.BaseMutationOptions<EquipAppearanceMutation, EquipAppearanceMutationVariables>;
export const EquipAssetDocument = gql`
    mutation EquipAsset($input: EquipAssetInput!) {
  equipAsset(input: $input) {
    status
    message
    type
  }
}
    `;
export type EquipAssetMutationFn = Apollo.MutationFunction<EquipAssetMutation, EquipAssetMutationVariables>;

/**
 * __useEquipAssetMutation__
 *
 * To run a mutation, you first call `useEquipAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipAssetMutation, { data, loading, error }] = useEquipAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipAssetMutation(baseOptions?: Apollo.MutationHookOptions<EquipAssetMutation, EquipAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipAssetMutation, EquipAssetMutationVariables>(EquipAssetDocument, options);
      }
export type EquipAssetMutationHookResult = ReturnType<typeof useEquipAssetMutation>;
export type EquipAssetMutationResult = Apollo.MutationResult<EquipAssetMutation>;
export type EquipAssetMutationOptions = Apollo.BaseMutationOptions<EquipAssetMutation, EquipAssetMutationVariables>;
export const EquipClassicAvatarDocument = gql`
    mutation EquipClassicAvatar($name: String!) {
  equipClassicAvatar(name: $name) {
    id
    glbUrl
    name
    provider
  }
}
    `;
export type EquipClassicAvatarMutationFn = Apollo.MutationFunction<EquipClassicAvatarMutation, EquipClassicAvatarMutationVariables>;

/**
 * __useEquipClassicAvatarMutation__
 *
 * To run a mutation, you first call `useEquipClassicAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipClassicAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipClassicAvatarMutation, { data, loading, error }] = useEquipClassicAvatarMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEquipClassicAvatarMutation(baseOptions?: Apollo.MutationHookOptions<EquipClassicAvatarMutation, EquipClassicAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipClassicAvatarMutation, EquipClassicAvatarMutationVariables>(EquipClassicAvatarDocument, options);
      }
export type EquipClassicAvatarMutationHookResult = ReturnType<typeof useEquipClassicAvatarMutation>;
export type EquipClassicAvatarMutationResult = Apollo.MutationResult<EquipClassicAvatarMutation>;
export type EquipClassicAvatarMutationOptions = Apollo.BaseMutationOptions<EquipClassicAvatarMutation, EquipClassicAvatarMutationVariables>;
export const EquipRpmAvatarDocument = gql`
    mutation EquipRpmAvatar($avatarId: String!) {
  equipRpmAvatar(avatarId: $avatarId) {
    id
    provider
    glbUrl
    name
    rpmAvatarId
    rpmGlbUrl
    thumbnail
    rpmJsonData {
      outfitGender
    }
  }
}
    `;
export type EquipRpmAvatarMutationFn = Apollo.MutationFunction<EquipRpmAvatarMutation, EquipRpmAvatarMutationVariables>;

/**
 * __useEquipRpmAvatarMutation__
 *
 * To run a mutation, you first call `useEquipRpmAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipRpmAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipRpmAvatarMutation, { data, loading, error }] = useEquipRpmAvatarMutation({
 *   variables: {
 *      avatarId: // value for 'avatarId'
 *   },
 * });
 */
export function useEquipRpmAvatarMutation(baseOptions?: Apollo.MutationHookOptions<EquipRpmAvatarMutation, EquipRpmAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipRpmAvatarMutation, EquipRpmAvatarMutationVariables>(EquipRpmAvatarDocument, options);
      }
export type EquipRpmAvatarMutationHookResult = ReturnType<typeof useEquipRpmAvatarMutation>;
export type EquipRpmAvatarMutationResult = Apollo.MutationResult<EquipRpmAvatarMutation>;
export type EquipRpmAvatarMutationOptions = Apollo.BaseMutationOptions<EquipRpmAvatarMutation, EquipRpmAvatarMutationVariables>;
export const UpdateFeatureToggleDocument = gql`
    mutation UpdateFeatureToggle($input: FeatureToggleInputDTO!) {
  updateFeatureToggle(input: $input) {
    name
    isEnabled
    enabledAt
    disabledAt
    criteria {
      tags {
        type
        name
      }
    }
    values {
      name
      isEnabled
      enabledAt
      disabledAt
      criteria {
        tags {
          type
          name
        }
      }
      values {
        name
        enabledAt
        values {
          name
          isEnabled
          enabledAt
          disabledAt
        }
      }
    }
  }
}
    `;
export type UpdateFeatureToggleMutationFn = Apollo.MutationFunction<UpdateFeatureToggleMutation, UpdateFeatureToggleMutationVariables>;

/**
 * __useUpdateFeatureToggleMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureToggleMutation, { data, loading, error }] = useUpdateFeatureToggleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeatureToggleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeatureToggleMutation, UpdateFeatureToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeatureToggleMutation, UpdateFeatureToggleMutationVariables>(UpdateFeatureToggleDocument, options);
      }
export type UpdateFeatureToggleMutationHookResult = ReturnType<typeof useUpdateFeatureToggleMutation>;
export type UpdateFeatureToggleMutationResult = Apollo.MutationResult<UpdateFeatureToggleMutation>;
export type UpdateFeatureToggleMutationOptions = Apollo.BaseMutationOptions<UpdateFeatureToggleMutation, UpdateFeatureToggleMutationVariables>;
export const CreateFeatureToggleDocument = gql`
    mutation CreateFeatureToggle($input: FeatureToggleInputDTO!) {
  updateFeatureToggle(input: $input) {
    name
    isEnabled
    enabledAt
    disabledAt
    criteria {
      tags {
        type
        name
      }
    }
    values {
      name
      isEnabled
      enabledAt
      disabledAt
      values {
        name
        isEnabled
        enabledAt
        values {
          name
          enabledAt
          disabledAt
        }
      }
    }
  }
}
    `;
export type CreateFeatureToggleMutationFn = Apollo.MutationFunction<CreateFeatureToggleMutation, CreateFeatureToggleMutationVariables>;

/**
 * __useCreateFeatureToggleMutation__
 *
 * To run a mutation, you first call `useCreateFeatureToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureToggleMutation, { data, loading, error }] = useCreateFeatureToggleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeatureToggleMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureToggleMutation, CreateFeatureToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureToggleMutation, CreateFeatureToggleMutationVariables>(CreateFeatureToggleDocument, options);
      }
export type CreateFeatureToggleMutationHookResult = ReturnType<typeof useCreateFeatureToggleMutation>;
export type CreateFeatureToggleMutationResult = Apollo.MutationResult<CreateFeatureToggleMutation>;
export type CreateFeatureToggleMutationOptions = Apollo.BaseMutationOptions<CreateFeatureToggleMutation, CreateFeatureToggleMutationVariables>;
export const DeleteFeatureToggleDocument = gql`
    mutation DeleteFeatureToggle($name: String!) {
  deleteFeatureToggle(name: $name)
}
    `;
export type DeleteFeatureToggleMutationFn = Apollo.MutationFunction<DeleteFeatureToggleMutation, DeleteFeatureToggleMutationVariables>;

/**
 * __useDeleteFeatureToggleMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureToggleMutation, { data, loading, error }] = useDeleteFeatureToggleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteFeatureToggleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeatureToggleMutation, DeleteFeatureToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeatureToggleMutation, DeleteFeatureToggleMutationVariables>(DeleteFeatureToggleDocument, options);
      }
export type DeleteFeatureToggleMutationHookResult = ReturnType<typeof useDeleteFeatureToggleMutation>;
export type DeleteFeatureToggleMutationResult = Apollo.MutationResult<DeleteFeatureToggleMutation>;
export type DeleteFeatureToggleMutationOptions = Apollo.BaseMutationOptions<DeleteFeatureToggleMutation, DeleteFeatureToggleMutationVariables>;
export const FinishRegistrationDocument = gql`
    mutation FinishRegistration($payload: FinishRegistrationDto!) {
  finishRegistration(input: $payload) {
    id
    username
    googleId
    hasFinishedRegistration
    isRegistered
    wallets {
      address
      type
    }
  }
}
    `;
export type FinishRegistrationMutationFn = Apollo.MutationFunction<FinishRegistrationMutation, FinishRegistrationMutationVariables>;

/**
 * __useFinishRegistrationMutation__
 *
 * To run a mutation, you first call `useFinishRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishRegistrationMutation, { data, loading, error }] = useFinishRegistrationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useFinishRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<FinishRegistrationMutation, FinishRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishRegistrationMutation, FinishRegistrationMutationVariables>(FinishRegistrationDocument, options);
      }
export type FinishRegistrationMutationHookResult = ReturnType<typeof useFinishRegistrationMutation>;
export type FinishRegistrationMutationResult = Apollo.MutationResult<FinishRegistrationMutation>;
export type FinishRegistrationMutationOptions = Apollo.BaseMutationOptions<FinishRegistrationMutation, FinishRegistrationMutationVariables>;
export const FollowUserDocument = gql`
    mutation FollowUser($targetId: Float!) {
  follow(targetId: $targetId) {
    id
    isFollowing
  }
}
    `;
export type FollowUserMutationFn = Apollo.MutationFunction<FollowUserMutation, FollowUserMutationVariables>;

/**
 * __useFollowUserMutation__
 *
 * To run a mutation, you first call `useFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserMutation, { data, loading, error }] = useFollowUserMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useFollowUserMutation(baseOptions?: Apollo.MutationHookOptions<FollowUserMutation, FollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, options);
      }
export type FollowUserMutationHookResult = ReturnType<typeof useFollowUserMutation>;
export type FollowUserMutationResult = Apollo.MutationResult<FollowUserMutation>;
export type FollowUserMutationOptions = Apollo.BaseMutationOptions<FollowUserMutation, FollowUserMutationVariables>;
export const ForkFromFileDocument = gql`
    mutation forkFromFile($fileId: String!) {
  forkFromFile(fileId: $fileId) {
    id
  }
}
    `;
export type ForkFromFileMutationFn = Apollo.MutationFunction<ForkFromFileMutation, ForkFromFileMutationVariables>;

/**
 * __useForkFromFileMutation__
 *
 * To run a mutation, you first call `useForkFromFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForkFromFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forkFromFileMutation, { data, loading, error }] = useForkFromFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useForkFromFileMutation(baseOptions?: Apollo.MutationHookOptions<ForkFromFileMutation, ForkFromFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForkFromFileMutation, ForkFromFileMutationVariables>(ForkFromFileDocument, options);
      }
export type ForkFromFileMutationHookResult = ReturnType<typeof useForkFromFileMutation>;
export type ForkFromFileMutationResult = Apollo.MutationResult<ForkFromFileMutation>;
export type ForkFromFileMutationOptions = Apollo.BaseMutationOptions<ForkFromFileMutation, ForkFromFileMutationVariables>;
export const GenerateNonceDocument = gql`
    mutation GenerateNonce {
  generateNonce
}
    `;
export type GenerateNonceMutationFn = Apollo.MutationFunction<GenerateNonceMutation, GenerateNonceMutationVariables>;

/**
 * __useGenerateNonceMutation__
 *
 * To run a mutation, you first call `useGenerateNonceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateNonceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateNonceMutation, { data, loading, error }] = useGenerateNonceMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateNonceMutation(baseOptions?: Apollo.MutationHookOptions<GenerateNonceMutation, GenerateNonceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateNonceMutation, GenerateNonceMutationVariables>(GenerateNonceDocument, options);
      }
export type GenerateNonceMutationHookResult = ReturnType<typeof useGenerateNonceMutation>;
export type GenerateNonceMutationResult = Apollo.MutationResult<GenerateNonceMutation>;
export type GenerateNonceMutationOptions = Apollo.BaseMutationOptions<GenerateNonceMutation, GenerateNonceMutationVariables>;
export const GenerateSkyboxFromPromptDocument = gql`
    mutation GenerateSkyboxFromPrompt($prompt: String!, $sessionId: ID!) {
  generateSkyboxFromPrompt(prompt: $prompt, sessionId: $sessionId)
}
    `;
export type GenerateSkyboxFromPromptMutationFn = Apollo.MutationFunction<GenerateSkyboxFromPromptMutation, GenerateSkyboxFromPromptMutationVariables>;

/**
 * __useGenerateSkyboxFromPromptMutation__
 *
 * To run a mutation, you first call `useGenerateSkyboxFromPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSkyboxFromPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSkyboxFromPromptMutation, { data, loading, error }] = useGenerateSkyboxFromPromptMutation({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGenerateSkyboxFromPromptMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSkyboxFromPromptMutation, GenerateSkyboxFromPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSkyboxFromPromptMutation, GenerateSkyboxFromPromptMutationVariables>(GenerateSkyboxFromPromptDocument, options);
      }
export type GenerateSkyboxFromPromptMutationHookResult = ReturnType<typeof useGenerateSkyboxFromPromptMutation>;
export type GenerateSkyboxFromPromptMutationResult = Apollo.MutationResult<GenerateSkyboxFromPromptMutation>;
export type GenerateSkyboxFromPromptMutationOptions = Apollo.BaseMutationOptions<GenerateSkyboxFromPromptMutation, GenerateSkyboxFromPromptMutationVariables>;
export const GenerateSkyboxUrlDocument = gql`
    mutation GenerateSkyboxUrl($prompt: String!) {
  generateSkyboxUrl(prompt: $prompt) {
    thumbnail
    cubenegx
    cubenegy
    cubenegz
    cubeposx
    cubeposy
    cubeposz
  }
}
    `;
export type GenerateSkyboxUrlMutationFn = Apollo.MutationFunction<GenerateSkyboxUrlMutation, GenerateSkyboxUrlMutationVariables>;

/**
 * __useGenerateSkyboxUrlMutation__
 *
 * To run a mutation, you first call `useGenerateSkyboxUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSkyboxUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSkyboxUrlMutation, { data, loading, error }] = useGenerateSkyboxUrlMutation({
 *   variables: {
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useGenerateSkyboxUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSkyboxUrlMutation, GenerateSkyboxUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSkyboxUrlMutation, GenerateSkyboxUrlMutationVariables>(GenerateSkyboxUrlDocument, options);
      }
export type GenerateSkyboxUrlMutationHookResult = ReturnType<typeof useGenerateSkyboxUrlMutation>;
export type GenerateSkyboxUrlMutationResult = Apollo.MutationResult<GenerateSkyboxUrlMutation>;
export type GenerateSkyboxUrlMutationOptions = Apollo.BaseMutationOptions<GenerateSkyboxUrlMutation, GenerateSkyboxUrlMutationVariables>;
export const GenerateUploadPictureUrlDocument = gql`
    mutation generateUploadPictureURL($format: String!) {
  generateUploadPictureURL(format: $format)
}
    `;
export type GenerateUploadPictureUrlMutationFn = Apollo.MutationFunction<GenerateUploadPictureUrlMutation, GenerateUploadPictureUrlMutationVariables>;

/**
 * __useGenerateUploadPictureUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadPictureUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadPictureUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadPictureUrlMutation, { data, loading, error }] = useGenerateUploadPictureUrlMutation({
 *   variables: {
 *      format: // value for 'format'
 *   },
 * });
 */
export function useGenerateUploadPictureUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadPictureUrlMutation, GenerateUploadPictureUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadPictureUrlMutation, GenerateUploadPictureUrlMutationVariables>(GenerateUploadPictureUrlDocument, options);
      }
export type GenerateUploadPictureUrlMutationHookResult = ReturnType<typeof useGenerateUploadPictureUrlMutation>;
export type GenerateUploadPictureUrlMutationResult = Apollo.MutationResult<GenerateUploadPictureUrlMutation>;
export type GenerateUploadPictureUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadPictureUrlMutation, GenerateUploadPictureUrlMutationVariables>;
export const GetDeleteAccountTokenDocument = gql`
    mutation GetDeleteAccountToken {
  getDeleteAccountToken
}
    `;
export type GetDeleteAccountTokenMutationFn = Apollo.MutationFunction<GetDeleteAccountTokenMutation, GetDeleteAccountTokenMutationVariables>;

/**
 * __useGetDeleteAccountTokenMutation__
 *
 * To run a mutation, you first call `useGetDeleteAccountTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetDeleteAccountTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getDeleteAccountTokenMutation, { data, loading, error }] = useGetDeleteAccountTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetDeleteAccountTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetDeleteAccountTokenMutation, GetDeleteAccountTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetDeleteAccountTokenMutation, GetDeleteAccountTokenMutationVariables>(GetDeleteAccountTokenDocument, options);
      }
export type GetDeleteAccountTokenMutationHookResult = ReturnType<typeof useGetDeleteAccountTokenMutation>;
export type GetDeleteAccountTokenMutationResult = Apollo.MutationResult<GetDeleteAccountTokenMutation>;
export type GetDeleteAccountTokenMutationOptions = Apollo.BaseMutationOptions<GetDeleteAccountTokenMutation, GetDeleteAccountTokenMutationVariables>;
export const LinkRpmAccountDocument = gql`
    mutation LinkRpmAccount($accountUserId: String!) {
  linkRpmAccount(accountUserId: $accountUserId) {
    id
    glbUrl
    rpmUserId
    rpmAvatarId
    rpmGlbUrl
    rpmHasLinkedAccount
    rpmJsonData {
      outfitGender
    }
    thumbnail
    name
    provider
  }
}
    `;
export type LinkRpmAccountMutationFn = Apollo.MutationFunction<LinkRpmAccountMutation, LinkRpmAccountMutationVariables>;

/**
 * __useLinkRpmAccountMutation__
 *
 * To run a mutation, you first call `useLinkRpmAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkRpmAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkRpmAccountMutation, { data, loading, error }] = useLinkRpmAccountMutation({
 *   variables: {
 *      accountUserId: // value for 'accountUserId'
 *   },
 * });
 */
export function useLinkRpmAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkRpmAccountMutation, LinkRpmAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkRpmAccountMutation, LinkRpmAccountMutationVariables>(LinkRpmAccountDocument, options);
      }
export type LinkRpmAccountMutationHookResult = ReturnType<typeof useLinkRpmAccountMutation>;
export type LinkRpmAccountMutationResult = Apollo.MutationResult<LinkRpmAccountMutation>;
export type LinkRpmAccountMutationOptions = Apollo.BaseMutationOptions<LinkRpmAccountMutation, LinkRpmAccountMutationVariables>;
export const LinkWalletDocument = gql`
    mutation LinkWallet($message: String!, $signature: String!, $walletType: String!) {
  linkWallet(message: $message, signature: $signature, walletType: $walletType)
}
    `;
export type LinkWalletMutationFn = Apollo.MutationFunction<LinkWalletMutation, LinkWalletMutationVariables>;

/**
 * __useLinkWalletMutation__
 *
 * To run a mutation, you first call `useLinkWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkWalletMutation, { data, loading, error }] = useLinkWalletMutation({
 *   variables: {
 *      message: // value for 'message'
 *      signature: // value for 'signature'
 *      walletType: // value for 'walletType'
 *   },
 * });
 */
export function useLinkWalletMutation(baseOptions?: Apollo.MutationHookOptions<LinkWalletMutation, LinkWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkWalletMutation, LinkWalletMutationVariables>(LinkWalletDocument, options);
      }
export type LinkWalletMutationHookResult = ReturnType<typeof useLinkWalletMutation>;
export type LinkWalletMutationResult = Apollo.MutationResult<LinkWalletMutation>;
export type LinkWalletMutationOptions = Apollo.BaseMutationOptions<LinkWalletMutation, LinkWalletMutationVariables>;
export const LogoutUserDocument = gql`
    mutation LogoutUser($refreshToken: String!) {
  logoutUser(refreshToken: $refreshToken)
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const LogoutAllDevicesDocument = gql`
    mutation LogoutAllDevices($userId: String!) {
  logoutAllDevices(userId: $userId)
}
    `;
export type LogoutAllDevicesMutationFn = Apollo.MutationFunction<LogoutAllDevicesMutation, LogoutAllDevicesMutationVariables>;

/**
 * __useLogoutAllDevicesMutation__
 *
 * To run a mutation, you first call `useLogoutAllDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutAllDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutAllDevicesMutation, { data, loading, error }] = useLogoutAllDevicesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLogoutAllDevicesMutation(baseOptions?: Apollo.MutationHookOptions<LogoutAllDevicesMutation, LogoutAllDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutAllDevicesMutation, LogoutAllDevicesMutationVariables>(LogoutAllDevicesDocument, options);
      }
export type LogoutAllDevicesMutationHookResult = ReturnType<typeof useLogoutAllDevicesMutation>;
export type LogoutAllDevicesMutationResult = Apollo.MutationResult<LogoutAllDevicesMutation>;
export type LogoutAllDevicesMutationOptions = Apollo.BaseMutationOptions<LogoutAllDevicesMutation, LogoutAllDevicesMutationVariables>;
export const MarkSuspensionAsResolvedDocument = gql`
    mutation MarkSuspensionAsResolved($payload: SuspendUserDTO!) {
  suspendUser(payload: $payload) {
    id
    endedAt
  }
}
    `;
export type MarkSuspensionAsResolvedMutationFn = Apollo.MutationFunction<MarkSuspensionAsResolvedMutation, MarkSuspensionAsResolvedMutationVariables>;

/**
 * __useMarkSuspensionAsResolvedMutation__
 *
 * To run a mutation, you first call `useMarkSuspensionAsResolvedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSuspensionAsResolvedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSuspensionAsResolvedMutation, { data, loading, error }] = useMarkSuspensionAsResolvedMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useMarkSuspensionAsResolvedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSuspensionAsResolvedMutation, MarkSuspensionAsResolvedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSuspensionAsResolvedMutation, MarkSuspensionAsResolvedMutationVariables>(MarkSuspensionAsResolvedDocument, options);
      }
export type MarkSuspensionAsResolvedMutationHookResult = ReturnType<typeof useMarkSuspensionAsResolvedMutation>;
export type MarkSuspensionAsResolvedMutationResult = Apollo.MutationResult<MarkSuspensionAsResolvedMutation>;
export type MarkSuspensionAsResolvedMutationOptions = Apollo.BaseMutationOptions<MarkSuspensionAsResolvedMutation, MarkSuspensionAsResolvedMutationVariables>;
export const ModerateUserAccountDocument = gql`
    mutation ModerateUserAccount($payload: ModerateUserDTO!) {
  moderateUserAccount(payload: $payload) {
    id
    email
  }
}
    `;
export type ModerateUserAccountMutationFn = Apollo.MutationFunction<ModerateUserAccountMutation, ModerateUserAccountMutationVariables>;

/**
 * __useModerateUserAccountMutation__
 *
 * To run a mutation, you first call `useModerateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModerateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderateUserAccountMutation, { data, loading, error }] = useModerateUserAccountMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useModerateUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<ModerateUserAccountMutation, ModerateUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModerateUserAccountMutation, ModerateUserAccountMutationVariables>(ModerateUserAccountDocument, options);
      }
export type ModerateUserAccountMutationHookResult = ReturnType<typeof useModerateUserAccountMutation>;
export type ModerateUserAccountMutationResult = Apollo.MutationResult<ModerateUserAccountMutation>;
export type ModerateUserAccountMutationOptions = Apollo.BaseMutationOptions<ModerateUserAccountMutation, ModerateUserAccountMutationVariables>;
export const MuteChatDocument = gql`
    mutation muteChat($payload: MutedChatDTO!) {
  muteChat(payload: $payload) {
    id
    chatId
  }
}
    `;
export type MuteChatMutationFn = Apollo.MutationFunction<MuteChatMutation, MuteChatMutationVariables>;

/**
 * __useMuteChatMutation__
 *
 * To run a mutation, you first call `useMuteChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMuteChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [muteChatMutation, { data, loading, error }] = useMuteChatMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useMuteChatMutation(baseOptions?: Apollo.MutationHookOptions<MuteChatMutation, MuteChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MuteChatMutation, MuteChatMutationVariables>(MuteChatDocument, options);
      }
export type MuteChatMutationHookResult = ReturnType<typeof useMuteChatMutation>;
export type MuteChatMutationResult = Apollo.MutationResult<MuteChatMutation>;
export type MuteChatMutationOptions = Apollo.BaseMutationOptions<MuteChatMutation, MuteChatMutationVariables>;
export const NewRpmUserByUserIdDocument = gql`
    mutation NewRpmUserByUserId($userId: ID!) {
  newRpmUserByUserId(userId: $userId) {
    success
  }
}
    `;
export type NewRpmUserByUserIdMutationFn = Apollo.MutationFunction<NewRpmUserByUserIdMutation, NewRpmUserByUserIdMutationVariables>;

/**
 * __useNewRpmUserByUserIdMutation__
 *
 * To run a mutation, you first call `useNewRpmUserByUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewRpmUserByUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newRpmUserByUserIdMutation, { data, loading, error }] = useNewRpmUserByUserIdMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNewRpmUserByUserIdMutation(baseOptions?: Apollo.MutationHookOptions<NewRpmUserByUserIdMutation, NewRpmUserByUserIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewRpmUserByUserIdMutation, NewRpmUserByUserIdMutationVariables>(NewRpmUserByUserIdDocument, options);
      }
export type NewRpmUserByUserIdMutationHookResult = ReturnType<typeof useNewRpmUserByUserIdMutation>;
export type NewRpmUserByUserIdMutationResult = Apollo.MutationResult<NewRpmUserByUserIdMutation>;
export type NewRpmUserByUserIdMutationOptions = Apollo.BaseMutationOptions<NewRpmUserByUserIdMutation, NewRpmUserByUserIdMutationVariables>;
export const PinCommentDocument = gql`
    mutation pinComment($commentId: Float!, $contentId: Float!) {
  pinComment(commentId: $commentId, contentId: $contentId) {
    id
    isPinned
  }
}
    `;
export type PinCommentMutationFn = Apollo.MutationFunction<PinCommentMutation, PinCommentMutationVariables>;

/**
 * __usePinCommentMutation__
 *
 * To run a mutation, you first call `usePinCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinCommentMutation, { data, loading, error }] = usePinCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function usePinCommentMutation(baseOptions?: Apollo.MutationHookOptions<PinCommentMutation, PinCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinCommentMutation, PinCommentMutationVariables>(PinCommentDocument, options);
      }
export type PinCommentMutationHookResult = ReturnType<typeof usePinCommentMutation>;
export type PinCommentMutationResult = Apollo.MutationResult<PinCommentMutation>;
export type PinCommentMutationOptions = Apollo.BaseMutationOptions<PinCommentMutation, PinCommentMutationVariables>;
export const PostCommentDocument = gql`
    mutation PostComment($contentId: ID!, $text: String!, $contentType: ContentType!) {
  postComment(
    payload: {contentId: $contentId, text: $text, contentType: $contentType}
  ) {
    contentId
    contentType
    text
    id
    likes
    createdAt
    updatedAt
    deletedAt
    isPinned
    isReported
    likes
    isLiked
    author {
      id
      role
      username
      pictureUrl
      level
      isEmployee
      isVerified
      suspension {
        id
      }
    }
    comments(payload: {first: 2}) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          contentId
          contentType
          likes
          isLiked
          isReported
          text
          id
          likes
          createdAt
          updatedAt
          deletedAt
          isPinned
          author {
            id
            role
            isVerified
            isEmployee
            username
            pictureUrl
            level
            isFollowing
            suspension {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type PostCommentMutationFn = Apollo.MutationFunction<PostCommentMutation, PostCommentMutationVariables>;

/**
 * __usePostCommentMutation__
 *
 * To run a mutation, you first call `usePostCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCommentMutation, { data, loading, error }] = usePostCommentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      text: // value for 'text'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function usePostCommentMutation(baseOptions?: Apollo.MutationHookOptions<PostCommentMutation, PostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCommentMutation, PostCommentMutationVariables>(PostCommentDocument, options);
      }
export type PostCommentMutationHookResult = ReturnType<typeof usePostCommentMutation>;
export type PostCommentMutationResult = Apollo.MutationResult<PostCommentMutation>;
export type PostCommentMutationOptions = Apollo.BaseMutationOptions<PostCommentMutation, PostCommentMutationVariables>;
export const PreviewAssetDocument = gql`
    mutation PreviewAsset($input: PreviewAssetInput!) {
  previewAsset(input: $input) {
    status
    message
    type
  }
}
    `;
export type PreviewAssetMutationFn = Apollo.MutationFunction<PreviewAssetMutation, PreviewAssetMutationVariables>;

/**
 * __usePreviewAssetMutation__
 *
 * To run a mutation, you first call `usePreviewAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewAssetMutation, { data, loading, error }] = usePreviewAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewAssetMutation(baseOptions?: Apollo.MutationHookOptions<PreviewAssetMutation, PreviewAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewAssetMutation, PreviewAssetMutationVariables>(PreviewAssetDocument, options);
      }
export type PreviewAssetMutationHookResult = ReturnType<typeof usePreviewAssetMutation>;
export type PreviewAssetMutationResult = Apollo.MutationResult<PreviewAssetMutation>;
export type PreviewAssetMutationOptions = Apollo.BaseMutationOptions<PreviewAssetMutation, PreviewAssetMutationVariables>;
export const CreateProjectRewardItemMutationDocument = gql`
    mutation CreateProjectRewardItemMutation($projectId: ID!, $values: [String!]!) {
  createProjectReward(
    projectReward: {projectId: $projectId, rewardType: APPEARANCE, values: $values}
  ) {
    projectId
    values
    project {
      id
      title
      thumbnail {
        id
        medium {
          id
          url
        }
      }
    }
  }
}
    `;
export type CreateProjectRewardItemMutationMutationFn = Apollo.MutationFunction<CreateProjectRewardItemMutationMutation, CreateProjectRewardItemMutationMutationVariables>;

/**
 * __useCreateProjectRewardItemMutationMutation__
 *
 * To run a mutation, you first call `useCreateProjectRewardItemMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectRewardItemMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectRewardItemMutationMutation, { data, loading, error }] = useCreateProjectRewardItemMutationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateProjectRewardItemMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectRewardItemMutationMutation, CreateProjectRewardItemMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectRewardItemMutationMutation, CreateProjectRewardItemMutationMutationVariables>(CreateProjectRewardItemMutationDocument, options);
      }
export type CreateProjectRewardItemMutationMutationHookResult = ReturnType<typeof useCreateProjectRewardItemMutationMutation>;
export type CreateProjectRewardItemMutationMutationResult = Apollo.MutationResult<CreateProjectRewardItemMutationMutation>;
export type CreateProjectRewardItemMutationMutationOptions = Apollo.BaseMutationOptions<CreateProjectRewardItemMutationMutation, CreateProjectRewardItemMutationMutationVariables>;
export const DeleteProjectRewardDocument = gql`
    mutation DeleteProjectReward($projectId: ID!) {
  deleteProjectReward(projectId: $projectId, rewardType: APPEARANCE)
}
    `;
export type DeleteProjectRewardMutationFn = Apollo.MutationFunction<DeleteProjectRewardMutation, DeleteProjectRewardMutationVariables>;

/**
 * __useDeleteProjectRewardMutation__
 *
 * To run a mutation, you first call `useDeleteProjectRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectRewardMutation, { data, loading, error }] = useDeleteProjectRewardMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectRewardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectRewardMutation, DeleteProjectRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectRewardMutation, DeleteProjectRewardMutationVariables>(DeleteProjectRewardDocument, options);
      }
export type DeleteProjectRewardMutationHookResult = ReturnType<typeof useDeleteProjectRewardMutation>;
export type DeleteProjectRewardMutationResult = Apollo.MutationResult<DeleteProjectRewardMutation>;
export type DeleteProjectRewardMutationOptions = Apollo.BaseMutationOptions<DeleteProjectRewardMutation, DeleteProjectRewardMutationVariables>;
export const UpdateProjectRewardDocument = gql`
    mutation UpdateProjectReward($projectId: ID!, $values: [String!]!) {
  updateProjectReward(
    projectReward: {projectId: $projectId, values: $values, rewardType: APPEARANCE}
  ) {
    projectId
    values
    project {
      id
      title
      thumbnail {
        id
        medium {
          id
          url
        }
      }
    }
  }
}
    `;
export type UpdateProjectRewardMutationFn = Apollo.MutationFunction<UpdateProjectRewardMutation, UpdateProjectRewardMutationVariables>;

/**
 * __useUpdateProjectRewardMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRewardMutation, { data, loading, error }] = useUpdateProjectRewardMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateProjectRewardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectRewardMutation, UpdateProjectRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectRewardMutation, UpdateProjectRewardMutationVariables>(UpdateProjectRewardDocument, options);
      }
export type UpdateProjectRewardMutationHookResult = ReturnType<typeof useUpdateProjectRewardMutation>;
export type UpdateProjectRewardMutationResult = Apollo.MutationResult<UpdateProjectRewardMutation>;
export type UpdateProjectRewardMutationOptions = Apollo.BaseMutationOptions<UpdateProjectRewardMutation, UpdateProjectRewardMutationVariables>;
export const PublishProjectDocument = gql`
    mutation publishProject($id: ID!, $title: String!, $description: String!, $categories: [String!], $tags: [String!]!, $visibility: Int!, $disableComments: Boolean) {
  publishProject(
    payload: {id: $id, title: $title, description: $description, categories: $categories, tags: $tags, visibility: $visibility, disableComments: $disableComments}
  ) {
    ...ProjectInfo
  }
}
    ${ProjectInfoFragmentDoc}`;
export type PublishProjectMutationFn = Apollo.MutationFunction<PublishProjectMutation, PublishProjectMutationVariables>;

/**
 * __usePublishProjectMutation__
 *
 * To run a mutation, you first call `usePublishProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishProjectMutation, { data, loading, error }] = usePublishProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      categories: // value for 'categories'
 *      tags: // value for 'tags'
 *      visibility: // value for 'visibility'
 *      disableComments: // value for 'disableComments'
 *   },
 * });
 */
export function usePublishProjectMutation(baseOptions?: Apollo.MutationHookOptions<PublishProjectMutation, PublishProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishProjectMutation, PublishProjectMutationVariables>(PublishProjectDocument, options);
      }
export type PublishProjectMutationHookResult = ReturnType<typeof usePublishProjectMutation>;
export type PublishProjectMutationResult = Apollo.MutationResult<PublishProjectMutation>;
export type PublishProjectMutationOptions = Apollo.BaseMutationOptions<PublishProjectMutation, PublishProjectMutationVariables>;
export const RefreshAccessTokenDocument = gql`
    mutation RefreshAccessToken($refreshToken: String!) {
  refreshAccessToken(refreshToken: $refreshToken)
}
    `;
export type RefreshAccessTokenMutationFn = Apollo.MutationFunction<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;

/**
 * __useRefreshAccessTokenMutation__
 *
 * To run a mutation, you first call `useRefreshAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAccessTokenMutation, { data, loading, error }] = useRefreshAccessTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>(RefreshAccessTokenDocument, options);
      }
export type RefreshAccessTokenMutationHookResult = ReturnType<typeof useRefreshAccessTokenMutation>;
export type RefreshAccessTokenMutationResult = Apollo.MutationResult<RefreshAccessTokenMutation>;
export type RefreshAccessTokenMutationOptions = Apollo.BaseMutationOptions<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;
export const RemoveActiveSessionsFromMatchmakeDocument = gql`
    mutation RemoveActiveSessionsFromMatchmake($projectId: ID!) {
  removeActiveSessionsFromMatchmake(projectId: $projectId)
}
    `;
export type RemoveActiveSessionsFromMatchmakeMutationFn = Apollo.MutationFunction<RemoveActiveSessionsFromMatchmakeMutation, RemoveActiveSessionsFromMatchmakeMutationVariables>;

/**
 * __useRemoveActiveSessionsFromMatchmakeMutation__
 *
 * To run a mutation, you first call `useRemoveActiveSessionsFromMatchmakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveActiveSessionsFromMatchmakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeActiveSessionsFromMatchmakeMutation, { data, loading, error }] = useRemoveActiveSessionsFromMatchmakeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveActiveSessionsFromMatchmakeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveActiveSessionsFromMatchmakeMutation, RemoveActiveSessionsFromMatchmakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveActiveSessionsFromMatchmakeMutation, RemoveActiveSessionsFromMatchmakeMutationVariables>(RemoveActiveSessionsFromMatchmakeDocument, options);
      }
export type RemoveActiveSessionsFromMatchmakeMutationHookResult = ReturnType<typeof useRemoveActiveSessionsFromMatchmakeMutation>;
export type RemoveActiveSessionsFromMatchmakeMutationResult = Apollo.MutationResult<RemoveActiveSessionsFromMatchmakeMutation>;
export type RemoveActiveSessionsFromMatchmakeMutationOptions = Apollo.BaseMutationOptions<RemoveActiveSessionsFromMatchmakeMutation, RemoveActiveSessionsFromMatchmakeMutationVariables>;
export const RemoveDescriptionDocument = gql`
    mutation removeDescription($id: Float!) {
  removeDescription(id: $id) {
    id
    username
    description
  }
}
    `;
export type RemoveDescriptionMutationFn = Apollo.MutationFunction<RemoveDescriptionMutation, RemoveDescriptionMutationVariables>;

/**
 * __useRemoveDescriptionMutation__
 *
 * To run a mutation, you first call `useRemoveDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDescriptionMutation, { data, loading, error }] = useRemoveDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDescriptionMutation, RemoveDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDescriptionMutation, RemoveDescriptionMutationVariables>(RemoveDescriptionDocument, options);
      }
export type RemoveDescriptionMutationHookResult = ReturnType<typeof useRemoveDescriptionMutation>;
export type RemoveDescriptionMutationResult = Apollo.MutationResult<RemoveDescriptionMutation>;
export type RemoveDescriptionMutationOptions = Apollo.BaseMutationOptions<RemoveDescriptionMutation, RemoveDescriptionMutationVariables>;
export const RemoveFeaturedProfileMutationDocument = gql`
    mutation RemoveFeaturedProfileMutation($id: Float!) {
  removeFeaturedProfile(id: $id)
}
    `;
export type RemoveFeaturedProfileMutationMutationFn = Apollo.MutationFunction<RemoveFeaturedProfileMutationMutation, RemoveFeaturedProfileMutationMutationVariables>;

/**
 * __useRemoveFeaturedProfileMutationMutation__
 *
 * To run a mutation, you first call `useRemoveFeaturedProfileMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFeaturedProfileMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFeaturedProfileMutationMutation, { data, loading, error }] = useRemoveFeaturedProfileMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveFeaturedProfileMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFeaturedProfileMutationMutation, RemoveFeaturedProfileMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFeaturedProfileMutationMutation, RemoveFeaturedProfileMutationMutationVariables>(RemoveFeaturedProfileMutationDocument, options);
      }
export type RemoveFeaturedProfileMutationMutationHookResult = ReturnType<typeof useRemoveFeaturedProfileMutationMutation>;
export type RemoveFeaturedProfileMutationMutationResult = Apollo.MutationResult<RemoveFeaturedProfileMutationMutation>;
export type RemoveFeaturedProfileMutationMutationOptions = Apollo.BaseMutationOptions<RemoveFeaturedProfileMutationMutation, RemoveFeaturedProfileMutationMutationVariables>;
export const RemoveFriendDocument = gql`
    mutation removeFriend($targetId: Float!) {
  removeFriend(targetId: $targetId) {
    id
    isFriends
    haveIFeaturedFriend
  }
}
    `;
export type RemoveFriendMutationFn = Apollo.MutationFunction<RemoveFriendMutation, RemoveFriendMutationVariables>;

/**
 * __useRemoveFriendMutation__
 *
 * To run a mutation, you first call `useRemoveFriendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFriendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFriendMutation, { data, loading, error }] = useRemoveFriendMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useRemoveFriendMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFriendMutation, RemoveFriendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFriendMutation, RemoveFriendMutationVariables>(RemoveFriendDocument, options);
      }
export type RemoveFriendMutationHookResult = ReturnType<typeof useRemoveFriendMutation>;
export type RemoveFriendMutationResult = Apollo.MutationResult<RemoveFriendMutation>;
export type RemoveFriendMutationOptions = Apollo.BaseMutationOptions<RemoveFriendMutation, RemoveFriendMutationVariables>;
export const RemoveProfileBackgroundDocument = gql`
    mutation removeProfileBackground($userId: Float!) {
  removeProfileBackground(userId: $userId) {
    id
    profileBackgroundUrl
  }
}
    `;
export type RemoveProfileBackgroundMutationFn = Apollo.MutationFunction<RemoveProfileBackgroundMutation, RemoveProfileBackgroundMutationVariables>;

/**
 * __useRemoveProfileBackgroundMutation__
 *
 * To run a mutation, you first call `useRemoveProfileBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProfileBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProfileBackgroundMutation, { data, loading, error }] = useRemoveProfileBackgroundMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveProfileBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProfileBackgroundMutation, RemoveProfileBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProfileBackgroundMutation, RemoveProfileBackgroundMutationVariables>(RemoveProfileBackgroundDocument, options);
      }
export type RemoveProfileBackgroundMutationHookResult = ReturnType<typeof useRemoveProfileBackgroundMutation>;
export type RemoveProfileBackgroundMutationResult = Apollo.MutationResult<RemoveProfileBackgroundMutation>;
export type RemoveProfileBackgroundMutationOptions = Apollo.BaseMutationOptions<RemoveProfileBackgroundMutation, RemoveProfileBackgroundMutationVariables>;
export const RemoveProfilePictureDocument = gql`
    mutation RemoveProfilePicture($id: Float!) {
  removeProfilePicture(id: $id)
}
    `;
export type RemoveProfilePictureMutationFn = Apollo.MutationFunction<RemoveProfilePictureMutation, RemoveProfilePictureMutationVariables>;

/**
 * __useRemoveProfilePictureMutation__
 *
 * To run a mutation, you first call `useRemoveProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProfilePictureMutation, { data, loading, error }] = useRemoveProfilePictureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveProfilePictureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProfilePictureMutation, RemoveProfilePictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProfilePictureMutation, RemoveProfilePictureMutationVariables>(RemoveProfilePictureDocument, options);
      }
export type RemoveProfilePictureMutationHookResult = ReturnType<typeof useRemoveProfilePictureMutation>;
export type RemoveProfilePictureMutationResult = Apollo.MutationResult<RemoveProfilePictureMutation>;
export type RemoveProfilePictureMutationOptions = Apollo.BaseMutationOptions<RemoveProfilePictureMutation, RemoveProfilePictureMutationVariables>;
export const RemoveSocialMediaTypeDocument = gql`
    mutation RemoveSocialMediaType($id: Float!, $type: SocialMediaType!) {
  removeSocialMediaType(id: $id, type: $type) {
    __typename
    id
    twitch
    youtube
    twitter
    instagram
    tiktok
  }
}
    `;
export type RemoveSocialMediaTypeMutationFn = Apollo.MutationFunction<RemoveSocialMediaTypeMutation, RemoveSocialMediaTypeMutationVariables>;

/**
 * __useRemoveSocialMediaTypeMutation__
 *
 * To run a mutation, you first call `useRemoveSocialMediaTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSocialMediaTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSocialMediaTypeMutation, { data, loading, error }] = useRemoveSocialMediaTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRemoveSocialMediaTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSocialMediaTypeMutation, RemoveSocialMediaTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSocialMediaTypeMutation, RemoveSocialMediaTypeMutationVariables>(RemoveSocialMediaTypeDocument, options);
      }
export type RemoveSocialMediaTypeMutationHookResult = ReturnType<typeof useRemoveSocialMediaTypeMutation>;
export type RemoveSocialMediaTypeMutationResult = Apollo.MutationResult<RemoveSocialMediaTypeMutation>;
export type RemoveSocialMediaTypeMutationOptions = Apollo.BaseMutationOptions<RemoveSocialMediaTypeMutation, RemoveSocialMediaTypeMutationVariables>;
export const RemoveTagFromContentDocument = gql`
    mutation RemoveTagFromContent($contentId: ID!, $name: String!, $type: TagType!) {
  removeTagFromContent(payload: {contentId: $contentId, name: $name, type: $type})
}
    `;
export type RemoveTagFromContentMutationFn = Apollo.MutationFunction<RemoveTagFromContentMutation, RemoveTagFromContentMutationVariables>;

/**
 * __useRemoveTagFromContentMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromContentMutation, { data, loading, error }] = useRemoveTagFromContentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRemoveTagFromContentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagFromContentMutation, RemoveTagFromContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagFromContentMutation, RemoveTagFromContentMutationVariables>(RemoveTagFromContentDocument, options);
      }
export type RemoveTagFromContentMutationHookResult = ReturnType<typeof useRemoveTagFromContentMutation>;
export type RemoveTagFromContentMutationResult = Apollo.MutationResult<RemoveTagFromContentMutation>;
export type RemoveTagFromContentMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromContentMutation, RemoveTagFromContentMutationVariables>;
export const ReplyToCommentDocument = gql`
    mutation replyToComment($commentId: ID!, $text: String!, $contentType: ContentType!) {
  postComment(
    payload: {contentId: $commentId, text: $text, contentType: $contentType}
  ) {
    id
    text
    createdAt
    updatedAt
    deletedAt
    isPinned
    __typename
    isLiked
    likes
    isReported
    contentId
    contentType
    author {
      level
      id
      role
      username
      pictureUrl
      isVerified
      isEmployee
      suspension {
        id
      }
    }
  }
}
    `;
export type ReplyToCommentMutationFn = Apollo.MutationFunction<ReplyToCommentMutation, ReplyToCommentMutationVariables>;

/**
 * __useReplyToCommentMutation__
 *
 * To run a mutation, you first call `useReplyToCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyToCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyToCommentMutation, { data, loading, error }] = useReplyToCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      text: // value for 'text'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useReplyToCommentMutation(baseOptions?: Apollo.MutationHookOptions<ReplyToCommentMutation, ReplyToCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyToCommentMutation, ReplyToCommentMutationVariables>(ReplyToCommentDocument, options);
      }
export type ReplyToCommentMutationHookResult = ReturnType<typeof useReplyToCommentMutation>;
export type ReplyToCommentMutationResult = Apollo.MutationResult<ReplyToCommentMutation>;
export type ReplyToCommentMutationOptions = Apollo.BaseMutationOptions<ReplyToCommentMutation, ReplyToCommentMutationVariables>;
export const ReportContentDocument = gql`
    mutation ReportContent($id: ID!, $type: ContentType!, $reason: ReportReason!, $reasonText: String, $rootContentId: ID!, $reportedUser: ID, $projectId: ID) {
  reportContent(
    payload: {id: $id, contentType: $type, reason: $reason, reasonText: $reasonText, rootContentId: $rootContentId, reportedUser: $reportedUser, projectId: $projectId}
  ) {
    ... on Project {
      id
      isReported
    }
    ... on Comment {
      id
      isReported
    }
    ... on User {
      id
      isReported
    }
    ... on Image {
      id
      isReported
    }
    ... on Chat {
      id
      isReported
    }
  }
}
    `;
export type ReportContentMutationFn = Apollo.MutationFunction<ReportContentMutation, ReportContentMutationVariables>;

/**
 * __useReportContentMutation__
 *
 * To run a mutation, you first call `useReportContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportContentMutation, { data, loading, error }] = useReportContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      reason: // value for 'reason'
 *      reasonText: // value for 'reasonText'
 *      rootContentId: // value for 'rootContentId'
 *      reportedUser: // value for 'reportedUser'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useReportContentMutation(baseOptions?: Apollo.MutationHookOptions<ReportContentMutation, ReportContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportContentMutation, ReportContentMutationVariables>(ReportContentDocument, options);
      }
export type ReportContentMutationHookResult = ReturnType<typeof useReportContentMutation>;
export type ReportContentMutationResult = Apollo.MutationResult<ReportContentMutation>;
export type ReportContentMutationOptions = Apollo.BaseMutationOptions<ReportContentMutation, ReportContentMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($token: String!, $password: String!) {
  resetPassword(payload: {token: $token, password: $password})
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ResetPasswordRequestDocument = gql`
    mutation ResetPasswordRequest($email: String!, $captcha: String!) {
  resetPasswordRequest(payload: {email: $email, captcha: $captcha})
}
    `;
export type ResetPasswordRequestMutationFn = Apollo.MutationFunction<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>;

/**
 * __useResetPasswordRequestMutation__
 *
 * To run a mutation, you first call `useResetPasswordRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordRequestMutation, { data, loading, error }] = useResetPasswordRequestMutation({
 *   variables: {
 *      email: // value for 'email'
 *      captcha: // value for 'captcha'
 *   },
 * });
 */
export function useResetPasswordRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>(ResetPasswordRequestDocument, options);
      }
export type ResetPasswordRequestMutationHookResult = ReturnType<typeof useResetPasswordRequestMutation>;
export type ResetPasswordRequestMutationResult = Apollo.MutationResult<ResetPasswordRequestMutation>;
export type ResetPasswordRequestMutationOptions = Apollo.BaseMutationOptions<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>;
export const RotateChallengesDocument = gql`
    mutation RotateChallenges($persistence: Persistence!) {
  rotateChallenges(persistence: $persistence) {
    badge {
      badge {
        id
      }
    }
  }
}
    `;
export type RotateChallengesMutationFn = Apollo.MutationFunction<RotateChallengesMutation, RotateChallengesMutationVariables>;

/**
 * __useRotateChallengesMutation__
 *
 * To run a mutation, you first call `useRotateChallengesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateChallengesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateChallengesMutation, { data, loading, error }] = useRotateChallengesMutation({
 *   variables: {
 *      persistence: // value for 'persistence'
 *   },
 * });
 */
export function useRotateChallengesMutation(baseOptions?: Apollo.MutationHookOptions<RotateChallengesMutation, RotateChallengesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RotateChallengesMutation, RotateChallengesMutationVariables>(RotateChallengesDocument, options);
      }
export type RotateChallengesMutationHookResult = ReturnType<typeof useRotateChallengesMutation>;
export type RotateChallengesMutationResult = Apollo.MutationResult<RotateChallengesMutation>;
export type RotateChallengesMutationOptions = Apollo.BaseMutationOptions<RotateChallengesMutation, RotateChallengesMutationVariables>;
export const SetFriendRequestsSeenDocument = gql`
    mutation setFriendRequestsSeen {
  setFriendRequestsSeen
}
    `;
export type SetFriendRequestsSeenMutationFn = Apollo.MutationFunction<SetFriendRequestsSeenMutation, SetFriendRequestsSeenMutationVariables>;

/**
 * __useSetFriendRequestsSeenMutation__
 *
 * To run a mutation, you first call `useSetFriendRequestsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFriendRequestsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFriendRequestsSeenMutation, { data, loading, error }] = useSetFriendRequestsSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetFriendRequestsSeenMutation(baseOptions?: Apollo.MutationHookOptions<SetFriendRequestsSeenMutation, SetFriendRequestsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFriendRequestsSeenMutation, SetFriendRequestsSeenMutationVariables>(SetFriendRequestsSeenDocument, options);
      }
export type SetFriendRequestsSeenMutationHookResult = ReturnType<typeof useSetFriendRequestsSeenMutation>;
export type SetFriendRequestsSeenMutationResult = Apollo.MutationResult<SetFriendRequestsSeenMutation>;
export type SetFriendRequestsSeenMutationOptions = Apollo.BaseMutationOptions<SetFriendRequestsSeenMutation, SetFriendRequestsSeenMutationVariables>;
export const SetHomeworldDocument = gql`
    mutation SetHomeworld($projectId: ID!) {
  createHomeworld(projectId: $projectId) {
    id
    active
    __typename
    project {
      id
      title
      isHomeworld
      isPublished
      engineVersion
      __typename
      thumbnail {
        id
        large {
          id
          url
        }
      }
    }
  }
}
    `;
export type SetHomeworldMutationFn = Apollo.MutationFunction<SetHomeworldMutation, SetHomeworldMutationVariables>;

/**
 * __useSetHomeworldMutation__
 *
 * To run a mutation, you first call `useSetHomeworldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHomeworldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHomeworldMutation, { data, loading, error }] = useSetHomeworldMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSetHomeworldMutation(baseOptions?: Apollo.MutationHookOptions<SetHomeworldMutation, SetHomeworldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHomeworldMutation, SetHomeworldMutationVariables>(SetHomeworldDocument, options);
      }
export type SetHomeworldMutationHookResult = ReturnType<typeof useSetHomeworldMutation>;
export type SetHomeworldMutationResult = Apollo.MutationResult<SetHomeworldMutation>;
export type SetHomeworldMutationOptions = Apollo.BaseMutationOptions<SetHomeworldMutation, SetHomeworldMutationVariables>;
export const SetProjectAuthorDocument = gql`
    mutation SetProjectAuthor($newOwnerId: Float!, $projectId: ID!) {
  setProjectAuthor(projectId: $projectId, newOwnerId: $newOwnerId) {
    id
    author {
      id
    }
  }
}
    `;
export type SetProjectAuthorMutationFn = Apollo.MutationFunction<SetProjectAuthorMutation, SetProjectAuthorMutationVariables>;

/**
 * __useSetProjectAuthorMutation__
 *
 * To run a mutation, you first call `useSetProjectAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectAuthorMutation, { data, loading, error }] = useSetProjectAuthorMutation({
 *   variables: {
 *      newOwnerId: // value for 'newOwnerId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSetProjectAuthorMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectAuthorMutation, SetProjectAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectAuthorMutation, SetProjectAuthorMutationVariables>(SetProjectAuthorDocument, options);
      }
export type SetProjectAuthorMutationHookResult = ReturnType<typeof useSetProjectAuthorMutation>;
export type SetProjectAuthorMutationResult = Apollo.MutationResult<SetProjectAuthorMutation>;
export type SetProjectAuthorMutationOptions = Apollo.BaseMutationOptions<SetProjectAuthorMutation, SetProjectAuthorMutationVariables>;
export const SetProjectPublishStatusDocument = gql`
    mutation setProjectPublishStatus($id: ID!, $isPublished: Boolean!) {
  setPublishStatus(id: $id, isPublished: $isPublished) {
    id
    isPublished
  }
}
    `;
export type SetProjectPublishStatusMutationFn = Apollo.MutationFunction<SetProjectPublishStatusMutation, SetProjectPublishStatusMutationVariables>;

/**
 * __useSetProjectPublishStatusMutation__
 *
 * To run a mutation, you first call `useSetProjectPublishStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectPublishStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectPublishStatusMutation, { data, loading, error }] = useSetProjectPublishStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isPublished: // value for 'isPublished'
 *   },
 * });
 */
export function useSetProjectPublishStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectPublishStatusMutation, SetProjectPublishStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectPublishStatusMutation, SetProjectPublishStatusMutationVariables>(SetProjectPublishStatusDocument, options);
      }
export type SetProjectPublishStatusMutationHookResult = ReturnType<typeof useSetProjectPublishStatusMutation>;
export type SetProjectPublishStatusMutationResult = Apollo.MutationResult<SetProjectPublishStatusMutation>;
export type SetProjectPublishStatusMutationOptions = Apollo.BaseMutationOptions<SetProjectPublishStatusMutation, SetProjectPublishStatusMutationVariables>;
export const SetSeenBadgesDocument = gql`
    mutation SetSeenBadges($badgeIds: [ID!]!) {
  setSeenBadges(badgeIds: $badgeIds)
}
    `;
export type SetSeenBadgesMutationFn = Apollo.MutationFunction<SetSeenBadgesMutation, SetSeenBadgesMutationVariables>;

/**
 * __useSetSeenBadgesMutation__
 *
 * To run a mutation, you first call `useSetSeenBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSeenBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSeenBadgesMutation, { data, loading, error }] = useSetSeenBadgesMutation({
 *   variables: {
 *      badgeIds: // value for 'badgeIds'
 *   },
 * });
 */
export function useSetSeenBadgesMutation(baseOptions?: Apollo.MutationHookOptions<SetSeenBadgesMutation, SetSeenBadgesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSeenBadgesMutation, SetSeenBadgesMutationVariables>(SetSeenBadgesDocument, options);
      }
export type SetSeenBadgesMutationHookResult = ReturnType<typeof useSetSeenBadgesMutation>;
export type SetSeenBadgesMutationResult = Apollo.MutationResult<SetSeenBadgesMutation>;
export type SetSeenBadgesMutationOptions = Apollo.BaseMutationOptions<SetSeenBadgesMutation, SetSeenBadgesMutationVariables>;
export const SetSeenSuspensionDocument = gql`
    mutation setSeenSuspension($id: ID!) {
  setSeenSuspension(id: $id) {
    id
    seen
    __typename
  }
}
    `;
export type SetSeenSuspensionMutationFn = Apollo.MutationFunction<SetSeenSuspensionMutation, SetSeenSuspensionMutationVariables>;

/**
 * __useSetSeenSuspensionMutation__
 *
 * To run a mutation, you first call `useSetSeenSuspensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSeenSuspensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSeenSuspensionMutation, { data, loading, error }] = useSetSeenSuspensionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetSeenSuspensionMutation(baseOptions?: Apollo.MutationHookOptions<SetSeenSuspensionMutation, SetSeenSuspensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSeenSuspensionMutation, SetSeenSuspensionMutationVariables>(SetSeenSuspensionDocument, options);
      }
export type SetSeenSuspensionMutationHookResult = ReturnType<typeof useSetSeenSuspensionMutation>;
export type SetSeenSuspensionMutationResult = Apollo.MutationResult<SetSeenSuspensionMutation>;
export type SetSeenSuspensionMutationOptions = Apollo.BaseMutationOptions<SetSeenSuspensionMutation, SetSeenSuspensionMutationVariables>;
export const SetUserLevelDocument = gql`
    mutation setUserLevel($userId: ID!, $level: Float!) {
  setUserLevel(userId: $userId, level: $level) {
    ... on Badge {
      id
      __typename
    }
    ... on SetUserLevelError {
      message
      __typename
    }
  }
}
    `;
export type SetUserLevelMutationFn = Apollo.MutationFunction<SetUserLevelMutation, SetUserLevelMutationVariables>;

/**
 * __useSetUserLevelMutation__
 *
 * To run a mutation, you first call `useSetUserLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserLevelMutation, { data, loading, error }] = useSetUserLevelMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useSetUserLevelMutation(baseOptions?: Apollo.MutationHookOptions<SetUserLevelMutation, SetUserLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserLevelMutation, SetUserLevelMutationVariables>(SetUserLevelDocument, options);
      }
export type SetUserLevelMutationHookResult = ReturnType<typeof useSetUserLevelMutation>;
export type SetUserLevelMutationResult = Apollo.MutationResult<SetUserLevelMutation>;
export type SetUserLevelMutationOptions = Apollo.BaseMutationOptions<SetUserLevelMutation, SetUserLevelMutationVariables>;
export const SetUserRoleDocument = gql`
    mutation SetUserRole($role: Int!, $userId: ID!) {
  setUserRole(userId: $userId, role: $role)
}
    `;
export type SetUserRoleMutationFn = Apollo.MutationFunction<SetUserRoleMutation, SetUserRoleMutationVariables>;

/**
 * __useSetUserRoleMutation__
 *
 * To run a mutation, you first call `useSetUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserRoleMutation, { data, loading, error }] = useSetUserRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetUserRoleMutation, SetUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserRoleMutation, SetUserRoleMutationVariables>(SetUserRoleDocument, options);
      }
export type SetUserRoleMutationHookResult = ReturnType<typeof useSetUserRoleMutation>;
export type SetUserRoleMutationResult = Apollo.MutationResult<SetUserRoleMutation>;
export type SetUserRoleMutationOptions = Apollo.BaseMutationOptions<SetUserRoleMutation, SetUserRoleMutationVariables>;
export const SignInWithEthereumDocument = gql`
    mutation SignInWithEthereum($message: String!, $signature: String!, $walletType: String!) {
  signInWithEthereum(
    message: $message
    signature: $signature
    walletType: $walletType
  ) {
    accessToken
    refreshToken
    user {
      id
      username
      totalPublishedGames
      isRegistered
      hasAcceptedTos
      avatarV2 {
        id
        glbUrl
      }
    }
  }
}
    `;
export type SignInWithEthereumMutationFn = Apollo.MutationFunction<SignInWithEthereumMutation, SignInWithEthereumMutationVariables>;

/**
 * __useSignInWithEthereumMutation__
 *
 * To run a mutation, you first call `useSignInWithEthereumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithEthereumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithEthereumMutation, { data, loading, error }] = useSignInWithEthereumMutation({
 *   variables: {
 *      message: // value for 'message'
 *      signature: // value for 'signature'
 *      walletType: // value for 'walletType'
 *   },
 * });
 */
export function useSignInWithEthereumMutation(baseOptions?: Apollo.MutationHookOptions<SignInWithEthereumMutation, SignInWithEthereumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInWithEthereumMutation, SignInWithEthereumMutationVariables>(SignInWithEthereumDocument, options);
      }
export type SignInWithEthereumMutationHookResult = ReturnType<typeof useSignInWithEthereumMutation>;
export type SignInWithEthereumMutationResult = Apollo.MutationResult<SignInWithEthereumMutation>;
export type SignInWithEthereumMutationOptions = Apollo.BaseMutationOptions<SignInWithEthereumMutation, SignInWithEthereumMutationVariables>;
export const SignInWithGoogleCodeDocument = gql`
    mutation SignInWithGoogleCode($code: String!) {
  signInWithGoogleCode(code: $code) {
    accessToken
    refreshToken
    user {
      ...CurrentUser
      hasAcceptedTos
      totalPublishedGames
      avatarV2 {
        id
        glbUrl
      }
    }
  }
}
    ${CurrentUserFragmentDoc}`;
export type SignInWithGoogleCodeMutationFn = Apollo.MutationFunction<SignInWithGoogleCodeMutation, SignInWithGoogleCodeMutationVariables>;

/**
 * __useSignInWithGoogleCodeMutation__
 *
 * To run a mutation, you first call `useSignInWithGoogleCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithGoogleCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithGoogleCodeMutation, { data, loading, error }] = useSignInWithGoogleCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSignInWithGoogleCodeMutation(baseOptions?: Apollo.MutationHookOptions<SignInWithGoogleCodeMutation, SignInWithGoogleCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInWithGoogleCodeMutation, SignInWithGoogleCodeMutationVariables>(SignInWithGoogleCodeDocument, options);
      }
export type SignInWithGoogleCodeMutationHookResult = ReturnType<typeof useSignInWithGoogleCodeMutation>;
export type SignInWithGoogleCodeMutationResult = Apollo.MutationResult<SignInWithGoogleCodeMutation>;
export type SignInWithGoogleCodeMutationOptions = Apollo.BaseMutationOptions<SignInWithGoogleCodeMutation, SignInWithGoogleCodeMutationVariables>;
export const SignUpWithEmailDocument = gql`
    mutation SignUpWithEmail($payload: CreateUserDto!) {
  createUser(payload: $payload) {
    accessToken
    refreshToken
    user {
      id
      pictureUrl
      role
      username
      level
      xp
    }
  }
}
    `;
export type SignUpWithEmailMutationFn = Apollo.MutationFunction<SignUpWithEmailMutation, SignUpWithEmailMutationVariables>;

/**
 * __useSignUpWithEmailMutation__
 *
 * To run a mutation, you first call `useSignUpWithEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpWithEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpWithEmailMutation, { data, loading, error }] = useSignUpWithEmailMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSignUpWithEmailMutation(baseOptions?: Apollo.MutationHookOptions<SignUpWithEmailMutation, SignUpWithEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpWithEmailMutation, SignUpWithEmailMutationVariables>(SignUpWithEmailDocument, options);
      }
export type SignUpWithEmailMutationHookResult = ReturnType<typeof useSignUpWithEmailMutation>;
export type SignUpWithEmailMutationResult = Apollo.MutationResult<SignUpWithEmailMutation>;
export type SignUpWithEmailMutationOptions = Apollo.BaseMutationOptions<SignUpWithEmailMutation, SignUpWithEmailMutationVariables>;
export const SigninDocument = gql`
    mutation Signin($username: String!, $password: String!) {
  loginUser(login: {username: $username, password: $password}) {
    accessToken
    refreshToken
    user {
      id
      birthdate
      username
      totalPublishedGames
      xp
      isRegistered
      level
      session {
        id
      }
    }
  }
}
    `;
export type SigninMutationFn = Apollo.MutationFunction<SigninMutation, SigninMutationVariables>;

/**
 * __useSigninMutation__
 *
 * To run a mutation, you first call `useSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinMutation, { data, loading, error }] = useSigninMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSigninMutation(baseOptions?: Apollo.MutationHookOptions<SigninMutation, SigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninMutation, SigninMutationVariables>(SigninDocument, options);
      }
export type SigninMutationHookResult = ReturnType<typeof useSigninMutation>;
export type SigninMutationResult = Apollo.MutationResult<SigninMutation>;
export type SigninMutationOptions = Apollo.BaseMutationOptions<SigninMutation, SigninMutationVariables>;
export const SuspendUserDocument = gql`
    mutation suspendUser($username: String!, $customMessage: String, $reason: Int!, $endedAt: Date!) {
  suspendUser(
    payload: {username: $username, customMessage: $customMessage, reason: $reason, endedAt: $endedAt}
  ) {
    id
  }
}
    `;
export type SuspendUserMutationFn = Apollo.MutationFunction<SuspendUserMutation, SuspendUserMutationVariables>;

/**
 * __useSuspendUserMutation__
 *
 * To run a mutation, you first call `useSuspendUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendUserMutation, { data, loading, error }] = useSuspendUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      customMessage: // value for 'customMessage'
 *      reason: // value for 'reason'
 *      endedAt: // value for 'endedAt'
 *   },
 * });
 */
export function useSuspendUserMutation(baseOptions?: Apollo.MutationHookOptions<SuspendUserMutation, SuspendUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendUserMutation, SuspendUserMutationVariables>(SuspendUserDocument, options);
      }
export type SuspendUserMutationHookResult = ReturnType<typeof useSuspendUserMutation>;
export type SuspendUserMutationResult = Apollo.MutationResult<SuspendUserMutation>;
export type SuspendUserMutationOptions = Apollo.BaseMutationOptions<SuspendUserMutation, SuspendUserMutationVariables>;
export const TagContentDocument = gql`
    mutation TagContent($contentId: ID!, $contentType: ContentType!, $name: String!, $type: TagType!) {
  tagContent(
    payload: {contentId: $contentId, contentType: $contentType, name: $name, type: $type}
  )
}
    `;
export type TagContentMutationFn = Apollo.MutationFunction<TagContentMutation, TagContentMutationVariables>;

/**
 * __useTagContentMutation__
 *
 * To run a mutation, you first call `useTagContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagContentMutation, { data, loading, error }] = useTagContentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      contentType: // value for 'contentType'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTagContentMutation(baseOptions?: Apollo.MutationHookOptions<TagContentMutation, TagContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagContentMutation, TagContentMutationVariables>(TagContentDocument, options);
      }
export type TagContentMutationHookResult = ReturnType<typeof useTagContentMutation>;
export type TagContentMutationResult = Apollo.MutationResult<TagContentMutation>;
export type TagContentMutationOptions = Apollo.BaseMutationOptions<TagContentMutation, TagContentMutationVariables>;
export const TagManyContentManyDocument = gql`
    mutation TagManyContentMany($payload: CreateManyTagsForManyContentDTO!) {
  tagManyContentMany(payload: $payload) {
    contentId
    tagId
  }
}
    `;
export type TagManyContentManyMutationFn = Apollo.MutationFunction<TagManyContentManyMutation, TagManyContentManyMutationVariables>;

/**
 * __useTagManyContentManyMutation__
 *
 * To run a mutation, you first call `useTagManyContentManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagManyContentManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagManyContentManyMutation, { data, loading, error }] = useTagManyContentManyMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTagManyContentManyMutation(baseOptions?: Apollo.MutationHookOptions<TagManyContentManyMutation, TagManyContentManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagManyContentManyMutation, TagManyContentManyMutationVariables>(TagManyContentManyDocument, options);
      }
export type TagManyContentManyMutationHookResult = ReturnType<typeof useTagManyContentManyMutation>;
export type TagManyContentManyMutationResult = Apollo.MutationResult<TagManyContentManyMutation>;
export type TagManyContentManyMutationOptions = Apollo.BaseMutationOptions<TagManyContentManyMutation, TagManyContentManyMutationVariables>;
export const TagSelfDocument = gql`
    mutation TagSelf($name: String!, $type: TagType!) {
  tagSelf(payload: {name: $name, type: $type})
}
    `;
export type TagSelfMutationFn = Apollo.MutationFunction<TagSelfMutation, TagSelfMutationVariables>;

/**
 * __useTagSelfMutation__
 *
 * To run a mutation, you first call `useTagSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagSelfMutation, { data, loading, error }] = useTagSelfMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTagSelfMutation(baseOptions?: Apollo.MutationHookOptions<TagSelfMutation, TagSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagSelfMutation, TagSelfMutationVariables>(TagSelfDocument, options);
      }
export type TagSelfMutationHookResult = ReturnType<typeof useTagSelfMutation>;
export type TagSelfMutationResult = Apollo.MutationResult<TagSelfMutation>;
export type TagSelfMutationOptions = Apollo.BaseMutationOptions<TagSelfMutation, TagSelfMutationVariables>;
export const ToggleLikeDocument = gql`
    mutation ToggleLike($contentId: ID!, $type: ContentType!) {
  toggleLike(id: $contentId, type: $type) {
    ... on Project {
      id
      isLiked
      likes
    }
    ... on Comment {
      id
      isLiked
      likes
    }
  }
}
    `;
export type ToggleLikeMutationFn = Apollo.MutationFunction<ToggleLikeMutation, ToggleLikeMutationVariables>;

/**
 * __useToggleLikeMutation__
 *
 * To run a mutation, you first call `useToggleLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLikeMutation, { data, loading, error }] = useToggleLikeMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useToggleLikeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLikeMutation, ToggleLikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLikeMutation, ToggleLikeMutationVariables>(ToggleLikeDocument, options);
      }
export type ToggleLikeMutationHookResult = ReturnType<typeof useToggleLikeMutation>;
export type ToggleLikeMutationResult = Apollo.MutationResult<ToggleLikeMutation>;
export type ToggleLikeMutationOptions = Apollo.BaseMutationOptions<ToggleLikeMutation, ToggleLikeMutationVariables>;
export const UnblockUserDocument = gql`
    mutation unblockUser($userId: ID!) {
  unblockUser(payload: {userId: $userId})
}
    `;
export type UnblockUserMutationFn = Apollo.MutationFunction<UnblockUserMutation, UnblockUserMutationVariables>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockUserMutation(baseOptions?: Apollo.MutationHookOptions<UnblockUserMutation, UnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(UnblockUserDocument, options);
      }
export type UnblockUserMutationHookResult = ReturnType<typeof useUnblockUserMutation>;
export type UnblockUserMutationResult = Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<UnblockUserMutation, UnblockUserMutationVariables>;
export const UnfollowUserDocument = gql`
    mutation UnfollowUser($targetId: Float!) {
  unfollow(targetId: $targetId) {
    id
    isFollowing
  }
}
    `;
export type UnfollowUserMutationFn = Apollo.MutationFunction<UnfollowUserMutation, UnfollowUserMutationVariables>;

/**
 * __useUnfollowUserMutation__
 *
 * To run a mutation, you first call `useUnfollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserMutation, { data, loading, error }] = useUnfollowUserMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useUnfollowUserMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowUserMutation, UnfollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowUserMutation, UnfollowUserMutationVariables>(UnfollowUserDocument, options);
      }
export type UnfollowUserMutationHookResult = ReturnType<typeof useUnfollowUserMutation>;
export type UnfollowUserMutationResult = Apollo.MutationResult<UnfollowUserMutation>;
export type UnfollowUserMutationOptions = Apollo.BaseMutationOptions<UnfollowUserMutation, UnfollowUserMutationVariables>;
export const UnlockAndEquipAssetToUserDocument = gql`
    mutation UnlockAndEquipAssetToUser($input: AssetUnlockAndEquipInput!) {
  unlockAndEquipAssetToUser(input: $input) {
    equipResult {
      message
      status
      type
    }
    unlockedAssetResponse {
      message
      status
      type
    }
  }
}
    `;
export type UnlockAndEquipAssetToUserMutationFn = Apollo.MutationFunction<UnlockAndEquipAssetToUserMutation, UnlockAndEquipAssetToUserMutationVariables>;

/**
 * __useUnlockAndEquipAssetToUserMutation__
 *
 * To run a mutation, you first call `useUnlockAndEquipAssetToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockAndEquipAssetToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockAndEquipAssetToUserMutation, { data, loading, error }] = useUnlockAndEquipAssetToUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlockAndEquipAssetToUserMutation(baseOptions?: Apollo.MutationHookOptions<UnlockAndEquipAssetToUserMutation, UnlockAndEquipAssetToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockAndEquipAssetToUserMutation, UnlockAndEquipAssetToUserMutationVariables>(UnlockAndEquipAssetToUserDocument, options);
      }
export type UnlockAndEquipAssetToUserMutationHookResult = ReturnType<typeof useUnlockAndEquipAssetToUserMutation>;
export type UnlockAndEquipAssetToUserMutationResult = Apollo.MutationResult<UnlockAndEquipAssetToUserMutation>;
export type UnlockAndEquipAssetToUserMutationOptions = Apollo.BaseMutationOptions<UnlockAndEquipAssetToUserMutation, UnlockAndEquipAssetToUserMutationVariables>;
export const UnlockAssetsForUsersDocument = gql`
    mutation UnlockAssetsForUsers($input: AssetUnlockForUsersInput!) {
  unlockAssetsForUsers(input: $input) {
    message
    status
    type
  }
}
    `;
export type UnlockAssetsForUsersMutationFn = Apollo.MutationFunction<UnlockAssetsForUsersMutation, UnlockAssetsForUsersMutationVariables>;

/**
 * __useUnlockAssetsForUsersMutation__
 *
 * To run a mutation, you first call `useUnlockAssetsForUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockAssetsForUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockAssetsForUsersMutation, { data, loading, error }] = useUnlockAssetsForUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlockAssetsForUsersMutation(baseOptions?: Apollo.MutationHookOptions<UnlockAssetsForUsersMutation, UnlockAssetsForUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockAssetsForUsersMutation, UnlockAssetsForUsersMutationVariables>(UnlockAssetsForUsersDocument, options);
      }
export type UnlockAssetsForUsersMutationHookResult = ReturnType<typeof useUnlockAssetsForUsersMutation>;
export type UnlockAssetsForUsersMutationResult = Apollo.MutationResult<UnlockAssetsForUsersMutation>;
export type UnlockAssetsForUsersMutationOptions = Apollo.BaseMutationOptions<UnlockAssetsForUsersMutation, UnlockAssetsForUsersMutationVariables>;
export const UnlockBadgeForUserDocument = gql`
    mutation UnlockBadgeForUser($username: String!, $badge: String!) {
  unlockBadgeForUser(username: $username, badge: $badge) {
    id
  }
}
    `;
export type UnlockBadgeForUserMutationFn = Apollo.MutationFunction<UnlockBadgeForUserMutation, UnlockBadgeForUserMutationVariables>;

/**
 * __useUnlockBadgeForUserMutation__
 *
 * To run a mutation, you first call `useUnlockBadgeForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockBadgeForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockBadgeForUserMutation, { data, loading, error }] = useUnlockBadgeForUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      badge: // value for 'badge'
 *   },
 * });
 */
export function useUnlockBadgeForUserMutation(baseOptions?: Apollo.MutationHookOptions<UnlockBadgeForUserMutation, UnlockBadgeForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockBadgeForUserMutation, UnlockBadgeForUserMutationVariables>(UnlockBadgeForUserDocument, options);
      }
export type UnlockBadgeForUserMutationHookResult = ReturnType<typeof useUnlockBadgeForUserMutation>;
export type UnlockBadgeForUserMutationResult = Apollo.MutationResult<UnlockBadgeForUserMutation>;
export type UnlockBadgeForUserMutationOptions = Apollo.BaseMutationOptions<UnlockBadgeForUserMutation, UnlockBadgeForUserMutationVariables>;
export const UnlockRpmAssetAchievementDocument = gql`
    mutation UnlockRpmAssetAchievement($id: ID!) {
  unlockRpmAssetAchievement(id: $id) {
    id
    unlockedAssets {
      id
      provider
      unlockedAt
    }
    claimableRpmAchievement {
      id
    }
  }
}
    `;
export type UnlockRpmAssetAchievementMutationFn = Apollo.MutationFunction<UnlockRpmAssetAchievementMutation, UnlockRpmAssetAchievementMutationVariables>;

/**
 * __useUnlockRpmAssetAchievementMutation__
 *
 * To run a mutation, you first call `useUnlockRpmAssetAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockRpmAssetAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockRpmAssetAchievementMutation, { data, loading, error }] = useUnlockRpmAssetAchievementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlockRpmAssetAchievementMutation(baseOptions?: Apollo.MutationHookOptions<UnlockRpmAssetAchievementMutation, UnlockRpmAssetAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockRpmAssetAchievementMutation, UnlockRpmAssetAchievementMutationVariables>(UnlockRpmAssetAchievementDocument, options);
      }
export type UnlockRpmAssetAchievementMutationHookResult = ReturnType<typeof useUnlockRpmAssetAchievementMutation>;
export type UnlockRpmAssetAchievementMutationResult = Apollo.MutationResult<UnlockRpmAssetAchievementMutation>;
export type UnlockRpmAssetAchievementMutationOptions = Apollo.BaseMutationOptions<UnlockRpmAssetAchievementMutation, UnlockRpmAssetAchievementMutationVariables>;
export const UnmuteChatDocument = gql`
    mutation unmuteChat($payload: MutedChatDTO!) {
  unmuteChat(payload: $payload)
}
    `;
export type UnmuteChatMutationFn = Apollo.MutationFunction<UnmuteChatMutation, UnmuteChatMutationVariables>;

/**
 * __useUnmuteChatMutation__
 *
 * To run a mutation, you first call `useUnmuteChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmuteChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmuteChatMutation, { data, loading, error }] = useUnmuteChatMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUnmuteChatMutation(baseOptions?: Apollo.MutationHookOptions<UnmuteChatMutation, UnmuteChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmuteChatMutation, UnmuteChatMutationVariables>(UnmuteChatDocument, options);
      }
export type UnmuteChatMutationHookResult = ReturnType<typeof useUnmuteChatMutation>;
export type UnmuteChatMutationResult = Apollo.MutationResult<UnmuteChatMutation>;
export type UnmuteChatMutationOptions = Apollo.BaseMutationOptions<UnmuteChatMutation, UnmuteChatMutationVariables>;
export const UpdateAppearanceDocument = gql`
    mutation UpdateAppearance($input: UpdateAppearanceDTO!) {
  updateAppearance(input: $input) {
    id
    displayName
    name
    quality
    isPromotional
    sourceDescription
  }
}
    `;
export type UpdateAppearanceMutationFn = Apollo.MutationFunction<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>;

/**
 * __useUpdateAppearanceMutation__
 *
 * To run a mutation, you first call `useUpdateAppearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppearanceMutation, { data, loading, error }] = useUpdateAppearanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppearanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>(UpdateAppearanceDocument, options);
      }
export type UpdateAppearanceMutationHookResult = ReturnType<typeof useUpdateAppearanceMutation>;
export type UpdateAppearanceMutationResult = Apollo.MutationResult<UpdateAppearanceMutation>;
export type UpdateAppearanceMutationOptions = Apollo.BaseMutationOptions<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation updateComment($commentId: ID!, $text: String!) {
  editComment(payload: {commentId: $commentId, text: $text}) {
    id
    text
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const UpdateContentfulCacheDocument = gql`
    mutation UpdateContentfulCache {
  updateContentfulCache
}
    `;
export type UpdateContentfulCacheMutationFn = Apollo.MutationFunction<UpdateContentfulCacheMutation, UpdateContentfulCacheMutationVariables>;

/**
 * __useUpdateContentfulCacheMutation__
 *
 * To run a mutation, you first call `useUpdateContentfulCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentfulCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentfulCacheMutation, { data, loading, error }] = useUpdateContentfulCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateContentfulCacheMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentfulCacheMutation, UpdateContentfulCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentfulCacheMutation, UpdateContentfulCacheMutationVariables>(UpdateContentfulCacheDocument, options);
      }
export type UpdateContentfulCacheMutationHookResult = ReturnType<typeof useUpdateContentfulCacheMutation>;
export type UpdateContentfulCacheMutationResult = Apollo.MutationResult<UpdateContentfulCacheMutation>;
export type UpdateContentfulCacheMutationOptions = Apollo.BaseMutationOptions<UpdateContentfulCacheMutation, UpdateContentfulCacheMutationVariables>;
export const UpdateFeedbackDocument = gql`
    mutation UpdateFeedback($correlation_id: String!, $rating: Int!) {
  updateFeedback(correlation_id: $correlation_id, rating: $rating)
}
    `;
export type UpdateFeedbackMutationFn = Apollo.MutationFunction<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;

/**
 * __useUpdateFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackMutation, { data, loading, error }] = useUpdateFeedbackMutation({
 *   variables: {
 *      correlation_id: // value for 'correlation_id'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useUpdateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>(UpdateFeedbackDocument, options);
      }
export type UpdateFeedbackMutationHookResult = ReturnType<typeof useUpdateFeedbackMutation>;
export type UpdateFeedbackMutationResult = Apollo.MutationResult<UpdateFeedbackMutation>;
export type UpdateFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;
export const UpdateLootSeenStatusDocument = gql`
    mutation updateLootSeenStatus($seen: Boolean!, $ids: [ID!]) {
  updateLootSeenStatus(seen: $seen, ids: $ids)
}
    `;
export type UpdateLootSeenStatusMutationFn = Apollo.MutationFunction<UpdateLootSeenStatusMutation, UpdateLootSeenStatusMutationVariables>;

/**
 * __useUpdateLootSeenStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLootSeenStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLootSeenStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLootSeenStatusMutation, { data, loading, error }] = useUpdateLootSeenStatusMutation({
 *   variables: {
 *      seen: // value for 'seen'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpdateLootSeenStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLootSeenStatusMutation, UpdateLootSeenStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLootSeenStatusMutation, UpdateLootSeenStatusMutationVariables>(UpdateLootSeenStatusDocument, options);
      }
export type UpdateLootSeenStatusMutationHookResult = ReturnType<typeof useUpdateLootSeenStatusMutation>;
export type UpdateLootSeenStatusMutationResult = Apollo.MutationResult<UpdateLootSeenStatusMutation>;
export type UpdateLootSeenStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLootSeenStatusMutation, UpdateLootSeenStatusMutationVariables>;
export const UpdateMessageMetadataDocument = gql`
    mutation UpdateMessageMetadata($result: String!, $id: ID!) {
  updateChatMessageMetadata(
    payload: {id: $id, humanReviewed: true, result: $result, resultDesc: ""}
  ) {
    id
  }
}
    `;
export type UpdateMessageMetadataMutationFn = Apollo.MutationFunction<UpdateMessageMetadataMutation, UpdateMessageMetadataMutationVariables>;

/**
 * __useUpdateMessageMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMetadataMutation, { data, loading, error }] = useUpdateMessageMetadataMutation({
 *   variables: {
 *      result: // value for 'result'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMessageMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageMetadataMutation, UpdateMessageMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageMetadataMutation, UpdateMessageMetadataMutationVariables>(UpdateMessageMetadataDocument, options);
      }
export type UpdateMessageMetadataMutationHookResult = ReturnType<typeof useUpdateMessageMetadataMutation>;
export type UpdateMessageMetadataMutationResult = Apollo.MutationResult<UpdateMessageMetadataMutation>;
export type UpdateMessageMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMetadataMutation, UpdateMessageMetadataMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $title: String!, $description: String!, $categories: [String!], $tags: [String!]!, $metaTags: [String!]!, $thumbnail: String, $visibility: Int!, $featured: Boolean, $locked: Boolean, $reFeature: Boolean, $disableComments: Boolean, $youtubeId: String) {
  updateProject(
    payload: {id: $id, title: $title, description: $description, categories: $categories, tags: $tags, metaTags: $metaTags, thumbnailId: $thumbnail, visibility: $visibility, featured: $featured, locked: $locked, reFeature: $reFeature, disableComments: $disableComments, youtubeId: $youtubeId}
  ) {
    id
    title
    description
    isPublished
    categories
    tags
    tags_v2 {
      id
      name
    }
    visibility
    featured
    disableComments
    youtubeId
    __typename
    author {
      id
      pictureUrl
      username
      role
    }
    thumbnail {
      id
      small {
        id
        url
      }
      medium {
        id
        url
      }
      large {
        id
        url
      }
    }
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      categories: // value for 'categories'
 *      tags: // value for 'tags'
 *      metaTags: // value for 'metaTags'
 *      thumbnail: // value for 'thumbnail'
 *      visibility: // value for 'visibility'
 *      featured: // value for 'featured'
 *      locked: // value for 'locked'
 *      reFeature: // value for 'reFeature'
 *      disableComments: // value for 'disableComments'
 *      youtubeId: // value for 'youtubeId'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateReportDocument = gql`
    mutation UpdateReport($id: ID!, $status: ReportStatus!) {
  updateReportStatus(payload: {id: $id, status: $status}) {
    id
    status
    resolved
  }
}
    `;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const UpdateEmailDocument = gql`
    mutation UpdateEmail($email: String!, $verifyAge: Boolean) {
  updateUserEmail(input: {email: $email, verifyAge: $verifyAge}) {
    id
    email
  }
}
    `;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      verifyAge: // value for 'verifyAge'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($oldPassword: String, $password: String!) {
  updateUserPassword(input: {currentPassword: $oldPassword, password: $password})
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateFriendsPublicityDocument = gql`
    mutation UpdateFriendsPublicity($friendsArePublic: Int!) {
  updateFriendsPublicity(payload: {publicity: $friendsArePublic}) {
    id
    friendsArePublic
  }
}
    `;
export type UpdateFriendsPublicityMutationFn = Apollo.MutationFunction<UpdateFriendsPublicityMutation, UpdateFriendsPublicityMutationVariables>;

/**
 * __useUpdateFriendsPublicityMutation__
 *
 * To run a mutation, you first call `useUpdateFriendsPublicityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFriendsPublicityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFriendsPublicityMutation, { data, loading, error }] = useUpdateFriendsPublicityMutation({
 *   variables: {
 *      friendsArePublic: // value for 'friendsArePublic'
 *   },
 * });
 */
export function useUpdateFriendsPublicityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFriendsPublicityMutation, UpdateFriendsPublicityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFriendsPublicityMutation, UpdateFriendsPublicityMutationVariables>(UpdateFriendsPublicityDocument, options);
      }
export type UpdateFriendsPublicityMutationHookResult = ReturnType<typeof useUpdateFriendsPublicityMutation>;
export type UpdateFriendsPublicityMutationResult = Apollo.MutationResult<UpdateFriendsPublicityMutation>;
export type UpdateFriendsPublicityMutationOptions = Apollo.BaseMutationOptions<UpdateFriendsPublicityMutation, UpdateFriendsPublicityMutationVariables>;
export const UpdateOnlyFriendsInMultiplayerDocument = gql`
    mutation UpdateOnlyFriendsInMultiplayer($onlyFriendsInMultiplayer: Boolean!) {
  updateOnlyFriendsInMultiplayer(
    onlyFriendsInMultiplayer: $onlyFriendsInMultiplayer
  ) {
    id
    onlyFriendsInMultiplayer
  }
}
    `;
export type UpdateOnlyFriendsInMultiplayerMutationFn = Apollo.MutationFunction<UpdateOnlyFriendsInMultiplayerMutation, UpdateOnlyFriendsInMultiplayerMutationVariables>;

/**
 * __useUpdateOnlyFriendsInMultiplayerMutation__
 *
 * To run a mutation, you first call `useUpdateOnlyFriendsInMultiplayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnlyFriendsInMultiplayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnlyFriendsInMultiplayerMutation, { data, loading, error }] = useUpdateOnlyFriendsInMultiplayerMutation({
 *   variables: {
 *      onlyFriendsInMultiplayer: // value for 'onlyFriendsInMultiplayer'
 *   },
 * });
 */
export function useUpdateOnlyFriendsInMultiplayerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOnlyFriendsInMultiplayerMutation, UpdateOnlyFriendsInMultiplayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOnlyFriendsInMultiplayerMutation, UpdateOnlyFriendsInMultiplayerMutationVariables>(UpdateOnlyFriendsInMultiplayerDocument, options);
      }
export type UpdateOnlyFriendsInMultiplayerMutationHookResult = ReturnType<typeof useUpdateOnlyFriendsInMultiplayerMutation>;
export type UpdateOnlyFriendsInMultiplayerMutationResult = Apollo.MutationResult<UpdateOnlyFriendsInMultiplayerMutation>;
export type UpdateOnlyFriendsInMultiplayerMutationOptions = Apollo.BaseMutationOptions<UpdateOnlyFriendsInMultiplayerMutation, UpdateOnlyFriendsInMultiplayerMutationVariables>;
export const UpdateBirthdateDocument = gql`
    mutation UpdateBirthdate($birthdate: Date!) {
  updateBirthdate(birthdate: $birthdate) {
    id
    __typename
    birthdate
  }
}
    `;
export type UpdateBirthdateMutationFn = Apollo.MutationFunction<UpdateBirthdateMutation, UpdateBirthdateMutationVariables>;

/**
 * __useUpdateBirthdateMutation__
 *
 * To run a mutation, you first call `useUpdateBirthdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBirthdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBirthdateMutation, { data, loading, error }] = useUpdateBirthdateMutation({
 *   variables: {
 *      birthdate: // value for 'birthdate'
 *   },
 * });
 */
export function useUpdateBirthdateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBirthdateMutation, UpdateBirthdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBirthdateMutation, UpdateBirthdateMutationVariables>(UpdateBirthdateDocument, options);
      }
export type UpdateBirthdateMutationHookResult = ReturnType<typeof useUpdateBirthdateMutation>;
export type UpdateBirthdateMutationResult = Apollo.MutationResult<UpdateBirthdateMutation>;
export type UpdateBirthdateMutationOptions = Apollo.BaseMutationOptions<UpdateBirthdateMutation, UpdateBirthdateMutationVariables>;
export const UpdateDescriptionDocument = gql`
    mutation UpdateDescription($description: String!) {
  updateDescription(description: $description) {
    id
    description
  }
}
    `;
export type UpdateDescriptionMutationFn = Apollo.MutationFunction<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>;

/**
 * __useUpdateDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDescriptionMutation, { data, loading, error }] = useUpdateDescriptionMutation({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>(UpdateDescriptionDocument, options);
      }
export type UpdateDescriptionMutationHookResult = ReturnType<typeof useUpdateDescriptionMutation>;
export type UpdateDescriptionMutationResult = Apollo.MutationResult<UpdateDescriptionMutation>;
export type UpdateDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>;
export const UpdateSocialMediaDocument = gql`
    mutation UpdateSocialMedia($twitch: String, $twitter: String, $youtube: String, $instagram: String, $tiktok: String) {
  updateSocialMedia(
    input: {twitch: $twitch, twitter: $twitter, youtube: $youtube, instagram: $instagram, tiktok: $tiktok}
  ) {
    twitter
    instagram
    youtube
    twitch
    tiktok
  }
}
    `;
export type UpdateSocialMediaMutationFn = Apollo.MutationFunction<UpdateSocialMediaMutation, UpdateSocialMediaMutationVariables>;

/**
 * __useUpdateSocialMediaMutation__
 *
 * To run a mutation, you first call `useUpdateSocialMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialMediaMutation, { data, loading, error }] = useUpdateSocialMediaMutation({
 *   variables: {
 *      twitch: // value for 'twitch'
 *      twitter: // value for 'twitter'
 *      youtube: // value for 'youtube'
 *      instagram: // value for 'instagram'
 *      tiktok: // value for 'tiktok'
 *   },
 * });
 */
export function useUpdateSocialMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialMediaMutation, UpdateSocialMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialMediaMutation, UpdateSocialMediaMutationVariables>(UpdateSocialMediaDocument, options);
      }
export type UpdateSocialMediaMutationHookResult = ReturnType<typeof useUpdateSocialMediaMutation>;
export type UpdateSocialMediaMutationResult = Apollo.MutationResult<UpdateSocialMediaMutation>;
export type UpdateSocialMediaMutationOptions = Apollo.BaseMutationOptions<UpdateSocialMediaMutation, UpdateSocialMediaMutationVariables>;
export const UpdateAchievementPublicityDocument = gql`
    mutation UpdateAchievementPublicity($publicity: Int!) {
  updateAchievementPublicity(payload: {publicity: $publicity}) {
    id
    achievementPublicity
  }
}
    `;
export type UpdateAchievementPublicityMutationFn = Apollo.MutationFunction<UpdateAchievementPublicityMutation, UpdateAchievementPublicityMutationVariables>;

/**
 * __useUpdateAchievementPublicityMutation__
 *
 * To run a mutation, you first call `useUpdateAchievementPublicityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAchievementPublicityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAchievementPublicityMutation, { data, loading, error }] = useUpdateAchievementPublicityMutation({
 *   variables: {
 *      publicity: // value for 'publicity'
 *   },
 * });
 */
export function useUpdateAchievementPublicityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAchievementPublicityMutation, UpdateAchievementPublicityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAchievementPublicityMutation, UpdateAchievementPublicityMutationVariables>(UpdateAchievementPublicityDocument, options);
      }
export type UpdateAchievementPublicityMutationHookResult = ReturnType<typeof useUpdateAchievementPublicityMutation>;
export type UpdateAchievementPublicityMutationResult = Apollo.MutationResult<UpdateAchievementPublicityMutation>;
export type UpdateAchievementPublicityMutationOptions = Apollo.BaseMutationOptions<UpdateAchievementPublicityMutation, UpdateAchievementPublicityMutationVariables>;
export const UpdateFavoriteGamesPublicityDocument = gql`
    mutation UpdateFavoriteGamesPublicity($publicity: Int!) {
  updateFavoriteGamesPublicity(payload: {publicity: $publicity}) {
    id
    favoriteGamesArePublic
  }
}
    `;
export type UpdateFavoriteGamesPublicityMutationFn = Apollo.MutationFunction<UpdateFavoriteGamesPublicityMutation, UpdateFavoriteGamesPublicityMutationVariables>;

/**
 * __useUpdateFavoriteGamesPublicityMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteGamesPublicityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteGamesPublicityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteGamesPublicityMutation, { data, loading, error }] = useUpdateFavoriteGamesPublicityMutation({
 *   variables: {
 *      publicity: // value for 'publicity'
 *   },
 * });
 */
export function useUpdateFavoriteGamesPublicityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoriteGamesPublicityMutation, UpdateFavoriteGamesPublicityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoriteGamesPublicityMutation, UpdateFavoriteGamesPublicityMutationVariables>(UpdateFavoriteGamesPublicityDocument, options);
      }
export type UpdateFavoriteGamesPublicityMutationHookResult = ReturnType<typeof useUpdateFavoriteGamesPublicityMutation>;
export type UpdateFavoriteGamesPublicityMutationResult = Apollo.MutationResult<UpdateFavoriteGamesPublicityMutation>;
export type UpdateFavoriteGamesPublicityMutationOptions = Apollo.BaseMutationOptions<UpdateFavoriteGamesPublicityMutation, UpdateFavoriteGamesPublicityMutationVariables>;
export const UpdateDirectMessagingPublicityDocument = gql`
    mutation UpdateDirectMessagingPublicity($publicity: Int!) {
  updateDirectMessagingPublicity(payload: {publicity: $publicity}) {
    id
    directMessagingPublicity
  }
}
    `;
export type UpdateDirectMessagingPublicityMutationFn = Apollo.MutationFunction<UpdateDirectMessagingPublicityMutation, UpdateDirectMessagingPublicityMutationVariables>;

/**
 * __useUpdateDirectMessagingPublicityMutation__
 *
 * To run a mutation, you first call `useUpdateDirectMessagingPublicityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDirectMessagingPublicityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDirectMessagingPublicityMutation, { data, loading, error }] = useUpdateDirectMessagingPublicityMutation({
 *   variables: {
 *      publicity: // value for 'publicity'
 *   },
 * });
 */
export function useUpdateDirectMessagingPublicityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDirectMessagingPublicityMutation, UpdateDirectMessagingPublicityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDirectMessagingPublicityMutation, UpdateDirectMessagingPublicityMutationVariables>(UpdateDirectMessagingPublicityDocument, options);
      }
export type UpdateDirectMessagingPublicityMutationHookResult = ReturnType<typeof useUpdateDirectMessagingPublicityMutation>;
export type UpdateDirectMessagingPublicityMutationResult = Apollo.MutationResult<UpdateDirectMessagingPublicityMutation>;
export type UpdateDirectMessagingPublicityMutationOptions = Apollo.BaseMutationOptions<UpdateDirectMessagingPublicityMutation, UpdateDirectMessagingPublicityMutationVariables>;
export const UpdateProfileBackgroundDocument = gql`
    mutation UpdateProfileBackground($format: String!) {
  updateProfileBackground(format: $format)
}
    `;
export type UpdateProfileBackgroundMutationFn = Apollo.MutationFunction<UpdateProfileBackgroundMutation, UpdateProfileBackgroundMutationVariables>;

/**
 * __useUpdateProfileBackgroundMutation__
 *
 * To run a mutation, you first call `useUpdateProfileBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileBackgroundMutation, { data, loading, error }] = useUpdateProfileBackgroundMutation({
 *   variables: {
 *      format: // value for 'format'
 *   },
 * });
 */
export function useUpdateProfileBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileBackgroundMutation, UpdateProfileBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileBackgroundMutation, UpdateProfileBackgroundMutationVariables>(UpdateProfileBackgroundDocument, options);
      }
export type UpdateProfileBackgroundMutationHookResult = ReturnType<typeof useUpdateProfileBackgroundMutation>;
export type UpdateProfileBackgroundMutationResult = Apollo.MutationResult<UpdateProfileBackgroundMutation>;
export type UpdateProfileBackgroundMutationOptions = Apollo.BaseMutationOptions<UpdateProfileBackgroundMutation, UpdateProfileBackgroundMutationVariables>;
export const UpdateUserTitleDocument = gql`
    mutation UpdateUserTitle($userTitle: String!) {
  updateUserTitle(title: $userTitle) {
    id
    title
  }
}
    `;
export type UpdateUserTitleMutationFn = Apollo.MutationFunction<UpdateUserTitleMutation, UpdateUserTitleMutationVariables>;

/**
 * __useUpdateUserTitleMutation__
 *
 * To run a mutation, you first call `useUpdateUserTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTitleMutation, { data, loading, error }] = useUpdateUserTitleMutation({
 *   variables: {
 *      userTitle: // value for 'userTitle'
 *   },
 * });
 */
export function useUpdateUserTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTitleMutation, UpdateUserTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTitleMutation, UpdateUserTitleMutationVariables>(UpdateUserTitleDocument, options);
      }
export type UpdateUserTitleMutationHookResult = ReturnType<typeof useUpdateUserTitleMutation>;
export type UpdateUserTitleMutationResult = Apollo.MutationResult<UpdateUserTitleMutation>;
export type UpdateUserTitleMutationOptions = Apollo.BaseMutationOptions<UpdateUserTitleMutation, UpdateUserTitleMutationVariables>;
export const UpdateUsernameDocument = gql`
    mutation UpdateUsername($input: UpdateUsernameInput!) {
  updateUsername(input: $input) {
    username
  }
}
    `;
export type UpdateUsernameMutationFn = Apollo.MutationFunction<UpdateUsernameMutation, UpdateUsernameMutationVariables>;

/**
 * __useUpdateUsernameMutation__
 *
 * To run a mutation, you first call `useUpdateUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsernameMutation, { data, loading, error }] = useUpdateUsernameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUsernameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUsernameMutation, UpdateUsernameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUsernameMutation, UpdateUsernameMutationVariables>(UpdateUsernameDocument, options);
      }
export type UpdateUsernameMutationHookResult = ReturnType<typeof useUpdateUsernameMutation>;
export type UpdateUsernameMutationResult = Apollo.MutationResult<UpdateUsernameMutation>;
export type UpdateUsernameMutationOptions = Apollo.BaseMutationOptions<UpdateUsernameMutation, UpdateUsernameMutationVariables>;
export const UpdateVisitedStatusDocument = gql`
    mutation updateVisitedStatus($id: ID, $sourceId: ID, $type: Int, $status: Boolean!, $date: Date) {
  updateNotificationVisitedStatus(
    payload: {id: $id, sourceId: $sourceId, type: $type, status: $status, date: $date}
  ) {
    __typename
    id
  }
}
    `;
export type UpdateVisitedStatusMutationFn = Apollo.MutationFunction<UpdateVisitedStatusMutation, UpdateVisitedStatusMutationVariables>;

/**
 * __useUpdateVisitedStatusMutation__
 *
 * To run a mutation, you first call `useUpdateVisitedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitedStatusMutation, { data, loading, error }] = useUpdateVisitedStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sourceId: // value for 'sourceId'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpdateVisitedStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitedStatusMutation, UpdateVisitedStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitedStatusMutation, UpdateVisitedStatusMutationVariables>(UpdateVisitedStatusDocument, options);
      }
export type UpdateVisitedStatusMutationHookResult = ReturnType<typeof useUpdateVisitedStatusMutation>;
export type UpdateVisitedStatusMutationResult = Apollo.MutationResult<UpdateVisitedStatusMutation>;
export type UpdateVisitedStatusMutationOptions = Apollo.BaseMutationOptions<UpdateVisitedStatusMutation, UpdateVisitedStatusMutationVariables>;
export const ValidateDeleteAccountTokenDocument = gql`
    query ValidateDeleteAccountToken($token: String!) {
  checkDeleteAccountToken(token: $token)
}
    `;

/**
 * __useValidateDeleteAccountTokenQuery__
 *
 * To run a query within a React component, call `useValidateDeleteAccountTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateDeleteAccountTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateDeleteAccountTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateDeleteAccountTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidateDeleteAccountTokenQuery, ValidateDeleteAccountTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateDeleteAccountTokenQuery, ValidateDeleteAccountTokenQueryVariables>(ValidateDeleteAccountTokenDocument, options);
      }
export function useValidateDeleteAccountTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateDeleteAccountTokenQuery, ValidateDeleteAccountTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateDeleteAccountTokenQuery, ValidateDeleteAccountTokenQueryVariables>(ValidateDeleteAccountTokenDocument, options);
        }
export type ValidateDeleteAccountTokenQueryHookResult = ReturnType<typeof useValidateDeleteAccountTokenQuery>;
export type ValidateDeleteAccountTokenLazyQueryHookResult = ReturnType<typeof useValidateDeleteAccountTokenLazyQuery>;
export type ValidateDeleteAccountTokenQueryResult = Apollo.QueryResult<ValidateDeleteAccountTokenQuery, ValidateDeleteAccountTokenQueryVariables>;
export const ValidateDirectMessageDocument = gql`
    mutation ValidateDirectMessage($message: String!, $chatId: String!) {
  moderateDirectMessage(message: $message, chatId: $chatId) {
    result
  }
}
    `;
export type ValidateDirectMessageMutationFn = Apollo.MutationFunction<ValidateDirectMessageMutation, ValidateDirectMessageMutationVariables>;

/**
 * __useValidateDirectMessageMutation__
 *
 * To run a mutation, you first call `useValidateDirectMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDirectMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDirectMessageMutation, { data, loading, error }] = useValidateDirectMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useValidateDirectMessageMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDirectMessageMutation, ValidateDirectMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDirectMessageMutation, ValidateDirectMessageMutationVariables>(ValidateDirectMessageDocument, options);
      }
export type ValidateDirectMessageMutationHookResult = ReturnType<typeof useValidateDirectMessageMutation>;
export type ValidateDirectMessageMutationResult = Apollo.MutationResult<ValidateDirectMessageMutation>;
export type ValidateDirectMessageMutationOptions = Apollo.BaseMutationOptions<ValidateDirectMessageMutation, ValidateDirectMessageMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($token: String!) {
  verifyEmail(token: $token)
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const CreateProjectWithCreativeSessionDocument = gql`
    mutation createProjectWithCreativeSession($channel: String!, $clientVersion: String, $clientNetworkProtocolVersion: String, $forkId: Float) {
  createProjectWithCreativeSession(
    channel: $channel
    clientVersion: $clientVersion
    clientNetworkProtocolVersion: $clientNetworkProtocolVersion
    forkId: $forkId
  ) {
    id
    sessionUrl
    sessionId
    newlyCreated
    sessionStatus
    playerCount
    maxPlayerCount
    publicity
    currentProject {
      id
    }
  }
}
    `;
export type CreateProjectWithCreativeSessionMutationFn = Apollo.MutationFunction<CreateProjectWithCreativeSessionMutation, CreateProjectWithCreativeSessionMutationVariables>;

/**
 * __useCreateProjectWithCreativeSessionMutation__
 *
 * To run a mutation, you first call `useCreateProjectWithCreativeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectWithCreativeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectWithCreativeSessionMutation, { data, loading, error }] = useCreateProjectWithCreativeSessionMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      clientVersion: // value for 'clientVersion'
 *      clientNetworkProtocolVersion: // value for 'clientNetworkProtocolVersion'
 *      forkId: // value for 'forkId'
 *   },
 * });
 */
export function useCreateProjectWithCreativeSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectWithCreativeSessionMutation, CreateProjectWithCreativeSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectWithCreativeSessionMutation, CreateProjectWithCreativeSessionMutationVariables>(CreateProjectWithCreativeSessionDocument, options);
      }
export type CreateProjectWithCreativeSessionMutationHookResult = ReturnType<typeof useCreateProjectWithCreativeSessionMutation>;
export type CreateProjectWithCreativeSessionMutationResult = Apollo.MutationResult<CreateProjectWithCreativeSessionMutation>;
export type CreateProjectWithCreativeSessionMutationOptions = Apollo.BaseMutationOptions<CreateProjectWithCreativeSessionMutation, CreateProjectWithCreativeSessionMutationVariables>;
export const SendFriendRequestDocument = gql`
    mutation sendFriendRequest($userId: Float!) {
  sendFriendRequest(targetId: $userId) {
    id
    haveISentFriendRequest
    haveIReceivedFriendRequest
  }
}
    `;
export type SendFriendRequestMutationFn = Apollo.MutationFunction<SendFriendRequestMutation, SendFriendRequestMutationVariables>;

/**
 * __useSendFriendRequestMutation__
 *
 * To run a mutation, you first call `useSendFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFriendRequestMutation, { data, loading, error }] = useSendFriendRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendFriendRequestMutation, SendFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFriendRequestMutation, SendFriendRequestMutationVariables>(SendFriendRequestDocument, options);
      }
export type SendFriendRequestMutationHookResult = ReturnType<typeof useSendFriendRequestMutation>;
export type SendFriendRequestMutationResult = Apollo.MutationResult<SendFriendRequestMutation>;
export type SendFriendRequestMutationOptions = Apollo.BaseMutationOptions<SendFriendRequestMutation, SendFriendRequestMutationVariables>;
export const AllAppearancesDocument = gql`
    query allAppearances {
  allAppearances {
    id
    name
    displayName
    thumbnailUrl
    sourceDescription
    quality
    isPromotional
  }
}
    `;

/**
 * __useAllAppearancesQuery__
 *
 * To run a query within a React component, call `useAllAppearancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAppearancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAppearancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAppearancesQuery(baseOptions?: Apollo.QueryHookOptions<AllAppearancesQuery, AllAppearancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAppearancesQuery, AllAppearancesQueryVariables>(AllAppearancesDocument, options);
      }
export function useAllAppearancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAppearancesQuery, AllAppearancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAppearancesQuery, AllAppearancesQueryVariables>(AllAppearancesDocument, options);
        }
export type AllAppearancesQueryHookResult = ReturnType<typeof useAllAppearancesQuery>;
export type AllAppearancesLazyQueryHookResult = ReturnType<typeof useAllAppearancesLazyQuery>;
export type AllAppearancesQueryResult = Apollo.QueryResult<AllAppearancesQuery, AllAppearancesQueryVariables>;
export const AllWarningsForUserDocument = gql`
    query allWarningsForUser($userId: ID!) {
  allWarningsForUser(userId: $userId) {
    id
    customMessage
  }
}
    `;

/**
 * __useAllWarningsForUserQuery__
 *
 * To run a query within a React component, call `useAllWarningsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWarningsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWarningsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAllWarningsForUserQuery(baseOptions: Apollo.QueryHookOptions<AllWarningsForUserQuery, AllWarningsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWarningsForUserQuery, AllWarningsForUserQueryVariables>(AllWarningsForUserDocument, options);
      }
export function useAllWarningsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWarningsForUserQuery, AllWarningsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWarningsForUserQuery, AllWarningsForUserQueryVariables>(AllWarningsForUserDocument, options);
        }
export type AllWarningsForUserQueryHookResult = ReturnType<typeof useAllWarningsForUserQuery>;
export type AllWarningsForUserLazyQueryHookResult = ReturnType<typeof useAllWarningsForUserLazyQuery>;
export type AllWarningsForUserQueryResult = Apollo.QueryResult<AllWarningsForUserQuery, AllWarningsForUserQueryVariables>;
export const AuthUserDocument = gql`
    query AuthUser {
  me {
    id
    role
    hasFinishedRegistration
    isEmployee
    username
  }
}
    `;

/**
 * __useAuthUserQuery__
 *
 * To run a query within a React component, call `useAuthUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthUserQuery(baseOptions?: Apollo.QueryHookOptions<AuthUserQuery, AuthUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthUserQuery, AuthUserQueryVariables>(AuthUserDocument, options);
      }
export function useAuthUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthUserQuery, AuthUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthUserQuery, AuthUserQueryVariables>(AuthUserDocument, options);
        }
export type AuthUserQueryHookResult = ReturnType<typeof useAuthUserQuery>;
export type AuthUserLazyQueryHookResult = ReturnType<typeof useAuthUserLazyQuery>;
export type AuthUserQueryResult = Apollo.QueryResult<AuthUserQuery, AuthUserQueryVariables>;
export const BadgesDocument = gql`
    query Badges {
  badges {
    id
    name
    displayName
    level
    icon
    type
    groupId
  }
}
    `;

/**
 * __useBadgesQuery__
 *
 * To run a query within a React component, call `useBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBadgesQuery(baseOptions?: Apollo.QueryHookOptions<BadgesQuery, BadgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BadgesQuery, BadgesQueryVariables>(BadgesDocument, options);
      }
export function useBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BadgesQuery, BadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BadgesQuery, BadgesQueryVariables>(BadgesDocument, options);
        }
export type BadgesQueryHookResult = ReturnType<typeof useBadgesQuery>;
export type BadgesLazyQueryHookResult = ReturnType<typeof useBadgesLazyQuery>;
export type BadgesQueryResult = Apollo.QueryResult<BadgesQuery, BadgesQueryVariables>;
export const BadgesByUsernameDocument = gql`
    query BadgesByUsername($username: String!, $userId: Int!) {
  userByUsername(username: $username) {
    id
    role
    username
    badges {
      user {
        id
        username
        isFriends
      }
      createdAt
      unlocked
      seen
      badge {
        displayName
        id
        level
        groupId
        icon
        groupTotal
        description
        locked_icon
        criteriaData(userId: $userId) {
          total
          currentValue
          name
          badgeId
        }
        nextBadge {
          description
          criteriaData(userId: $userId) {
            total
            currentValue
            name
            badgeId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBadgesByUsernameQuery__
 *
 * To run a query within a React component, call `useBadgesByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useBadgesByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBadgesByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBadgesByUsernameQuery(baseOptions: Apollo.QueryHookOptions<BadgesByUsernameQuery, BadgesByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BadgesByUsernameQuery, BadgesByUsernameQueryVariables>(BadgesByUsernameDocument, options);
      }
export function useBadgesByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BadgesByUsernameQuery, BadgesByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BadgesByUsernameQuery, BadgesByUsernameQueryVariables>(BadgesByUsernameDocument, options);
        }
export type BadgesByUsernameQueryHookResult = ReturnType<typeof useBadgesByUsernameQuery>;
export type BadgesByUsernameLazyQueryHookResult = ReturnType<typeof useBadgesByUsernameLazyQuery>;
export type BadgesByUsernameQueryResult = Apollo.QueryResult<BadgesByUsernameQuery, BadgesByUsernameQueryVariables>;
export const BlockedUsersDocument = gql`
    query blockedUsers {
  me {
    __typename
    id
    blockedUsers {
      user2 {
        id
        role
        username
        pictureUrl
        level
        haveIBlocked
      }
    }
  }
}
    `;

/**
 * __useBlockedUsersQuery__
 *
 * To run a query within a React component, call `useBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockedUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBlockedUsersQuery(baseOptions?: Apollo.QueryHookOptions<BlockedUsersQuery, BlockedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockedUsersQuery, BlockedUsersQueryVariables>(BlockedUsersDocument, options);
      }
export function useBlockedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockedUsersQuery, BlockedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockedUsersQuery, BlockedUsersQueryVariables>(BlockedUsersDocument, options);
        }
export type BlockedUsersQueryHookResult = ReturnType<typeof useBlockedUsersQuery>;
export type BlockedUsersLazyQueryHookResult = ReturnType<typeof useBlockedUsersLazyQuery>;
export type BlockedUsersQueryResult = Apollo.QueryResult<BlockedUsersQuery, BlockedUsersQueryVariables>;
export const BuildInfoDocument = gql`
    query buildInfo {
  buildInfo {
    latestCommit
    revision
    version
  }
}
    `;

/**
 * __useBuildInfoQuery__
 *
 * To run a query within a React component, call `useBuildInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuildInfoQuery(baseOptions?: Apollo.QueryHookOptions<BuildInfoQuery, BuildInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildInfoQuery, BuildInfoQueryVariables>(BuildInfoDocument, options);
      }
export function useBuildInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildInfoQuery, BuildInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildInfoQuery, BuildInfoQueryVariables>(BuildInfoDocument, options);
        }
export type BuildInfoQueryHookResult = ReturnType<typeof useBuildInfoQuery>;
export type BuildInfoLazyQueryHookResult = ReturnType<typeof useBuildInfoLazyQuery>;
export type BuildInfoQueryResult = Apollo.QueryResult<BuildInfoQuery, BuildInfoQueryVariables>;
export const CheckVerifyEmailTokenDocument = gql`
    query CheckVerifyEmailToken($token: String!) {
  checkVerifyEmailToken(token: $token)
}
    `;

/**
 * __useCheckVerifyEmailTokenQuery__
 *
 * To run a query within a React component, call `useCheckVerifyEmailTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckVerifyEmailTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckVerifyEmailTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCheckVerifyEmailTokenQuery(baseOptions: Apollo.QueryHookOptions<CheckVerifyEmailTokenQuery, CheckVerifyEmailTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckVerifyEmailTokenQuery, CheckVerifyEmailTokenQueryVariables>(CheckVerifyEmailTokenDocument, options);
      }
export function useCheckVerifyEmailTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckVerifyEmailTokenQuery, CheckVerifyEmailTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckVerifyEmailTokenQuery, CheckVerifyEmailTokenQueryVariables>(CheckVerifyEmailTokenDocument, options);
        }
export type CheckVerifyEmailTokenQueryHookResult = ReturnType<typeof useCheckVerifyEmailTokenQuery>;
export type CheckVerifyEmailTokenLazyQueryHookResult = ReturnType<typeof useCheckVerifyEmailTokenLazyQuery>;
export type CheckVerifyEmailTokenQueryResult = Apollo.QueryResult<CheckVerifyEmailTokenQuery, CheckVerifyEmailTokenQueryVariables>;
export const CheckoutSessionStatusDocument = gql`
    query CheckoutSessionStatus($sessionId: String!) {
  checkoutSessionStatus(sessionId: $sessionId) {
    isCompleted
    paymentIntentId
  }
}
    `;

/**
 * __useCheckoutSessionStatusQuery__
 *
 * To run a query within a React component, call `useCheckoutSessionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSessionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutSessionStatusQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCheckoutSessionStatusQuery(baseOptions: Apollo.QueryHookOptions<CheckoutSessionStatusQuery, CheckoutSessionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutSessionStatusQuery, CheckoutSessionStatusQueryVariables>(CheckoutSessionStatusDocument, options);
      }
export function useCheckoutSessionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutSessionStatusQuery, CheckoutSessionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutSessionStatusQuery, CheckoutSessionStatusQueryVariables>(CheckoutSessionStatusDocument, options);
        }
export type CheckoutSessionStatusQueryHookResult = ReturnType<typeof useCheckoutSessionStatusQuery>;
export type CheckoutSessionStatusLazyQueryHookResult = ReturnType<typeof useCheckoutSessionStatusLazyQuery>;
export type CheckoutSessionStatusQueryResult = Apollo.QueryResult<CheckoutSessionStatusQuery, CheckoutSessionStatusQueryVariables>;
export const CommentsDocument = gql`
    query Comments($contentId: ID!, $cursor: ID, $first: Float) {
  repliesV2(payload: {first: $first, after: $cursor}, commentId: $contentId) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        contentId
        contentType
        text
        id
        likes
        createdAt
        updatedAt
        deletedAt
        isPinned
        isReported
        likes
        isLiked
        author {
          id
          role
          username
          pictureUrl
          level
          isEmployee
          isVerified
          suspension {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const CommentsWithRepliesDocument = gql`
    query CommentsWithReplies($contentId: ID!, $cursor: ID, $includeContentIds: [ID!], $first: Float) {
  repliesV2(payload: {first: $first, after: $cursor}, commentId: $contentId) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        contentId
        contentType
        text
        id
        likes
        createdAt
        updatedAt
        deletedAt
        isPinned
        isReported
        likes
        isLiked
        author {
          id
          role
          username
          pictureUrl
          level
          isEmployee
          isVerified
          suspension {
            id
          }
        }
        comments(payload: {first: 2, includeContentIds: $includeContentIds}) {
          pageInfo {
            hasNextPage
            startCursor
            endCursor
          }
          totalCount
          edges {
            node {
              contentId
              contentType
              likes
              isLiked
              isReported
              text
              id
              likes
              createdAt
              updatedAt
              deletedAt
              isPinned
              author {
                ...AuthorFragment
              }
            }
          }
        }
      }
    }
  }
}
    ${AuthorFragmentFragmentDoc}`;

/**
 * __useCommentsWithRepliesQuery__
 *
 * To run a query within a React component, call `useCommentsWithRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsWithRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsWithRepliesQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      cursor: // value for 'cursor'
 *      includeContentIds: // value for 'includeContentIds'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCommentsWithRepliesQuery(baseOptions: Apollo.QueryHookOptions<CommentsWithRepliesQuery, CommentsWithRepliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsWithRepliesQuery, CommentsWithRepliesQueryVariables>(CommentsWithRepliesDocument, options);
      }
export function useCommentsWithRepliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsWithRepliesQuery, CommentsWithRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsWithRepliesQuery, CommentsWithRepliesQueryVariables>(CommentsWithRepliesDocument, options);
        }
export type CommentsWithRepliesQueryHookResult = ReturnType<typeof useCommentsWithRepliesQuery>;
export type CommentsWithRepliesLazyQueryHookResult = ReturnType<typeof useCommentsWithRepliesLazyQuery>;
export type CommentsWithRepliesQueryResult = Apollo.QueryResult<CommentsWithRepliesQuery, CommentsWithRepliesQueryVariables>;
export const CommonFriendsDocument = gql`
    query commonFriends($username: String!) {
  me {
    id
    getCommonFriends(username: $username) {
      user {
        id
        role
        username
        pictureUrl
        level
        isFriends
        isVerified
        isEmployee
      }
      friendSince
    }
  }
}
    `;

/**
 * __useCommonFriendsQuery__
 *
 * To run a query within a React component, call `useCommonFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonFriendsQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useCommonFriendsQuery(baseOptions: Apollo.QueryHookOptions<CommonFriendsQuery, CommonFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommonFriendsQuery, CommonFriendsQueryVariables>(CommonFriendsDocument, options);
      }
export function useCommonFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommonFriendsQuery, CommonFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommonFriendsQuery, CommonFriendsQueryVariables>(CommonFriendsDocument, options);
        }
export type CommonFriendsQueryHookResult = ReturnType<typeof useCommonFriendsQuery>;
export type CommonFriendsLazyQueryHookResult = ReturnType<typeof useCommonFriendsLazyQuery>;
export type CommonFriendsQueryResult = Apollo.QueryResult<CommonFriendsQuery, CommonFriendsQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  me {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserAvatarDocument = gql`
    query CurrentUserAvatar {
  me {
    id
    avatarV2 {
      id
      glbUrl
      rpmUserId
      rpmAvatarId
      rpmGlbUrl
      rpmHasLinkedAccount
      rpmJsonData {
        outfitGender
      }
      thumbnail
      name
      provider
      thumbnail
    }
  }
}
    `;

/**
 * __useCurrentUserAvatarQuery__
 *
 * To run a query within a React component, call `useCurrentUserAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAvatarQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAvatarQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAvatarQuery, CurrentUserAvatarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAvatarQuery, CurrentUserAvatarQueryVariables>(CurrentUserAvatarDocument, options);
      }
export function useCurrentUserAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAvatarQuery, CurrentUserAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAvatarQuery, CurrentUserAvatarQueryVariables>(CurrentUserAvatarDocument, options);
        }
export type CurrentUserAvatarQueryHookResult = ReturnType<typeof useCurrentUserAvatarQuery>;
export type CurrentUserAvatarLazyQueryHookResult = ReturnType<typeof useCurrentUserAvatarLazyQuery>;
export type CurrentUserAvatarQueryResult = Apollo.QueryResult<CurrentUserAvatarQuery, CurrentUserAvatarQueryVariables>;
export const DailyChallengesDocument = gql`
    query DailyChallenges($userId: Int) {
  dailyChallenges {
    expires
    badge {
      createdAt
      unlocked
      badge {
        displayName
        description
        name
        icon
        locked_icon
        id
        difficulty
        criteriaData(userId: $userId) {
          total
          currentValue
        }
      }
    }
    reward {
      id
      value
    }
  }
}
    `;

/**
 * __useDailyChallengesQuery__
 *
 * To run a query within a React component, call `useDailyChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyChallengesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDailyChallengesQuery(baseOptions?: Apollo.QueryHookOptions<DailyChallengesQuery, DailyChallengesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyChallengesQuery, DailyChallengesQueryVariables>(DailyChallengesDocument, options);
      }
export function useDailyChallengesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyChallengesQuery, DailyChallengesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyChallengesQuery, DailyChallengesQueryVariables>(DailyChallengesDocument, options);
        }
export type DailyChallengesQueryHookResult = ReturnType<typeof useDailyChallengesQuery>;
export type DailyChallengesLazyQueryHookResult = ReturnType<typeof useDailyChallengesLazyQuery>;
export type DailyChallengesQueryResult = Apollo.QueryResult<DailyChallengesQuery, DailyChallengesQueryVariables>;
export const DaoLandingDocument = gql`
    query DaoLanding {
  contentfulYoutubeLinks {
    daoLandingPage
    daoLandingPageTitle
    daoLandingPageDescription
  }
}
    `;

/**
 * __useDaoLandingQuery__
 *
 * To run a query within a React component, call `useDaoLandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDaoLandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDaoLandingQuery({
 *   variables: {
 *   },
 * });
 */
export function useDaoLandingQuery(baseOptions?: Apollo.QueryHookOptions<DaoLandingQuery, DaoLandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DaoLandingQuery, DaoLandingQueryVariables>(DaoLandingDocument, options);
      }
export function useDaoLandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DaoLandingQuery, DaoLandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DaoLandingQuery, DaoLandingQueryVariables>(DaoLandingDocument, options);
        }
export type DaoLandingQueryHookResult = ReturnType<typeof useDaoLandingQuery>;
export type DaoLandingLazyQueryHookResult = ReturnType<typeof useDaoLandingLazyQuery>;
export type DaoLandingQueryResult = Apollo.QueryResult<DaoLandingQuery, DaoLandingQueryVariables>;
export const FindFeatureToggleDocument = gql`
    query FindFeatureToggle($name: String!) {
  findFeatureToggle(name: $name) {
    name
    isEnabled
    isEnabledForUser
    enabledAt
    disabledAt
    description
    createdBy
    isConfig
    criteria {
      minLevel
      minRole
      tags {
        name
        type
      }
    }
    values {
      name
      isEnabled
      enabledAt
      disabledAt
      values {
        name
        isEnabled
        enabledAt
        disabledAt
      }
    }
  }
}
    `;

/**
 * __useFindFeatureToggleQuery__
 *
 * To run a query within a React component, call `useFindFeatureToggleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFeatureToggleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFeatureToggleQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFindFeatureToggleQuery(baseOptions: Apollo.QueryHookOptions<FindFeatureToggleQuery, FindFeatureToggleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFeatureToggleQuery, FindFeatureToggleQueryVariables>(FindFeatureToggleDocument, options);
      }
export function useFindFeatureToggleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFeatureToggleQuery, FindFeatureToggleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFeatureToggleQuery, FindFeatureToggleQueryVariables>(FindFeatureToggleDocument, options);
        }
export type FindFeatureToggleQueryHookResult = ReturnType<typeof useFindFeatureToggleQuery>;
export type FindFeatureToggleLazyQueryHookResult = ReturnType<typeof useFindFeatureToggleLazyQuery>;
export type FindFeatureToggleQueryResult = Apollo.QueryResult<FindFeatureToggleQuery, FindFeatureToggleQueryVariables>;
export const FeaturedFriendsDocument = gql`
    query featuredFriends($userId: Float!, $first: Float!, $cursor: ID) {
  featuredFriends(userId: $userId, payload: {first: $first, after: $cursor}) {
    pageInfo {
      hasNextPage
      endCursor
    }
    items {
      id
      createdAt
      targetId
      target {
        id
        pictureUrl
        username
        profileBackgroundUrl
        isVerified
        isEmployee
        totalFollowers
        isFollowing
      }
    }
  }
}
    `;

/**
 * __useFeaturedFriendsQuery__
 *
 * To run a query within a React component, call `useFeaturedFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedFriendsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useFeaturedFriendsQuery(baseOptions: Apollo.QueryHookOptions<FeaturedFriendsQuery, FeaturedFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedFriendsQuery, FeaturedFriendsQueryVariables>(FeaturedFriendsDocument, options);
      }
export function useFeaturedFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedFriendsQuery, FeaturedFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedFriendsQuery, FeaturedFriendsQueryVariables>(FeaturedFriendsDocument, options);
        }
export type FeaturedFriendsQueryHookResult = ReturnType<typeof useFeaturedFriendsQuery>;
export type FeaturedFriendsLazyQueryHookResult = ReturnType<typeof useFeaturedFriendsLazyQuery>;
export type FeaturedFriendsQueryResult = Apollo.QueryResult<FeaturedFriendsQuery, FeaturedFriendsQueryVariables>;
export const FeaturedProfilesDocument = gql`
    query FeaturedProfiles {
  findAllFeaturedProfiles {
    userId
    addedAt
    user {
      id
      username
      pictureUrl
    }
  }
}
    `;

/**
 * __useFeaturedProfilesQuery__
 *
 * To run a query within a React component, call `useFeaturedProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturedProfilesQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedProfilesQuery, FeaturedProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedProfilesQuery, FeaturedProfilesQueryVariables>(FeaturedProfilesDocument, options);
      }
export function useFeaturedProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedProfilesQuery, FeaturedProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedProfilesQuery, FeaturedProfilesQueryVariables>(FeaturedProfilesDocument, options);
        }
export type FeaturedProfilesQueryHookResult = ReturnType<typeof useFeaturedProfilesQuery>;
export type FeaturedProfilesLazyQueryHookResult = ReturnType<typeof useFeaturedProfilesLazyQuery>;
export type FeaturedProfilesQueryResult = Apollo.QueryResult<FeaturedProfilesQuery, FeaturedProfilesQueryVariables>;
export const FetchUsersDocument = gql`
    query fetchUsers($cursor: ID, $filter: String, $meta: [String!], $role: UserRole, $first: Float) {
  users(
    payload: {first: $first, after: $cursor, filter: $filter, role: $role, meta: $meta}
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        role
        level
        username
        email
        pictureUrl
        isVerified
        isDeveloper
        isBetatester
        isEmployee
        haveISentFriendRequest
        haveIReceivedFriendRequest
        isFriends
        createdAt
      }
    }
  }
}
    `;

/**
 * __useFetchUsersQuery__
 *
 * To run a query within a React component, call `useFetchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *      meta: // value for 'meta'
 *      role: // value for 'role'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFetchUsersQuery(baseOptions?: Apollo.QueryHookOptions<FetchUsersQuery, FetchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, options);
      }
export function useFetchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersQuery, FetchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, options);
        }
export type FetchUsersQueryHookResult = ReturnType<typeof useFetchUsersQuery>;
export type FetchUsersLazyQueryHookResult = ReturnType<typeof useFetchUsersLazyQuery>;
export type FetchUsersQueryResult = Apollo.QueryResult<FetchUsersQuery, FetchUsersQueryVariables>;
export const FindAllProjectRewardsDocument = gql`
    query FindAllProjectRewards {
  findAllProjectRewards {
    projectId
    values
    project {
      id
      title
      thumbnail {
        id
        medium {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllProjectRewardsQuery__
 *
 * To run a query within a React component, call `useFindAllProjectRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllProjectRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllProjectRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllProjectRewardsQuery(baseOptions?: Apollo.QueryHookOptions<FindAllProjectRewardsQuery, FindAllProjectRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllProjectRewardsQuery, FindAllProjectRewardsQueryVariables>(FindAllProjectRewardsDocument, options);
      }
export function useFindAllProjectRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllProjectRewardsQuery, FindAllProjectRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllProjectRewardsQuery, FindAllProjectRewardsQueryVariables>(FindAllProjectRewardsDocument, options);
        }
export type FindAllProjectRewardsQueryHookResult = ReturnType<typeof useFindAllProjectRewardsQuery>;
export type FindAllProjectRewardsLazyQueryHookResult = ReturnType<typeof useFindAllProjectRewardsLazyQuery>;
export type FindAllProjectRewardsQueryResult = Apollo.QueryResult<FindAllProjectRewardsQuery, FindAllProjectRewardsQueryVariables>;
export const FindUsernameUpdatedAtDocument = gql`
    query FindUsernameUpdatedAt($username: String!) {
  findUsernameUpdatedAt(username: $username) {
    isAllowChange
    message
    username
    updatedAt
    userId
  }
}
    `;

/**
 * __useFindUsernameUpdatedAtQuery__
 *
 * To run a query within a React component, call `useFindUsernameUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsernameUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsernameUpdatedAtQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useFindUsernameUpdatedAtQuery(baseOptions: Apollo.QueryHookOptions<FindUsernameUpdatedAtQuery, FindUsernameUpdatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUsernameUpdatedAtQuery, FindUsernameUpdatedAtQueryVariables>(FindUsernameUpdatedAtDocument, options);
      }
export function useFindUsernameUpdatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUsernameUpdatedAtQuery, FindUsernameUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUsernameUpdatedAtQuery, FindUsernameUpdatedAtQueryVariables>(FindUsernameUpdatedAtDocument, options);
        }
export type FindUsernameUpdatedAtQueryHookResult = ReturnType<typeof useFindUsernameUpdatedAtQuery>;
export type FindUsernameUpdatedAtLazyQueryHookResult = ReturnType<typeof useFindUsernameUpdatedAtLazyQuery>;
export type FindUsernameUpdatedAtQueryResult = Apollo.QueryResult<FindUsernameUpdatedAtQuery, FindUsernameUpdatedAtQueryVariables>;
export const FollowingGamesDocument = gql`
    query FollowingGames($first: Float!, $cursor: ID, $maxEngineVersion: Int) {
  me {
    id
    role
    __typename
    projects(
      payload: {first: $first, after: $cursor, sortBy: NEW, filterFollowing: true, maxEngineVersion: $maxEngineVersion}
    ) {
      __typename
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          __typename
          id
          title
          likes
          totalViews
          tags
          tags_v2 {
            ...TagFragment
          }
          gameKit
          engineVersion
          thumbnail {
            id
            small {
              id
              url
            }
          }
          author {
            ...AuthorFragment
          }
        }
      }
    }
  }
}
    ${TagFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}`;

/**
 * __useFollowingGamesQuery__
 *
 * To run a query within a React component, call `useFollowingGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowingGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowingGamesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      maxEngineVersion: // value for 'maxEngineVersion'
 *   },
 * });
 */
export function useFollowingGamesQuery(baseOptions: Apollo.QueryHookOptions<FollowingGamesQuery, FollowingGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowingGamesQuery, FollowingGamesQueryVariables>(FollowingGamesDocument, options);
      }
export function useFollowingGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowingGamesQuery, FollowingGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowingGamesQuery, FollowingGamesQueryVariables>(FollowingGamesDocument, options);
        }
export type FollowingGamesQueryHookResult = ReturnType<typeof useFollowingGamesQuery>;
export type FollowingGamesLazyQueryHookResult = ReturnType<typeof useFollowingGamesLazyQuery>;
export type FollowingGamesQueryResult = Apollo.QueryResult<FollowingGamesQuery, FollowingGamesQueryVariables>;
export const FriendRequestAmountDocument = gql`
    query FriendRequestAmount {
  friendRequestAmount
}
    `;

/**
 * __useFriendRequestAmountQuery__
 *
 * To run a query within a React component, call `useFriendRequestAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendRequestAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendRequestAmountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFriendRequestAmountQuery(baseOptions?: Apollo.QueryHookOptions<FriendRequestAmountQuery, FriendRequestAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendRequestAmountQuery, FriendRequestAmountQueryVariables>(FriendRequestAmountDocument, options);
      }
export function useFriendRequestAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendRequestAmountQuery, FriendRequestAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendRequestAmountQuery, FriendRequestAmountQueryVariables>(FriendRequestAmountDocument, options);
        }
export type FriendRequestAmountQueryHookResult = ReturnType<typeof useFriendRequestAmountQuery>;
export type FriendRequestAmountLazyQueryHookResult = ReturnType<typeof useFriendRequestAmountLazyQuery>;
export type FriendRequestAmountQueryResult = Apollo.QueryResult<FriendRequestAmountQuery, FriendRequestAmountQueryVariables>;
export const FriendRequestsDocument = gql`
    query FriendRequests {
  me {
    id
    getFriendInvites {
      id
      role
      username
      pictureUrl
      haveIReceivedFriendRequest
      level
      isEmployee
      isVerified
    }
  }
}
    `;

/**
 * __useFriendRequestsQuery__
 *
 * To run a query within a React component, call `useFriendRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFriendRequestsQuery(baseOptions?: Apollo.QueryHookOptions<FriendRequestsQuery, FriendRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendRequestsQuery, FriendRequestsQueryVariables>(FriendRequestsDocument, options);
      }
export function useFriendRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendRequestsQuery, FriendRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendRequestsQuery, FriendRequestsQueryVariables>(FriendRequestsDocument, options);
        }
export type FriendRequestsQueryHookResult = ReturnType<typeof useFriendRequestsQuery>;
export type FriendRequestsLazyQueryHookResult = ReturnType<typeof useFriendRequestsLazyQuery>;
export type FriendRequestsQueryResult = Apollo.QueryResult<FriendRequestsQuery, FriendRequestsQueryVariables>;
export const FrontPageContentDocument = gql`
    query FrontPageContent {
  frontPageContent {
    hero {
      buttonLabel
      header
      heroBackground {
        url
      }
      projectIdOrButtonLink
      showForLoggedIn
      showForLoggedOut
      subHeader
      preHeader
    }
    feeds {
      title
      buttonLink
      buttonText
      tags
      specificProjectIds
      description
      includeSoMe
      meta
      orderIndex
      quantity
      onlyFollowing
      showForLoggedIn
      showForLoggedOut
      sortBy
    }
    article {
      title
      article
      modalText
      modalButtonText
      modalTitle
      openModal
      ctaButtonLink
      ctaButtonText
      startDate
      endDate
      iosCtaButtonLink
      showForLoggedIn
      showForLoggedOut
      thumbnail {
        url
      }
    }
  }
}
    `;

/**
 * __useFrontPageContentQuery__
 *
 * To run a query within a React component, call `useFrontPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontPageContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrontPageContentQuery(baseOptions?: Apollo.QueryHookOptions<FrontPageContentQuery, FrontPageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FrontPageContentQuery, FrontPageContentQueryVariables>(FrontPageContentDocument, options);
      }
export function useFrontPageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrontPageContentQuery, FrontPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FrontPageContentQuery, FrontPageContentQueryVariables>(FrontPageContentDocument, options);
        }
export type FrontPageContentQueryHookResult = ReturnType<typeof useFrontPageContentQuery>;
export type FrontPageContentLazyQueryHookResult = ReturnType<typeof useFrontPageContentLazyQuery>;
export type FrontPageContentQueryResult = Apollo.QueryResult<FrontPageContentQuery, FrontPageContentQueryVariables>;
export const GameKitSessionsDocument = gql`
    query GameKitSessions($gameKit: GameKit!, $cursor: ID) {
  getSessionsByGameKit(
    gameKit: $gameKit
    payload: {first: 8, after: $cursor, sortBy: NEW, maxEngineVersion: 2}
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        playerCount
        maxPlayerCount
        createdAt
        sessionUrl
        publicity
        currentProject {
          title
          id
          gameKit
          likes
          totalViews
          disableComments
          projectType
          thumbnail {
            id
            small {
              id
              url
            }
          }
          author {
            id
            role
            username
          }
          thumbnail {
            id
            small {
              url
              id
            }
          }
        }
        settings {
          ... on ShooterSessionSettings {
            id
            subWinCondition
            winCondition
            winConditionValue
            gameMode
            timeLimit
          }
          ... on PlatformerSessionSettings {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGameKitSessionsQuery__
 *
 * To run a query within a React component, call `useGameKitSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameKitSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameKitSessionsQuery({
 *   variables: {
 *      gameKit: // value for 'gameKit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGameKitSessionsQuery(baseOptions: Apollo.QueryHookOptions<GameKitSessionsQuery, GameKitSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameKitSessionsQuery, GameKitSessionsQueryVariables>(GameKitSessionsDocument, options);
      }
export function useGameKitSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameKitSessionsQuery, GameKitSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameKitSessionsQuery, GameKitSessionsQueryVariables>(GameKitSessionsDocument, options);
        }
export type GameKitSessionsQueryHookResult = ReturnType<typeof useGameKitSessionsQuery>;
export type GameKitSessionsLazyQueryHookResult = ReturnType<typeof useGameKitSessionsLazyQuery>;
export type GameKitSessionsQueryResult = Apollo.QueryResult<GameKitSessionsQuery, GameKitSessionsQueryVariables>;
export const GameTemplatesDocument = gql`
    query GameTemplates {
  gameTemplates {
    author {
      id
      username
    }
    id
    title
    thumbnail {
      small {
        id
        url
      }
      medium {
        id
        url
      }
      large {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useGameTemplatesQuery__
 *
 * To run a query within a React component, call `useGameTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGameTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GameTemplatesQuery, GameTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameTemplatesQuery, GameTemplatesQueryVariables>(GameTemplatesDocument, options);
      }
export function useGameTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameTemplatesQuery, GameTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameTemplatesQuery, GameTemplatesQueryVariables>(GameTemplatesDocument, options);
        }
export type GameTemplatesQueryHookResult = ReturnType<typeof useGameTemplatesQuery>;
export type GameTemplatesLazyQueryHookResult = ReturnType<typeof useGameTemplatesLazyQuery>;
export type GameTemplatesQueryResult = Apollo.QueryResult<GameTemplatesQuery, GameTemplatesQueryVariables>;
export const GetAppearancesDocument = gql`
    query GetAppearances {
  appearances(type: SKIN, input: {first: 64}) {
    items {
      id
      name
      displayName
      sourceDescription
      type
      quality
      canEquip
      description
      appearanceQuality
      thumbnailUrl
      glbGZUrl
      quality
      achievementIconUrl
      isVariation
      parentAppearanceId
      variations {
        id
        name
        displayName
        description
        sourceDescription
        canEquip
        quality
        thumbnailUrl
        glbGZUrl
        achievementIconUrl
        appearanceQuality
        isVariation
        parentAppearanceId
        source {
          defaultSourceDescription
          badge {
            displayName
            level
            description
            groupTotal
            groupId
          }
        }
      }
      source {
        defaultSourceDescription
        badge {
          displayName
          level
          description
          groupTotal
          groupId
        }
      }
    }
  }
}
    `;

/**
 * __useGetAppearancesQuery__
 *
 * To run a query within a React component, call `useGetAppearancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppearancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppearancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppearancesQuery(baseOptions?: Apollo.QueryHookOptions<GetAppearancesQuery, GetAppearancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppearancesQuery, GetAppearancesQueryVariables>(GetAppearancesDocument, options);
      }
export function useGetAppearancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppearancesQuery, GetAppearancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppearancesQuery, GetAppearancesQueryVariables>(GetAppearancesDocument, options);
        }
export type GetAppearancesQueryHookResult = ReturnType<typeof useGetAppearancesQuery>;
export type GetAppearancesLazyQueryHookResult = ReturnType<typeof useGetAppearancesLazyQuery>;
export type GetAppearancesQueryResult = Apollo.QueryResult<GetAppearancesQuery, GetAppearancesQueryVariables>;
export const GetOrCreatePublicSessionForProjectDocument = gql`
    query getOrCreatePublicSessionForProject($channel: String!, $clientVersion: String!, $clientNetworkProtocolVersion: String!, $projectId: ID!) {
  getOrCreatePublicSessionForProject(
    channel: $channel
    clientVersion: $clientVersion
    clientNetworkProtocolVersion: $clientNetworkProtocolVersion
    id: $projectId
  ) {
    id
    sessionUrl
    sessionId
    newlyCreated
    sessionStatus
    playerCount
    maxPlayerCount
    publicity
  }
}
    `;

/**
 * __useGetOrCreatePublicSessionForProjectQuery__
 *
 * To run a query within a React component, call `useGetOrCreatePublicSessionForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreatePublicSessionForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrCreatePublicSessionForProjectQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      clientVersion: // value for 'clientVersion'
 *      clientNetworkProtocolVersion: // value for 'clientNetworkProtocolVersion'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetOrCreatePublicSessionForProjectQuery(baseOptions: Apollo.QueryHookOptions<GetOrCreatePublicSessionForProjectQuery, GetOrCreatePublicSessionForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrCreatePublicSessionForProjectQuery, GetOrCreatePublicSessionForProjectQueryVariables>(GetOrCreatePublicSessionForProjectDocument, options);
      }
export function useGetOrCreatePublicSessionForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrCreatePublicSessionForProjectQuery, GetOrCreatePublicSessionForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrCreatePublicSessionForProjectQuery, GetOrCreatePublicSessionForProjectQueryVariables>(GetOrCreatePublicSessionForProjectDocument, options);
        }
export type GetOrCreatePublicSessionForProjectQueryHookResult = ReturnType<typeof useGetOrCreatePublicSessionForProjectQuery>;
export type GetOrCreatePublicSessionForProjectLazyQueryHookResult = ReturnType<typeof useGetOrCreatePublicSessionForProjectLazyQuery>;
export type GetOrCreatePublicSessionForProjectQueryResult = Apollo.QueryResult<GetOrCreatePublicSessionForProjectQuery, GetOrCreatePublicSessionForProjectQueryVariables>;
export const GetScheduledProjectUpdatesDocument = gql`
    query GetScheduledProjectUpdates {
  getScheduledProjectUpdates {
    projectId
    updateAt
    featured
    reFeature
    youtubeId
    project {
      id
      title
      description
      engineVersion
      totalViews
      publishedAt
      canEdit
      isPublished
      isLiked
      likes
      isReported
      projectType
      disableComments
      youtubeId
      gameKit
      tags
      visibility
      leaderboard {
        id
      }
      thumbnail {
        id
        large {
          id
          url
        }
      }
      thumbnails {
        id
        large {
          id
          url
        }
      }
      author {
        id
        role
        username
        pictureUrl
        level
        isFollowing
        suspension {
          id
        }
        socialMedia {
          id
          twitter
          twitch
          youtube
          instagram
          tiktok
        }
      }
    }
  }
}
    `;

/**
 * __useGetScheduledProjectUpdatesQuery__
 *
 * To run a query within a React component, call `useGetScheduledProjectUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledProjectUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledProjectUpdatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScheduledProjectUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<GetScheduledProjectUpdatesQuery, GetScheduledProjectUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledProjectUpdatesQuery, GetScheduledProjectUpdatesQueryVariables>(GetScheduledProjectUpdatesDocument, options);
      }
export function useGetScheduledProjectUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledProjectUpdatesQuery, GetScheduledProjectUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledProjectUpdatesQuery, GetScheduledProjectUpdatesQueryVariables>(GetScheduledProjectUpdatesDocument, options);
        }
export type GetScheduledProjectUpdatesQueryHookResult = ReturnType<typeof useGetScheduledProjectUpdatesQuery>;
export type GetScheduledProjectUpdatesLazyQueryHookResult = ReturnType<typeof useGetScheduledProjectUpdatesLazyQuery>;
export type GetScheduledProjectUpdatesQueryResult = Apollo.QueryResult<GetScheduledProjectUpdatesQuery, GetScheduledProjectUpdatesQueryVariables>;
export const GoogleUserDocument = gql`
    query GoogleUser($code: String!) {
  googleUser(code: $code) {
    id
    googleId
  }
}
    `;

/**
 * __useGoogleUserQuery__
 *
 * To run a query within a React component, call `useGoogleUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleUserQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGoogleUserQuery(baseOptions: Apollo.QueryHookOptions<GoogleUserQuery, GoogleUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleUserQuery, GoogleUserQueryVariables>(GoogleUserDocument, options);
      }
export function useGoogleUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleUserQuery, GoogleUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleUserQuery, GoogleUserQueryVariables>(GoogleUserDocument, options);
        }
export type GoogleUserQueryHookResult = ReturnType<typeof useGoogleUserQuery>;
export type GoogleUserLazyQueryHookResult = ReturnType<typeof useGoogleUserLazyQuery>;
export type GoogleUserQueryResult = Apollo.QueryResult<GoogleUserQuery, GoogleUserQueryVariables>;
export const IsProfileImageReportedDocument = gql`
    query IsProfileImageReported($username: String!) {
  userByUsername(username: $username, relations: "profileImage") {
    id
    username
    profileImage {
      id
      isReported
    }
  }
}
    `;

/**
 * __useIsProfileImageReportedQuery__
 *
 * To run a query within a React component, call `useIsProfileImageReportedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsProfileImageReportedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsProfileImageReportedQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIsProfileImageReportedQuery(baseOptions: Apollo.QueryHookOptions<IsProfileImageReportedQuery, IsProfileImageReportedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsProfileImageReportedQuery, IsProfileImageReportedQueryVariables>(IsProfileImageReportedDocument, options);
      }
export function useIsProfileImageReportedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsProfileImageReportedQuery, IsProfileImageReportedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsProfileImageReportedQuery, IsProfileImageReportedQueryVariables>(IsProfileImageReportedDocument, options);
        }
export type IsProfileImageReportedQueryHookResult = ReturnType<typeof useIsProfileImageReportedQuery>;
export type IsProfileImageReportedLazyQueryHookResult = ReturnType<typeof useIsProfileImageReportedLazyQuery>;
export type IsProfileImageReportedQueryResult = Apollo.QueryResult<IsProfileImageReportedQuery, IsProfileImageReportedQueryVariables>;
export const IsSuspendedDocument = gql`
    query IsSuspended {
  me {
    id
    isSuspended
  }
}
    `;

/**
 * __useIsSuspendedQuery__
 *
 * To run a query within a React component, call `useIsSuspendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSuspendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSuspendedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsSuspendedQuery(baseOptions?: Apollo.QueryHookOptions<IsSuspendedQuery, IsSuspendedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsSuspendedQuery, IsSuspendedQueryVariables>(IsSuspendedDocument, options);
      }
export function useIsSuspendedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsSuspendedQuery, IsSuspendedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsSuspendedQuery, IsSuspendedQueryVariables>(IsSuspendedDocument, options);
        }
export type IsSuspendedQueryHookResult = ReturnType<typeof useIsSuspendedQuery>;
export type IsSuspendedLazyQueryHookResult = ReturnType<typeof useIsSuspendedLazyQuery>;
export type IsSuspendedQueryResult = Apollo.QueryResult<IsSuspendedQuery, IsSuspendedQueryVariables>;
export const LatestHiberChallengeDocument = gql`
    query LatestHiberChallenge {
  latestHiberChallenge(platform: WEB) {
    title
    tag
    description
    buttonText
    featuredGameId
    thumbnail {
      url
    }
    thumbnailSmall {
      url
    }
  }
}
    `;

/**
 * __useLatestHiberChallengeQuery__
 *
 * To run a query within a React component, call `useLatestHiberChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestHiberChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestHiberChallengeQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestHiberChallengeQuery(baseOptions?: Apollo.QueryHookOptions<LatestHiberChallengeQuery, LatestHiberChallengeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestHiberChallengeQuery, LatestHiberChallengeQueryVariables>(LatestHiberChallengeDocument, options);
      }
export function useLatestHiberChallengeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestHiberChallengeQuery, LatestHiberChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestHiberChallengeQuery, LatestHiberChallengeQueryVariables>(LatestHiberChallengeDocument, options);
        }
export type LatestHiberChallengeQueryHookResult = ReturnType<typeof useLatestHiberChallengeQuery>;
export type LatestHiberChallengeLazyQueryHookResult = ReturnType<typeof useLatestHiberChallengeLazyQuery>;
export type LatestHiberChallengeQueryResult = Apollo.QueryResult<LatestHiberChallengeQuery, LatestHiberChallengeQueryVariables>;
export const LatestNewsDocument = gql`
    query latestNews {
  latestNewsArticle {
    title
    ctaButtonText
    ctaButtonLink
    iosCtaButtonLink
    showForLoggedIn
    showForLoggedOut
    startDate
    endDate
    modalTitle
    modalButtonText
    modalText
    openModal
    thumbnail {
      url
    }
    article
  }
}
    `;

/**
 * __useLatestNewsQuery__
 *
 * To run a query within a React component, call `useLatestNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestNewsQuery(baseOptions?: Apollo.QueryHookOptions<LatestNewsQuery, LatestNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestNewsQuery, LatestNewsQueryVariables>(LatestNewsDocument, options);
      }
export function useLatestNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestNewsQuery, LatestNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestNewsQuery, LatestNewsQueryVariables>(LatestNewsDocument, options);
        }
export type LatestNewsQueryHookResult = ReturnType<typeof useLatestNewsQuery>;
export type LatestNewsLazyQueryHookResult = ReturnType<typeof useLatestNewsLazyQuery>;
export type LatestNewsQueryResult = Apollo.QueryResult<LatestNewsQuery, LatestNewsQueryVariables>;
export const LeaderboardDocument = gql`
    query Leaderboard($projectId: ID!, $platform: LeaderboardPlatform!, $first: Int, $skip: Int, $timespan: LeaderboardPeriod, $group: LeaderboardGroup, $cycle: Int) {
  leaderboard: leaderboardByProjectId(projectId: $projectId) {
    id
    project {
      author {
        id
        username
      }
    }
    me(
      filter: {platform: $platform, timespan: $timespan, group: $group, cycle: $cycle}
    ) {
      rank
      score
      attempts
      user {
        id
        role
        isVerified
        isEmployee
        username
        pictureUrl
      }
    }
    entries(
      filter: {platform: $platform, first: $first, skip: $skip, timespan: $timespan, group: $group, cycle: $cycle}
    ) {
      hasNextPage
      entries {
        rank
        score
        attempts
        user {
          id
          role
          isVerified
          isEmployee
          username
          pictureUrl
        }
      }
    }
  }
}
    `;

/**
 * __useLeaderboardQuery__
 *
 * To run a query within a React component, call `useLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      platform: // value for 'platform'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      timespan: // value for 'timespan'
 *      group: // value for 'group'
 *      cycle: // value for 'cycle'
 *   },
 * });
 */
export function useLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
      }
export function useLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
        }
export type LeaderboardQueryHookResult = ReturnType<typeof useLeaderboardQuery>;
export type LeaderboardLazyQueryHookResult = ReturnType<typeof useLeaderboardLazyQuery>;
export type LeaderboardQueryResult = Apollo.QueryResult<LeaderboardQuery, LeaderboardQueryVariables>;
export const LeaderboardV2Document = gql`
    query LeaderboardV2($projectId: ID!, $platform: LeaderboardPlatform!, $first: Int!, $after: String, $kind: LeaderboardScoreKind, $order: LeaderboardSortOrder, $type: String!) {
  leaderboardV2(
    input: {projectId: $projectId, first: $first, platform: $platform, after: $after, kind: $kind, order: $order, type: $type}
  ) {
    type
    leaderboard {
      score
      rank
      id
      user {
        id
        username
        pictureUrl
        isEmployee
        isVerified
      }
    }
    myResult {
      score
      rank
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useLeaderboardV2Query__
 *
 * To run a query within a React component, call `useLeaderboardV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardV2Query({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      platform: // value for 'platform'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      kind: // value for 'kind'
 *      order: // value for 'order'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLeaderboardV2Query(baseOptions: Apollo.QueryHookOptions<LeaderboardV2Query, LeaderboardV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardV2Query, LeaderboardV2QueryVariables>(LeaderboardV2Document, options);
      }
export function useLeaderboardV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardV2Query, LeaderboardV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardV2Query, LeaderboardV2QueryVariables>(LeaderboardV2Document, options);
        }
export type LeaderboardV2QueryHookResult = ReturnType<typeof useLeaderboardV2Query>;
export type LeaderboardV2LazyQueryHookResult = ReturnType<typeof useLeaderboardV2LazyQuery>;
export type LeaderboardV2QueryResult = Apollo.QueryResult<LeaderboardV2Query, LeaderboardV2QueryVariables>;
export const LootDocument = gql`
    query Loot($payload: FetchLootDTO) {
  loot(payload: $payload) {
    id
    type
    createdAt
    seen
    refId
    content {
      title
      src
      rarity
      description
      persistence
      values {
        type
        subType
        value
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useLootQuery__
 *
 * To run a query within a React component, call `useLootQuery` and pass it any options that fit your needs.
 * When your component renders, `useLootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLootQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useLootQuery(baseOptions?: Apollo.QueryHookOptions<LootQuery, LootQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LootQuery, LootQueryVariables>(LootDocument, options);
      }
export function useLootLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LootQuery, LootQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LootQuery, LootQueryVariables>(LootDocument, options);
        }
export type LootQueryHookResult = ReturnType<typeof useLootQuery>;
export type LootLazyQueryHookResult = ReturnType<typeof useLootLazyQuery>;
export type LootQueryResult = Apollo.QueryResult<LootQuery, LootQueryVariables>;
export const MatchmakeDocument = gql`
    query Matchmake($request: MatchmakeRequest!) {
  matchMake(request: $request) {
    id
    sessionUrl
  }
}
    `;

/**
 * __useMatchmakeQuery__
 *
 * To run a query within a React component, call `useMatchmakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchmakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchmakeQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useMatchmakeQuery(baseOptions: Apollo.QueryHookOptions<MatchmakeQuery, MatchmakeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchmakeQuery, MatchmakeQueryVariables>(MatchmakeDocument, options);
      }
export function useMatchmakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchmakeQuery, MatchmakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchmakeQuery, MatchmakeQueryVariables>(MatchmakeDocument, options);
        }
export type MatchmakeQueryHookResult = ReturnType<typeof useMatchmakeQuery>;
export type MatchmakeLazyQueryHookResult = ReturnType<typeof useMatchmakeLazyQuery>;
export type MatchmakeQueryResult = Apollo.QueryResult<MatchmakeQuery, MatchmakeQueryVariables>;
export const MessageToBeReviewedDocument = gql`
    query MessageToBeReviewed($id: Float!) {
  messageToBeReviewed(id: $id) {
    confidence
    result
    id
    history {
      message
      id
      sender {
        id
        role
        username
      }
    }
  }
}
    `;

/**
 * __useMessageToBeReviewedQuery__
 *
 * To run a query within a React component, call `useMessageToBeReviewedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageToBeReviewedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageToBeReviewedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageToBeReviewedQuery(baseOptions: Apollo.QueryHookOptions<MessageToBeReviewedQuery, MessageToBeReviewedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageToBeReviewedQuery, MessageToBeReviewedQueryVariables>(MessageToBeReviewedDocument, options);
      }
export function useMessageToBeReviewedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageToBeReviewedQuery, MessageToBeReviewedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageToBeReviewedQuery, MessageToBeReviewedQueryVariables>(MessageToBeReviewedDocument, options);
        }
export type MessageToBeReviewedQueryHookResult = ReturnType<typeof useMessageToBeReviewedQuery>;
export type MessageToBeReviewedLazyQueryHookResult = ReturnType<typeof useMessageToBeReviewedLazyQuery>;
export type MessageToBeReviewedQueryResult = Apollo.QueryResult<MessageToBeReviewedQuery, MessageToBeReviewedQueryVariables>;
export const MessagesToBeReviewedDocument = gql`
    query MessagesToBeReviewed($humanReviewed: Boolean!) {
  messagesToBeReviewed(humanReviewed: $humanReviewed) {
    confidence
    result
    id
    humanReviewed
    message {
      message
      id
      createdAt
      sender {
        id
        role
        username
        pictureUrl
      }
    }
  }
}
    `;

/**
 * __useMessagesToBeReviewedQuery__
 *
 * To run a query within a React component, call `useMessagesToBeReviewedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesToBeReviewedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesToBeReviewedQuery({
 *   variables: {
 *      humanReviewed: // value for 'humanReviewed'
 *   },
 * });
 */
export function useMessagesToBeReviewedQuery(baseOptions: Apollo.QueryHookOptions<MessagesToBeReviewedQuery, MessagesToBeReviewedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesToBeReviewedQuery, MessagesToBeReviewedQueryVariables>(MessagesToBeReviewedDocument, options);
      }
export function useMessagesToBeReviewedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesToBeReviewedQuery, MessagesToBeReviewedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesToBeReviewedQuery, MessagesToBeReviewedQueryVariables>(MessagesToBeReviewedDocument, options);
        }
export type MessagesToBeReviewedQueryHookResult = ReturnType<typeof useMessagesToBeReviewedQuery>;
export type MessagesToBeReviewedLazyQueryHookResult = ReturnType<typeof useMessagesToBeReviewedLazyQuery>;
export type MessagesToBeReviewedQueryResult = Apollo.QueryResult<MessagesToBeReviewedQuery, MessagesToBeReviewedQueryVariables>;
export const MyProjectsDocument = gql`
    query MyProjects($first: Float!, $cursor: ID, $sortBy: SortBy!, $maxEngineVersion: Int) {
  me {
    id
    role
    username
    projects(
      payload: {first: $first, after: $cursor, sortBy: $sortBy, maxEngineVersion: $maxEngineVersion}
      includeUnpublished: true
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          title
          description
          isPublished
          visibility
          totalViews
          likes
          tags
          tags_v2 {
            ...TagFragment
          }
          tags
          gameKit
          createdAt
          publishedAt
          deletedAt
          featured
          projectType
          engineVersion
          gameKit
          isHomeworld
          thumbnail {
            id
            medium {
              id
              url
            }
            large {
              id
              url
            }
          }
          thumbnails {
            id
            medium {
              id
              url
            }
            large {
              id
              url
            }
          }
          author {
            id
            role
            isVerified
            isEmployee
            username
            suspension {
              id
            }
          }
        }
      }
    }
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useMyProjectsQuery__
 *
 * To run a query within a React component, call `useMyProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      sortBy: // value for 'sortBy'
 *      maxEngineVersion: // value for 'maxEngineVersion'
 *   },
 * });
 */
export function useMyProjectsQuery(baseOptions: Apollo.QueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProjectsQuery, MyProjectsQueryVariables>(MyProjectsDocument, options);
      }
export function useMyProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProjectsQuery, MyProjectsQueryVariables>(MyProjectsDocument, options);
        }
export type MyProjectsQueryHookResult = ReturnType<typeof useMyProjectsQuery>;
export type MyProjectsLazyQueryHookResult = ReturnType<typeof useMyProjectsLazyQuery>;
export type MyProjectsQueryResult = Apollo.QueryResult<MyProjectsQuery, MyProjectsQueryVariables>;
export const MyTotalFriendsDocument = gql`
    query MyTotalFriends {
  me {
    id
    totalFriends
  }
}
    `;

/**
 * __useMyTotalFriendsQuery__
 *
 * To run a query within a React component, call `useMyTotalFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTotalFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTotalFriendsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTotalFriendsQuery(baseOptions?: Apollo.QueryHookOptions<MyTotalFriendsQuery, MyTotalFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTotalFriendsQuery, MyTotalFriendsQueryVariables>(MyTotalFriendsDocument, options);
      }
export function useMyTotalFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTotalFriendsQuery, MyTotalFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTotalFriendsQuery, MyTotalFriendsQueryVariables>(MyTotalFriendsDocument, options);
        }
export type MyTotalFriendsQueryHookResult = ReturnType<typeof useMyTotalFriendsQuery>;
export type MyTotalFriendsLazyQueryHookResult = ReturnType<typeof useMyTotalFriendsLazyQuery>;
export type MyTotalFriendsQueryResult = Apollo.QueryResult<MyTotalFriendsQuery, MyTotalFriendsQueryVariables>;
export const NextBadgeDocument = gql`
    query NextBadge($badgeId: Float!, $userId: Int!, $skip: Boolean!) {
  badge(badgeId: $badgeId) {
    id
    criteriaData(userId: $userId) @include(if: $skip) {
      currentValue
      total
      name
      badgeId
    }
    nextBadge @skip(if: $skip) {
      displayName
      level
      id
      description
      criteriaData(userId: $userId) {
        currentValue
        total
        name
        badgeId
      }
      rewards {
        id
        value
        rewardItemName
        subType
        type
      }
    }
    rewards {
      id
      value
      subType
      type
      rewardItemName
    }
  }
}
    `;

/**
 * __useNextBadgeQuery__
 *
 * To run a query within a React component, call `useNextBadgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextBadgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextBadgeQuery({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *      userId: // value for 'userId'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useNextBadgeQuery(baseOptions: Apollo.QueryHookOptions<NextBadgeQuery, NextBadgeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextBadgeQuery, NextBadgeQueryVariables>(NextBadgeDocument, options);
      }
export function useNextBadgeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextBadgeQuery, NextBadgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextBadgeQuery, NextBadgeQueryVariables>(NextBadgeDocument, options);
        }
export type NextBadgeQueryHookResult = ReturnType<typeof useNextBadgeQuery>;
export type NextBadgeLazyQueryHookResult = ReturnType<typeof useNextBadgeLazyQuery>;
export type NextBadgeQueryResult = Apollo.QueryResult<NextBadgeQuery, NextBadgeQueryVariables>;
export const NotificationsAmountDocument = gql`
    query notificationsAmount {
  notificationsAmount
}
    `;

/**
 * __useNotificationsAmountQuery__
 *
 * To run a query within a React component, call `useNotificationsAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsAmountQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsAmountQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsAmountQuery, NotificationsAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsAmountQuery, NotificationsAmountQueryVariables>(NotificationsAmountDocument, options);
      }
export function useNotificationsAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsAmountQuery, NotificationsAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsAmountQuery, NotificationsAmountQueryVariables>(NotificationsAmountDocument, options);
        }
export type NotificationsAmountQueryHookResult = ReturnType<typeof useNotificationsAmountQuery>;
export type NotificationsAmountLazyQueryHookResult = ReturnType<typeof useNotificationsAmountLazyQuery>;
export type NotificationsAmountQueryResult = Apollo.QueryResult<NotificationsAmountQuery, NotificationsAmountQueryVariables>;
export const NotificationsDocument = gql`
    query notifications($cursor: ID) {
  me {
    id
    __typename
    notifications(payload: {first: 15, after: $cursor}) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        id
        sourceId
        type
        read
        total
        createdAt
        sourceContentType
        visited
        __typename
        content {
          title
          image {
            url
          }
          linkTo {
            as
            href
          }
          customData {
            commentText
            gameKit
            projectTitle
          }
        }
        lastUsers {
          id
          role
          username
          pictureUrl
        }
        message
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const NumberOfActivePlayersDocument = gql`
    query NumberOfActivePlayers($id: ID!) {
  project(id: $id) {
    id
    numberOfActivePlayersV2
  }
}
    `;

/**
 * __useNumberOfActivePlayersQuery__
 *
 * To run a query within a React component, call `useNumberOfActivePlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberOfActivePlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberOfActivePlayersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNumberOfActivePlayersQuery(baseOptions: Apollo.QueryHookOptions<NumberOfActivePlayersQuery, NumberOfActivePlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NumberOfActivePlayersQuery, NumberOfActivePlayersQueryVariables>(NumberOfActivePlayersDocument, options);
      }
export function useNumberOfActivePlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NumberOfActivePlayersQuery, NumberOfActivePlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NumberOfActivePlayersQuery, NumberOfActivePlayersQueryVariables>(NumberOfActivePlayersDocument, options);
        }
export type NumberOfActivePlayersQueryHookResult = ReturnType<typeof useNumberOfActivePlayersQuery>;
export type NumberOfActivePlayersLazyQueryHookResult = ReturnType<typeof useNumberOfActivePlayersLazyQuery>;
export type NumberOfActivePlayersQueryResult = Apollo.QueryResult<NumberOfActivePlayersQuery, NumberOfActivePlayersQueryVariables>;
export const OnlineFriendsDocument = gql`
    query OnlineFriends {
  onlineFriends {
    friendSince
    user {
      id
      role
      isVerified
      isEmployee
      username
      level
      pictureUrl
      isValidAge
      privacySettings {
        directMessagingPublicity
      }
      session {
        id
        sessionStatus
        actionStatus
        sessionLength
      }
      activeSession {
        id
        type
        sessionUrl
        players {
          sessionUserId
          sessionUsername
        }
        project {
          id
          title
          numberOfActivePlayersV2
          engineVersion
          visibility
          thumbnail {
            medium {
              url
            }
            small {
              url
            }
          }
          gameKit
          completionRate
          totalViews
        }
      }
    }
  }
}
    `;

/**
 * __useOnlineFriendsQuery__
 *
 * To run a query within a React component, call `useOnlineFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnlineFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnlineFriendsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnlineFriendsQuery(baseOptions?: Apollo.QueryHookOptions<OnlineFriendsQuery, OnlineFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnlineFriendsQuery, OnlineFriendsQueryVariables>(OnlineFriendsDocument, options);
      }
export function useOnlineFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnlineFriendsQuery, OnlineFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnlineFriendsQuery, OnlineFriendsQueryVariables>(OnlineFriendsDocument, options);
        }
export type OnlineFriendsQueryHookResult = ReturnType<typeof useOnlineFriendsQuery>;
export type OnlineFriendsLazyQueryHookResult = ReturnType<typeof useOnlineFriendsLazyQuery>;
export type OnlineFriendsQueryResult = Apollo.QueryResult<OnlineFriendsQuery, OnlineFriendsQueryVariables>;
export const PageDocument = gql`
    query Page($slug: String, $previewUserType: UserType) {
  page(platform: WEB, slug: $slug, previewUserType: $previewUserType) {
    title
    slug
    modules {
      __typename
      ... on Banner {
        id
        header
        text
        bannerLayout: layout
        background {
          url
        }
        buttonLabel
        projectIdOrButtonLink
        __typename
      }
      ... on Hero {
        id
        header
        preHeader
        subHeader
        background {
          url
        }
        buttonLabel
        projectIdOrButtonLink
        __typename
      }
      ... on ChallengeBanner {
        id
        buttonText: buttonLabel
        projectIdOrLink
        __typename
      }
      ... on NewsFeed {
        id
        __typename
      }
      ... on ProjectFeedRegular {
        id
        title
        layout
        showAuthor
        quantity
        sortBy
        tags
        metaTags
        forkIds
        directPlayOnClick
        filters
        page {
          title
          slug
          filters
          metaTags
          tags
          sortBy
        }
      }
      ... on ProjectFeedSpecific {
        id
        title
        layout
        showAuthor
        projectIds
        directPlayOnClick
        page {
          slug
        }
      }
      ... on SessionFeed {
        id
        title
        quantity
        liveEvents {
          id
          worldId
          label
        }
      }
      ... on UserFeedOnlineFriends {
        id
        title
      }
      ... on UserFeedRegular {
        title
        quantity
        metaTags
        tags
        layout
        cta
      }
      ... on Carousel {
        id
        items {
          id
          header
          text
          background {
            url
          }
          backgroundVideo {
            url
          }
          layout
          buttonLabel
          projectIdOrButtonLink
        }
      }
      ... on Section {
        id
        title
      }
    }
  }
}
    `;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      previewUserType: // value for 'previewUserType'
 *   },
 * });
 */
export function usePageQuery(baseOptions?: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const PaymentDetailsDocument = gql`
    query PaymentDetails($id: String!) {
  paymentDetails(paymentIntentId: $id) {
    chargeId
    orderDate
    paymentMethodType
    subtotal
    total
    currency
    taxAmount
    receiptNumber
  }
}
    `;

/**
 * __usePaymentDetailsQuery__
 *
 * To run a query within a React component, call `usePaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentDetailsQuery, PaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
      }
export function usePaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentDetailsQuery, PaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
        }
export type PaymentDetailsQueryHookResult = ReturnType<typeof usePaymentDetailsQuery>;
export type PaymentDetailsLazyQueryHookResult = ReturnType<typeof usePaymentDetailsLazyQuery>;
export type PaymentDetailsQueryResult = Apollo.QueryResult<PaymentDetailsQuery, PaymentDetailsQueryVariables>;
export const PrivacySettingsDocument = gql`
    query privacySettings($username: String!) {
  userByUsername(username: $username) {
    id
    getOrCreatePrivacySettings {
      id
      userId
      friendsArePublic
      onlyFriendsInMultiplayer
      achievementPublicity
      favoriteGamesArePublic
      directMessagingPublicity
    }
  }
}
    `;

/**
 * __usePrivacySettingsQuery__
 *
 * To run a query within a React component, call `usePrivacySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacySettingsQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function usePrivacySettingsQuery(baseOptions: Apollo.QueryHookOptions<PrivacySettingsQuery, PrivacySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacySettingsQuery, PrivacySettingsQueryVariables>(PrivacySettingsDocument, options);
      }
export function usePrivacySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacySettingsQuery, PrivacySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacySettingsQuery, PrivacySettingsQueryVariables>(PrivacySettingsDocument, options);
        }
export type PrivacySettingsQueryHookResult = ReturnType<typeof usePrivacySettingsQuery>;
export type PrivacySettingsLazyQueryHookResult = ReturnType<typeof usePrivacySettingsLazyQuery>;
export type PrivacySettingsQueryResult = Apollo.QueryResult<PrivacySettingsQuery, PrivacySettingsQueryVariables>;
export const ProductByIdDocument = gql`
    query ProductById($id: String!) {
  productById(productId: $id) {
    ...ShopItem
  }
}
    ${ShopItemFragmentDoc}`;

/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
      }
export function useProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
        }
export type ProductByIdQueryHookResult = ReturnType<typeof useProductByIdQuery>;
export type ProductByIdLazyQueryHookResult = ReturnType<typeof useProductByIdLazyQuery>;
export type ProductByIdQueryResult = Apollo.QueryResult<ProductByIdQuery, ProductByIdQueryVariables>;
export const ProfilePageUserDocument = gql`
    query ProfilePageUser($username: String!) {
  userByUsername(username: $username) {
    id
    level
    role
    username
    title
    description
    pictureUrl
    birthdate
    profileBackgroundUrl
    isFollowing
    isFriends
    deletedAt
    isValidAge
    hasDefaultProfileImage
    isVerified
    isDeveloper
    isBetatester
    isEmployee
    totalFollowers
    totalProjectViews
    haveIReceivedFriendRequest
    haveISentFriendRequest
    haveIFeaturedFriend
    haveIBlocked
    haveIReported
    socialMedia {
      id
      twitter
      twitch
      instagram
      youtube
      tiktok
    }
    activeSession {
      id
      type
      sessionUrl
      project {
        id
        title
        numberOfActivePlayersV2
        engineVersion
        visibility
        thumbnail {
          medium {
            url
          }
        }
      }
    }
    getOrCreatePrivacySettings {
      id
      userId
      friendsArePublic
      onlyFriendsInMultiplayer
      achievementPublicity
      favoriteGamesArePublic
      directMessagingPublicity
    }
  }
}
    `;

/**
 * __useProfilePageUserQuery__
 *
 * To run a query within a React component, call `useProfilePageUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageUserQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfilePageUserQuery(baseOptions: Apollo.QueryHookOptions<ProfilePageUserQuery, ProfilePageUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfilePageUserQuery, ProfilePageUserQueryVariables>(ProfilePageUserDocument, options);
      }
export function useProfilePageUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfilePageUserQuery, ProfilePageUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfilePageUserQuery, ProfilePageUserQueryVariables>(ProfilePageUserDocument, options);
        }
export type ProfilePageUserQueryHookResult = ReturnType<typeof useProfilePageUserQuery>;
export type ProfilePageUserLazyQueryHookResult = ReturnType<typeof useProfilePageUserLazyQuery>;
export type ProfilePageUserQueryResult = Apollo.QueryResult<ProfilePageUserQuery, ProfilePageUserQueryVariables>;
export const ProjectDocument = gql`
    query Project($id: ID!) {
  project(id: $id) {
    ...ProjectFragment
    categories
    iframeUrl
  }
}
    ${ProjectFragmentFragmentDoc}`;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const ProjectActiveFriendsDocument = gql`
    query ProjectActiveFriends($id: ID!, $limit: Int) {
  project(id: $id) {
    id
    activeFriends(limit: $limit) {
      id
      username
      pictureUrl
    }
  }
}
    `;

/**
 * __useProjectActiveFriendsQuery__
 *
 * To run a query within a React component, call `useProjectActiveFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectActiveFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectActiveFriendsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProjectActiveFriendsQuery(baseOptions: Apollo.QueryHookOptions<ProjectActiveFriendsQuery, ProjectActiveFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectActiveFriendsQuery, ProjectActiveFriendsQueryVariables>(ProjectActiveFriendsDocument, options);
      }
export function useProjectActiveFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectActiveFriendsQuery, ProjectActiveFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectActiveFriendsQuery, ProjectActiveFriendsQueryVariables>(ProjectActiveFriendsDocument, options);
        }
export type ProjectActiveFriendsQueryHookResult = ReturnType<typeof useProjectActiveFriendsQuery>;
export type ProjectActiveFriendsLazyQueryHookResult = ReturnType<typeof useProjectActiveFriendsLazyQuery>;
export type ProjectActiveFriendsQueryResult = Apollo.QueryResult<ProjectActiveFriendsQuery, ProjectActiveFriendsQueryVariables>;
export const ProjectCommentsDocument = gql`
    query ProjectComments($projectId: ID!, $cursor: ID) {
  project(id: $projectId) {
    id
    comments(payload: {first: 10, after: $cursor}) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edges {
        node {
          text
          id
          likes
          createdAt
          updatedAt
          deletedAt
          isPinned
          isReported
          likes
          isLiked
          author {
            id
            role
            username
            pictureUrl
            level
            suspension {
              id
            }
          }
          comments(payload: {first: 2}) {
            pageInfo {
              hasNextPage
              startCursor
              endCursor
            }
            totalCount
            edges {
              node {
                likes
                isLiked
                isReported
                text
                id
                likes
                createdAt
                updatedAt
                deletedAt
                isPinned
                author {
                  ...AuthorFragment
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${AuthorFragmentFragmentDoc}`;

/**
 * __useProjectCommentsQuery__
 *
 * To run a query within a React component, call `useProjectCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCommentsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useProjectCommentsQuery(baseOptions: Apollo.QueryHookOptions<ProjectCommentsQuery, ProjectCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectCommentsQuery, ProjectCommentsQueryVariables>(ProjectCommentsDocument, options);
      }
export function useProjectCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCommentsQuery, ProjectCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectCommentsQuery, ProjectCommentsQueryVariables>(ProjectCommentsDocument, options);
        }
export type ProjectCommentsQueryHookResult = ReturnType<typeof useProjectCommentsQuery>;
export type ProjectCommentsLazyQueryHookResult = ReturnType<typeof useProjectCommentsLazyQuery>;
export type ProjectCommentsQueryResult = Apollo.QueryResult<ProjectCommentsQuery, ProjectCommentsQueryVariables>;
export const ProjectEmbedDocument = gql`
    query ProjectEmbed($id: ID!) {
  project(id: $id) {
    id
    playUrl
    title
    description
    thumbnail {
      id
      large {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useProjectEmbedQuery__
 *
 * To run a query within a React component, call `useProjectEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEmbedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectEmbedQuery(baseOptions: Apollo.QueryHookOptions<ProjectEmbedQuery, ProjectEmbedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEmbedQuery, ProjectEmbedQueryVariables>(ProjectEmbedDocument, options);
      }
export function useProjectEmbedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEmbedQuery, ProjectEmbedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEmbedQuery, ProjectEmbedQueryVariables>(ProjectEmbedDocument, options);
        }
export type ProjectEmbedQueryHookResult = ReturnType<typeof useProjectEmbedQuery>;
export type ProjectEmbedLazyQueryHookResult = ReturnType<typeof useProjectEmbedLazyQuery>;
export type ProjectEmbedQueryResult = Apollo.QueryResult<ProjectEmbedQuery, ProjectEmbedQueryVariables>;
export const ProjectFeedPageDocument = gql`
    query ProjectFeedPage($slug: String!, $preview: Boolean) {
  projectFeedPage(slug: $slug, preview: $preview) {
    title
    slug
    filters
    metaTags
    tags
    forkIds
    sortBy
    description
    background {
      url
    }
  }
}
    `;

/**
 * __useProjectFeedPageQuery__
 *
 * To run a query within a React component, call `useProjectFeedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFeedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFeedPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useProjectFeedPageQuery(baseOptions: Apollo.QueryHookOptions<ProjectFeedPageQuery, ProjectFeedPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFeedPageQuery, ProjectFeedPageQueryVariables>(ProjectFeedPageDocument, options);
      }
export function useProjectFeedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFeedPageQuery, ProjectFeedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFeedPageQuery, ProjectFeedPageQueryVariables>(ProjectFeedPageDocument, options);
        }
export type ProjectFeedPageQueryHookResult = ReturnType<typeof useProjectFeedPageQuery>;
export type ProjectFeedPageLazyQueryHookResult = ReturnType<typeof useProjectFeedPageLazyQuery>;
export type ProjectFeedPageQueryResult = Apollo.QueryResult<ProjectFeedPageQuery, ProjectFeedPageQueryVariables>;
export const ProjectTemplatesDocument = gql`
    query ProjectTemplates($preview: Boolean) {
  projectTemplates(preview: $preview) {
    id
    isNew
    category
    project {
      author {
        id
        username
      }
      id
      title
      thumbnail {
        small {
          id
          url
        }
        medium {
          id
          url
        }
        large {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useProjectTemplatesQuery__
 *
 * To run a query within a React component, call `useProjectTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTemplatesQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useProjectTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, options);
      }
export function useProjectTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, options);
        }
export type ProjectTemplatesQueryHookResult = ReturnType<typeof useProjectTemplatesQuery>;
export type ProjectTemplatesLazyQueryHookResult = ReturnType<typeof useProjectTemplatesLazyQuery>;
export type ProjectTemplatesQueryResult = Apollo.QueryResult<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>;
export const ProjectsDocument = gql`
    query Projects($first: Float!, $cursor: ID, $filter: String, $sortBy: SortBy, $gamekit: GameKit, $requireRelevancy: Boolean, $tags: [String!], $meta: [String!], $forkIds: [ID!], $maxEngineVersion: Int, $minEngineVersion: Int, $filterFollowing: Boolean) {
  projects(
    payload: {first: $first, after: $cursor, filter: $filter, projectGameKit: $gamekit, sortBy: $sortBy, requireRelevancy: $requireRelevancy, tags: $tags, meta: $meta, forkIds: $forkIds, maxEngineVersion: $maxEngineVersion, minEngineVersion: $minEngineVersion, filterFollowing: $filterFollowing}
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        title
        completionRate
        engineVersion
        gameKit
        thumbnail {
          id
          medium {
            id
            url
          }
        }
        author {
          id
          username
          pictureUrl
          isEmployee
          isVerified
        }
        featured
        totalViews
      }
    }
  }
}
    `;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      gamekit: // value for 'gamekit'
 *      requireRelevancy: // value for 'requireRelevancy'
 *      tags: // value for 'tags'
 *      meta: // value for 'meta'
 *      forkIds: // value for 'forkIds'
 *      maxEngineVersion: // value for 'maxEngineVersion'
 *      minEngineVersion: // value for 'minEngineVersion'
 *      filterFollowing: // value for 'filterFollowing'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectsByIdsDocument = gql`
    query projectsByIds($projectIds: [ID!]!) {
  projectsByIds(projectIds: $projectIds) {
    id
    title
    engineVersion
    gameKit
    completionRate
    thumbnail {
      id
      medium {
        id
        url
      }
    }
    author {
      id
      username
      pictureUrl
      isEmployee
      isVerified
    }
    featured
    totalViews
  }
}
    `;

/**
 * __useProjectsByIdsQuery__
 *
 * To run a query within a React component, call `useProjectsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByIdsQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *   },
 * });
 */
export function useProjectsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsByIdsQuery, ProjectsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsByIdsQuery, ProjectsByIdsQueryVariables>(ProjectsByIdsDocument, options);
      }
export function useProjectsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsByIdsQuery, ProjectsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsByIdsQuery, ProjectsByIdsQueryVariables>(ProjectsByIdsDocument, options);
        }
export type ProjectsByIdsQueryHookResult = ReturnType<typeof useProjectsByIdsQuery>;
export type ProjectsByIdsLazyQueryHookResult = ReturnType<typeof useProjectsByIdsLazyQuery>;
export type ProjectsByIdsQueryResult = Apollo.QueryResult<ProjectsByIdsQuery, ProjectsByIdsQueryVariables>;
export const ProjectsByUserDocument = gql`
    query ProjectsByUser($first: Float, $username: String!, $cursor: ID, $filterFavorites: Boolean, $sortBy: SortBy, $maxEngineVersion: Int) {
  userByUsername(username: $username) {
    id
    role
    username
    projects(
      payload: {first: $first, after: $cursor, filterFavorites: $filterFavorites, sortBy: $sortBy, maxEngineVersion: $maxEngineVersion}
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          title
          description
          isPublished
          visibility
          featured
          totalViews
          engineVersion
          completionRate
          likes
          tags
          tags_v2 {
            ...TagFragment
          }
          projectType
          createdAt
          deletedAt
          publishedAt
          gameKit
          isHomeworld
          thumbnail {
            id
            small {
              id
              url
            }
            medium {
              id
              url
            }
            large {
              id
              url
            }
          }
          thumbnails {
            id
            medium {
              id
              url
            }
          }
          author {
            ...AuthorFragment
          }
        }
      }
    }
  }
}
    ${TagFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}`;

/**
 * __useProjectsByUserQuery__
 *
 * To run a query within a React component, call `useProjectsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByUserQuery({
 *   variables: {
 *      first: // value for 'first'
 *      username: // value for 'username'
 *      cursor: // value for 'cursor'
 *      filterFavorites: // value for 'filterFavorites'
 *      sortBy: // value for 'sortBy'
 *      maxEngineVersion: // value for 'maxEngineVersion'
 *   },
 * });
 */
export function useProjectsByUserQuery(baseOptions: Apollo.QueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsByUserQuery, ProjectsByUserQueryVariables>(ProjectsByUserDocument, options);
      }
export function useProjectsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsByUserQuery, ProjectsByUserQueryVariables>(ProjectsByUserDocument, options);
        }
export type ProjectsByUserQueryHookResult = ReturnType<typeof useProjectsByUserQuery>;
export type ProjectsByUserLazyQueryHookResult = ReturnType<typeof useProjectsByUserLazyQuery>;
export type ProjectsByUserQueryResult = Apollo.QueryResult<ProjectsByUserQuery, ProjectsByUserQueryVariables>;
export const ProviderSessionTokenDocument = gql`
    query ProviderSessionToken($provider: AvatarProvider!) {
  providerSessionToken(provider: $provider)
}
    `;

/**
 * __useProviderSessionTokenQuery__
 *
 * To run a query within a React component, call `useProviderSessionTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderSessionTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderSessionTokenQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useProviderSessionTokenQuery(baseOptions: Apollo.QueryHookOptions<ProviderSessionTokenQuery, ProviderSessionTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderSessionTokenQuery, ProviderSessionTokenQueryVariables>(ProviderSessionTokenDocument, options);
      }
export function useProviderSessionTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderSessionTokenQuery, ProviderSessionTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderSessionTokenQuery, ProviderSessionTokenQueryVariables>(ProviderSessionTokenDocument, options);
        }
export type ProviderSessionTokenQueryHookResult = ReturnType<typeof useProviderSessionTokenQuery>;
export type ProviderSessionTokenLazyQueryHookResult = ReturnType<typeof useProviderSessionTokenLazyQuery>;
export type ProviderSessionTokenQueryResult = Apollo.QueryResult<ProviderSessionTokenQuery, ProviderSessionTokenQueryVariables>;
export const QuerySnippetModelDocument = gql`
    query querySnippetModel($question: String!, $prev_output: String, $prefabId: String, $correlation_id: String, $place_prefab: Boolean) {
  querySnippetModel(
    question: $question
    prev_output: $prev_output
    prefabId: $prefabId
    correlation_id: $correlation_id
    place_prefab: $place_prefab
  ) {
    correlation_id
    creator_ver
    data
    endpoint_ver
    prev_output
    seed
  }
}
    `;

/**
 * __useQuerySnippetModelQuery__
 *
 * To run a query within a React component, call `useQuerySnippetModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySnippetModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySnippetModelQuery({
 *   variables: {
 *      question: // value for 'question'
 *      prev_output: // value for 'prev_output'
 *      prefabId: // value for 'prefabId'
 *      correlation_id: // value for 'correlation_id'
 *      place_prefab: // value for 'place_prefab'
 *   },
 * });
 */
export function useQuerySnippetModelQuery(baseOptions: Apollo.QueryHookOptions<QuerySnippetModelQuery, QuerySnippetModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuerySnippetModelQuery, QuerySnippetModelQueryVariables>(QuerySnippetModelDocument, options);
      }
export function useQuerySnippetModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuerySnippetModelQuery, QuerySnippetModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuerySnippetModelQuery, QuerySnippetModelQueryVariables>(QuerySnippetModelDocument, options);
        }
export type QuerySnippetModelQueryHookResult = ReturnType<typeof useQuerySnippetModelQuery>;
export type QuerySnippetModelLazyQueryHookResult = ReturnType<typeof useQuerySnippetModelLazyQuery>;
export type QuerySnippetModelQueryResult = Apollo.QueryResult<QuerySnippetModelQuery, QuerySnippetModelQueryVariables>;
export const QueryWorldModelDocument = gql`
    query queryWorldModel($correlation_id: String!, $prev_output: String, $project_id: String, $question: String!, $seed: Int, $strategy: String) {
  queryWorldModel(
    question: $question
    prev_output: $prev_output
    correlation_id: $correlation_id
    seed: $seed
    strategy: $strategy
    project_id: $project_id
  ) {
    prev_output
    data
    reply
    endpoint_ver
    creator_ver
    correlation_id
    seed
    strategy
  }
}
    `;

/**
 * __useQueryWorldModelQuery__
 *
 * To run a query within a React component, call `useQueryWorldModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryWorldModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryWorldModelQuery({
 *   variables: {
 *      correlation_id: // value for 'correlation_id'
 *      prev_output: // value for 'prev_output'
 *      project_id: // value for 'project_id'
 *      question: // value for 'question'
 *      seed: // value for 'seed'
 *      strategy: // value for 'strategy'
 *   },
 * });
 */
export function useQueryWorldModelQuery(baseOptions: Apollo.QueryHookOptions<QueryWorldModelQuery, QueryWorldModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryWorldModelQuery, QueryWorldModelQueryVariables>(QueryWorldModelDocument, options);
      }
export function useQueryWorldModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryWorldModelQuery, QueryWorldModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryWorldModelQuery, QueryWorldModelQueryVariables>(QueryWorldModelDocument, options);
        }
export type QueryWorldModelQueryHookResult = ReturnType<typeof useQueryWorldModelQuery>;
export type QueryWorldModelLazyQueryHookResult = ReturnType<typeof useQueryWorldModelLazyQuery>;
export type QueryWorldModelQueryResult = Apollo.QueryResult<QueryWorldModelQuery, QueryWorldModelQueryVariables>;
export const RandomSessionDocument = gql`
    query RandomSession($projectId: ID, $gameKit: GameKit) {
  randomSession(payload: {projectId: $projectId, gameKit: $gameKit}) {
    id
    sessionUrl
    sessionId
    newlyCreated
    sessionStatus
    playerCount
    maxPlayerCount
    publicity
    currentProject {
      id
      title
      projectType
      totalViews
      disableComments
      likes
      thumbnail {
        id
        small {
          id
          url
        }
      }
      author {
        id
        role
        username
      }
    }
  }
}
    `;

/**
 * __useRandomSessionQuery__
 *
 * To run a query within a React component, call `useRandomSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRandomSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRandomSessionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      gameKit: // value for 'gameKit'
 *   },
 * });
 */
export function useRandomSessionQuery(baseOptions?: Apollo.QueryHookOptions<RandomSessionQuery, RandomSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RandomSessionQuery, RandomSessionQueryVariables>(RandomSessionDocument, options);
      }
export function useRandomSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RandomSessionQuery, RandomSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RandomSessionQuery, RandomSessionQueryVariables>(RandomSessionDocument, options);
        }
export type RandomSessionQueryHookResult = ReturnType<typeof useRandomSessionQuery>;
export type RandomSessionLazyQueryHookResult = ReturnType<typeof useRandomSessionLazyQuery>;
export type RandomSessionQueryResult = Apollo.QueryResult<RandomSessionQuery, RandomSessionQueryVariables>;
export const RandomizedUsernamesDocument = gql`
    query RandomizedUsernames($amount: Int!) {
  randomizedUsernames(amount: $amount)
}
    `;

/**
 * __useRandomizedUsernamesQuery__
 *
 * To run a query within a React component, call `useRandomizedUsernamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRandomizedUsernamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRandomizedUsernamesQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useRandomizedUsernamesQuery(baseOptions: Apollo.QueryHookOptions<RandomizedUsernamesQuery, RandomizedUsernamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RandomizedUsernamesQuery, RandomizedUsernamesQueryVariables>(RandomizedUsernamesDocument, options);
      }
export function useRandomizedUsernamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RandomizedUsernamesQuery, RandomizedUsernamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RandomizedUsernamesQuery, RandomizedUsernamesQueryVariables>(RandomizedUsernamesDocument, options);
        }
export type RandomizedUsernamesQueryHookResult = ReturnType<typeof useRandomizedUsernamesQuery>;
export type RandomizedUsernamesLazyQueryHookResult = ReturnType<typeof useRandomizedUsernamesLazyQuery>;
export type RandomizedUsernamesQueryResult = Apollo.QueryResult<RandomizedUsernamesQuery, RandomizedUsernamesQueryVariables>;
export const RecommendationsDocument = gql`
    query Recommendations($quantity: Int!, $cursor: String, $sort: RecommendationSort, $projectId: String) {
  recommendations(
    payload: {quantity: $quantity, cursor: $cursor, sort: $sort, projectId: $projectId}
  ) {
    cursor
    items {
      id
      title
      engineVersion
      thumbnail {
        id
        medium {
          id
          url
        }
      }
      author {
        id
        username
        pictureUrl
        isEmployee
        isVerified
      }
      featured
      totalViews
      gameKit
      completionRate
    }
  }
}
    `;

/**
 * __useRecommendationsQuery__
 *
 * To run a query within a React component, call `useRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationsQuery({
 *   variables: {
 *      quantity: // value for 'quantity'
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<RecommendationsQuery, RecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendationsQuery, RecommendationsQueryVariables>(RecommendationsDocument, options);
      }
export function useRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendationsQuery, RecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendationsQuery, RecommendationsQueryVariables>(RecommendationsDocument, options);
        }
export type RecommendationsQueryHookResult = ReturnType<typeof useRecommendationsQuery>;
export type RecommendationsLazyQueryHookResult = ReturnType<typeof useRecommendationsLazyQuery>;
export type RecommendationsQueryResult = Apollo.QueryResult<RecommendationsQuery, RecommendationsQueryVariables>;
export const RepliesDocument = gql`
    query replies($commentId: ID!, $cursor: ID, $first: Float!) {
  replies(commentId: $commentId, payload: {first: $first, after: $cursor}) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        contentId
        contentType
        likes
        isLiked
        text
        id
        createdAt
        updatedAt
        deletedAt
        isPinned
        isReported
        author {
          isVerified
          isEmployee
          id
          level
          role
          username
          pictureUrl
          suspension {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRepliesQuery__
 *
 * To run a query within a React component, call `useRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepliesQuery({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRepliesQuery(baseOptions: Apollo.QueryHookOptions<RepliesQuery, RepliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepliesQuery, RepliesQueryVariables>(RepliesDocument, options);
      }
export function useRepliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepliesQuery, RepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepliesQuery, RepliesQueryVariables>(RepliesDocument, options);
        }
export type RepliesQueryHookResult = ReturnType<typeof useRepliesQuery>;
export type RepliesLazyQueryHookResult = ReturnType<typeof useRepliesLazyQuery>;
export type RepliesQueryResult = Apollo.QueryResult<RepliesQuery, RepliesQueryVariables>;
export const ReportsDocument = gql`
    query Reports($filter: String, $contentType: ContentType, $status: ReportStatus, $sortBy: SortReportBy) {
  reports(
    payload: {contentType: $contentType, status: $status, filter: $filter, sortBy: $sortBy}
  ) {
    id
    contentId
    reason
    contentType
    status
    totalReports
    projectId
    createdAt
    resolved
    content {
      __typename
      ... on Project {
        title
        id
        description
        viewUrl
        author {
          id
          role
          username
          suspension {
            id
          }
          suspensions {
            id
            createdAt
            endedAt
            reason
            customMessage
          }
        }
        __typename
        thumbnail {
          id
          large {
            url
            id
          }
        }
      }
      ... on User {
        id
        role
        isVerified
        isEmployee
        username
        pictureUrl
        __typename
        suspension {
          id
        }
        suspensions {
          id
          createdAt
          endedAt
          reason
          customMessage
        }
      }
      ... on Comment {
        id
        contentId
        contentType
        author {
          id
          role
          username
          suspension {
            id
          }
          suspensions {
            id
            createdAt
            endedAt
            reason
            customMessage
          }
        }
        __typename
        rawText
      }
      ... on Image {
        id
        __typename
        file {
          id
          owner {
            id
            role
            username
            pictureUrl
            suspension {
              id
            }
            suspensions {
              id
              createdAt
              endedAt
              reason
              customMessage
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      contentType: // value for 'contentType'
 *      status: // value for 'status'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useReportsQuery(baseOptions?: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
      }
export function useReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
        }
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsQueryResult = Apollo.QueryResult<ReportsQuery, ReportsQueryVariables>;
export const ReportsForContentDocument = gql`
    query ReportsForContent($contentId: ID!) {
  reportsForContent(id: $contentId) {
    id
    contentType
    contentId
    reason
    reasonText
    createdAt
    status
    resolved
    user {
      id
      role
      username
    }
  }
}
    `;

/**
 * __useReportsForContentQuery__
 *
 * To run a query within a React component, call `useReportsForContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsForContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsForContentQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useReportsForContentQuery(baseOptions: Apollo.QueryHookOptions<ReportsForContentQuery, ReportsForContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsForContentQuery, ReportsForContentQueryVariables>(ReportsForContentDocument, options);
      }
export function useReportsForContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsForContentQuery, ReportsForContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsForContentQuery, ReportsForContentQueryVariables>(ReportsForContentDocument, options);
        }
export type ReportsForContentQueryHookResult = ReturnType<typeof useReportsForContentQuery>;
export type ReportsForContentLazyQueryHookResult = ReturnType<typeof useReportsForContentLazyQuery>;
export type ReportsForContentQueryResult = Apollo.QueryResult<ReportsForContentQuery, ReportsForContentQueryVariables>;
export const RequestAccessToProjectDocument = gql`
    query RequestAccessToProject($projectId: ID!) {
  requestAccessToProject(projectId: $projectId) {
    granted
    reason
  }
}
    `;

/**
 * __useRequestAccessToProjectQuery__
 *
 * To run a query within a React component, call `useRequestAccessToProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessToProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestAccessToProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRequestAccessToProjectQuery(baseOptions: Apollo.QueryHookOptions<RequestAccessToProjectQuery, RequestAccessToProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestAccessToProjectQuery, RequestAccessToProjectQueryVariables>(RequestAccessToProjectDocument, options);
      }
export function useRequestAccessToProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestAccessToProjectQuery, RequestAccessToProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestAccessToProjectQuery, RequestAccessToProjectQueryVariables>(RequestAccessToProjectDocument, options);
        }
export type RequestAccessToProjectQueryHookResult = ReturnType<typeof useRequestAccessToProjectQuery>;
export type RequestAccessToProjectLazyQueryHookResult = ReturnType<typeof useRequestAccessToProjectLazyQuery>;
export type RequestAccessToProjectQueryResult = Apollo.QueryResult<RequestAccessToProjectQuery, RequestAccessToProjectQueryVariables>;
export const RewardLadderDocument = gql`
    query RewardLadder {
  criteriasForBadgeGroupId(groupId: 0) {
    id
    total
    badgeId
  }
  me {
    id
    isRegistered
    level
    avatarV2 {
      id
      provider
      unlockedAssets {
        id
      }
    }
  }
  unlockableRpmAchievements {
    id
    title
    description
    maleId
    femaleId
    thumbnail
    thumbnailDetailed
    type
    rarity
    levelRequired
  }
}
    `;

/**
 * __useRewardLadderQuery__
 *
 * To run a query within a React component, call `useRewardLadderQuery` and pass it any options that fit your needs.
 * When your component renders, `useRewardLadderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRewardLadderQuery({
 *   variables: {
 *   },
 * });
 */
export function useRewardLadderQuery(baseOptions?: Apollo.QueryHookOptions<RewardLadderQuery, RewardLadderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RewardLadderQuery, RewardLadderQueryVariables>(RewardLadderDocument, options);
      }
export function useRewardLadderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RewardLadderQuery, RewardLadderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RewardLadderQuery, RewardLadderQueryVariables>(RewardLadderDocument, options);
        }
export type RewardLadderQueryHookResult = ReturnType<typeof useRewardLadderQuery>;
export type RewardLadderLazyQueryHookResult = ReturnType<typeof useRewardLadderLazyQuery>;
export type RewardLadderQueryResult = Apollo.QueryResult<RewardLadderQuery, RewardLadderQueryVariables>;
export const SearchFriendsDocument = gql`
    query searchFriends($username: String!) {
  me {
    id
    getFriends(payload: {filter: $username, first: 40}) {
      edges {
        node {
          user {
            id
            username
            pictureUrl
            isValidAge
            privacySettings {
              userId
              id
              directMessagingPublicity
            }
            activeSession {
              id
              project {
                id
                title
                thumbnail {
                  large {
                    url
                  }
                }
              }
            }
            session {
              id
              sessionStatus
              lastSeen
              actionStatus
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchFriendsQuery__
 *
 * To run a query within a React component, call `useSearchFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFriendsQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useSearchFriendsQuery(baseOptions: Apollo.QueryHookOptions<SearchFriendsQuery, SearchFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFriendsQuery, SearchFriendsQueryVariables>(SearchFriendsDocument, options);
      }
export function useSearchFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFriendsQuery, SearchFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFriendsQuery, SearchFriendsQueryVariables>(SearchFriendsDocument, options);
        }
export type SearchFriendsQueryHookResult = ReturnType<typeof useSearchFriendsQuery>;
export type SearchFriendsLazyQueryHookResult = ReturnType<typeof useSearchFriendsLazyQuery>;
export type SearchFriendsQueryResult = Apollo.QueryResult<SearchFriendsQuery, SearchFriendsQueryVariables>;
export const SessionsByProjectsDocument = gql`
    query SessionsByProjects($limit: Int!, $projectIds: [ID!]!, $showPinnedWorlds: Boolean!) {
  mostPopularProjectsV2(limit: $limit, exclude: $projectIds) {
    numberOfActivePlayersV2
    id
    title
    isRestricted
    visibility
    iframeUrl
    thumbnail {
      id
      medium {
        id
        url
      }
    }
  }
  projectsByIds(projectIds: $projectIds) @include(if: $showPinnedWorlds) {
    id
    title
    iframeUrl
    thumbnail {
      id
      medium {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useSessionsByProjectsQuery__
 *
 * To run a query within a React component, call `useSessionsByProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionsByProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionsByProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      projectIds: // value for 'projectIds'
 *      showPinnedWorlds: // value for 'showPinnedWorlds'
 *   },
 * });
 */
export function useSessionsByProjectsQuery(baseOptions: Apollo.QueryHookOptions<SessionsByProjectsQuery, SessionsByProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionsByProjectsQuery, SessionsByProjectsQueryVariables>(SessionsByProjectsDocument, options);
      }
export function useSessionsByProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionsByProjectsQuery, SessionsByProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionsByProjectsQuery, SessionsByProjectsQueryVariables>(SessionsByProjectsDocument, options);
        }
export type SessionsByProjectsQueryHookResult = ReturnType<typeof useSessionsByProjectsQuery>;
export type SessionsByProjectsLazyQueryHookResult = ReturnType<typeof useSessionsByProjectsLazyQuery>;
export type SessionsByProjectsQueryResult = Apollo.QueryResult<SessionsByProjectsQuery, SessionsByProjectsQueryVariables>;
export const SocialFeedDocument = gql`
    query SocialFeed($payload: ProjectSearchDTO, $includeOwnGames: Boolean) {
  socialFeed(payload: $payload, includeOwnGames: $includeOwnGames) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      title
      completionRate
      gameKit
      engineVersion
      thumbnail {
        id
        medium {
          id
          url
        }
      }
      author {
        id
        username
        pictureUrl
        isEmployee
        isVerified
      }
      featured
      totalViews
    }
  }
}
    `;

/**
 * __useSocialFeedQuery__
 *
 * To run a query within a React component, call `useSocialFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialFeedQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *      includeOwnGames: // value for 'includeOwnGames'
 *   },
 * });
 */
export function useSocialFeedQuery(baseOptions?: Apollo.QueryHookOptions<SocialFeedQuery, SocialFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialFeedQuery, SocialFeedQueryVariables>(SocialFeedDocument, options);
      }
export function useSocialFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialFeedQuery, SocialFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialFeedQuery, SocialFeedQueryVariables>(SocialFeedDocument, options);
        }
export type SocialFeedQueryHookResult = ReturnType<typeof useSocialFeedQuery>;
export type SocialFeedLazyQueryHookResult = ReturnType<typeof useSocialFeedLazyQuery>;
export type SocialFeedQueryResult = Apollo.QueryResult<SocialFeedQuery, SocialFeedQueryVariables>;
export const SuspensionsByUserIdDocument = gql`
    query SuspensionsByUserId($userId: Float!) {
  suspensionsByUserId(userId: $userId) {
    id
    customMessage
    reason
    endedAt
    createdAt
    reason
  }
}
    `;

/**
 * __useSuspensionsByUserIdQuery__
 *
 * To run a query within a React component, call `useSuspensionsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuspensionsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuspensionsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSuspensionsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<SuspensionsByUserIdQuery, SuspensionsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuspensionsByUserIdQuery, SuspensionsByUserIdQueryVariables>(SuspensionsByUserIdDocument, options);
      }
export function useSuspensionsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuspensionsByUserIdQuery, SuspensionsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuspensionsByUserIdQuery, SuspensionsByUserIdQueryVariables>(SuspensionsByUserIdDocument, options);
        }
export type SuspensionsByUserIdQueryHookResult = ReturnType<typeof useSuspensionsByUserIdQuery>;
export type SuspensionsByUserIdLazyQueryHookResult = ReturnType<typeof useSuspensionsByUserIdLazyQuery>;
export type SuspensionsByUserIdQueryResult = Apollo.QueryResult<SuspensionsByUserIdQuery, SuspensionsByUserIdQueryVariables>;
export const TagsDocument = gql`
    query Tags($first: Float!, $cursor: ID, $filter: String, $sortBy: SortBy, $minEngineVersion: Int, $maxEngineVersion: Int, $tagTypes: [TagType!], $preferExactMatch: Boolean, $contentTypes: [ContentType!], $limit: Int) {
  tags(
    payload: {first: $first, after: $cursor, filter: $filter, sortBy: $sortBy, minEngineVersion: $minEngineVersion, maxEngineVersion: $maxEngineVersion}
    tagTypes: $tagTypes
    preferExactMatch: $preferExactMatch
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        name
        type
        totalContent(
          contentTypes: $contentTypes
          minEngineVersion: $minEngineVersion
          maxEngineVersion: $maxEngineVersion
        )
        projects(
          minEngineVersion: $minEngineVersion
          maxEngineVersion: $maxEngineVersion
          limit: $limit
        ) {
          id
          title
          likes
          totalViews
          tags
          completionRate
          engineVersion
          gameKit
          tags_v2 {
            ...TagFragment
          }
          thumbnail {
            id
            small {
              id
              url
            }
            medium {
              id
              url
            }
          }
          author {
            ...AuthorFragment
          }
        }
      }
    }
  }
}
    ${TagFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      minEngineVersion: // value for 'minEngineVersion'
 *      maxEngineVersion: // value for 'maxEngineVersion'
 *      tagTypes: // value for 'tagTypes'
 *      preferExactMatch: // value for 'preferExactMatch'
 *      contentTypes: // value for 'contentTypes'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagsQuery(baseOptions: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const TutorialSectionDocument = gql`
    query TutorialSection {
  tutorialSections {
    id
    title
    description
    tutorialVideos {
      title
      name
      videoLink
      thumbnailUrl
    }
  }
}
    `;

/**
 * __useTutorialSectionQuery__
 *
 * To run a query within a React component, call `useTutorialSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTutorialSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTutorialSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useTutorialSectionQuery(baseOptions?: Apollo.QueryHookOptions<TutorialSectionQuery, TutorialSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TutorialSectionQuery, TutorialSectionQueryVariables>(TutorialSectionDocument, options);
      }
export function useTutorialSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TutorialSectionQuery, TutorialSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TutorialSectionQuery, TutorialSectionQueryVariables>(TutorialSectionDocument, options);
        }
export type TutorialSectionQueryHookResult = ReturnType<typeof useTutorialSectionQuery>;
export type TutorialSectionLazyQueryHookResult = ReturnType<typeof useTutorialSectionLazyQuery>;
export type TutorialSectionQueryResult = Apollo.QueryResult<TutorialSectionQuery, TutorialSectionQueryVariables>;
export const UnlockedAchiementsDocument = gql`
    query UnlockedAchiements($first: Float, $username: String!, $after: ID) {
  userByUsername(username: $username) {
    id
    unlockedBadges(input: {first: $first, after: $after}) {
      pageInfo {
        hasNextPage
        endCursor
      }
      items {
        id
        createdAt
        badge {
          displayName
          id
          level
          groupId
          icon
          groupTotal
          locked_icon
          description
        }
      }
    }
  }
}
    `;

/**
 * __useUnlockedAchiementsQuery__
 *
 * To run a query within a React component, call `useUnlockedAchiementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnlockedAchiementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnlockedAchiementsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      username: // value for 'username'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUnlockedAchiementsQuery(baseOptions: Apollo.QueryHookOptions<UnlockedAchiementsQuery, UnlockedAchiementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnlockedAchiementsQuery, UnlockedAchiementsQueryVariables>(UnlockedAchiementsDocument, options);
      }
export function useUnlockedAchiementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnlockedAchiementsQuery, UnlockedAchiementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnlockedAchiementsQuery, UnlockedAchiementsQueryVariables>(UnlockedAchiementsDocument, options);
        }
export type UnlockedAchiementsQueryHookResult = ReturnType<typeof useUnlockedAchiementsQuery>;
export type UnlockedAchiementsLazyQueryHookResult = ReturnType<typeof useUnlockedAchiementsLazyQuery>;
export type UnlockedAchiementsQueryResult = Apollo.QueryResult<UnlockedAchiementsQuery, UnlockedAchiementsQueryVariables>;
export const UnlockedAssetsDocument = gql`
    query UnlockedAssets {
  me {
    id
    softCurrency
    avatarV2 {
      id
      unlockedAssets {
        id
        provider
      }
    }
  }
}
    `;

/**
 * __useUnlockedAssetsQuery__
 *
 * To run a query within a React component, call `useUnlockedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnlockedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnlockedAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnlockedAssetsQuery(baseOptions?: Apollo.QueryHookOptions<UnlockedAssetsQuery, UnlockedAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnlockedAssetsQuery, UnlockedAssetsQueryVariables>(UnlockedAssetsDocument, options);
      }
export function useUnlockedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnlockedAssetsQuery, UnlockedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnlockedAssetsQuery, UnlockedAssetsQueryVariables>(UnlockedAssetsDocument, options);
        }
export type UnlockedAssetsQueryHookResult = ReturnType<typeof useUnlockedAssetsQuery>;
export type UnlockedAssetsLazyQueryHookResult = ReturnType<typeof useUnlockedAssetsLazyQuery>;
export type UnlockedAssetsQueryResult = Apollo.QueryResult<UnlockedAssetsQuery, UnlockedAssetsQueryVariables>;
export const UnseenAchievementsLootDocument = gql`
    query UnseenAchievementsLoot {
  me {
    id
    avatarV2 {
      id
      claimableRpmAchievement {
        id
      }
    }
  }
}
    `;

/**
 * __useUnseenAchievementsLootQuery__
 *
 * To run a query within a React component, call `useUnseenAchievementsLootQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnseenAchievementsLootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnseenAchievementsLootQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnseenAchievementsLootQuery(baseOptions?: Apollo.QueryHookOptions<UnseenAchievementsLootQuery, UnseenAchievementsLootQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnseenAchievementsLootQuery, UnseenAchievementsLootQueryVariables>(UnseenAchievementsLootDocument, options);
      }
export function useUnseenAchievementsLootLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnseenAchievementsLootQuery, UnseenAchievementsLootQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnseenAchievementsLootQuery, UnseenAchievementsLootQueryVariables>(UnseenAchievementsLootDocument, options);
        }
export type UnseenAchievementsLootQueryHookResult = ReturnType<typeof useUnseenAchievementsLootQuery>;
export type UnseenAchievementsLootLazyQueryHookResult = ReturnType<typeof useUnseenAchievementsLootLazyQuery>;
export type UnseenAchievementsLootQueryResult = Apollo.QueryResult<UnseenAchievementsLootQuery, UnseenAchievementsLootQueryVariables>;
export const UserByUsernameDocument = gql`
    query UserByUsername($username: String!) {
  userByUsername(username: $username) {
    id
    role
    username
    title
    pictureUrl
    profileBackgroundUrl
    description
    isValidAge
    haveISentFriendRequest
    haveIReceivedFriendRequest
    haveIBlocked
    haveIReported
    isFriends
    totalFriends
    totalFollowers
    level
    xp
    createdAt
    totalFollowing
    hasDefaultProfileImage
    haveIFeaturedFriend
    isFollowing
    isVerified
    isDeveloper
    isBetatester
    isEmployee
    deletedAt
    email
    birthdate
    homeworld {
      id
      __typename
      project {
        id
        __typename
        isPublished
        title
        engineVersion
        thumbnail {
          id
          large {
            id
            url
          }
        }
      }
    }
    session {
      id
      sessionStatus
    }
    getOrCreatePrivacySettings {
      id
      userId
      friendsArePublic
      onlyFriendsInMultiplayer
      achievementPublicity
      favoriteGamesArePublic
      directMessagingPublicity
    }
    socialMedia {
      id
      twitter
      twitch
      instagram
      youtube
      tiktok
    }
    unlockedBadges(input: {first: 5}) {
      items {
        createdAt
        badge {
          displayName
          id
          level
          groupId
          icon
          groupTotal
          locked_icon
          description
        }
      }
    }
  }
}
    `;

/**
 * __useUserByUsernameQuery__
 *
 * To run a query within a React component, call `useUserByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUserByUsernameQuery(baseOptions: Apollo.QueryHookOptions<UserByUsernameQuery, UserByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByUsernameQuery, UserByUsernameQueryVariables>(UserByUsernameDocument, options);
      }
export function useUserByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByUsernameQuery, UserByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByUsernameQuery, UserByUsernameQueryVariables>(UserByUsernameDocument, options);
        }
export type UserByUsernameQueryHookResult = ReturnType<typeof useUserByUsernameQuery>;
export type UserByUsernameLazyQueryHookResult = ReturnType<typeof useUserByUsernameLazyQuery>;
export type UserByUsernameQueryResult = Apollo.QueryResult<UserByUsernameQuery, UserByUsernameQueryVariables>;
export const UserByUsernamesDocument = gql`
    query UserByUsernames($usernames: String!) {
  userByUsernames(usernames: $usernames) {
    id
    username
  }
}
    `;

/**
 * __useUserByUsernamesQuery__
 *
 * To run a query within a React component, call `useUserByUsernamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByUsernamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByUsernamesQuery({
 *   variables: {
 *      usernames: // value for 'usernames'
 *   },
 * });
 */
export function useUserByUsernamesQuery(baseOptions: Apollo.QueryHookOptions<UserByUsernamesQuery, UserByUsernamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByUsernamesQuery, UserByUsernamesQueryVariables>(UserByUsernamesDocument, options);
      }
export function useUserByUsernamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByUsernamesQuery, UserByUsernamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByUsernamesQuery, UserByUsernamesQueryVariables>(UserByUsernamesDocument, options);
        }
export type UserByUsernamesQueryHookResult = ReturnType<typeof useUserByUsernamesQuery>;
export type UserByUsernamesLazyQueryHookResult = ReturnType<typeof useUserByUsernamesLazyQuery>;
export type UserByUsernamesQueryResult = Apollo.QueryResult<UserByUsernamesQuery, UserByUsernamesQueryVariables>;
export const UserFollowersDocument = gql`
    query UserFollowers($username: String!, $cursor: ID) {
  userByUsername(username: $username) {
    id
    role
    username
    totalFollowers
    getFollowers(payload: {first: 50, after: $cursor}) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          user {
            id
            role
            isVerified
            isEmployee
            username
            level
            pictureUrl
          }
          followedSince
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useUserFollowersQuery__
 *
 * To run a query within a React component, call `useUserFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFollowersQuery({
 *   variables: {
 *      username: // value for 'username'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useUserFollowersQuery(baseOptions: Apollo.QueryHookOptions<UserFollowersQuery, UserFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFollowersQuery, UserFollowersQueryVariables>(UserFollowersDocument, options);
      }
export function useUserFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFollowersQuery, UserFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFollowersQuery, UserFollowersQueryVariables>(UserFollowersDocument, options);
        }
export type UserFollowersQueryHookResult = ReturnType<typeof useUserFollowersQuery>;
export type UserFollowersLazyQueryHookResult = ReturnType<typeof useUserFollowersLazyQuery>;
export type UserFollowersQueryResult = Apollo.QueryResult<UserFollowersQuery, UserFollowersQueryVariables>;
export const UserFollowingDocument = gql`
    query UserFollowing($username: String!, $cursor: ID) {
  userByUsername(username: $username) {
    id
    role
    username
    totalFollowing
    getFollowing(payload: {first: 50, after: $cursor}) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          user {
            id
            role
            isVerified
            isEmployee
            username
            level
            pictureUrl
          }
          followedSince
        }
      }
    }
  }
}
    `;

/**
 * __useUserFollowingQuery__
 *
 * To run a query within a React component, call `useUserFollowingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFollowingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFollowingQuery({
 *   variables: {
 *      username: // value for 'username'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useUserFollowingQuery(baseOptions: Apollo.QueryHookOptions<UserFollowingQuery, UserFollowingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFollowingQuery, UserFollowingQueryVariables>(UserFollowingDocument, options);
      }
export function useUserFollowingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFollowingQuery, UserFollowingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFollowingQuery, UserFollowingQueryVariables>(UserFollowingDocument, options);
        }
export type UserFollowingQueryHookResult = ReturnType<typeof useUserFollowingQuery>;
export type UserFollowingLazyQueryHookResult = ReturnType<typeof useUserFollowingLazyQuery>;
export type UserFollowingQueryResult = Apollo.QueryResult<UserFollowingQuery, UserFollowingQueryVariables>;
export const UserFriendsDocument = gql`
    query UserFriends($username: String!, $cursor: ID, $first: Float!) {
  userByUsername(username: $username) {
    id
    role
    username
    isFriends
    totalFriends
    getFriends(payload: {first: $first, after: $cursor}) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          user {
            id
            isVerified
            isEmployee
            isFriends
            username
            level
            pictureUrl
          }
          friendSince
        }
      }
    }
  }
}
    `;

/**
 * __useUserFriendsQuery__
 *
 * To run a query within a React component, call `useUserFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFriendsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUserFriendsQuery(baseOptions: Apollo.QueryHookOptions<UserFriendsQuery, UserFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFriendsQuery, UserFriendsQueryVariables>(UserFriendsDocument, options);
      }
export function useUserFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFriendsQuery, UserFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFriendsQuery, UserFriendsQueryVariables>(UserFriendsDocument, options);
        }
export type UserFriendsQueryHookResult = ReturnType<typeof useUserFriendsQuery>;
export type UserFriendsLazyQueryHookResult = ReturnType<typeof useUserFriendsLazyQuery>;
export type UserFriendsQueryResult = Apollo.QueryResult<UserFriendsQuery, UserFriendsQueryVariables>;
export const UserHasBoughtProductDocument = gql`
    query UserHasBoughtProduct($productId: String!) {
  userHasBoughtProduct(productId: $productId) {
    hasBoughtProduct
  }
}
    `;

/**
 * __useUserHasBoughtProductQuery__
 *
 * To run a query within a React component, call `useUserHasBoughtProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHasBoughtProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHasBoughtProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useUserHasBoughtProductQuery(baseOptions: Apollo.QueryHookOptions<UserHasBoughtProductQuery, UserHasBoughtProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserHasBoughtProductQuery, UserHasBoughtProductQueryVariables>(UserHasBoughtProductDocument, options);
      }
export function useUserHasBoughtProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserHasBoughtProductQuery, UserHasBoughtProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserHasBoughtProductQuery, UserHasBoughtProductQueryVariables>(UserHasBoughtProductDocument, options);
        }
export type UserHasBoughtProductQueryHookResult = ReturnType<typeof useUserHasBoughtProductQuery>;
export type UserHasBoughtProductLazyQueryHookResult = ReturnType<typeof useUserHasBoughtProductLazyQuery>;
export type UserHasBoughtProductQueryResult = Apollo.QueryResult<UserHasBoughtProductQuery, UserHasBoughtProductQueryVariables>;
export const UserHomeworldDocument = gql`
    query UserHomeworld($username: String!) {
  userByUsername(username: $username) {
    id
    homeworld {
      id
      project {
        id
        isPublished
        engineVersion
        isRestricted
      }
    }
  }
}
    `;

/**
 * __useUserHomeworldQuery__
 *
 * To run a query within a React component, call `useUserHomeworldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHomeworldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHomeworldQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUserHomeworldQuery(baseOptions: Apollo.QueryHookOptions<UserHomeworldQuery, UserHomeworldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserHomeworldQuery, UserHomeworldQueryVariables>(UserHomeworldDocument, options);
      }
export function useUserHomeworldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserHomeworldQuery, UserHomeworldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserHomeworldQuery, UserHomeworldQueryVariables>(UserHomeworldDocument, options);
        }
export type UserHomeworldQueryHookResult = ReturnType<typeof useUserHomeworldQuery>;
export type UserHomeworldLazyQueryHookResult = ReturnType<typeof useUserHomeworldLazyQuery>;
export type UserHomeworldQueryResult = Apollo.QueryResult<UserHomeworldQuery, UserHomeworldQueryVariables>;
export const UserIdByUsernameDocument = gql`
    query UserIdByUsername($username: String!) {
  userByUsername(username: $username) {
    id
  }
}
    `;

/**
 * __useUserIdByUsernameQuery__
 *
 * To run a query within a React component, call `useUserIdByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIdByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIdByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUserIdByUsernameQuery(baseOptions: Apollo.QueryHookOptions<UserIdByUsernameQuery, UserIdByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserIdByUsernameQuery, UserIdByUsernameQueryVariables>(UserIdByUsernameDocument, options);
      }
export function useUserIdByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserIdByUsernameQuery, UserIdByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserIdByUsernameQuery, UserIdByUsernameQueryVariables>(UserIdByUsernameDocument, options);
        }
export type UserIdByUsernameQueryHookResult = ReturnType<typeof useUserIdByUsernameQuery>;
export type UserIdByUsernameLazyQueryHookResult = ReturnType<typeof useUserIdByUsernameLazyQuery>;
export type UserIdByUsernameQueryResult = Apollo.QueryResult<UserIdByUsernameQuery, UserIdByUsernameQueryVariables>;
export const UserSuspensionsDocument = gql`
    query UserSuspensions($payload: SearchDTO!) {
  activeSuspensionList(payload: $payload) {
    totalCount
    suspensionList {
      id
      reason
      createdAt
      customMessage
      user {
        id
        username
      }
    }
  }
}
    `;

/**
 * __useUserSuspensionsQuery__
 *
 * To run a query within a React component, call `useUserSuspensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSuspensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSuspensionsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUserSuspensionsQuery(baseOptions: Apollo.QueryHookOptions<UserSuspensionsQuery, UserSuspensionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSuspensionsQuery, UserSuspensionsQueryVariables>(UserSuspensionsDocument, options);
      }
export function useUserSuspensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSuspensionsQuery, UserSuspensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSuspensionsQuery, UserSuspensionsQueryVariables>(UserSuspensionsDocument, options);
        }
export type UserSuspensionsQueryHookResult = ReturnType<typeof useUserSuspensionsQuery>;
export type UserSuspensionsLazyQueryHookResult = ReturnType<typeof useUserSuspensionsLazyQuery>;
export type UserSuspensionsQueryResult = Apollo.QueryResult<UserSuspensionsQuery, UserSuspensionsQueryVariables>;
export const UserTagsDocument = gql`
    query UserTags($username: String!) {
  userByUsername(username: $username) {
    id
    tags_v2 {
      __typename
      name
      type
      id
    }
  }
}
    `;

/**
 * __useUserTagsQuery__
 *
 * To run a query within a React component, call `useUserTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTagsQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUserTagsQuery(baseOptions: Apollo.QueryHookOptions<UserTagsQuery, UserTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTagsQuery, UserTagsQueryVariables>(UserTagsDocument, options);
      }
export function useUserTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTagsQuery, UserTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTagsQuery, UserTagsQueryVariables>(UserTagsDocument, options);
        }
export type UserTagsQueryHookResult = ReturnType<typeof useUserTagsQuery>;
export type UserTagsLazyQueryHookResult = ReturnType<typeof useUserTagsLazyQuery>;
export type UserTagsQueryResult = Apollo.QueryResult<UserTagsQuery, UserTagsQueryVariables>;
export const ValidateResetPasswordTokenDocument = gql`
    query ValidateResetPasswordToken($token: String!) {
  checkResetPasswordToken(token: $token)
}
    `;

/**
 * __useValidateResetPasswordTokenQuery__
 *
 * To run a query within a React component, call `useValidateResetPasswordTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateResetPasswordTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateResetPasswordTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateResetPasswordTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidateResetPasswordTokenQuery, ValidateResetPasswordTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateResetPasswordTokenQuery, ValidateResetPasswordTokenQueryVariables>(ValidateResetPasswordTokenDocument, options);
      }
export function useValidateResetPasswordTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateResetPasswordTokenQuery, ValidateResetPasswordTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateResetPasswordTokenQuery, ValidateResetPasswordTokenQueryVariables>(ValidateResetPasswordTokenDocument, options);
        }
export type ValidateResetPasswordTokenQueryHookResult = ReturnType<typeof useValidateResetPasswordTokenQuery>;
export type ValidateResetPasswordTokenLazyQueryHookResult = ReturnType<typeof useValidateResetPasswordTokenLazyQuery>;
export type ValidateResetPasswordTokenQueryResult = Apollo.QueryResult<ValidateResetPasswordTokenQuery, ValidateResetPasswordTokenQueryVariables>;
export const WalletDocument = gql`
    query Wallet {
  me {
    id
    wallets {
      address
      type
    }
  }
}
    `;

/**
 * __useWalletQuery__
 *
 * To run a query within a React component, call `useWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletQuery(baseOptions?: Apollo.QueryHookOptions<WalletQuery, WalletQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletQuery, WalletQueryVariables>(WalletDocument, options);
      }
export function useWalletLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletQuery, WalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletQuery, WalletQueryVariables>(WalletDocument, options);
        }
export type WalletQueryHookResult = ReturnType<typeof useWalletQuery>;
export type WalletLazyQueryHookResult = ReturnType<typeof useWalletLazyQuery>;
export type WalletQueryResult = Apollo.QueryResult<WalletQuery, WalletQueryVariables>;
export const WarningsDocument = gql`
    query warnings {
  warnings {
    user {
      id
      username
    }
    total
    endingAt
    customMessage
    id
  }
}
    `;

/**
 * __useWarningsQuery__
 *
 * To run a query within a React component, call `useWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarningsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWarningsQuery(baseOptions?: Apollo.QueryHookOptions<WarningsQuery, WarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WarningsQuery, WarningsQueryVariables>(WarningsDocument, options);
      }
export function useWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarningsQuery, WarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WarningsQuery, WarningsQueryVariables>(WarningsDocument, options);
        }
export type WarningsQueryHookResult = ReturnType<typeof useWarningsQuery>;
export type WarningsLazyQueryHookResult = ReturnType<typeof useWarningsLazyQuery>;
export type WarningsQueryResult = Apollo.QueryResult<WarningsQuery, WarningsQueryVariables>;
export const FindAllFeatureTogglesDocument = gql`
    query FindAllFeatureToggles {
  findAllFeatureToggles {
    name
    isEnabled
    enabledAt
    disabledAt
    description
    createdBy
    isConfig
    createdAt
    updatedAt
    criteria {
      minLevel
      minRole
      tags {
        name
        type
      }
    }
    values {
      name
      isEnabled
      enabledAt
      disabledAt
      createdAt
      updatedAt
      criteria {
        minLevel
        minRole
        tags {
          name
          type
        }
      }
      values {
        name
        isEnabled
        enabledAt
        disabledAt
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useFindAllFeatureTogglesQuery__
 *
 * To run a query within a React component, call `useFindAllFeatureTogglesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllFeatureTogglesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllFeatureTogglesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllFeatureTogglesQuery(baseOptions?: Apollo.QueryHookOptions<FindAllFeatureTogglesQuery, FindAllFeatureTogglesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllFeatureTogglesQuery, FindAllFeatureTogglesQueryVariables>(FindAllFeatureTogglesDocument, options);
      }
export function useFindAllFeatureTogglesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllFeatureTogglesQuery, FindAllFeatureTogglesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllFeatureTogglesQuery, FindAllFeatureTogglesQueryVariables>(FindAllFeatureTogglesDocument, options);
        }
export type FindAllFeatureTogglesQueryHookResult = ReturnType<typeof useFindAllFeatureTogglesQuery>;
export type FindAllFeatureTogglesLazyQueryHookResult = ReturnType<typeof useFindAllFeatureTogglesLazyQuery>;
export type FindAllFeatureTogglesQueryResult = Apollo.QueryResult<FindAllFeatureTogglesQuery, FindAllFeatureTogglesQueryVariables>;
export const IsUsernameAvailableDocument = gql`
    query isUsernameAvailable($username: String!) {
  isUsernameAvailable(username: $username)
}
    `;

/**
 * __useIsUsernameAvailableQuery__
 *
 * To run a query within a React component, call `useIsUsernameAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUsernameAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUsernameAvailableQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIsUsernameAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsUsernameAvailableQuery, IsUsernameAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUsernameAvailableQuery, IsUsernameAvailableQueryVariables>(IsUsernameAvailableDocument, options);
      }
export function useIsUsernameAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUsernameAvailableQuery, IsUsernameAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUsernameAvailableQuery, IsUsernameAvailableQueryVariables>(IsUsernameAvailableDocument, options);
        }
export type IsUsernameAvailableQueryHookResult = ReturnType<typeof useIsUsernameAvailableQuery>;
export type IsUsernameAvailableLazyQueryHookResult = ReturnType<typeof useIsUsernameAvailableLazyQuery>;
export type IsUsernameAvailableQueryResult = Apollo.QueryResult<IsUsernameAvailableQuery, IsUsernameAvailableQueryVariables>;
export const LeaderboardEmbedDocument = gql`
    query LeaderboardEmbed($id: ID!) {
  project(id: $id) {
    id
    match: hasTag(name: "g_gameplay_match_settings", type: Meta)
    author {
      id
    }
    tags_v2 {
      ...TagFragment
    }
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useLeaderboardEmbedQuery__
 *
 * To run a query within a React component, call `useLeaderboardEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardEmbedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeaderboardEmbedQuery(baseOptions: Apollo.QueryHookOptions<LeaderboardEmbedQuery, LeaderboardEmbedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardEmbedQuery, LeaderboardEmbedQueryVariables>(LeaderboardEmbedDocument, options);
      }
export function useLeaderboardEmbedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardEmbedQuery, LeaderboardEmbedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardEmbedQuery, LeaderboardEmbedQueryVariables>(LeaderboardEmbedDocument, options);
        }
export type LeaderboardEmbedQueryHookResult = ReturnType<typeof useLeaderboardEmbedQuery>;
export type LeaderboardEmbedLazyQueryHookResult = ReturnType<typeof useLeaderboardEmbedLazyQuery>;
export type LeaderboardEmbedQueryResult = Apollo.QueryResult<LeaderboardEmbedQuery, LeaderboardEmbedQueryVariables>;
export const ProductPathDocument = gql`
    query ProductPath($assetIds: [String!]!) {
  me {
    __typename
    id
    hasUnlockedAssets(assetIds: $assetIds)
  }
}
    `;

/**
 * __useProductPathQuery__
 *
 * To run a query within a React component, call `useProductPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPathQuery({
 *   variables: {
 *      assetIds: // value for 'assetIds'
 *   },
 * });
 */
export function useProductPathQuery(baseOptions: Apollo.QueryHookOptions<ProductPathQuery, ProductPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPathQuery, ProductPathQueryVariables>(ProductPathDocument, options);
      }
export function useProductPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPathQuery, ProductPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPathQuery, ProductPathQueryVariables>(ProductPathDocument, options);
        }
export type ProductPathQueryHookResult = ReturnType<typeof useProductPathQuery>;
export type ProductPathLazyQueryHookResult = ReturnType<typeof useProductPathLazyQuery>;
export type ProductPathQueryResult = Apollo.QueryResult<ProductPathQuery, ProductPathQueryVariables>;
export const PurchaseProductWithSoftCurrencyDocument = gql`
    mutation PurchaseProductWithSoftCurrency($productId: String!) {
  purchaseProductWithSoftCurrency(productId: $productId) {
    ...ShopItem
  }
}
    ${ShopItemFragmentDoc}`;
export type PurchaseProductWithSoftCurrencyMutationFn = Apollo.MutationFunction<PurchaseProductWithSoftCurrencyMutation, PurchaseProductWithSoftCurrencyMutationVariables>;

/**
 * __usePurchaseProductWithSoftCurrencyMutation__
 *
 * To run a mutation, you first call `usePurchaseProductWithSoftCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseProductWithSoftCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseProductWithSoftCurrencyMutation, { data, loading, error }] = usePurchaseProductWithSoftCurrencyMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function usePurchaseProductWithSoftCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseProductWithSoftCurrencyMutation, PurchaseProductWithSoftCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseProductWithSoftCurrencyMutation, PurchaseProductWithSoftCurrencyMutationVariables>(PurchaseProductWithSoftCurrencyDocument, options);
      }
export type PurchaseProductWithSoftCurrencyMutationHookResult = ReturnType<typeof usePurchaseProductWithSoftCurrencyMutation>;
export type PurchaseProductWithSoftCurrencyMutationResult = Apollo.MutationResult<PurchaseProductWithSoftCurrencyMutation>;
export type PurchaseProductWithSoftCurrencyMutationOptions = Apollo.BaseMutationOptions<PurchaseProductWithSoftCurrencyMutation, PurchaseProductWithSoftCurrencyMutationVariables>;
export const MyLoadoutDocument = gql`
    query MyLoadout {
  me {
    id
    avatarV2 {
      id
      rpmHasLinkedAccount
      rpmJsonData {
        outfitGender
      }
    }
    loadout {
      id
      avatarName
      avatarProvider
      avatarRpmUrl
      emotes
    }
    inventory {
      titles {
        id
        title
        assetType
      }
      emotes {
        emoteId
        animationUrl
        thumbnailUrl
      }
    }
  }
}
    `;

/**
 * __useMyLoadoutQuery__
 *
 * To run a query within a React component, call `useMyLoadoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLoadoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLoadoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyLoadoutQuery(baseOptions?: Apollo.QueryHookOptions<MyLoadoutQuery, MyLoadoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLoadoutQuery, MyLoadoutQueryVariables>(MyLoadoutDocument, options);
      }
export function useMyLoadoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLoadoutQuery, MyLoadoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLoadoutQuery, MyLoadoutQueryVariables>(MyLoadoutDocument, options);
        }
export type MyLoadoutQueryHookResult = ReturnType<typeof useMyLoadoutQuery>;
export type MyLoadoutLazyQueryHookResult = ReturnType<typeof useMyLoadoutLazyQuery>;
export type MyLoadoutQueryResult = Apollo.QueryResult<MyLoadoutQuery, MyLoadoutQueryVariables>;
export const SetEmotesDocument = gql`
    mutation SetEmotes($emotes: [String!]!) {
  setEmotes(emotes: $emotes) {
    id
    avatarName
    avatarProvider
    avatarRpmUrl
    emotes
  }
}
    `;
export type SetEmotesMutationFn = Apollo.MutationFunction<SetEmotesMutation, SetEmotesMutationVariables>;

/**
 * __useSetEmotesMutation__
 *
 * To run a mutation, you first call `useSetEmotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEmotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEmotesMutation, { data, loading, error }] = useSetEmotesMutation({
 *   variables: {
 *      emotes: // value for 'emotes'
 *   },
 * });
 */
export function useSetEmotesMutation(baseOptions?: Apollo.MutationHookOptions<SetEmotesMutation, SetEmotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEmotesMutation, SetEmotesMutationVariables>(SetEmotesDocument, options);
      }
export type SetEmotesMutationHookResult = ReturnType<typeof useSetEmotesMutation>;
export type SetEmotesMutationResult = Apollo.MutationResult<SetEmotesMutation>;
export type SetEmotesMutationOptions = Apollo.BaseMutationOptions<SetEmotesMutation, SetEmotesMutationVariables>;
export const GiveNewRpmIdUserByUsernameDocument = gql`
    query GiveNewRpmIdUserByUsername($username: String!) {
  userByUsername(username: $username) {
    id
    avatarV2 {
      id
      rpmUserId
      unlockedAssets {
        id
        provider
        unlockedAt
      }
    }
  }
}
    `;

/**
 * __useGiveNewRpmIdUserByUsernameQuery__
 *
 * To run a query within a React component, call `useGiveNewRpmIdUserByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiveNewRpmIdUserByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiveNewRpmIdUserByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGiveNewRpmIdUserByUsernameQuery(baseOptions: Apollo.QueryHookOptions<GiveNewRpmIdUserByUsernameQuery, GiveNewRpmIdUserByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiveNewRpmIdUserByUsernameQuery, GiveNewRpmIdUserByUsernameQueryVariables>(GiveNewRpmIdUserByUsernameDocument, options);
      }
export function useGiveNewRpmIdUserByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiveNewRpmIdUserByUsernameQuery, GiveNewRpmIdUserByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiveNewRpmIdUserByUsernameQuery, GiveNewRpmIdUserByUsernameQueryVariables>(GiveNewRpmIdUserByUsernameDocument, options);
        }
export type GiveNewRpmIdUserByUsernameQueryHookResult = ReturnType<typeof useGiveNewRpmIdUserByUsernameQuery>;
export type GiveNewRpmIdUserByUsernameLazyQueryHookResult = ReturnType<typeof useGiveNewRpmIdUserByUsernameLazyQuery>;
export type GiveNewRpmIdUserByUsernameQueryResult = Apollo.QueryResult<GiveNewRpmIdUserByUsernameQuery, GiveNewRpmIdUserByUsernameQueryVariables>;
export const ActivityLogDocument = gql`
    query ActivityLog($username: String!, $input: FindActivityLogsInput!) {
  activityLogs(username: $username, input: $input) {
    timestamp
    correlationId
    data {
      __typename
      ... on SoftCurrencyTransactionLog {
        amount
        reason
      }
    }
  }
  userByUsername(username: $username) {
    id
    softCurrency
  }
}
    `;

/**
 * __useActivityLogQuery__
 *
 * To run a query within a React component, call `useActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogQuery({
 *   variables: {
 *      username: // value for 'username'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityLogQuery(baseOptions: Apollo.QueryHookOptions<ActivityLogQuery, ActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogQuery, ActivityLogQueryVariables>(ActivityLogDocument, options);
      }
export function useActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogQuery, ActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogQuery, ActivityLogQueryVariables>(ActivityLogDocument, options);
        }
export type ActivityLogQueryHookResult = ReturnType<typeof useActivityLogQuery>;
export type ActivityLogLazyQueryHookResult = ReturnType<typeof useActivityLogLazyQuery>;
export type ActivityLogQueryResult = Apollo.QueryResult<ActivityLogQuery, ActivityLogQueryVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($input: UpdateResourceDTO!) {
  updateResource(input: $input) {
    success
    reason
  }
}
    `;
export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const CheckIsStashCheckoutCompletedDocument = gql`
    query CheckIsStashCheckoutCompleted($checkoutId: String!) {
  checkIsStashCheckoutCompleted(checkoutId: $checkoutId)
}
    `;

/**
 * __useCheckIsStashCheckoutCompletedQuery__
 *
 * To run a query within a React component, call `useCheckIsStashCheckoutCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIsStashCheckoutCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIsStashCheckoutCompletedQuery({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *   },
 * });
 */
export function useCheckIsStashCheckoutCompletedQuery(baseOptions: Apollo.QueryHookOptions<CheckIsStashCheckoutCompletedQuery, CheckIsStashCheckoutCompletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIsStashCheckoutCompletedQuery, CheckIsStashCheckoutCompletedQueryVariables>(CheckIsStashCheckoutCompletedDocument, options);
      }
export function useCheckIsStashCheckoutCompletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIsStashCheckoutCompletedQuery, CheckIsStashCheckoutCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIsStashCheckoutCompletedQuery, CheckIsStashCheckoutCompletedQueryVariables>(CheckIsStashCheckoutCompletedDocument, options);
        }
export type CheckIsStashCheckoutCompletedQueryHookResult = ReturnType<typeof useCheckIsStashCheckoutCompletedQuery>;
export type CheckIsStashCheckoutCompletedLazyQueryHookResult = ReturnType<typeof useCheckIsStashCheckoutCompletedLazyQuery>;
export type CheckIsStashCheckoutCompletedQueryResult = Apollo.QueryResult<CheckIsStashCheckoutCompletedQuery, CheckIsStashCheckoutCompletedQueryVariables>;
export const CreateStashCheckoutLinkDocument = gql`
    mutation CreateStashCheckoutLink($productId: String!) {
  createStashCheckoutLink(productId: $productId) {
    id
    url
  }
}
    `;
export type CreateStashCheckoutLinkMutationFn = Apollo.MutationFunction<CreateStashCheckoutLinkMutation, CreateStashCheckoutLinkMutationVariables>;

/**
 * __useCreateStashCheckoutLinkMutation__
 *
 * To run a mutation, you first call `useCreateStashCheckoutLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStashCheckoutLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStashCheckoutLinkMutation, { data, loading, error }] = useCreateStashCheckoutLinkMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useCreateStashCheckoutLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateStashCheckoutLinkMutation, CreateStashCheckoutLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStashCheckoutLinkMutation, CreateStashCheckoutLinkMutationVariables>(CreateStashCheckoutLinkDocument, options);
      }
export type CreateStashCheckoutLinkMutationHookResult = ReturnType<typeof useCreateStashCheckoutLinkMutation>;
export type CreateStashCheckoutLinkMutationResult = Apollo.MutationResult<CreateStashCheckoutLinkMutation>;
export type CreateStashCheckoutLinkMutationOptions = Apollo.BaseMutationOptions<CreateStashCheckoutLinkMutation, CreateStashCheckoutLinkMutationVariables>;
export const EquipProductDocument = gql`
    mutation EquipProduct($id: ID!) {
  equipProduct(id: $id) {
    id
    avatarRpmUrl
    avatarName
    avatarProvider
    emotes
  }
}
    `;
export type EquipProductMutationFn = Apollo.MutationFunction<EquipProductMutation, EquipProductMutationVariables>;

/**
 * __useEquipProductMutation__
 *
 * To run a mutation, you first call `useEquipProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipProductMutation, { data, loading, error }] = useEquipProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEquipProductMutation(baseOptions?: Apollo.MutationHookOptions<EquipProductMutation, EquipProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipProductMutation, EquipProductMutationVariables>(EquipProductDocument, options);
      }
export type EquipProductMutationHookResult = ReturnType<typeof useEquipProductMutation>;
export type EquipProductMutationResult = Apollo.MutationResult<EquipProductMutation>;
export type EquipProductMutationOptions = Apollo.BaseMutationOptions<EquipProductMutation, EquipProductMutationVariables>;
export const MyInventoryDocument = gql`
    query MyInventory {
  me {
    id
    loadout {
      emotes
    }
    allUnlockedIds
  }
}
    `;

/**
 * __useMyInventoryQuery__
 *
 * To run a query within a React component, call `useMyInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInventoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyInventoryQuery(baseOptions?: Apollo.QueryHookOptions<MyInventoryQuery, MyInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInventoryQuery, MyInventoryQueryVariables>(MyInventoryDocument, options);
      }
export function useMyInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInventoryQuery, MyInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInventoryQuery, MyInventoryQueryVariables>(MyInventoryDocument, options);
        }
export type MyInventoryQueryHookResult = ReturnType<typeof useMyInventoryQuery>;
export type MyInventoryLazyQueryHookResult = ReturnType<typeof useMyInventoryLazyQuery>;
export type MyInventoryQueryResult = Apollo.QueryResult<MyInventoryQuery, MyInventoryQueryVariables>;
export const SearchPageDocument = gql`
    query SearchPage($searchTerm: String!, $searchType: String!) {
  search(searchTerm: $searchTerm, searchType: $searchType) {
    totalHits
    searchedTerm
    explorableTags {
      tag
      count
    }
    sections {
      __typename
      ... on SearchResultProjectFeedSection {
        feed {
          id
          title
          totalViews
          featured
          completionRate
          gameKit
          thumbnail {
            id
            medium {
              id
              url
            }
          }
          author {
            id
            username
            pictureUrl
            isVerified
            isEmployee
          }
        }
        title
        subTitle
        viewMoreUrl
      }
      ... on SearchResultUserSection {
        totalHits
        users {
          id
          role
          level
          username
          email
          pictureUrl
          isVerified
          isEmployee
          haveISentFriendRequest
          haveIReceivedFriendRequest
          isFriends
          createdAt
        }
      }
    }
    noResultFoundSuggestions
  }
}
    `;

/**
 * __useSearchPageQuery__
 *
 * To run a query within a React component, call `useSearchPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      searchType: // value for 'searchType'
 *   },
 * });
 */
export function useSearchPageQuery(baseOptions: Apollo.QueryHookOptions<SearchPageQuery, SearchPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPageQuery, SearchPageQueryVariables>(SearchPageDocument, options);
      }
export function useSearchPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPageQuery, SearchPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPageQuery, SearchPageQueryVariables>(SearchPageDocument, options);
        }
export type SearchPageQueryHookResult = ReturnType<typeof useSearchPageQuery>;
export type SearchPageLazyQueryHookResult = ReturnType<typeof useSearchPageLazyQuery>;
export type SearchPageQueryResult = Apollo.QueryResult<SearchPageQuery, SearchPageQueryVariables>;
export const ShopProductsDocument = gql`
    query ShopProducts {
  shopProducts {
    ...ShopItem
  }
}
    ${ShopItemFragmentDoc}`;

/**
 * __useShopProductsQuery__
 *
 * To run a query within a React component, call `useShopProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopProductsQuery(baseOptions?: Apollo.QueryHookOptions<ShopProductsQuery, ShopProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopProductsQuery, ShopProductsQueryVariables>(ShopProductsDocument, options);
      }
export function useShopProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopProductsQuery, ShopProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopProductsQuery, ShopProductsQueryVariables>(ShopProductsDocument, options);
        }
export type ShopProductsQueryHookResult = ReturnType<typeof useShopProductsQuery>;
export type ShopProductsLazyQueryHookResult = ReturnType<typeof useShopProductsLazyQuery>;
export type ShopProductsQueryResult = Apollo.QueryResult<ShopProductsQuery, ShopProductsQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AccessControlItem": [
      "AccessControlItemDateTime",
      "AccessControlItemLeaderboard",
      "AccessControlItemNFT"
    ],
    "ActivityLogItem": [
      "SoftCurrencyTransactionLog"
    ],
    "ContentUnion": [
      "Chat",
      "Comment",
      "Image",
      "Project",
      "User"
    ],
    "MultiplayerSessionSettings": [
      "PlatformerSessionSettings",
      "ShooterSessionSettings"
    ],
    "PageModule": [
      "Banner",
      "Carousel",
      "ChallengeBanner",
      "Hero",
      "NewsFeed",
      "ProjectFeedRegular",
      "ProjectFeedSpecific",
      "Section",
      "SessionFeed",
      "UserFeedOnlineFriends",
      "UserFeedRegular"
    ],
    "SearchResultSection": [
      "SearchResultProjectFeedSection",
      "SearchResultUserSection"
    ],
    "SetUserLevelResult": [
      "Badge",
      "SetUserLevelError"
    ],
    "ShopItem": [
      "EmoteShopItem",
      "GameAssetShopItem",
      "RpmShopItem"
    ]
  }
};
      export default result;
    